/* eslint-disable */
// This code was auto-generated by running
// npm run generate:types
// Please do not modify this code by hand.

'use strict';
exports.validateHelloRequest = validate10;
const schema11 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'HelloRequest.json',
  title: 'HelloRequest',
  type: 'object',
  oneOf: [
    {
      $ref: 'PrepAndSendRequest.json',
      $comment: 'This item must be first in the list or it breaks PHP tests',
    },
    {
      $ref: 'SignerAppRequest.json',
      $comment: 'This item must be second in the list or it breaks PHP tests',
    },
    { $ref: 'ModalResponse.json' },
    { $ref: 'EditSignersObject.json' },
    { $ref: 'HomePage.json' },
  ],
};
const schema12 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'PrepAndSendRequest.json',
  title: 'PrepAndSendRequest',
  type: 'object',
  properties: {
    guid: { type: 'string' },
    settings: { $ref: 'Settings.json' },
    options: { $ref: 'Options.json' },
    flags: { $ref: 'Flags.json' },
    accountSettings: { $ref: 'AccountSettings.json' },
    requestData: { $ref: 'RequestData.json' },
    embeddedData: { $ref: 'EmbeddedData.json' },
    user: { $ref: 'User.json' },
  },
  additionalProperties: false,
  required: [
    'guid',
    'settings',
    'flags',
    'accountSettings',
    'user',
    'options',
    'requestData',
  ],
};
const schema13 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'Settings.json',
  type: 'object',
  title: 'Settings',
  additionalProperties: false,
  properties: {
    addCoverPage: { type: 'boolean' },
    recipientOrder: { type: 'boolean' },
    qes: { type: 'boolean' },
    nom151: { type: 'boolean' },
    recipientReassignment: { type: 'boolean' },
    requireSignerInfo: { type: 'boolean' },
    sendHighResFax: { type: 'boolean' },
    needsCharge: { type: 'boolean' },
    hasForm: { type: 'boolean' },
    mobileFriendlySigning: { type: 'boolean' },
  },
};
const func4 = Object.prototype.hasOwnProperty;
const schema14 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'Options.json',
  type: 'object',
  title: 'Options',
  properties: {
    forceSignerRoles: {
      type: 'boolean',
      description: 'Embedded - force showing signer roles',
    },
    forceSubjectMessage: {
      type: 'boolean',
      description: 'Embedded - force showing subject message',
    },
    hideContinueButton: {
      type: 'boolean',
      description: 'Embedded - force showing subject message',
    },
    isMeOnly: { type: 'boolean' },
    hideProgressStepper: { type: 'boolean', description: 'Hide Stepper icons' },
    hideStepperContainer: {
      type: 'boolean',
      description: 'Hide entire stepper',
    },
    requireSignerInfo: {
      type: 'boolean',
      description: 'Show modal asking for user first & last name',
    },
    blockCC: { type: 'boolean', description: 'Block use of CCs' },
    lockDocumentTitle: { type: 'boolean', description: 'Lock the title' },
    lockDocumentMessage: { type: 'boolean', description: 'Lock the message' },
    dateFormat: { $ref: 'Field.json#/definitions/JSDateFormat' },
    features: {
      type: 'array',
      items: { type: 'string' },
      description:
        'A list of features that are being made available on this request',
    },
    integrationMetadata: {
      $ref: '#/definitions/SignatureRequestIntegrationMetadata',
    },
  },
  required: ['features'],
  definitions: {
    SignatureRequestIntegrationMetadata: {
      type: 'object',
      title: 'SignatureRequestIntegrationMetadata',
      description:
        'Additional metadata used by the integration framework. This data is stored in the SuperGroupMetadata table',
      properties: {
        associatedObjectId: { type: 'string' },
        associatedObjectType: { type: 'string' },
        context: { type: 'string' },
        showMissingFieldsTooltip: { type: 'boolean' },
      },
    },
  },
};
const schema34 = {
  type: 'string',
  title: 'JSDateFormat',
  enum: [
    'default',
    'MM / DD / YYYY',
    'MM - DD - YYYY',
    'DD / MM / YYYY',
    'DD - MM - YYYY',
    'YYYY / MM / DD',
    'YYYY - MM - DD',
  ],
};
const schema45 = {
  type: 'object',
  title: 'SignatureRequestIntegrationMetadata',
  description:
    'Additional metadata used by the integration framework. This data is stored in the SuperGroupMetadata table',
  properties: {
    associatedObjectId: { type: 'string' },
    associatedObjectType: { type: 'string' },
    context: { type: 'string' },
    showMissingFieldsTooltip: { type: 'boolean' },
  },
};
const func0 = require('ajv/dist/runtime/equal').default;
function validate12(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="Options.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (data.features === undefined && (missing0 = 'features')) {
        validate12.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.forceSignerRoles !== undefined) {
          const _errs1 = errors;
          if (typeof data.forceSignerRoles !== 'boolean') {
            validate12.errors = [
              {
                instancePath: instancePath + '/forceSignerRoles',
                schemaPath: '#/properties/forceSignerRoles/type',
                keyword: 'type',
                params: { type: 'boolean' },
                message: 'must be boolean',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.forceSubjectMessage !== undefined) {
            const _errs3 = errors;
            if (typeof data.forceSubjectMessage !== 'boolean') {
              validate12.errors = [
                {
                  instancePath: instancePath + '/forceSubjectMessage',
                  schemaPath: '#/properties/forceSubjectMessage/type',
                  keyword: 'type',
                  params: { type: 'boolean' },
                  message: 'must be boolean',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.hideContinueButton !== undefined) {
              const _errs5 = errors;
              if (typeof data.hideContinueButton !== 'boolean') {
                validate12.errors = [
                  {
                    instancePath: instancePath + '/hideContinueButton',
                    schemaPath: '#/properties/hideContinueButton/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.isMeOnly !== undefined) {
                const _errs7 = errors;
                if (typeof data.isMeOnly !== 'boolean') {
                  validate12.errors = [
                    {
                      instancePath: instancePath + '/isMeOnly',
                      schemaPath: '#/properties/isMeOnly/type',
                      keyword: 'type',
                      params: { type: 'boolean' },
                      message: 'must be boolean',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.hideProgressStepper !== undefined) {
                  const _errs9 = errors;
                  if (typeof data.hideProgressStepper !== 'boolean') {
                    validate12.errors = [
                      {
                        instancePath: instancePath + '/hideProgressStepper',
                        schemaPath: '#/properties/hideProgressStepper/type',
                        keyword: 'type',
                        params: { type: 'boolean' },
                        message: 'must be boolean',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.hideStepperContainer !== undefined) {
                    const _errs11 = errors;
                    if (typeof data.hideStepperContainer !== 'boolean') {
                      validate12.errors = [
                        {
                          instancePath: instancePath + '/hideStepperContainer',
                          schemaPath: '#/properties/hideStepperContainer/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.requireSignerInfo !== undefined) {
                      const _errs13 = errors;
                      if (typeof data.requireSignerInfo !== 'boolean') {
                        validate12.errors = [
                          {
                            instancePath: instancePath + '/requireSignerInfo',
                            schemaPath: '#/properties/requireSignerInfo/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.blockCC !== undefined) {
                        const _errs15 = errors;
                        if (typeof data.blockCC !== 'boolean') {
                          validate12.errors = [
                            {
                              instancePath: instancePath + '/blockCC',
                              schemaPath: '#/properties/blockCC/type',
                              keyword: 'type',
                              params: { type: 'boolean' },
                              message: 'must be boolean',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.lockDocumentTitle !== undefined) {
                          const _errs17 = errors;
                          if (typeof data.lockDocumentTitle !== 'boolean') {
                            validate12.errors = [
                              {
                                instancePath:
                                  instancePath + '/lockDocumentTitle',
                                schemaPath:
                                  '#/properties/lockDocumentTitle/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs17 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.lockDocumentMessage !== undefined) {
                            const _errs19 = errors;
                            if (typeof data.lockDocumentMessage !== 'boolean') {
                              validate12.errors = [
                                {
                                  instancePath:
                                    instancePath + '/lockDocumentMessage',
                                  schemaPath:
                                    '#/properties/lockDocumentMessage/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs19 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.dateFormat !== undefined) {
                              let data10 = data.dateFormat;
                              const _errs21 = errors;
                              if (typeof data10 !== 'string') {
                                validate12.errors = [
                                  {
                                    instancePath: instancePath + '/dateFormat',
                                    schemaPath:
                                      'Field.json#/definitions/JSDateFormat/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              if (
                                !(
                                  data10 === 'default' ||
                                  data10 === 'MM / DD / YYYY' ||
                                  data10 === 'MM - DD - YYYY' ||
                                  data10 === 'DD / MM / YYYY' ||
                                  data10 === 'DD - MM - YYYY' ||
                                  data10 === 'YYYY / MM / DD' ||
                                  data10 === 'YYYY - MM - DD'
                                )
                              ) {
                                validate12.errors = [
                                  {
                                    instancePath: instancePath + '/dateFormat',
                                    schemaPath:
                                      'Field.json#/definitions/JSDateFormat/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema34.enum },
                                    message:
                                      'must be equal to one of the allowed values',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs21 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.features !== undefined) {
                                let data11 = data.features;
                                const _errs24 = errors;
                                if (errors === _errs24) {
                                  if (Array.isArray(data11)) {
                                    var valid2 = true;
                                    const len0 = data11.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                      const _errs26 = errors;
                                      if (typeof data11[i0] !== 'string') {
                                        validate12.errors = [
                                          {
                                            instancePath:
                                              instancePath + '/features/' + i0,
                                            schemaPath:
                                              '#/properties/features/items/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid2 = _errs26 === errors;
                                      if (!valid2) {
                                        break;
                                      }
                                    }
                                  } else {
                                    validate12.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/features',
                                        schemaPath:
                                          '#/properties/features/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array',
                                      },
                                    ];
                                    return false;
                                  }
                                }
                                var valid0 = _errs24 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.integrationMetadata !== undefined) {
                                  let data13 = data.integrationMetadata;
                                  const _errs28 = errors;
                                  const _errs29 = errors;
                                  if (errors === _errs29) {
                                    if (
                                      data13 &&
                                      typeof data13 == 'object' &&
                                      !Array.isArray(data13)
                                    ) {
                                      if (
                                        data13.associatedObjectId !== undefined
                                      ) {
                                        const _errs31 = errors;
                                        if (
                                          typeof data13.associatedObjectId !==
                                          'string'
                                        ) {
                                          validate12.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/integrationMetadata/associatedObjectId',
                                              schemaPath:
                                                '#/definitions/SignatureRequestIntegrationMetadata/properties/associatedObjectId/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid4 = _errs31 === errors;
                                      } else {
                                        var valid4 = true;
                                      }
                                      if (valid4) {
                                        if (
                                          data13.associatedObjectType !==
                                          undefined
                                        ) {
                                          const _errs33 = errors;
                                          if (
                                            typeof data13.associatedObjectType !==
                                            'string'
                                          ) {
                                            validate12.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/integrationMetadata/associatedObjectType',
                                                schemaPath:
                                                  '#/definitions/SignatureRequestIntegrationMetadata/properties/associatedObjectType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid4 = _errs33 === errors;
                                        } else {
                                          var valid4 = true;
                                        }
                                        if (valid4) {
                                          if (data13.context !== undefined) {
                                            const _errs35 = errors;
                                            if (
                                              typeof data13.context !== 'string'
                                            ) {
                                              validate12.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/integrationMetadata/context',
                                                  schemaPath:
                                                    '#/definitions/SignatureRequestIntegrationMetadata/properties/context/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid4 = _errs35 === errors;
                                          } else {
                                            var valid4 = true;
                                          }
                                          if (valid4) {
                                            if (
                                              data13.showMissingFieldsTooltip !==
                                              undefined
                                            ) {
                                              const _errs37 = errors;
                                              if (
                                                typeof data13.showMissingFieldsTooltip !==
                                                'boolean'
                                              ) {
                                                validate12.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/integrationMetadata/showMissingFieldsTooltip',
                                                    schemaPath:
                                                      '#/definitions/SignatureRequestIntegrationMetadata/properties/showMissingFieldsTooltip/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid4 = _errs37 === errors;
                                            } else {
                                              var valid4 = true;
                                            }
                                          }
                                        }
                                      }
                                    } else {
                                      validate12.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/integrationMetadata',
                                          schemaPath:
                                            '#/definitions/SignatureRequestIntegrationMetadata/type',
                                          keyword: 'type',
                                          params: { type: 'object' },
                                          message: 'must be object',
                                        },
                                      ];
                                      return false;
                                    }
                                  }
                                  var valid0 = _errs28 === errors;
                                } else {
                                  var valid0 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate12.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate12.errors = vErrors;
  return errors === 0;
}
const schema46 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'Flags.json',
  type: 'object',
  title: 'Flags',
  properties: {
    requestType: { $ref: '#/definitions/RequestType' },
    isHelloFax: {
      type: 'boolean',
      description: 'Is this HelloFax (vs HelloSign)?',
    },
    isEditTemplate: {
      type: 'boolean',
      description: 'True if this is coming from a edit template flow',
    },
    isResend: {
      type: 'boolean',
      description: 'True if this is coming from a resend or draft flow',
    },
    integration: { $ref: '#/definitions/Integration' },
    allowExpiresAt: {
      type: 'boolean',
      description: 'True if the expiration field can be shown',
    },
    hasTemplateReuseWarning: {
      type: 'boolean',
      description:
        'True if the underlying template for edit-and-resend has been modified',
    },
    displayDocToTemplateBanner: {
      type: 'boolean',
      description: 'True if subscription is eligible for creating template',
    },
    shouldConvertDocToTemplate: {
      type: 'boolean',
      description: 'True if Doc to template banner checkbox is checked',
    },
    templateConversionCandidateId: {
      type: 'string',
      description: 'Document to Template conversion ID',
    },
    canUseDataValidation: { type: 'boolean' },
    canUseCustomRegexDataValidation: { type: 'boolean' },
    canUseForm: {
      type: 'boolean',
      description: 'Does this subscription have access to create forms',
    },
    isFromFax: {
      type: 'boolean',
      description: 'Indicates whether the request originated on Dropbox Fax',
    },
    disableExternalSignature: { type: 'boolean' },
    isApiUser: {
      type: 'boolean',
      description:
        'Indicates whether the user has an api plan or access to api',
    },
  },
  required: ['requestType'],
  definitions: {
    RequestType: {
      type: 'integer',
      title: 'RequestType',
      enum: [1, 2, 3, 4, 5, 7, 8, 9, 10, 11, 12, 13, 14],
      tsEnumNames: [
        'SendDoc',
        'RequestSig',
        'ResponseSig',
        'Template',
        'SendTemplate',
        'Demo',
        'FinalizeDocGmail',
        'ReusableLink',
        'SelfSave',
        'EmbeddedRequest',
        'EmbeddedTemplate',
        'BulkSend',
        'EditAndResendDoc',
      ],
      'x-enum-names': [
        'SendDoc',
        'RequestSig',
        'ResponseSig',
        'Template',
        'SendTemplate',
        'Demo',
        'FinalizeDocGmail',
        'ReusableLink',
        'SelfSave',
        'EmbeddedRequest',
        'EmbeddedTemplate',
        'BulkSend',
        'EditAndResendDoc',
      ],
    },
    Integration: {
      type: 'object',
      title: 'Integration',
      description:
        'Is third-party (or Dropbox) integration enabled for this request',
      oneOf: [
        { $ref: '#/definitions/DeepIntegration' },
        { $ref: '#/definitions/SharePointIntegration' },
        { $ref: '#/definitions/HubSpotIntegration' },
        { $ref: '#/definitions/HubSpotV2Integration' },
      ],
    },
    IntegrationData: {
      type: 'object',
      title: 'IntegrationData',
      description: 'Data relevant to integrations',
      properties: {
        externalCacheKey: { type: 'string' },
        externalAppKey: { type: 'string' },
        externalAppPickerSrc: { type: 'string' },
        externalAccountId: { type: 'string' },
        externalFolderPath: { type: 'string' },
        externalFileName: { type: 'string' },
        externalDefaultSavePath: { type: 'string' },
        recipientsProvidedByHostPage: { type: 'boolean' },
      },
      required: ['externalAppKey', 'externalAppPickerSrc'],
    },
    IntegrationNames: {
      type: 'string',
      title: 'IntegrationNames',
      enum: [
        'deepintegration',
        'officeAddInSelfSign',
        'SharePoint',
        'hubspot',
        'hubspotv2',
      ],
      tsEnumNames: [
        'DeepIntegration',
        'OfficeSelfSign',
        'SharePoint',
        'Hubspot',
        'HubspotV2',
      ],
      'x-enum-names': [
        'DeepIntegration',
        'OfficeSelfSign',
        'SharePoint',
        'Hubspot',
        'HubspotV2',
      ],
    },
    DeepIntegration: {
      type: 'object',
      title: 'DeepIntegration',
      properties: {
        name: {
          type: 'string',
          enum: ['deepintegration', 'officeAddInSelfSign'],
        },
        data: { $ref: '#/definitions/IntegrationData' },
      },
    },
    SharePointIntegration: {
      type: 'object',
      title: 'SharePointIntegration',
      properties: {
        name: { const: 'SharePoint', default: 'SharePoint' },
        data: { $ref: '#/definitions/IntegrationData' },
      },
    },
    HubSpotIntegration: {
      type: 'object',
      title: 'HubSpotIntegration',
      properties: {
        name: { const: 'hubspot', default: 'hubspot' },
        data: { $ref: '#/definitions/IntegrationData' },
      },
    },
    HubSpotV2Integration: {
      type: 'object',
      title: 'HubSpotV2Integration',
      properties: {
        name: { const: 'hubspotv2', default: 'hubspotv2' },
        data: { $ref: '#/definitions/IntegrationData' },
      },
    },
  },
};
const schema47 = {
  type: 'integer',
  title: 'RequestType',
  enum: [1, 2, 3, 4, 5, 7, 8, 9, 10, 11, 12, 13, 14],
  tsEnumNames: [
    'SendDoc',
    'RequestSig',
    'ResponseSig',
    'Template',
    'SendTemplate',
    'Demo',
    'FinalizeDocGmail',
    'ReusableLink',
    'SelfSave',
    'EmbeddedRequest',
    'EmbeddedTemplate',
    'BulkSend',
    'EditAndResendDoc',
  ],
  'x-enum-names': [
    'SendDoc',
    'RequestSig',
    'ResponseSig',
    'Template',
    'SendTemplate',
    'Demo',
    'FinalizeDocGmail',
    'ReusableLink',
    'SelfSave',
    'EmbeddedRequest',
    'EmbeddedTemplate',
    'BulkSend',
    'EditAndResendDoc',
  ],
};
const schema48 = {
  type: 'object',
  title: 'Integration',
  description:
    'Is third-party (or Dropbox) integration enabled for this request',
  oneOf: [
    { $ref: '#/definitions/DeepIntegration' },
    { $ref: '#/definitions/SharePointIntegration' },
    { $ref: '#/definitions/HubSpotIntegration' },
    { $ref: '#/definitions/HubSpotV2Integration' },
  ],
};
const schema49 = {
  type: 'object',
  title: 'DeepIntegration',
  properties: {
    name: { type: 'string', enum: ['deepintegration', 'officeAddInSelfSign'] },
    data: { $ref: '#/definitions/IntegrationData' },
  },
};
const schema50 = {
  type: 'object',
  title: 'IntegrationData',
  description: 'Data relevant to integrations',
  properties: {
    externalCacheKey: { type: 'string' },
    externalAppKey: { type: 'string' },
    externalAppPickerSrc: { type: 'string' },
    externalAccountId: { type: 'string' },
    externalFolderPath: { type: 'string' },
    externalFileName: { type: 'string' },
    externalDefaultSavePath: { type: 'string' },
    recipientsProvidedByHostPage: { type: 'boolean' },
  },
  required: ['externalAppKey', 'externalAppPickerSrc'],
};
function validate34(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.name !== undefined) {
        let data0 = data.name;
        const _errs1 = errors;
        if (typeof data0 !== 'string') {
          validate34.errors = [
            {
              instancePath: instancePath + '/name',
              schemaPath: '#/properties/name/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            },
          ];
          return false;
        }
        if (!(data0 === 'deepintegration' || data0 === 'officeAddInSelfSign')) {
          validate34.errors = [
            {
              instancePath: instancePath + '/name',
              schemaPath: '#/properties/name/enum',
              keyword: 'enum',
              params: { allowedValues: schema49.properties.name.enum },
              message: 'must be equal to one of the allowed values',
            },
          ];
          return false;
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.data !== undefined) {
          let data1 = data.data;
          const _errs3 = errors;
          const _errs4 = errors;
          if (errors === _errs4) {
            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
              let missing0;
              if (
                (data1.externalAppKey === undefined &&
                  (missing0 = 'externalAppKey')) ||
                (data1.externalAppPickerSrc === undefined &&
                  (missing0 = 'externalAppPickerSrc'))
              ) {
                validate34.errors = [
                  {
                    instancePath: instancePath + '/data',
                    schemaPath: '#/definitions/IntegrationData/required',
                    keyword: 'required',
                    params: { missingProperty: missing0 },
                    message: "must have required property '" + missing0 + "'",
                  },
                ];
                return false;
              } else {
                if (data1.externalCacheKey !== undefined) {
                  const _errs6 = errors;
                  if (typeof data1.externalCacheKey !== 'string') {
                    validate34.errors = [
                      {
                        instancePath: instancePath + '/data/externalCacheKey',
                        schemaPath:
                          '#/definitions/IntegrationData/properties/externalCacheKey/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid2 = _errs6 === errors;
                } else {
                  var valid2 = true;
                }
                if (valid2) {
                  if (data1.externalAppKey !== undefined) {
                    const _errs8 = errors;
                    if (typeof data1.externalAppKey !== 'string') {
                      validate34.errors = [
                        {
                          instancePath: instancePath + '/data/externalAppKey',
                          schemaPath:
                            '#/definitions/IntegrationData/properties/externalAppKey/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid2 = _errs8 === errors;
                  } else {
                    var valid2 = true;
                  }
                  if (valid2) {
                    if (data1.externalAppPickerSrc !== undefined) {
                      const _errs10 = errors;
                      if (typeof data1.externalAppPickerSrc !== 'string') {
                        validate34.errors = [
                          {
                            instancePath:
                              instancePath + '/data/externalAppPickerSrc',
                            schemaPath:
                              '#/definitions/IntegrationData/properties/externalAppPickerSrc/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs10 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data1.externalAccountId !== undefined) {
                        const _errs12 = errors;
                        if (typeof data1.externalAccountId !== 'string') {
                          validate34.errors = [
                            {
                              instancePath:
                                instancePath + '/data/externalAccountId',
                              schemaPath:
                                '#/definitions/IntegrationData/properties/externalAccountId/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid2 = _errs12 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data1.externalFolderPath !== undefined) {
                          const _errs14 = errors;
                          if (typeof data1.externalFolderPath !== 'string') {
                            validate34.errors = [
                              {
                                instancePath:
                                  instancePath + '/data/externalFolderPath',
                                schemaPath:
                                  '#/definitions/IntegrationData/properties/externalFolderPath/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid2 = _errs14 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data1.externalFileName !== undefined) {
                            const _errs16 = errors;
                            if (typeof data1.externalFileName !== 'string') {
                              validate34.errors = [
                                {
                                  instancePath:
                                    instancePath + '/data/externalFileName',
                                  schemaPath:
                                    '#/definitions/IntegrationData/properties/externalFileName/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid2 = _errs16 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data1.externalDefaultSavePath !== undefined) {
                              const _errs18 = errors;
                              if (
                                typeof data1.externalDefaultSavePath !==
                                'string'
                              ) {
                                validate34.errors = [
                                  {
                                    instancePath:
                                      instancePath +
                                      '/data/externalDefaultSavePath',
                                    schemaPath:
                                      '#/definitions/IntegrationData/properties/externalDefaultSavePath/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid2 = _errs18 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (
                                data1.recipientsProvidedByHostPage !== undefined
                              ) {
                                const _errs20 = errors;
                                if (
                                  typeof data1.recipientsProvidedByHostPage !==
                                  'boolean'
                                ) {
                                  validate34.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/data/recipientsProvidedByHostPage',
                                      schemaPath:
                                        '#/definitions/IntegrationData/properties/recipientsProvidedByHostPage/type',
                                      keyword: 'type',
                                      params: { type: 'boolean' },
                                      message: 'must be boolean',
                                    },
                                  ];
                                  return false;
                                }
                                var valid2 = _errs20 === errors;
                              } else {
                                var valid2 = true;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            } else {
              validate34.errors = [
                {
                  instancePath: instancePath + '/data',
                  schemaPath: '#/definitions/IntegrationData/type',
                  keyword: 'type',
                  params: { type: 'object' },
                  message: 'must be object',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs3 === errors;
        } else {
          var valid0 = true;
        }
      }
    } else {
      validate34.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate34.errors = vErrors;
  return errors === 0;
}
const schema51 = {
  type: 'object',
  title: 'SharePointIntegration',
  properties: {
    name: { const: 'SharePoint', default: 'SharePoint' },
    data: { $ref: '#/definitions/IntegrationData' },
  },
};
function validate36(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.name !== undefined) {
        const _errs1 = errors;
        if (!func0(data.name, 'SharePoint')) {
          validate36.errors = [
            {
              instancePath: instancePath + '/name',
              schemaPath: '#/properties/name/const',
              keyword: 'const',
              params: { allowedValue: 'SharePoint' },
              message: 'must be equal to constant',
            },
          ];
          return false;
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.data !== undefined) {
          let data1 = data.data;
          const _errs2 = errors;
          const _errs3 = errors;
          if (errors === _errs3) {
            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
              let missing0;
              if (
                (data1.externalAppKey === undefined &&
                  (missing0 = 'externalAppKey')) ||
                (data1.externalAppPickerSrc === undefined &&
                  (missing0 = 'externalAppPickerSrc'))
              ) {
                validate36.errors = [
                  {
                    instancePath: instancePath + '/data',
                    schemaPath: '#/definitions/IntegrationData/required',
                    keyword: 'required',
                    params: { missingProperty: missing0 },
                    message: "must have required property '" + missing0 + "'",
                  },
                ];
                return false;
              } else {
                if (data1.externalCacheKey !== undefined) {
                  const _errs5 = errors;
                  if (typeof data1.externalCacheKey !== 'string') {
                    validate36.errors = [
                      {
                        instancePath: instancePath + '/data/externalCacheKey',
                        schemaPath:
                          '#/definitions/IntegrationData/properties/externalCacheKey/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid2 = _errs5 === errors;
                } else {
                  var valid2 = true;
                }
                if (valid2) {
                  if (data1.externalAppKey !== undefined) {
                    const _errs7 = errors;
                    if (typeof data1.externalAppKey !== 'string') {
                      validate36.errors = [
                        {
                          instancePath: instancePath + '/data/externalAppKey',
                          schemaPath:
                            '#/definitions/IntegrationData/properties/externalAppKey/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid2 = _errs7 === errors;
                  } else {
                    var valid2 = true;
                  }
                  if (valid2) {
                    if (data1.externalAppPickerSrc !== undefined) {
                      const _errs9 = errors;
                      if (typeof data1.externalAppPickerSrc !== 'string') {
                        validate36.errors = [
                          {
                            instancePath:
                              instancePath + '/data/externalAppPickerSrc',
                            schemaPath:
                              '#/definitions/IntegrationData/properties/externalAppPickerSrc/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs9 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data1.externalAccountId !== undefined) {
                        const _errs11 = errors;
                        if (typeof data1.externalAccountId !== 'string') {
                          validate36.errors = [
                            {
                              instancePath:
                                instancePath + '/data/externalAccountId',
                              schemaPath:
                                '#/definitions/IntegrationData/properties/externalAccountId/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid2 = _errs11 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data1.externalFolderPath !== undefined) {
                          const _errs13 = errors;
                          if (typeof data1.externalFolderPath !== 'string') {
                            validate36.errors = [
                              {
                                instancePath:
                                  instancePath + '/data/externalFolderPath',
                                schemaPath:
                                  '#/definitions/IntegrationData/properties/externalFolderPath/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid2 = _errs13 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data1.externalFileName !== undefined) {
                            const _errs15 = errors;
                            if (typeof data1.externalFileName !== 'string') {
                              validate36.errors = [
                                {
                                  instancePath:
                                    instancePath + '/data/externalFileName',
                                  schemaPath:
                                    '#/definitions/IntegrationData/properties/externalFileName/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid2 = _errs15 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data1.externalDefaultSavePath !== undefined) {
                              const _errs17 = errors;
                              if (
                                typeof data1.externalDefaultSavePath !==
                                'string'
                              ) {
                                validate36.errors = [
                                  {
                                    instancePath:
                                      instancePath +
                                      '/data/externalDefaultSavePath',
                                    schemaPath:
                                      '#/definitions/IntegrationData/properties/externalDefaultSavePath/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid2 = _errs17 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (
                                data1.recipientsProvidedByHostPage !== undefined
                              ) {
                                const _errs19 = errors;
                                if (
                                  typeof data1.recipientsProvidedByHostPage !==
                                  'boolean'
                                ) {
                                  validate36.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/data/recipientsProvidedByHostPage',
                                      schemaPath:
                                        '#/definitions/IntegrationData/properties/recipientsProvidedByHostPage/type',
                                      keyword: 'type',
                                      params: { type: 'boolean' },
                                      message: 'must be boolean',
                                    },
                                  ];
                                  return false;
                                }
                                var valid2 = _errs19 === errors;
                              } else {
                                var valid2 = true;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            } else {
              validate36.errors = [
                {
                  instancePath: instancePath + '/data',
                  schemaPath: '#/definitions/IntegrationData/type',
                  keyword: 'type',
                  params: { type: 'object' },
                  message: 'must be object',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs2 === errors;
        } else {
          var valid0 = true;
        }
      }
    } else {
      validate36.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate36.errors = vErrors;
  return errors === 0;
}
const schema53 = {
  type: 'object',
  title: 'HubSpotIntegration',
  properties: {
    name: { const: 'hubspot', default: 'hubspot' },
    data: { $ref: '#/definitions/IntegrationData' },
  },
};
function validate38(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.name !== undefined) {
        const _errs1 = errors;
        if (!func0(data.name, 'hubspot')) {
          validate38.errors = [
            {
              instancePath: instancePath + '/name',
              schemaPath: '#/properties/name/const',
              keyword: 'const',
              params: { allowedValue: 'hubspot' },
              message: 'must be equal to constant',
            },
          ];
          return false;
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.data !== undefined) {
          let data1 = data.data;
          const _errs2 = errors;
          const _errs3 = errors;
          if (errors === _errs3) {
            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
              let missing0;
              if (
                (data1.externalAppKey === undefined &&
                  (missing0 = 'externalAppKey')) ||
                (data1.externalAppPickerSrc === undefined &&
                  (missing0 = 'externalAppPickerSrc'))
              ) {
                validate38.errors = [
                  {
                    instancePath: instancePath + '/data',
                    schemaPath: '#/definitions/IntegrationData/required',
                    keyword: 'required',
                    params: { missingProperty: missing0 },
                    message: "must have required property '" + missing0 + "'",
                  },
                ];
                return false;
              } else {
                if (data1.externalCacheKey !== undefined) {
                  const _errs5 = errors;
                  if (typeof data1.externalCacheKey !== 'string') {
                    validate38.errors = [
                      {
                        instancePath: instancePath + '/data/externalCacheKey',
                        schemaPath:
                          '#/definitions/IntegrationData/properties/externalCacheKey/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid2 = _errs5 === errors;
                } else {
                  var valid2 = true;
                }
                if (valid2) {
                  if (data1.externalAppKey !== undefined) {
                    const _errs7 = errors;
                    if (typeof data1.externalAppKey !== 'string') {
                      validate38.errors = [
                        {
                          instancePath: instancePath + '/data/externalAppKey',
                          schemaPath:
                            '#/definitions/IntegrationData/properties/externalAppKey/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid2 = _errs7 === errors;
                  } else {
                    var valid2 = true;
                  }
                  if (valid2) {
                    if (data1.externalAppPickerSrc !== undefined) {
                      const _errs9 = errors;
                      if (typeof data1.externalAppPickerSrc !== 'string') {
                        validate38.errors = [
                          {
                            instancePath:
                              instancePath + '/data/externalAppPickerSrc',
                            schemaPath:
                              '#/definitions/IntegrationData/properties/externalAppPickerSrc/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs9 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data1.externalAccountId !== undefined) {
                        const _errs11 = errors;
                        if (typeof data1.externalAccountId !== 'string') {
                          validate38.errors = [
                            {
                              instancePath:
                                instancePath + '/data/externalAccountId',
                              schemaPath:
                                '#/definitions/IntegrationData/properties/externalAccountId/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid2 = _errs11 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data1.externalFolderPath !== undefined) {
                          const _errs13 = errors;
                          if (typeof data1.externalFolderPath !== 'string') {
                            validate38.errors = [
                              {
                                instancePath:
                                  instancePath + '/data/externalFolderPath',
                                schemaPath:
                                  '#/definitions/IntegrationData/properties/externalFolderPath/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid2 = _errs13 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data1.externalFileName !== undefined) {
                            const _errs15 = errors;
                            if (typeof data1.externalFileName !== 'string') {
                              validate38.errors = [
                                {
                                  instancePath:
                                    instancePath + '/data/externalFileName',
                                  schemaPath:
                                    '#/definitions/IntegrationData/properties/externalFileName/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid2 = _errs15 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data1.externalDefaultSavePath !== undefined) {
                              const _errs17 = errors;
                              if (
                                typeof data1.externalDefaultSavePath !==
                                'string'
                              ) {
                                validate38.errors = [
                                  {
                                    instancePath:
                                      instancePath +
                                      '/data/externalDefaultSavePath',
                                    schemaPath:
                                      '#/definitions/IntegrationData/properties/externalDefaultSavePath/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid2 = _errs17 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (
                                data1.recipientsProvidedByHostPage !== undefined
                              ) {
                                const _errs19 = errors;
                                if (
                                  typeof data1.recipientsProvidedByHostPage !==
                                  'boolean'
                                ) {
                                  validate38.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/data/recipientsProvidedByHostPage',
                                      schemaPath:
                                        '#/definitions/IntegrationData/properties/recipientsProvidedByHostPage/type',
                                      keyword: 'type',
                                      params: { type: 'boolean' },
                                      message: 'must be boolean',
                                    },
                                  ];
                                  return false;
                                }
                                var valid2 = _errs19 === errors;
                              } else {
                                var valid2 = true;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            } else {
              validate38.errors = [
                {
                  instancePath: instancePath + '/data',
                  schemaPath: '#/definitions/IntegrationData/type',
                  keyword: 'type',
                  params: { type: 'object' },
                  message: 'must be object',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs2 === errors;
        } else {
          var valid0 = true;
        }
      }
    } else {
      validate38.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate38.errors = vErrors;
  return errors === 0;
}
const schema55 = {
  type: 'object',
  title: 'HubSpotV2Integration',
  properties: {
    name: { const: 'hubspotv2', default: 'hubspotv2' },
    data: { $ref: '#/definitions/IntegrationData' },
  },
};
function validate40(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.name !== undefined) {
        const _errs1 = errors;
        if (!func0(data.name, 'hubspotv2')) {
          validate40.errors = [
            {
              instancePath: instancePath + '/name',
              schemaPath: '#/properties/name/const',
              keyword: 'const',
              params: { allowedValue: 'hubspotv2' },
              message: 'must be equal to constant',
            },
          ];
          return false;
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.data !== undefined) {
          let data1 = data.data;
          const _errs2 = errors;
          const _errs3 = errors;
          if (errors === _errs3) {
            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
              let missing0;
              if (
                (data1.externalAppKey === undefined &&
                  (missing0 = 'externalAppKey')) ||
                (data1.externalAppPickerSrc === undefined &&
                  (missing0 = 'externalAppPickerSrc'))
              ) {
                validate40.errors = [
                  {
                    instancePath: instancePath + '/data',
                    schemaPath: '#/definitions/IntegrationData/required',
                    keyword: 'required',
                    params: { missingProperty: missing0 },
                    message: "must have required property '" + missing0 + "'",
                  },
                ];
                return false;
              } else {
                if (data1.externalCacheKey !== undefined) {
                  const _errs5 = errors;
                  if (typeof data1.externalCacheKey !== 'string') {
                    validate40.errors = [
                      {
                        instancePath: instancePath + '/data/externalCacheKey',
                        schemaPath:
                          '#/definitions/IntegrationData/properties/externalCacheKey/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid2 = _errs5 === errors;
                } else {
                  var valid2 = true;
                }
                if (valid2) {
                  if (data1.externalAppKey !== undefined) {
                    const _errs7 = errors;
                    if (typeof data1.externalAppKey !== 'string') {
                      validate40.errors = [
                        {
                          instancePath: instancePath + '/data/externalAppKey',
                          schemaPath:
                            '#/definitions/IntegrationData/properties/externalAppKey/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid2 = _errs7 === errors;
                  } else {
                    var valid2 = true;
                  }
                  if (valid2) {
                    if (data1.externalAppPickerSrc !== undefined) {
                      const _errs9 = errors;
                      if (typeof data1.externalAppPickerSrc !== 'string') {
                        validate40.errors = [
                          {
                            instancePath:
                              instancePath + '/data/externalAppPickerSrc',
                            schemaPath:
                              '#/definitions/IntegrationData/properties/externalAppPickerSrc/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs9 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data1.externalAccountId !== undefined) {
                        const _errs11 = errors;
                        if (typeof data1.externalAccountId !== 'string') {
                          validate40.errors = [
                            {
                              instancePath:
                                instancePath + '/data/externalAccountId',
                              schemaPath:
                                '#/definitions/IntegrationData/properties/externalAccountId/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid2 = _errs11 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data1.externalFolderPath !== undefined) {
                          const _errs13 = errors;
                          if (typeof data1.externalFolderPath !== 'string') {
                            validate40.errors = [
                              {
                                instancePath:
                                  instancePath + '/data/externalFolderPath',
                                schemaPath:
                                  '#/definitions/IntegrationData/properties/externalFolderPath/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid2 = _errs13 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data1.externalFileName !== undefined) {
                            const _errs15 = errors;
                            if (typeof data1.externalFileName !== 'string') {
                              validate40.errors = [
                                {
                                  instancePath:
                                    instancePath + '/data/externalFileName',
                                  schemaPath:
                                    '#/definitions/IntegrationData/properties/externalFileName/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid2 = _errs15 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data1.externalDefaultSavePath !== undefined) {
                              const _errs17 = errors;
                              if (
                                typeof data1.externalDefaultSavePath !==
                                'string'
                              ) {
                                validate40.errors = [
                                  {
                                    instancePath:
                                      instancePath +
                                      '/data/externalDefaultSavePath',
                                    schemaPath:
                                      '#/definitions/IntegrationData/properties/externalDefaultSavePath/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid2 = _errs17 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (
                                data1.recipientsProvidedByHostPage !== undefined
                              ) {
                                const _errs19 = errors;
                                if (
                                  typeof data1.recipientsProvidedByHostPage !==
                                  'boolean'
                                ) {
                                  validate40.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/data/recipientsProvidedByHostPage',
                                      schemaPath:
                                        '#/definitions/IntegrationData/properties/recipientsProvidedByHostPage/type',
                                      keyword: 'type',
                                      params: { type: 'boolean' },
                                      message: 'must be boolean',
                                    },
                                  ];
                                  return false;
                                }
                                var valid2 = _errs19 === errors;
                              } else {
                                var valid2 = true;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            } else {
              validate40.errors = [
                {
                  instancePath: instancePath + '/data',
                  schemaPath: '#/definitions/IntegrationData/type',
                  keyword: 'type',
                  params: { type: 'object' },
                  message: 'must be object',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs2 === errors;
        } else {
          var valid0 = true;
        }
      }
    } else {
      validate40.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate40.errors = vErrors;
  return errors === 0;
}
function validate33(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == 'object' && !Array.isArray(data))) {
    validate33.errors = [
      {
        instancePath,
        schemaPath: '#/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      },
    ];
    return false;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (
    !validate34(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
    })
  ) {
    vErrors =
      vErrors === null ? validate34.errors : vErrors.concat(validate34.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs3 = errors;
  if (
    !validate36(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
    })
  ) {
    vErrors =
      vErrors === null ? validate36.errors : vErrors.concat(validate36.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs3 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs4 = errors;
    if (
      !validate38(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
      })
    ) {
      vErrors =
        vErrors === null
          ? validate38.errors
          : vErrors.concat(validate38.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs4 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
      const _errs5 = errors;
      if (
        !validate40(data, {
          instancePath,
          parentData,
          parentDataProperty,
          rootData,
        })
      ) {
        vErrors =
          vErrors === null
            ? validate40.errors
            : vErrors.concat(validate40.errors);
        errors = vErrors.length;
      }
      var _valid0 = _errs5 === errors;
      if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [passing0, 3];
      } else {
        if (_valid0) {
          valid0 = true;
          passing0 = 3;
        }
      }
    }
  }
  if (!valid0) {
    const err0 = {
      instancePath,
      schemaPath: '#/oneOf',
      keyword: 'oneOf',
      params: { passingSchemas: passing0 },
      message: 'must match exactly one schema in oneOf',
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
    validate33.errors = vErrors;
    return false;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate33.errors = vErrors;
  return errors === 0;
}
function validate32(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="Flags.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (data.requestType === undefined && (missing0 = 'requestType')) {
        validate32.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.requestType !== undefined) {
          let data0 = data.requestType;
          const _errs1 = errors;
          if (
            !(
              typeof data0 == 'number' &&
              !(data0 % 1) &&
              !isNaN(data0) &&
              isFinite(data0)
            )
          ) {
            validate32.errors = [
              {
                instancePath: instancePath + '/requestType',
                schemaPath: '#/definitions/RequestType/type',
                keyword: 'type',
                params: { type: 'integer' },
                message: 'must be integer',
              },
            ];
            return false;
          }
          if (
            !(
              data0 === 1 ||
              data0 === 2 ||
              data0 === 3 ||
              data0 === 4 ||
              data0 === 5 ||
              data0 === 7 ||
              data0 === 8 ||
              data0 === 9 ||
              data0 === 10 ||
              data0 === 11 ||
              data0 === 12 ||
              data0 === 13 ||
              data0 === 14
            )
          ) {
            validate32.errors = [
              {
                instancePath: instancePath + '/requestType',
                schemaPath: '#/definitions/RequestType/enum',
                keyword: 'enum',
                params: { allowedValues: schema47.enum },
                message: 'must be equal to one of the allowed values',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.isHelloFax !== undefined) {
            const _errs4 = errors;
            if (typeof data.isHelloFax !== 'boolean') {
              validate32.errors = [
                {
                  instancePath: instancePath + '/isHelloFax',
                  schemaPath: '#/properties/isHelloFax/type',
                  keyword: 'type',
                  params: { type: 'boolean' },
                  message: 'must be boolean',
                },
              ];
              return false;
            }
            var valid0 = _errs4 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.isEditTemplate !== undefined) {
              const _errs6 = errors;
              if (typeof data.isEditTemplate !== 'boolean') {
                validate32.errors = [
                  {
                    instancePath: instancePath + '/isEditTemplate',
                    schemaPath: '#/properties/isEditTemplate/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  },
                ];
                return false;
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.isResend !== undefined) {
                const _errs8 = errors;
                if (typeof data.isResend !== 'boolean') {
                  validate32.errors = [
                    {
                      instancePath: instancePath + '/isResend',
                      schemaPath: '#/properties/isResend/type',
                      keyword: 'type',
                      params: { type: 'boolean' },
                      message: 'must be boolean',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.integration !== undefined) {
                  const _errs10 = errors;
                  if (
                    !validate33(data.integration, {
                      instancePath: instancePath + '/integration',
                      parentData: data,
                      parentDataProperty: 'integration',
                      rootData,
                    })
                  ) {
                    vErrors =
                      vErrors === null
                        ? validate33.errors
                        : vErrors.concat(validate33.errors);
                    errors = vErrors.length;
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.allowExpiresAt !== undefined) {
                    const _errs11 = errors;
                    if (typeof data.allowExpiresAt !== 'boolean') {
                      validate32.errors = [
                        {
                          instancePath: instancePath + '/allowExpiresAt',
                          schemaPath: '#/properties/allowExpiresAt/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.hasTemplateReuseWarning !== undefined) {
                      const _errs13 = errors;
                      if (typeof data.hasTemplateReuseWarning !== 'boolean') {
                        validate32.errors = [
                          {
                            instancePath:
                              instancePath + '/hasTemplateReuseWarning',
                            schemaPath:
                              '#/properties/hasTemplateReuseWarning/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.displayDocToTemplateBanner !== undefined) {
                        const _errs15 = errors;
                        if (
                          typeof data.displayDocToTemplateBanner !== 'boolean'
                        ) {
                          validate32.errors = [
                            {
                              instancePath:
                                instancePath + '/displayDocToTemplateBanner',
                              schemaPath:
                                '#/properties/displayDocToTemplateBanner/type',
                              keyword: 'type',
                              params: { type: 'boolean' },
                              message: 'must be boolean',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.shouldConvertDocToTemplate !== undefined) {
                          const _errs17 = errors;
                          if (
                            typeof data.shouldConvertDocToTemplate !== 'boolean'
                          ) {
                            validate32.errors = [
                              {
                                instancePath:
                                  instancePath + '/shouldConvertDocToTemplate',
                                schemaPath:
                                  '#/properties/shouldConvertDocToTemplate/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs17 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (
                            data.templateConversionCandidateId !== undefined
                          ) {
                            const _errs19 = errors;
                            if (
                              typeof data.templateConversionCandidateId !==
                              'string'
                            ) {
                              validate32.errors = [
                                {
                                  instancePath:
                                    instancePath +
                                    '/templateConversionCandidateId',
                                  schemaPath:
                                    '#/properties/templateConversionCandidateId/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs19 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.canUseDataValidation !== undefined) {
                              const _errs21 = errors;
                              if (
                                typeof data.canUseDataValidation !== 'boolean'
                              ) {
                                validate32.errors = [
                                  {
                                    instancePath:
                                      instancePath + '/canUseDataValidation',
                                    schemaPath:
                                      '#/properties/canUseDataValidation/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs21 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (
                                data.canUseCustomRegexDataValidation !==
                                undefined
                              ) {
                                const _errs23 = errors;
                                if (
                                  typeof data.canUseCustomRegexDataValidation !==
                                  'boolean'
                                ) {
                                  validate32.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/canUseCustomRegexDataValidation',
                                      schemaPath:
                                        '#/properties/canUseCustomRegexDataValidation/type',
                                      keyword: 'type',
                                      params: { type: 'boolean' },
                                      message: 'must be boolean',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs23 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.canUseForm !== undefined) {
                                  const _errs25 = errors;
                                  if (typeof data.canUseForm !== 'boolean') {
                                    validate32.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/canUseForm',
                                        schemaPath:
                                          '#/properties/canUseForm/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs25 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.isFromFax !== undefined) {
                                    const _errs27 = errors;
                                    if (typeof data.isFromFax !== 'boolean') {
                                      validate32.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/isFromFax',
                                          schemaPath:
                                            '#/properties/isFromFax/type',
                                          keyword: 'type',
                                          params: { type: 'boolean' },
                                          message: 'must be boolean',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid0 = _errs27 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (
                                      data.disableExternalSignature !==
                                      undefined
                                    ) {
                                      const _errs29 = errors;
                                      if (
                                        typeof data.disableExternalSignature !==
                                        'boolean'
                                      ) {
                                        validate32.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/disableExternalSignature',
                                            schemaPath:
                                              '#/properties/disableExternalSignature/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid0 = _errs29 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.isApiUser !== undefined) {
                                        const _errs31 = errors;
                                        if (
                                          typeof data.isApiUser !== 'boolean'
                                        ) {
                                          validate32.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/isApiUser',
                                              schemaPath:
                                                '#/properties/isApiUser/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid0 = _errs31 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate32.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate32.errors = vErrors;
  return errors === 0;
}
const schema57 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'AccountSettings.json',
  type: 'object',
  title: 'AccountSettings',
  properties: {
    allowIntegrationsUpload: {
      type: 'boolean',
      description:
        "Allow user to select a file from third-party website on 'Select documents' page",
    },
    allowRecipientAccessCodes: {
      type: 'boolean',
      description:
        'Ability to add signer pin per signer as part of the signature request',
    },
    allowRecipientSmsAuthNumbers: {
      type: 'boolean',
      description:
        'Ability to add signer SMS authentication per signer as part of the signature request',
    },
    allowRecipientAttachments: {
      type: 'boolean',
      description:
        'Ability to require signers to attach (both required or optional) attachments as part of their signing process',
    },
    allowRecipientReassignment: {
      type: 'boolean',
      description:
        "Allow recipient reassignment checkbox on 'Add signers' page",
    },
    allowQualifiedSignature: {
      type: 'boolean',
      description:
        'Should this user be given the ability to send Qualified E-Signatures',
    },
    allowNom151: {
      type: 'boolean',
      description: 'Allow user to enable NOM 151 for the request',
    },
    allowSmsSignatureDelivery: {
      type: 'boolean',
      description:
        'The SMS tools add-on has been purchased and this account has permission to use it',
    },
    allowTemplateDelete: {
      type: 'boolean',
      description: 'Allow template deletion from P&S workflow',
    },
    allowCreateEditTemplate: {
      type: 'boolean',
      description:
        'True if the current account has permission to create/edit templates',
    },
    allowTemplatePreview: {
      type: 'boolean',
      description:
        'True if the current account has the ability to preview templates',
    },
    allowOptionalTemplateSigners: {
      type: 'boolean',
      description:
        'Allow template signature requests to have optional signers if at least one signer is populated.',
    },
    allowSmsAuth: { type: 'boolean', description: 'Allow SMS authentication' },
    smsAuthLeft: {
      type: 'number',
      description:
        'The amount of sms authentication requests the account has left',
    },
    allowBulkSend: { type: 'boolean', description: 'Allow bulk send' },
    canAccessRecipientAccessCodes: {
      type: 'boolean',
      description:
        'Has a non-Enterprise+ plan that can use recipient access codes regardless of setting',
    },
    canUpgradeTierSmsSignatureDelivery: {
      type: 'boolean',
      description:
        "User's add-on tier for SMS Signature Delivery can be auto-upgraded",
    },
    noMultiFaxes: {
      type: 'boolean',
      description:
        'Is the account prevented from sending faxes to multiple recipients',
    },
    maxTemplateNumber: {
      type: 'number',
      description: 'User subscription template quota',
    },
    isAtTemplateLimit: {
      type: 'boolean',
      description:
        "Is user at their account-type's limit for creating templates?",
    },
    isAtDocumentLimit: {
      type: 'boolean',
      description:
        "Is user at their account-type's limit for sending signature request?",
    },
    hasHIPAA: {
      type: 'boolean',
      description: "Does the user's subsription have the HIPAA tag?",
    },
    isNewHsPlan: {
      type: 'boolean',
      description: 'Is the plan in context a Blueberry plan?',
    },
    isTransactionalPlan: {
      type: 'boolean',
      description: 'Is the plan in context a transactional plan?',
    },
    alwaysSendMeACopy: {
      type: 'boolean',
      description: 'User wants a copy of PDF/Fax sent to themselves',
    },
    alwaysSendOthersACopy: {
      type: 'boolean',
      description:
        'User wants a copy of complete/faxed PDF sent to recipients and CCs',
    },
    needsCharge: {
      type: 'boolean',
      description: 'True if the fax request needs a one-time charge',
    },
    chargeType: {
      type: 'string',
      description: 'Which charge flow the user needs to see',
    },
    totalPriceInCents: {
      type: 'number',
      description: 'The total price of the charge in cents',
    },
    freeFaxPagesLeft: {
      type: 'number',
      description: 'The amount of free faxes the account has left',
    },
    faxPageCurrentCount: {
      type: 'number',
      description: 'The amount of fax pages in the current request',
    },
    overageFaxMaxLimitInCents: {
      type: 'number',
      description: 'The maximum fax price users can send in a free account',
    },
    pricePerFaxInCents: {
      type: 'number',
      description: "The normal price for a fax on the account's subscription",
    },
    initialPageLimit: {
      type: 'number',
      description: 'How many pages until you are over the initial pricePerFax',
    },
    overagePriceInCentsPerPage: {
      type: 'number',
      description: 'How much each page costs after your initial limit',
    },
    internationalMultiplier: {
      type: 'number',
      description:
        'How much the price of a page multiplies based on the receiving country',
    },
    uploadIntegrations: { $ref: '#/definitions/UploadIntegrations' },
    isSMSToolsOn: {
      type: 'boolean',
      description:
        'The SMS tools add-on has been purchased AND its setting is turned on via Admin Console',
    },
  },
  required: ['allowTemplateDelete', 'uploadIntegrations', 'smsAuthLeft'],
  definitions: {
    UploadIntegrationType: {
      type: 'string',
      title: 'UploadIntegrationType',
      enum: ['B', 'D', 'E', 'G', 'T'],
    },
    DropboxIntegration: {
      type: 'object',
      title: 'DropboxIntegration',
      properties: {
        id: { const: 'D', default: 'D' },
        key: { type: 'string' },
        nonce: { type: 'string' },
        enabled: { type: 'boolean' },
      },
      required: ['id', 'key', 'nonce', 'enabled'],
    },
    OneDriveIntegration: {
      type: 'object',
      title: 'OneDriveIntegration',
      properties: {
        id: { const: 'T', default: 'T' },
        token: { type: 'string' },
        clientId: { type: 'string' },
        nonce: { type: 'string' },
        enabled: { type: 'boolean' },
      },
      required: ['id', 'clientId', 'nonce', 'enabled'],
    },
    GoogleDriveIntegration: {
      type: 'object',
      title: 'GoogleDriveIntegration',
      properties: {
        id: { const: 'G', default: 'G' },
        key: { type: 'string' },
        token: { type: 'string' },
        abbrKey: { type: 'string' },
        enabled: { type: 'boolean' },
        loginHint: { type: 'string' },
      },
      required: ['id', 'key', 'abbrKey', 'enabled'],
    },
    BoxIntegration: {
      type: 'object',
      title: 'BoxIntegration',
      properties: {
        id: { const: 'B', default: 'B' },
        enabled: { type: 'boolean' },
      },
      required: ['id', 'enabled'],
    },
    EvernoteIntegration: {
      type: 'object',
      title: 'EvernoteIntegration',
      properties: {
        id: { const: 'E', default: 'E' },
        enabled: { type: 'boolean' },
      },
      required: ['id', 'enabled'],
    },
    UploadIntegrations: {
      type: 'object',
      title: 'UploadIntegrations',
      properties: {
        D: { $ref: '#/definitions/DropboxIntegration' },
        T: { $ref: '#/definitions/OneDriveIntegration' },
        G: { $ref: '#/definitions/GoogleDriveIntegration' },
        B: { $ref: '#/definitions/BoxIntegration' },
        E: { $ref: '#/definitions/EvernoteIntegration' },
      },
    },
    UploadIntegrationOptions: {
      type: 'object',
      title: 'UploadIntegrationOptions',
      oneOf: [
        { $ref: '#/definitions/DropboxIntegration' },
        { $ref: '#/definitions/OneDriveIntegration' },
        { $ref: '#/definitions/GoogleDriveIntegration' },
        { $ref: '#/definitions/BoxIntegration' },
        { $ref: '#/definitions/EvernoteIntegration' },
      ],
    },
  },
};
const schema58 = {
  type: 'object',
  title: 'UploadIntegrations',
  properties: {
    D: { $ref: '#/definitions/DropboxIntegration' },
    T: { $ref: '#/definitions/OneDriveIntegration' },
    G: { $ref: '#/definitions/GoogleDriveIntegration' },
    B: { $ref: '#/definitions/BoxIntegration' },
    E: { $ref: '#/definitions/EvernoteIntegration' },
  },
};
const schema59 = {
  type: 'object',
  title: 'DropboxIntegration',
  properties: {
    id: { const: 'D', default: 'D' },
    key: { type: 'string' },
    nonce: { type: 'string' },
    enabled: { type: 'boolean' },
  },
  required: ['id', 'key', 'nonce', 'enabled'],
};
const schema60 = {
  type: 'object',
  title: 'OneDriveIntegration',
  properties: {
    id: { const: 'T', default: 'T' },
    token: { type: 'string' },
    clientId: { type: 'string' },
    nonce: { type: 'string' },
    enabled: { type: 'boolean' },
  },
  required: ['id', 'clientId', 'nonce', 'enabled'],
};
const schema61 = {
  type: 'object',
  title: 'GoogleDriveIntegration',
  properties: {
    id: { const: 'G', default: 'G' },
    key: { type: 'string' },
    token: { type: 'string' },
    abbrKey: { type: 'string' },
    enabled: { type: 'boolean' },
    loginHint: { type: 'string' },
  },
  required: ['id', 'key', 'abbrKey', 'enabled'],
};
const schema62 = {
  type: 'object',
  title: 'BoxIntegration',
  properties: {
    id: { const: 'B', default: 'B' },
    enabled: { type: 'boolean' },
  },
  required: ['id', 'enabled'],
};
const schema63 = {
  type: 'object',
  title: 'EvernoteIntegration',
  properties: {
    id: { const: 'E', default: 'E' },
    enabled: { type: 'boolean' },
  },
  required: ['id', 'enabled'],
};
function validate45(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.D !== undefined) {
        let data0 = data.D;
        const _errs1 = errors;
        const _errs2 = errors;
        if (errors === _errs2) {
          if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
            let missing0;
            if (
              (data0.id === undefined && (missing0 = 'id')) ||
              (data0.key === undefined && (missing0 = 'key')) ||
              (data0.nonce === undefined && (missing0 = 'nonce')) ||
              (data0.enabled === undefined && (missing0 = 'enabled'))
            ) {
              validate45.errors = [
                {
                  instancePath: instancePath + '/D',
                  schemaPath: '#/definitions/DropboxIntegration/required',
                  keyword: 'required',
                  params: { missingProperty: missing0 },
                  message: "must have required property '" + missing0 + "'",
                },
              ];
              return false;
            } else {
              if (data0.id !== undefined) {
                const _errs4 = errors;
                if (!func0(data0.id, 'D')) {
                  validate45.errors = [
                    {
                      instancePath: instancePath + '/D/id',
                      schemaPath:
                        '#/definitions/DropboxIntegration/properties/id/const',
                      keyword: 'const',
                      params: { allowedValue: 'D' },
                      message: 'must be equal to constant',
                    },
                  ];
                  return false;
                }
                var valid2 = _errs4 === errors;
              } else {
                var valid2 = true;
              }
              if (valid2) {
                if (data0.key !== undefined) {
                  const _errs5 = errors;
                  if (typeof data0.key !== 'string') {
                    validate45.errors = [
                      {
                        instancePath: instancePath + '/D/key',
                        schemaPath:
                          '#/definitions/DropboxIntegration/properties/key/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid2 = _errs5 === errors;
                } else {
                  var valid2 = true;
                }
                if (valid2) {
                  if (data0.nonce !== undefined) {
                    const _errs7 = errors;
                    if (typeof data0.nonce !== 'string') {
                      validate45.errors = [
                        {
                          instancePath: instancePath + '/D/nonce',
                          schemaPath:
                            '#/definitions/DropboxIntegration/properties/nonce/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid2 = _errs7 === errors;
                  } else {
                    var valid2 = true;
                  }
                  if (valid2) {
                    if (data0.enabled !== undefined) {
                      const _errs9 = errors;
                      if (typeof data0.enabled !== 'boolean') {
                        validate45.errors = [
                          {
                            instancePath: instancePath + '/D/enabled',
                            schemaPath:
                              '#/definitions/DropboxIntegration/properties/enabled/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs9 === errors;
                    } else {
                      var valid2 = true;
                    }
                  }
                }
              }
            }
          } else {
            validate45.errors = [
              {
                instancePath: instancePath + '/D',
                schemaPath: '#/definitions/DropboxIntegration/type',
                keyword: 'type',
                params: { type: 'object' },
                message: 'must be object',
              },
            ];
            return false;
          }
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.T !== undefined) {
          let data5 = data.T;
          const _errs11 = errors;
          const _errs12 = errors;
          if (errors === _errs12) {
            if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
              let missing1;
              if (
                (data5.id === undefined && (missing1 = 'id')) ||
                (data5.clientId === undefined && (missing1 = 'clientId')) ||
                (data5.nonce === undefined && (missing1 = 'nonce')) ||
                (data5.enabled === undefined && (missing1 = 'enabled'))
              ) {
                validate45.errors = [
                  {
                    instancePath: instancePath + '/T',
                    schemaPath: '#/definitions/OneDriveIntegration/required',
                    keyword: 'required',
                    params: { missingProperty: missing1 },
                    message: "must have required property '" + missing1 + "'",
                  },
                ];
                return false;
              } else {
                if (data5.id !== undefined) {
                  const _errs14 = errors;
                  if (!func0(data5.id, 'T')) {
                    validate45.errors = [
                      {
                        instancePath: instancePath + '/T/id',
                        schemaPath:
                          '#/definitions/OneDriveIntegration/properties/id/const',
                        keyword: 'const',
                        params: { allowedValue: 'T' },
                        message: 'must be equal to constant',
                      },
                    ];
                    return false;
                  }
                  var valid4 = _errs14 === errors;
                } else {
                  var valid4 = true;
                }
                if (valid4) {
                  if (data5.token !== undefined) {
                    const _errs15 = errors;
                    if (typeof data5.token !== 'string') {
                      validate45.errors = [
                        {
                          instancePath: instancePath + '/T/token',
                          schemaPath:
                            '#/definitions/OneDriveIntegration/properties/token/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid4 = _errs15 === errors;
                  } else {
                    var valid4 = true;
                  }
                  if (valid4) {
                    if (data5.clientId !== undefined) {
                      const _errs17 = errors;
                      if (typeof data5.clientId !== 'string') {
                        validate45.errors = [
                          {
                            instancePath: instancePath + '/T/clientId',
                            schemaPath:
                              '#/definitions/OneDriveIntegration/properties/clientId/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid4 = _errs17 === errors;
                    } else {
                      var valid4 = true;
                    }
                    if (valid4) {
                      if (data5.nonce !== undefined) {
                        const _errs19 = errors;
                        if (typeof data5.nonce !== 'string') {
                          validate45.errors = [
                            {
                              instancePath: instancePath + '/T/nonce',
                              schemaPath:
                                '#/definitions/OneDriveIntegration/properties/nonce/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid4 = _errs19 === errors;
                      } else {
                        var valid4 = true;
                      }
                      if (valid4) {
                        if (data5.enabled !== undefined) {
                          const _errs21 = errors;
                          if (typeof data5.enabled !== 'boolean') {
                            validate45.errors = [
                              {
                                instancePath: instancePath + '/T/enabled',
                                schemaPath:
                                  '#/definitions/OneDriveIntegration/properties/enabled/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid4 = _errs21 === errors;
                        } else {
                          var valid4 = true;
                        }
                      }
                    }
                  }
                }
              }
            } else {
              validate45.errors = [
                {
                  instancePath: instancePath + '/T',
                  schemaPath: '#/definitions/OneDriveIntegration/type',
                  keyword: 'type',
                  params: { type: 'object' },
                  message: 'must be object',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs11 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.G !== undefined) {
            let data11 = data.G;
            const _errs23 = errors;
            const _errs24 = errors;
            if (errors === _errs24) {
              if (
                data11 &&
                typeof data11 == 'object' &&
                !Array.isArray(data11)
              ) {
                let missing2;
                if (
                  (data11.id === undefined && (missing2 = 'id')) ||
                  (data11.key === undefined && (missing2 = 'key')) ||
                  (data11.abbrKey === undefined && (missing2 = 'abbrKey')) ||
                  (data11.enabled === undefined && (missing2 = 'enabled'))
                ) {
                  validate45.errors = [
                    {
                      instancePath: instancePath + '/G',
                      schemaPath:
                        '#/definitions/GoogleDriveIntegration/required',
                      keyword: 'required',
                      params: { missingProperty: missing2 },
                      message: "must have required property '" + missing2 + "'",
                    },
                  ];
                  return false;
                } else {
                  if (data11.id !== undefined) {
                    const _errs26 = errors;
                    if (!func0(data11.id, 'G')) {
                      validate45.errors = [
                        {
                          instancePath: instancePath + '/G/id',
                          schemaPath:
                            '#/definitions/GoogleDriveIntegration/properties/id/const',
                          keyword: 'const',
                          params: { allowedValue: 'G' },
                          message: 'must be equal to constant',
                        },
                      ];
                      return false;
                    }
                    var valid6 = _errs26 === errors;
                  } else {
                    var valid6 = true;
                  }
                  if (valid6) {
                    if (data11.key !== undefined) {
                      const _errs27 = errors;
                      if (typeof data11.key !== 'string') {
                        validate45.errors = [
                          {
                            instancePath: instancePath + '/G/key',
                            schemaPath:
                              '#/definitions/GoogleDriveIntegration/properties/key/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid6 = _errs27 === errors;
                    } else {
                      var valid6 = true;
                    }
                    if (valid6) {
                      if (data11.token !== undefined) {
                        const _errs29 = errors;
                        if (typeof data11.token !== 'string') {
                          validate45.errors = [
                            {
                              instancePath: instancePath + '/G/token',
                              schemaPath:
                                '#/definitions/GoogleDriveIntegration/properties/token/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid6 = _errs29 === errors;
                      } else {
                        var valid6 = true;
                      }
                      if (valid6) {
                        if (data11.abbrKey !== undefined) {
                          const _errs31 = errors;
                          if (typeof data11.abbrKey !== 'string') {
                            validate45.errors = [
                              {
                                instancePath: instancePath + '/G/abbrKey',
                                schemaPath:
                                  '#/definitions/GoogleDriveIntegration/properties/abbrKey/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid6 = _errs31 === errors;
                        } else {
                          var valid6 = true;
                        }
                        if (valid6) {
                          if (data11.enabled !== undefined) {
                            const _errs33 = errors;
                            if (typeof data11.enabled !== 'boolean') {
                              validate45.errors = [
                                {
                                  instancePath: instancePath + '/G/enabled',
                                  schemaPath:
                                    '#/definitions/GoogleDriveIntegration/properties/enabled/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid6 = _errs33 === errors;
                          } else {
                            var valid6 = true;
                          }
                          if (valid6) {
                            if (data11.loginHint !== undefined) {
                              const _errs35 = errors;
                              if (typeof data11.loginHint !== 'string') {
                                validate45.errors = [
                                  {
                                    instancePath: instancePath + '/G/loginHint',
                                    schemaPath:
                                      '#/definitions/GoogleDriveIntegration/properties/loginHint/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid6 = _errs35 === errors;
                            } else {
                              var valid6 = true;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              } else {
                validate45.errors = [
                  {
                    instancePath: instancePath + '/G',
                    schemaPath: '#/definitions/GoogleDriveIntegration/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                  },
                ];
                return false;
              }
            }
            var valid0 = _errs23 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.B !== undefined) {
              let data18 = data.B;
              const _errs37 = errors;
              const _errs38 = errors;
              if (errors === _errs38) {
                if (
                  data18 &&
                  typeof data18 == 'object' &&
                  !Array.isArray(data18)
                ) {
                  let missing3;
                  if (
                    (data18.id === undefined && (missing3 = 'id')) ||
                    (data18.enabled === undefined && (missing3 = 'enabled'))
                  ) {
                    validate45.errors = [
                      {
                        instancePath: instancePath + '/B',
                        schemaPath: '#/definitions/BoxIntegration/required',
                        keyword: 'required',
                        params: { missingProperty: missing3 },
                        message:
                          "must have required property '" + missing3 + "'",
                      },
                    ];
                    return false;
                  } else {
                    if (data18.id !== undefined) {
                      const _errs40 = errors;
                      if (!func0(data18.id, 'B')) {
                        validate45.errors = [
                          {
                            instancePath: instancePath + '/B/id',
                            schemaPath:
                              '#/definitions/BoxIntegration/properties/id/const',
                            keyword: 'const',
                            params: { allowedValue: 'B' },
                            message: 'must be equal to constant',
                          },
                        ];
                        return false;
                      }
                      var valid8 = _errs40 === errors;
                    } else {
                      var valid8 = true;
                    }
                    if (valid8) {
                      if (data18.enabled !== undefined) {
                        const _errs41 = errors;
                        if (typeof data18.enabled !== 'boolean') {
                          validate45.errors = [
                            {
                              instancePath: instancePath + '/B/enabled',
                              schemaPath:
                                '#/definitions/BoxIntegration/properties/enabled/type',
                              keyword: 'type',
                              params: { type: 'boolean' },
                              message: 'must be boolean',
                            },
                          ];
                          return false;
                        }
                        var valid8 = _errs41 === errors;
                      } else {
                        var valid8 = true;
                      }
                    }
                  }
                } else {
                  validate45.errors = [
                    {
                      instancePath: instancePath + '/B',
                      schemaPath: '#/definitions/BoxIntegration/type',
                      keyword: 'type',
                      params: { type: 'object' },
                      message: 'must be object',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs37 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.E !== undefined) {
                let data21 = data.E;
                const _errs43 = errors;
                const _errs44 = errors;
                if (errors === _errs44) {
                  if (
                    data21 &&
                    typeof data21 == 'object' &&
                    !Array.isArray(data21)
                  ) {
                    let missing4;
                    if (
                      (data21.id === undefined && (missing4 = 'id')) ||
                      (data21.enabled === undefined && (missing4 = 'enabled'))
                    ) {
                      validate45.errors = [
                        {
                          instancePath: instancePath + '/E',
                          schemaPath:
                            '#/definitions/EvernoteIntegration/required',
                          keyword: 'required',
                          params: { missingProperty: missing4 },
                          message:
                            "must have required property '" + missing4 + "'",
                        },
                      ];
                      return false;
                    } else {
                      if (data21.id !== undefined) {
                        const _errs46 = errors;
                        if (!func0(data21.id, 'E')) {
                          validate45.errors = [
                            {
                              instancePath: instancePath + '/E/id',
                              schemaPath:
                                '#/definitions/EvernoteIntegration/properties/id/const',
                              keyword: 'const',
                              params: { allowedValue: 'E' },
                              message: 'must be equal to constant',
                            },
                          ];
                          return false;
                        }
                        var valid10 = _errs46 === errors;
                      } else {
                        var valid10 = true;
                      }
                      if (valid10) {
                        if (data21.enabled !== undefined) {
                          const _errs47 = errors;
                          if (typeof data21.enabled !== 'boolean') {
                            validate45.errors = [
                              {
                                instancePath: instancePath + '/E/enabled',
                                schemaPath:
                                  '#/definitions/EvernoteIntegration/properties/enabled/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid10 = _errs47 === errors;
                        } else {
                          var valid10 = true;
                        }
                      }
                    }
                  } else {
                    validate45.errors = [
                      {
                        instancePath: instancePath + '/E',
                        schemaPath: '#/definitions/EvernoteIntegration/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs43 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate45.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate45.errors = vErrors;
  return errors === 0;
}
function validate44(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="AccountSettings.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.allowTemplateDelete === undefined &&
          (missing0 = 'allowTemplateDelete')) ||
        (data.uploadIntegrations === undefined &&
          (missing0 = 'uploadIntegrations')) ||
        (data.smsAuthLeft === undefined && (missing0 = 'smsAuthLeft'))
      ) {
        validate44.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.allowIntegrationsUpload !== undefined) {
          const _errs1 = errors;
          if (typeof data.allowIntegrationsUpload !== 'boolean') {
            validate44.errors = [
              {
                instancePath: instancePath + '/allowIntegrationsUpload',
                schemaPath: '#/properties/allowIntegrationsUpload/type',
                keyword: 'type',
                params: { type: 'boolean' },
                message: 'must be boolean',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.allowRecipientAccessCodes !== undefined) {
            const _errs3 = errors;
            if (typeof data.allowRecipientAccessCodes !== 'boolean') {
              validate44.errors = [
                {
                  instancePath: instancePath + '/allowRecipientAccessCodes',
                  schemaPath: '#/properties/allowRecipientAccessCodes/type',
                  keyword: 'type',
                  params: { type: 'boolean' },
                  message: 'must be boolean',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.allowRecipientSmsAuthNumbers !== undefined) {
              const _errs5 = errors;
              if (typeof data.allowRecipientSmsAuthNumbers !== 'boolean') {
                validate44.errors = [
                  {
                    instancePath:
                      instancePath + '/allowRecipientSmsAuthNumbers',
                    schemaPath:
                      '#/properties/allowRecipientSmsAuthNumbers/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.allowRecipientAttachments !== undefined) {
                const _errs7 = errors;
                if (typeof data.allowRecipientAttachments !== 'boolean') {
                  validate44.errors = [
                    {
                      instancePath: instancePath + '/allowRecipientAttachments',
                      schemaPath: '#/properties/allowRecipientAttachments/type',
                      keyword: 'type',
                      params: { type: 'boolean' },
                      message: 'must be boolean',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.allowRecipientReassignment !== undefined) {
                  const _errs9 = errors;
                  if (typeof data.allowRecipientReassignment !== 'boolean') {
                    validate44.errors = [
                      {
                        instancePath:
                          instancePath + '/allowRecipientReassignment',
                        schemaPath:
                          '#/properties/allowRecipientReassignment/type',
                        keyword: 'type',
                        params: { type: 'boolean' },
                        message: 'must be boolean',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.allowQualifiedSignature !== undefined) {
                    const _errs11 = errors;
                    if (typeof data.allowQualifiedSignature !== 'boolean') {
                      validate44.errors = [
                        {
                          instancePath:
                            instancePath + '/allowQualifiedSignature',
                          schemaPath:
                            '#/properties/allowQualifiedSignature/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.allowNom151 !== undefined) {
                      const _errs13 = errors;
                      if (typeof data.allowNom151 !== 'boolean') {
                        validate44.errors = [
                          {
                            instancePath: instancePath + '/allowNom151',
                            schemaPath: '#/properties/allowNom151/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.allowSmsSignatureDelivery !== undefined) {
                        const _errs15 = errors;
                        if (
                          typeof data.allowSmsSignatureDelivery !== 'boolean'
                        ) {
                          validate44.errors = [
                            {
                              instancePath:
                                instancePath + '/allowSmsSignatureDelivery',
                              schemaPath:
                                '#/properties/allowSmsSignatureDelivery/type',
                              keyword: 'type',
                              params: { type: 'boolean' },
                              message: 'must be boolean',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.allowTemplateDelete !== undefined) {
                          const _errs17 = errors;
                          if (typeof data.allowTemplateDelete !== 'boolean') {
                            validate44.errors = [
                              {
                                instancePath:
                                  instancePath + '/allowTemplateDelete',
                                schemaPath:
                                  '#/properties/allowTemplateDelete/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs17 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.allowCreateEditTemplate !== undefined) {
                            const _errs19 = errors;
                            if (
                              typeof data.allowCreateEditTemplate !== 'boolean'
                            ) {
                              validate44.errors = [
                                {
                                  instancePath:
                                    instancePath + '/allowCreateEditTemplate',
                                  schemaPath:
                                    '#/properties/allowCreateEditTemplate/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs19 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.allowTemplatePreview !== undefined) {
                              const _errs21 = errors;
                              if (
                                typeof data.allowTemplatePreview !== 'boolean'
                              ) {
                                validate44.errors = [
                                  {
                                    instancePath:
                                      instancePath + '/allowTemplatePreview',
                                    schemaPath:
                                      '#/properties/allowTemplatePreview/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs21 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (
                                data.allowOptionalTemplateSigners !== undefined
                              ) {
                                const _errs23 = errors;
                                if (
                                  typeof data.allowOptionalTemplateSigners !==
                                  'boolean'
                                ) {
                                  validate44.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/allowOptionalTemplateSigners',
                                      schemaPath:
                                        '#/properties/allowOptionalTemplateSigners/type',
                                      keyword: 'type',
                                      params: { type: 'boolean' },
                                      message: 'must be boolean',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs23 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.allowSmsAuth !== undefined) {
                                  const _errs25 = errors;
                                  if (typeof data.allowSmsAuth !== 'boolean') {
                                    validate44.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/allowSmsAuth',
                                        schemaPath:
                                          '#/properties/allowSmsAuth/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs25 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.smsAuthLeft !== undefined) {
                                    let data13 = data.smsAuthLeft;
                                    const _errs27 = errors;
                                    if (
                                      !(
                                        typeof data13 == 'number' &&
                                        isFinite(data13)
                                      )
                                    ) {
                                      validate44.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/smsAuthLeft',
                                          schemaPath:
                                            '#/properties/smsAuthLeft/type',
                                          keyword: 'type',
                                          params: { type: 'number' },
                                          message: 'must be number',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid0 = _errs27 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.allowBulkSend !== undefined) {
                                      const _errs29 = errors;
                                      if (
                                        typeof data.allowBulkSend !== 'boolean'
                                      ) {
                                        validate44.errors = [
                                          {
                                            instancePath:
                                              instancePath + '/allowBulkSend',
                                            schemaPath:
                                              '#/properties/allowBulkSend/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid0 = _errs29 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (
                                        data.canAccessRecipientAccessCodes !==
                                        undefined
                                      ) {
                                        const _errs31 = errors;
                                        if (
                                          typeof data.canAccessRecipientAccessCodes !==
                                          'boolean'
                                        ) {
                                          validate44.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/canAccessRecipientAccessCodes',
                                              schemaPath:
                                                '#/properties/canAccessRecipientAccessCodes/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid0 = _errs31 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (
                                          data.canUpgradeTierSmsSignatureDelivery !==
                                          undefined
                                        ) {
                                          const _errs33 = errors;
                                          if (
                                            typeof data.canUpgradeTierSmsSignatureDelivery !==
                                            'boolean'
                                          ) {
                                            validate44.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/canUpgradeTierSmsSignatureDelivery',
                                                schemaPath:
                                                  '#/properties/canUpgradeTierSmsSignatureDelivery/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid0 = _errs33 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                        if (valid0) {
                                          if (data.noMultiFaxes !== undefined) {
                                            const _errs35 = errors;
                                            if (
                                              typeof data.noMultiFaxes !==
                                              'boolean'
                                            ) {
                                              validate44.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/noMultiFaxes',
                                                  schemaPath:
                                                    '#/properties/noMultiFaxes/type',
                                                  keyword: 'type',
                                                  params: { type: 'boolean' },
                                                  message: 'must be boolean',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid0 = _errs35 === errors;
                                          } else {
                                            var valid0 = true;
                                          }
                                          if (valid0) {
                                            if (
                                              data.maxTemplateNumber !==
                                              undefined
                                            ) {
                                              let data18 =
                                                data.maxTemplateNumber;
                                              const _errs37 = errors;
                                              if (
                                                !(
                                                  typeof data18 == 'number' &&
                                                  isFinite(data18)
                                                )
                                              ) {
                                                validate44.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/maxTemplateNumber',
                                                    schemaPath:
                                                      '#/properties/maxTemplateNumber/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid0 = _errs37 === errors;
                                            } else {
                                              var valid0 = true;
                                            }
                                            if (valid0) {
                                              if (
                                                data.isAtTemplateLimit !==
                                                undefined
                                              ) {
                                                const _errs39 = errors;
                                                if (
                                                  typeof data.isAtTemplateLimit !==
                                                  'boolean'
                                                ) {
                                                  validate44.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/isAtTemplateLimit',
                                                      schemaPath:
                                                        '#/properties/isAtTemplateLimit/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'boolean',
                                                      },
                                                      message:
                                                        'must be boolean',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid0 = _errs39 === errors;
                                              } else {
                                                var valid0 = true;
                                              }
                                              if (valid0) {
                                                if (
                                                  data.isAtDocumentLimit !==
                                                  undefined
                                                ) {
                                                  const _errs41 = errors;
                                                  if (
                                                    typeof data.isAtDocumentLimit !==
                                                    'boolean'
                                                  ) {
                                                    validate44.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath +
                                                          '/isAtDocumentLimit',
                                                        schemaPath:
                                                          '#/properties/isAtDocumentLimit/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'boolean',
                                                        },
                                                        message:
                                                          'must be boolean',
                                                      },
                                                    ];
                                                    return false;
                                                  }
                                                  var valid0 =
                                                    _errs41 === errors;
                                                } else {
                                                  var valid0 = true;
                                                }
                                                if (valid0) {
                                                  if (
                                                    data.hasHIPAA !== undefined
                                                  ) {
                                                    const _errs43 = errors;
                                                    if (
                                                      typeof data.hasHIPAA !==
                                                      'boolean'
                                                    ) {
                                                      validate44.errors = [
                                                        {
                                                          instancePath:
                                                            instancePath +
                                                            '/hasHIPAA',
                                                          schemaPath:
                                                            '#/properties/hasHIPAA/type',
                                                          keyword: 'type',
                                                          params: {
                                                            type: 'boolean',
                                                          },
                                                          message:
                                                            'must be boolean',
                                                        },
                                                      ];
                                                      return false;
                                                    }
                                                    var valid0 =
                                                      _errs43 === errors;
                                                  } else {
                                                    var valid0 = true;
                                                  }
                                                  if (valid0) {
                                                    if (
                                                      data.isNewHsPlan !==
                                                      undefined
                                                    ) {
                                                      const _errs45 = errors;
                                                      if (
                                                        typeof data.isNewHsPlan !==
                                                        'boolean'
                                                      ) {
                                                        validate44.errors = [
                                                          {
                                                            instancePath:
                                                              instancePath +
                                                              '/isNewHsPlan',
                                                            schemaPath:
                                                              '#/properties/isNewHsPlan/type',
                                                            keyword: 'type',
                                                            params: {
                                                              type: 'boolean',
                                                            },
                                                            message:
                                                              'must be boolean',
                                                          },
                                                        ];
                                                        return false;
                                                      }
                                                      var valid0 =
                                                        _errs45 === errors;
                                                    } else {
                                                      var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                      if (
                                                        data.isTransactionalPlan !==
                                                        undefined
                                                      ) {
                                                        const _errs47 = errors;
                                                        if (
                                                          typeof data.isTransactionalPlan !==
                                                          'boolean'
                                                        ) {
                                                          validate44.errors = [
                                                            {
                                                              instancePath:
                                                                instancePath +
                                                                '/isTransactionalPlan',
                                                              schemaPath:
                                                                '#/properties/isTransactionalPlan/type',
                                                              keyword: 'type',
                                                              params: {
                                                                type: 'boolean',
                                                              },
                                                              message:
                                                                'must be boolean',
                                                            },
                                                          ];
                                                          return false;
                                                        }
                                                        var valid0 =
                                                          _errs47 === errors;
                                                      } else {
                                                        var valid0 = true;
                                                      }
                                                      if (valid0) {
                                                        if (
                                                          data.alwaysSendMeACopy !==
                                                          undefined
                                                        ) {
                                                          const _errs49 =
                                                            errors;
                                                          if (
                                                            typeof data.alwaysSendMeACopy !==
                                                            'boolean'
                                                          ) {
                                                            validate44.errors =
                                                              [
                                                                {
                                                                  instancePath:
                                                                    instancePath +
                                                                    '/alwaysSendMeACopy',
                                                                  schemaPath:
                                                                    '#/properties/alwaysSendMeACopy/type',
                                                                  keyword:
                                                                    'type',
                                                                  params: {
                                                                    type: 'boolean',
                                                                  },
                                                                  message:
                                                                    'must be boolean',
                                                                },
                                                              ];
                                                            return false;
                                                          }
                                                          var valid0 =
                                                            _errs49 === errors;
                                                        } else {
                                                          var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                          if (
                                                            data.alwaysSendOthersACopy !==
                                                            undefined
                                                          ) {
                                                            const _errs51 =
                                                              errors;
                                                            if (
                                                              typeof data.alwaysSendOthersACopy !==
                                                              'boolean'
                                                            ) {
                                                              validate44.errors =
                                                                [
                                                                  {
                                                                    instancePath:
                                                                      instancePath +
                                                                      '/alwaysSendOthersACopy',
                                                                    schemaPath:
                                                                      '#/properties/alwaysSendOthersACopy/type',
                                                                    keyword:
                                                                      'type',
                                                                    params: {
                                                                      type: 'boolean',
                                                                    },
                                                                    message:
                                                                      'must be boolean',
                                                                  },
                                                                ];
                                                              return false;
                                                            }
                                                            var valid0 =
                                                              _errs51 ===
                                                              errors;
                                                          } else {
                                                            var valid0 = true;
                                                          }
                                                          if (valid0) {
                                                            if (
                                                              data.needsCharge !==
                                                              undefined
                                                            ) {
                                                              const _errs53 =
                                                                errors;
                                                              if (
                                                                typeof data.needsCharge !==
                                                                'boolean'
                                                              ) {
                                                                validate44.errors =
                                                                  [
                                                                    {
                                                                      instancePath:
                                                                        instancePath +
                                                                        '/needsCharge',
                                                                      schemaPath:
                                                                        '#/properties/needsCharge/type',
                                                                      keyword:
                                                                        'type',
                                                                      params: {
                                                                        type: 'boolean',
                                                                      },
                                                                      message:
                                                                        'must be boolean',
                                                                    },
                                                                  ];
                                                                return false;
                                                              }
                                                              var valid0 =
                                                                _errs53 ===
                                                                errors;
                                                            } else {
                                                              var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                              if (
                                                                data.chargeType !==
                                                                undefined
                                                              ) {
                                                                const _errs55 =
                                                                  errors;
                                                                if (
                                                                  typeof data.chargeType !==
                                                                  'string'
                                                                ) {
                                                                  validate44.errors =
                                                                    [
                                                                      {
                                                                        instancePath:
                                                                          instancePath +
                                                                          '/chargeType',
                                                                        schemaPath:
                                                                          '#/properties/chargeType/type',
                                                                        keyword:
                                                                          'type',
                                                                        params:
                                                                          {
                                                                            type: 'string',
                                                                          },
                                                                        message:
                                                                          'must be string',
                                                                      },
                                                                    ];
                                                                  return false;
                                                                }
                                                                var valid0 =
                                                                  _errs55 ===
                                                                  errors;
                                                              } else {
                                                                var valid0 = true;
                                                              }
                                                              if (valid0) {
                                                                if (
                                                                  data.totalPriceInCents !==
                                                                  undefined
                                                                ) {
                                                                  let data28 =
                                                                    data.totalPriceInCents;
                                                                  const _errs57 =
                                                                    errors;
                                                                  if (
                                                                    !(
                                                                      typeof data28 ==
                                                                        'number' &&
                                                                      isFinite(
                                                                        data28,
                                                                      )
                                                                    )
                                                                  ) {
                                                                    validate44.errors =
                                                                      [
                                                                        {
                                                                          instancePath:
                                                                            instancePath +
                                                                            '/totalPriceInCents',
                                                                          schemaPath:
                                                                            '#/properties/totalPriceInCents/type',
                                                                          keyword:
                                                                            'type',
                                                                          params:
                                                                            {
                                                                              type: 'number',
                                                                            },
                                                                          message:
                                                                            'must be number',
                                                                        },
                                                                      ];
                                                                    return false;
                                                                  }
                                                                  var valid0 =
                                                                    _errs57 ===
                                                                    errors;
                                                                } else {
                                                                  var valid0 = true;
                                                                }
                                                                if (valid0) {
                                                                  if (
                                                                    data.freeFaxPagesLeft !==
                                                                    undefined
                                                                  ) {
                                                                    let data29 =
                                                                      data.freeFaxPagesLeft;
                                                                    const _errs59 =
                                                                      errors;
                                                                    if (
                                                                      !(
                                                                        typeof data29 ==
                                                                          'number' &&
                                                                        isFinite(
                                                                          data29,
                                                                        )
                                                                      )
                                                                    ) {
                                                                      validate44.errors =
                                                                        [
                                                                          {
                                                                            instancePath:
                                                                              instancePath +
                                                                              '/freeFaxPagesLeft',
                                                                            schemaPath:
                                                                              '#/properties/freeFaxPagesLeft/type',
                                                                            keyword:
                                                                              'type',
                                                                            params:
                                                                              {
                                                                                type: 'number',
                                                                              },
                                                                            message:
                                                                              'must be number',
                                                                          },
                                                                        ];
                                                                      return false;
                                                                    }
                                                                    var valid0 =
                                                                      _errs59 ===
                                                                      errors;
                                                                  } else {
                                                                    var valid0 = true;
                                                                  }
                                                                  if (valid0) {
                                                                    if (
                                                                      data.faxPageCurrentCount !==
                                                                      undefined
                                                                    ) {
                                                                      let data30 =
                                                                        data.faxPageCurrentCount;
                                                                      const _errs61 =
                                                                        errors;
                                                                      if (
                                                                        !(
                                                                          typeof data30 ==
                                                                            'number' &&
                                                                          isFinite(
                                                                            data30,
                                                                          )
                                                                        )
                                                                      ) {
                                                                        validate44.errors =
                                                                          [
                                                                            {
                                                                              instancePath:
                                                                                instancePath +
                                                                                '/faxPageCurrentCount',
                                                                              schemaPath:
                                                                                '#/properties/faxPageCurrentCount/type',
                                                                              keyword:
                                                                                'type',
                                                                              params:
                                                                                {
                                                                                  type: 'number',
                                                                                },
                                                                              message:
                                                                                'must be number',
                                                                            },
                                                                          ];
                                                                        return false;
                                                                      }
                                                                      var valid0 =
                                                                        _errs61 ===
                                                                        errors;
                                                                    } else {
                                                                      var valid0 = true;
                                                                    }
                                                                    if (
                                                                      valid0
                                                                    ) {
                                                                      if (
                                                                        data.overageFaxMaxLimitInCents !==
                                                                        undefined
                                                                      ) {
                                                                        let data31 =
                                                                          data.overageFaxMaxLimitInCents;
                                                                        const _errs63 =
                                                                          errors;
                                                                        if (
                                                                          !(
                                                                            typeof data31 ==
                                                                              'number' &&
                                                                            isFinite(
                                                                              data31,
                                                                            )
                                                                          )
                                                                        ) {
                                                                          validate44.errors =
                                                                            [
                                                                              {
                                                                                instancePath:
                                                                                  instancePath +
                                                                                  '/overageFaxMaxLimitInCents',
                                                                                schemaPath:
                                                                                  '#/properties/overageFaxMaxLimitInCents/type',
                                                                                keyword:
                                                                                  'type',
                                                                                params:
                                                                                  {
                                                                                    type: 'number',
                                                                                  },
                                                                                message:
                                                                                  'must be number',
                                                                              },
                                                                            ];
                                                                          return false;
                                                                        }
                                                                        var valid0 =
                                                                          _errs63 ===
                                                                          errors;
                                                                      } else {
                                                                        var valid0 = true;
                                                                      }
                                                                      if (
                                                                        valid0
                                                                      ) {
                                                                        if (
                                                                          data.pricePerFaxInCents !==
                                                                          undefined
                                                                        ) {
                                                                          let data32 =
                                                                            data.pricePerFaxInCents;
                                                                          const _errs65 =
                                                                            errors;
                                                                          if (
                                                                            !(
                                                                              typeof data32 ==
                                                                                'number' &&
                                                                              isFinite(
                                                                                data32,
                                                                              )
                                                                            )
                                                                          ) {
                                                                            validate44.errors =
                                                                              [
                                                                                {
                                                                                  instancePath:
                                                                                    instancePath +
                                                                                    '/pricePerFaxInCents',
                                                                                  schemaPath:
                                                                                    '#/properties/pricePerFaxInCents/type',
                                                                                  keyword:
                                                                                    'type',
                                                                                  params:
                                                                                    {
                                                                                      type: 'number',
                                                                                    },
                                                                                  message:
                                                                                    'must be number',
                                                                                },
                                                                              ];
                                                                            return false;
                                                                          }
                                                                          var valid0 =
                                                                            _errs65 ===
                                                                            errors;
                                                                        } else {
                                                                          var valid0 = true;
                                                                        }
                                                                        if (
                                                                          valid0
                                                                        ) {
                                                                          if (
                                                                            data.initialPageLimit !==
                                                                            undefined
                                                                          ) {
                                                                            let data33 =
                                                                              data.initialPageLimit;
                                                                            const _errs67 =
                                                                              errors;
                                                                            if (
                                                                              !(
                                                                                typeof data33 ==
                                                                                  'number' &&
                                                                                isFinite(
                                                                                  data33,
                                                                                )
                                                                              )
                                                                            ) {
                                                                              validate44.errors =
                                                                                [
                                                                                  {
                                                                                    instancePath:
                                                                                      instancePath +
                                                                                      '/initialPageLimit',
                                                                                    schemaPath:
                                                                                      '#/properties/initialPageLimit/type',
                                                                                    keyword:
                                                                                      'type',
                                                                                    params:
                                                                                      {
                                                                                        type: 'number',
                                                                                      },
                                                                                    message:
                                                                                      'must be number',
                                                                                  },
                                                                                ];
                                                                              return false;
                                                                            }
                                                                            var valid0 =
                                                                              _errs67 ===
                                                                              errors;
                                                                          } else {
                                                                            var valid0 = true;
                                                                          }
                                                                          if (
                                                                            valid0
                                                                          ) {
                                                                            if (
                                                                              data.overagePriceInCentsPerPage !==
                                                                              undefined
                                                                            ) {
                                                                              let data34 =
                                                                                data.overagePriceInCentsPerPage;
                                                                              const _errs69 =
                                                                                errors;
                                                                              if (
                                                                                !(
                                                                                  typeof data34 ==
                                                                                    'number' &&
                                                                                  isFinite(
                                                                                    data34,
                                                                                  )
                                                                                )
                                                                              ) {
                                                                                validate44.errors =
                                                                                  [
                                                                                    {
                                                                                      instancePath:
                                                                                        instancePath +
                                                                                        '/overagePriceInCentsPerPage',
                                                                                      schemaPath:
                                                                                        '#/properties/overagePriceInCentsPerPage/type',
                                                                                      keyword:
                                                                                        'type',
                                                                                      params:
                                                                                        {
                                                                                          type: 'number',
                                                                                        },
                                                                                      message:
                                                                                        'must be number',
                                                                                    },
                                                                                  ];
                                                                                return false;
                                                                              }
                                                                              var valid0 =
                                                                                _errs69 ===
                                                                                errors;
                                                                            } else {
                                                                              var valid0 = true;
                                                                            }
                                                                            if (
                                                                              valid0
                                                                            ) {
                                                                              if (
                                                                                data.internationalMultiplier !==
                                                                                undefined
                                                                              ) {
                                                                                let data35 =
                                                                                  data.internationalMultiplier;
                                                                                const _errs71 =
                                                                                  errors;
                                                                                if (
                                                                                  !(
                                                                                    typeof data35 ==
                                                                                      'number' &&
                                                                                    isFinite(
                                                                                      data35,
                                                                                    )
                                                                                  )
                                                                                ) {
                                                                                  validate44.errors =
                                                                                    [
                                                                                      {
                                                                                        instancePath:
                                                                                          instancePath +
                                                                                          '/internationalMultiplier',
                                                                                        schemaPath:
                                                                                          '#/properties/internationalMultiplier/type',
                                                                                        keyword:
                                                                                          'type',
                                                                                        params:
                                                                                          {
                                                                                            type: 'number',
                                                                                          },
                                                                                        message:
                                                                                          'must be number',
                                                                                      },
                                                                                    ];
                                                                                  return false;
                                                                                }
                                                                                var valid0 =
                                                                                  _errs71 ===
                                                                                  errors;
                                                                              } else {
                                                                                var valid0 = true;
                                                                              }
                                                                              if (
                                                                                valid0
                                                                              ) {
                                                                                if (
                                                                                  data.uploadIntegrations !==
                                                                                  undefined
                                                                                ) {
                                                                                  const _errs73 =
                                                                                    errors;
                                                                                  if (
                                                                                    !validate45(
                                                                                      data.uploadIntegrations,
                                                                                      {
                                                                                        instancePath:
                                                                                          instancePath +
                                                                                          '/uploadIntegrations',
                                                                                        parentData:
                                                                                          data,
                                                                                        parentDataProperty:
                                                                                          'uploadIntegrations',
                                                                                        rootData,
                                                                                      },
                                                                                    )
                                                                                  ) {
                                                                                    vErrors =
                                                                                      vErrors ===
                                                                                      null
                                                                                        ? validate45.errors
                                                                                        : vErrors.concat(
                                                                                            validate45.errors,
                                                                                          );
                                                                                    errors =
                                                                                      vErrors.length;
                                                                                  }
                                                                                  var valid0 =
                                                                                    _errs73 ===
                                                                                    errors;
                                                                                } else {
                                                                                  var valid0 = true;
                                                                                }
                                                                                if (
                                                                                  valid0
                                                                                ) {
                                                                                  if (
                                                                                    data.isSMSToolsOn !==
                                                                                    undefined
                                                                                  ) {
                                                                                    const _errs74 =
                                                                                      errors;
                                                                                    if (
                                                                                      typeof data.isSMSToolsOn !==
                                                                                      'boolean'
                                                                                    ) {
                                                                                      validate44.errors =
                                                                                        [
                                                                                          {
                                                                                            instancePath:
                                                                                              instancePath +
                                                                                              '/isSMSToolsOn',
                                                                                            schemaPath:
                                                                                              '#/properties/isSMSToolsOn/type',
                                                                                            keyword:
                                                                                              'type',
                                                                                            params:
                                                                                              {
                                                                                                type: 'boolean',
                                                                                              },
                                                                                            message:
                                                                                              'must be boolean',
                                                                                          },
                                                                                        ];
                                                                                      return false;
                                                                                    }
                                                                                    var valid0 =
                                                                                      _errs74 ===
                                                                                      errors;
                                                                                  } else {
                                                                                    var valid0 = true;
                                                                                  }
                                                                                }
                                                                              }
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate44.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate44.errors = vErrors;
  return errors === 0;
}
const schema64 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'RequestData.json',
  title: 'RequestData',
  type: 'object',
  properties: {
    files: { type: 'array', items: { $ref: 'File.json' } },
    editorData: { $ref: 'EditorData.json' },
    recipients: { type: 'array', items: { $ref: 'Recipient.json' } },
    ccs: {
      type: 'array',
      items: {
        oneOf: [
          { $ref: 'Recipient.json#/definitions/CCEmail' },
          { $ref: 'Recipient.json#/definitions/CCRole' },
        ],
      },
    },
    title: { type: 'string' },
    message: { type: 'string' },
    expiresAt: { type: 'string', format: 'date-time' },
    templates: { type: 'array', items: { $ref: 'Template.json' } },
    coverPage: { $ref: 'CoverPage.json' },
    bulkSend: { $ref: 'BulkSend.json' },
  },
  required: [
    'files',
    'editorData',
    'recipients',
    'ccs',
    'templates',
    'bulkSend',
    'title',
    'message',
  ],
};
const schema101 = {
  type: 'object',
  title: 'CCRole',
  additionalProperties: false,
  properties: {
    type: { const: 'ccRole', default: 'ccRole' },
    id: { type: 'string' },
    name: { type: 'string' },
  },
  required: ['type', 'id', 'name'],
};
const schema118 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'CoverPage.json',
  type: 'object',
  title: 'CoverPage',
  additionalProperties: false,
  properties: {
    to: { type: 'string' },
    from: { type: 'string' },
    message: { type: 'string' },
  },
  required: ['to', 'from', 'message'],
};
const schema65 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'File.json',
  title: 'File',
  type: 'object',
  additionalProperties: false,
  properties: {
    status: { $ref: '#/definitions/FileStatus' },
    name: { type: 'string' },
    type: { $ref: '#/definitions/FileType' },
    guid: { type: 'string' },
    documentGuid: { type: 'string' },
    draftSnapshotGuid: { type: 'string' },
    tsmGroupGuid: { type: 'string' },
    templateGuid: { type: 'string' },
    rootSnapshotGuid: { type: 'string' },
    order: { type: 'number' },
    fields: { type: 'array', items: { $ref: 'Field.json' } },
    pwRequired: { type: 'boolean' },
    pageCount: { type: 'number' },
    externalFileCacheKey: { type: 'string' },
    externalServiceReference: { type: 'string' },
    externalServiceType: { type: 'string' },
  },
  required: [
    'name',
    'type',
    'guid',
    'fields',
    'pwRequired',
    'rootSnapshotGuid',
  ],
  definitions: {
    FileStatus: {
      type: 'string',
      title: 'FileStatus',
      enum: [
        'converting',
        'ok',
        'file downloaded',
        'downloading',
        'download queued',
        'deleted',
        'error',
        '404 Error',
        'password required',
        'too many pages',
        'file too large',
        'retrieve error',
        'bad request',
        'bad auth',
      ],
    },
    FileType: {
      type: 'string',
      title: 'FileType',
      enum: ['Upload', 'Template', 'External'],
      tsEnumNames: ['Upload', 'Template', 'External'],
    },
  },
};
const schema66 = {
  type: 'string',
  title: 'FileStatus',
  enum: [
    'converting',
    'ok',
    'file downloaded',
    'downloading',
    'download queued',
    'deleted',
    'error',
    '404 Error',
    'password required',
    'too many pages',
    'file too large',
    'retrieve error',
    'bad request',
    'bad auth',
  ],
};
const schema67 = {
  type: 'string',
  title: 'FileType',
  enum: ['Upload', 'Template', 'External'],
  tsEnumNames: ['Upload', 'Template', 'External'],
};
const schema15 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'Field.json',
  title: 'Field',
  type: 'object',
  oneOf: [
    { $ref: '#/definitions/TextField' },
    { $ref: '#/definitions/SignatureField' },
    { $ref: '#/definitions/InitialsField' },
    { $ref: '#/definitions/DateField' },
    { $ref: '#/definitions/CheckboxField' },
    { $ref: '#/definitions/RadioField' },
    { $ref: '#/definitions/DropdownField' },
    { $ref: '#/definitions/HyperlinkField' },
  ],
  definitions: {
    FieldIntegrationMetadata: {
      type: 'object',
      title: 'FieldIntegrationMetadata',
      description: 'Currently only being used for HubSpot V2 integration',
      properties: {
        externalName: { type: 'string' },
        externalType: { type: 'string' },
        isTopField: { type: 'boolean' },
      },
    },
    MergeField: {
      type: 'object',
      title: 'MergeField',
      additionalProperties: false,
      properties: {
        name: { type: 'string' },
        type: { type: 'string', enum: ['text', 'checkbox'] },
        integrationMetadata: { $ref: '#/definitions/FieldIntegrationMetadata' },
      },
    },
    FieldType: {
      type: 'string',
      title: 'FieldType',
      enum: [
        'checkbox',
        'date',
        'initials',
        'signature',
        'text',
        'dropdown',
        'radiobutton',
        'hyperlink',
      ],
    },
    SignatureType: { type: 'string', title: 'SignatureType', enum: ['S', 'I'] },
    SignatureCreateType: {
      type: 'string',
      title: 'SignatureCreateType',
      enum: ['A', 'C', 'U', 'T', 'E', 'X'],
    },
    Signature: {
      type: 'object',
      title: 'Signature',
      additionalProperties: false,
      properties: {
        type: { $ref: '#/definitions/SignatureType' },
        createType: { $ref: '#/definitions/SignatureCreateType' },
        createdAt: { type: 'string', format: 'date-time' },
        lastUsedAt: { type: 'string', format: 'date-time' },
        guid: { type: 'string' },
        width: { type: 'number' },
        height: { type: 'number' },
      },
      required: ['guid', 'type'],
    },
    FontFamily: {
      type: 'string',
      enum: [
        'helvetica',
        'arial',
        'calibri',
        'cambria',
        'courier',
        'georgia',
        'times',
        'trebuchet',
        'verdana',
        'notoSerif',
        'notoSans',
        'roboto',
        'robotoMono',
      ],
      title: 'FontFamily',
    },
    JSDateFormat: {
      type: 'string',
      title: 'JSDateFormat',
      enum: [
        'default',
        'MM / DD / YYYY',
        'MM - DD - YYYY',
        'DD / MM / YYYY',
        'DD - MM - YYYY',
        'YYYY / MM / DD',
        'YYYY - MM - DD',
      ],
    },
    PHPDateFormat: {
      type: 'string',
      title: 'PHPDateFormat',
      enum: [
        'Default',
        'm / d / Y',
        'm - d - Y',
        'd / m / Y',
        'd - m - Y',
        'Y / m / d',
        'Y - m - d',
      ],
    },
    FontSize: { type: 'number', title: 'FontSize', minimum: 7, maximum: 48 },
    Color: { type: 'string', title: 'Color', enum: ['black', 'blue', 'red'] },
    ValidationType: {
      type: 'string',
      title: 'ValidationType',
      description: 'Validation options available for a text field',
      enum: [
        'numbers_only',
        'letters_only',
        'phone_number',
        'bank_routing_number',
        'bank_account_number',
        'email_address',
        'zip_code',
        'social_security_number',
        'employer_identification_number',
        'custom_regex',
      ],
    },
    AutoFillType: {
      type: 'string',
      title: 'AutoFillType',
      enum: [
        'name',
        'lastName',
        'firstName',
        'company',
        'email',
        'emailOrPhoneNumber',
        'title',
        'none',
      ],
    },
    SignerField: {
      title: 'SignerField',
      type: 'object',
      properties: {
        type: { $ref: '#/definitions/FieldType' },
        pageIndex: { type: 'number' },
        id: { type: 'string' },
        apiId: { type: 'string' },
        documentId: { type: 'string' },
        x: { type: 'number' },
        y: { type: 'number' },
        width: { type: 'number' },
        height: { type: 'number' },
        required: { type: 'boolean' },
        readOnly: { type: 'boolean' },
        name: { type: 'string' },
        isAutoFill: { type: 'boolean' },
        autoFillValue: { type: 'string' },
        autoFillType: { $ref: '#/definitions/AutoFillType' },
        linkId: { type: 'string' },
        isDisabled: { type: 'boolean' },
        fontSize: { $ref: '#/definitions/FontSize' },
        originalFontSize: { $ref: '#/definitions/FontSize' },
        fontFamily: { $ref: '#/definitions/FontFamily' },
        value: { type: ['string', 'null'] },
        placeholder: { type: 'string' },
        masked: { type: 'boolean' },
        isEditableMergeField: { type: 'boolean' },
        lines: { type: 'string' },
        numLines: { type: 'number' },
        numCharsPerLine: { type: 'number' },
        lineHeight: { type: 'number' },
        validationType: { $ref: '#/definitions/ValidationType' },
        validationCustomRegex: { type: 'string' },
        validationCustomRegexFormatLabel: { type: 'string' },
        signature: { $ref: '#/definitions/Signature' },
        color: { $ref: '#/definitions/Color' },
        dateFormat: { $ref: '#/definitions/JSDateFormat' },
        checked: { type: 'boolean' },
        requirement: { type: 'string' },
        groupLabel: { type: 'string' },
        groupFormLabel: { type: 'string' },
        group: { type: 'string' },
        options: { type: 'array', items: { type: 'string' } },
        url: { type: 'string' },
        formLabel: { type: 'string' },
      },
    },
    TextField: {
      title: 'TextField',
      properties: {
        type: { const: 'text', default: 'text' },
        pageIndex: { type: 'number' },
        id: { type: 'string' },
        apiId: { type: 'string' },
        documentId: { type: 'string' },
        x: { type: 'number' },
        y: { type: 'number' },
        width: { type: 'number' },
        height: { type: 'number' },
        signer: { type: 'string' },
        required: { type: 'boolean' },
        readOnly: { type: 'boolean' },
        name: { type: 'string' },
        autoFillType: { $ref: '#/definitions/AutoFillType' },
        linkId: { type: 'string' },
        isDisabled: { type: 'boolean' },
        fontSize: { $ref: '#/definitions/FontSize' },
        originalFontSize: { $ref: '#/definitions/FontSize' },
        fontFamily: { $ref: '#/definitions/FontFamily' },
        value: { type: 'string' },
        placeholder: { type: 'string' },
        masked: { type: 'boolean' },
        isEditableMergeField: { type: 'boolean' },
        lines: { type: 'string' },
        numLines: { type: 'number' },
        numCharsPerLine: { type: 'number' },
        lineHeight: { type: 'number' },
        integrationMetadata: { $ref: '#/definitions/FieldIntegrationMetadata' },
        validationType: { $ref: '#/definitions/ValidationType' },
        validationCustomRegex: { type: 'string' },
        validationCustomRegexFormatLabel: { type: 'string' },
        formLabel: { type: 'string' },
        linkIdViaApi: { type: 'boolean' },
      },
      required: [
        'pageIndex',
        'signer',
        'documentId',
        'fontSize',
        'fontFamily',
        'type',
        'id',
        'name',
        'required',
        'readOnly',
        'x',
        'y',
        'width',
        'height',
      ],
    },
    SignatureField: {
      title: 'SignatureField',
      properties: {
        type: { const: 'signature', default: 'signature' },
        pageIndex: { type: 'number' },
        id: { type: 'string' },
        apiId: { type: 'string' },
        documentId: { type: 'string' },
        x: { type: 'number' },
        y: { type: 'number' },
        width: { type: 'number' },
        height: { type: 'number' },
        signer: { type: 'string' },
        required: { type: 'boolean' },
        readOnly: { type: 'boolean' },
        name: { type: 'string' },
        linkId: { type: 'string' },
        isDisabled: { type: 'boolean' },
        signature: { $ref: '#/definitions/Signature' },
        color: { $ref: '#/definitions/Color' },
        formLabel: { type: 'string' },
      },
      required: [
        'pageIndex',
        'signer',
        'documentId',
        'id',
        'name',
        'required',
        'readOnly',
        'x',
        'y',
        'width',
        'height',
        'type',
      ],
    },
    InitialsField: {
      title: 'InitialsField',
      properties: {
        type: { const: 'initials', default: 'initials' },
        pageIndex: { type: 'number' },
        id: { type: 'string' },
        apiId: { type: 'string' },
        documentId: { type: 'string' },
        x: { type: 'number' },
        y: { type: 'number' },
        width: { type: 'number' },
        height: { type: 'number' },
        signer: { type: 'string' },
        required: { type: 'boolean' },
        readOnly: { type: 'boolean' },
        name: { type: 'string' },
        linkId: { type: 'string' },
        isDisabled: { type: 'boolean' },
        signature: { $ref: '#/definitions/Signature' },
        color: { $ref: '#/definitions/Color' },
        formLabel: { type: 'string' },
      },
      required: [
        'pageIndex',
        'signer',
        'documentId',
        'id',
        'name',
        'required',
        'readOnly',
        'x',
        'y',
        'width',
        'height',
        'type',
      ],
    },
    DateField: {
      title: 'DateField',
      properties: {
        pageIndex: { type: 'number' },
        id: { type: 'string' },
        apiId: { type: 'string' },
        documentId: { type: 'string' },
        x: { type: 'number' },
        y: { type: 'number' },
        width: { type: 'number' },
        height: { type: 'number' },
        signer: { type: 'string' },
        required: { type: 'boolean' },
        readOnly: { type: 'boolean' },
        name: { type: 'string' },
        linkId: { type: 'string' },
        isDisabled: { type: 'boolean' },
        fontSize: { $ref: '#/definitions/FontSize' },
        originalFontSize: { $ref: '#/definitions/FontSize' },
        fontFamily: { $ref: '#/definitions/FontFamily' },
        lineHeight: { type: 'number' },
        value: { type: ['string', 'null'] },
        placeholder: { type: 'string' },
        type: { const: 'date', default: 'date' },
        dateFormat: { $ref: '#/definitions/JSDateFormat' },
        formLabel: { type: 'string' },
      },
      required: [
        'pageIndex',
        'signer',
        'documentId',
        'value',
        'fontSize',
        'fontFamily',
        'type',
        'id',
        'name',
        'required',
        'readOnly',
        'x',
        'y',
        'width',
        'height',
      ],
    },
    RadioField: {
      title: 'RadioField',
      properties: {
        pageIndex: { type: 'number' },
        id: { type: 'string' },
        apiId: { type: 'string' },
        documentId: { type: 'string' },
        x: { type: 'number' },
        y: { type: 'number' },
        width: { type: 'number' },
        height: { type: 'number' },
        signer: { type: 'string' },
        required: { type: 'boolean' },
        readOnly: { type: 'boolean' },
        name: { type: 'string' },
        linkId: { type: 'string' },
        isDisabled: { type: 'boolean' },
        type: { const: 'radiobutton', default: 'radiobutton' },
        checked: { type: 'boolean' },
        requirement: { type: 'string' },
        groupLabel: { type: 'string' },
        groupFormLabel: { type: 'string' },
        group: { type: 'string' },
        formLabel: { type: 'string' },
      },
      required: [
        'checked',
        'requirement',
        'group',
        'pageIndex',
        'signer',
        'documentId',
        'id',
        'name',
        'required',
        'readOnly',
        'x',
        'y',
        'width',
        'height',
        'type',
      ],
    },
    DropdownField: {
      title: 'DropdownField',
      properties: {
        pageIndex: { type: 'number' },
        id: { type: 'string' },
        apiId: { type: 'string' },
        documentId: { type: 'string' },
        x: { type: 'number' },
        y: { type: 'number' },
        width: { type: 'number' },
        height: { type: 'number' },
        signer: { type: 'string' },
        required: { type: 'boolean' },
        readOnly: { type: 'boolean' },
        name: { type: 'string' },
        isDisabled: { type: 'boolean' },
        type: { const: 'dropdown', default: 'dropdown' },
        value: { type: ['string', 'null'] },
        options: { type: 'array', items: { type: 'string' } },
        fontSize: { $ref: '#/definitions/FontSize' },
        fontFamily: { $ref: '#/definitions/FontFamily' },
        lineHeight: { type: 'number' },
        formLabel: { type: 'string' },
      },
      required: [
        'pageIndex',
        'signer',
        'documentId',
        'fontSize',
        'fontFamily',
        'type',
        'id',
        'name',
        'required',
        'readOnly',
        'x',
        'y',
        'width',
        'height',
        'options',
      ],
    },
    CheckboxField: {
      title: 'CheckboxField',
      properties: {
        pageIndex: { type: 'number' },
        id: { type: 'string' },
        apiId: { type: 'string' },
        documentId: { type: 'string' },
        x: { type: 'number' },
        y: { type: 'number' },
        width: { type: 'number' },
        height: { type: 'number' },
        signer: { type: 'string' },
        required: { type: 'boolean' },
        readOnly: { type: 'boolean' },
        name: { type: 'string' },
        isDisabled: { type: 'boolean' },
        type: { const: 'checkbox', default: 'checkbox' },
        checked: { type: 'boolean' },
        requirement: { type: 'string' },
        groupLabel: { type: 'string' },
        groupFormLabel: { type: 'string' },
        group: { type: 'string' },
        integrationMetadata: { $ref: '#/definitions/FieldIntegrationMetadata' },
        formLabel: { type: 'string' },
      },
      required: [
        'pageIndex',
        'signer',
        'documentId',
        'id',
        'name',
        'required',
        'readOnly',
        'x',
        'y',
        'width',
        'height',
        'type',
      ],
    },
    HyperlinkField: {
      title: 'HyperlinkField',
      properties: {
        type: { const: 'hyperlink', default: 'hyperlink' },
        pageIndex: { type: 'number' },
        id: { type: 'string' },
        apiId: { type: 'string' },
        documentId: { type: 'string' },
        x: { type: 'number' },
        y: { type: 'number' },
        width: { type: 'number' },
        height: { type: 'number' },
        signer: { type: 'string' },
        required: { type: 'boolean' },
        readOnly: { type: 'boolean' },
        name: { type: 'string' },
        linkId: { type: 'string' },
        isDisabled: { type: 'boolean' },
        lineHeight: { type: 'number' },
        fontFamily: { $ref: '#/definitions/FontFamily' },
        fontSize: { $ref: '#/definitions/FontSize' },
        value: { type: ['string', 'null'] },
        url: { type: 'string' },
        formLabel: { type: 'string' },
      },
      required: [
        'pageIndex',
        'signer',
        'documentId',
        'fontSize',
        'fontFamily',
        'value',
        'url',
        'type',
        'id',
        'name',
        'required',
        'readOnly',
        'x',
        'y',
        'width',
        'height',
      ],
    },
  },
};
const schema37 = {
  title: 'RadioField',
  properties: {
    pageIndex: { type: 'number' },
    id: { type: 'string' },
    apiId: { type: 'string' },
    documentId: { type: 'string' },
    x: { type: 'number' },
    y: { type: 'number' },
    width: { type: 'number' },
    height: { type: 'number' },
    signer: { type: 'string' },
    required: { type: 'boolean' },
    readOnly: { type: 'boolean' },
    name: { type: 'string' },
    linkId: { type: 'string' },
    isDisabled: { type: 'boolean' },
    type: { const: 'radiobutton', default: 'radiobutton' },
    checked: { type: 'boolean' },
    requirement: { type: 'string' },
    groupLabel: { type: 'string' },
    groupFormLabel: { type: 'string' },
    group: { type: 'string' },
    formLabel: { type: 'string' },
  },
  required: [
    'checked',
    'requirement',
    'group',
    'pageIndex',
    'signer',
    'documentId',
    'id',
    'name',
    'required',
    'readOnly',
    'x',
    'y',
    'width',
    'height',
    'type',
  ],
};
const schema16 = {
  title: 'TextField',
  properties: {
    type: { const: 'text', default: 'text' },
    pageIndex: { type: 'number' },
    id: { type: 'string' },
    apiId: { type: 'string' },
    documentId: { type: 'string' },
    x: { type: 'number' },
    y: { type: 'number' },
    width: { type: 'number' },
    height: { type: 'number' },
    signer: { type: 'string' },
    required: { type: 'boolean' },
    readOnly: { type: 'boolean' },
    name: { type: 'string' },
    autoFillType: { $ref: '#/definitions/AutoFillType' },
    linkId: { type: 'string' },
    isDisabled: { type: 'boolean' },
    fontSize: { $ref: '#/definitions/FontSize' },
    originalFontSize: { $ref: '#/definitions/FontSize' },
    fontFamily: { $ref: '#/definitions/FontFamily' },
    value: { type: 'string' },
    placeholder: { type: 'string' },
    masked: { type: 'boolean' },
    isEditableMergeField: { type: 'boolean' },
    lines: { type: 'string' },
    numLines: { type: 'number' },
    numCharsPerLine: { type: 'number' },
    lineHeight: { type: 'number' },
    integrationMetadata: { $ref: '#/definitions/FieldIntegrationMetadata' },
    validationType: { $ref: '#/definitions/ValidationType' },
    validationCustomRegex: { type: 'string' },
    validationCustomRegexFormatLabel: { type: 'string' },
    formLabel: { type: 'string' },
    linkIdViaApi: { type: 'boolean' },
  },
  required: [
    'pageIndex',
    'signer',
    'documentId',
    'fontSize',
    'fontFamily',
    'type',
    'id',
    'name',
    'required',
    'readOnly',
    'x',
    'y',
    'width',
    'height',
  ],
};
const schema17 = {
  type: 'string',
  title: 'AutoFillType',
  enum: [
    'name',
    'lastName',
    'firstName',
    'company',
    'email',
    'emailOrPhoneNumber',
    'title',
    'none',
  ],
};
const schema18 = { type: 'number', title: 'FontSize', minimum: 7, maximum: 48 };
const schema20 = {
  type: 'string',
  enum: [
    'helvetica',
    'arial',
    'calibri',
    'cambria',
    'courier',
    'georgia',
    'times',
    'trebuchet',
    'verdana',
    'notoSerif',
    'notoSans',
    'roboto',
    'robotoMono',
  ],
  title: 'FontFamily',
};
const schema21 = {
  type: 'object',
  title: 'FieldIntegrationMetadata',
  description: 'Currently only being used for HubSpot V2 integration',
  properties: {
    externalName: { type: 'string' },
    externalType: { type: 'string' },
    isTopField: { type: 'boolean' },
  },
};
const schema22 = {
  type: 'string',
  title: 'ValidationType',
  description: 'Validation options available for a text field',
  enum: [
    'numbers_only',
    'letters_only',
    'phone_number',
    'bank_routing_number',
    'bank_account_number',
    'email_address',
    'zip_code',
    'social_security_number',
    'employer_identification_number',
    'custom_regex',
  ],
};
function validate14(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    let missing0;
    if (
      (data.pageIndex === undefined && (missing0 = 'pageIndex')) ||
      (data.signer === undefined && (missing0 = 'signer')) ||
      (data.documentId === undefined && (missing0 = 'documentId')) ||
      (data.fontSize === undefined && (missing0 = 'fontSize')) ||
      (data.fontFamily === undefined && (missing0 = 'fontFamily')) ||
      (data.type === undefined && (missing0 = 'type')) ||
      (data.id === undefined && (missing0 = 'id')) ||
      (data.name === undefined && (missing0 = 'name')) ||
      (data.required === undefined && (missing0 = 'required')) ||
      (data.readOnly === undefined && (missing0 = 'readOnly')) ||
      (data.x === undefined && (missing0 = 'x')) ||
      (data.y === undefined && (missing0 = 'y')) ||
      (data.width === undefined && (missing0 = 'width')) ||
      (data.height === undefined && (missing0 = 'height'))
    ) {
      validate14.errors = [
        {
          instancePath,
          schemaPath: '#/required',
          keyword: 'required',
          params: { missingProperty: missing0 },
          message: "must have required property '" + missing0 + "'",
        },
      ];
      return false;
    } else {
      if (data.type !== undefined) {
        const _errs0 = errors;
        if (!func0(data.type, 'text')) {
          validate14.errors = [
            {
              instancePath: instancePath + '/type',
              schemaPath: '#/properties/type/const',
              keyword: 'const',
              params: { allowedValue: 'text' },
              message: 'must be equal to constant',
            },
          ];
          return false;
        }
        var valid0 = _errs0 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.pageIndex !== undefined) {
          let data1 = data.pageIndex;
          const _errs1 = errors;
          if (!(typeof data1 == 'number' && isFinite(data1))) {
            validate14.errors = [
              {
                instancePath: instancePath + '/pageIndex',
                schemaPath: '#/properties/pageIndex/type',
                keyword: 'type',
                params: { type: 'number' },
                message: 'must be number',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.id !== undefined) {
            const _errs3 = errors;
            if (typeof data.id !== 'string') {
              validate14.errors = [
                {
                  instancePath: instancePath + '/id',
                  schemaPath: '#/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.apiId !== undefined) {
              const _errs5 = errors;
              if (typeof data.apiId !== 'string') {
                validate14.errors = [
                  {
                    instancePath: instancePath + '/apiId',
                    schemaPath: '#/properties/apiId/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.documentId !== undefined) {
                const _errs7 = errors;
                if (typeof data.documentId !== 'string') {
                  validate14.errors = [
                    {
                      instancePath: instancePath + '/documentId',
                      schemaPath: '#/properties/documentId/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.x !== undefined) {
                  let data5 = data.x;
                  const _errs9 = errors;
                  if (!(typeof data5 == 'number' && isFinite(data5))) {
                    validate14.errors = [
                      {
                        instancePath: instancePath + '/x',
                        schemaPath: '#/properties/x/type',
                        keyword: 'type',
                        params: { type: 'number' },
                        message: 'must be number',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.y !== undefined) {
                    let data6 = data.y;
                    const _errs11 = errors;
                    if (!(typeof data6 == 'number' && isFinite(data6))) {
                      validate14.errors = [
                        {
                          instancePath: instancePath + '/y',
                          schemaPath: '#/properties/y/type',
                          keyword: 'type',
                          params: { type: 'number' },
                          message: 'must be number',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.width !== undefined) {
                      let data7 = data.width;
                      const _errs13 = errors;
                      if (!(typeof data7 == 'number' && isFinite(data7))) {
                        validate14.errors = [
                          {
                            instancePath: instancePath + '/width',
                            schemaPath: '#/properties/width/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.height !== undefined) {
                        let data8 = data.height;
                        const _errs15 = errors;
                        if (!(typeof data8 == 'number' && isFinite(data8))) {
                          validate14.errors = [
                            {
                              instancePath: instancePath + '/height',
                              schemaPath: '#/properties/height/type',
                              keyword: 'type',
                              params: { type: 'number' },
                              message: 'must be number',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.signer !== undefined) {
                          const _errs17 = errors;
                          if (typeof data.signer !== 'string') {
                            validate14.errors = [
                              {
                                instancePath: instancePath + '/signer',
                                schemaPath: '#/properties/signer/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs17 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.required !== undefined) {
                            const _errs19 = errors;
                            if (typeof data.required !== 'boolean') {
                              validate14.errors = [
                                {
                                  instancePath: instancePath + '/required',
                                  schemaPath: '#/properties/required/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs19 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.readOnly !== undefined) {
                              const _errs21 = errors;
                              if (typeof data.readOnly !== 'boolean') {
                                validate14.errors = [
                                  {
                                    instancePath: instancePath + '/readOnly',
                                    schemaPath: '#/properties/readOnly/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs21 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.name !== undefined) {
                                const _errs23 = errors;
                                if (typeof data.name !== 'string') {
                                  validate14.errors = [
                                    {
                                      instancePath: instancePath + '/name',
                                      schemaPath: '#/properties/name/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs23 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.autoFillType !== undefined) {
                                  let data13 = data.autoFillType;
                                  const _errs25 = errors;
                                  if (typeof data13 !== 'string') {
                                    validate14.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/autoFillType',
                                        schemaPath:
                                          '#/definitions/AutoFillType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  if (
                                    !(
                                      data13 === 'name' ||
                                      data13 === 'lastName' ||
                                      data13 === 'firstName' ||
                                      data13 === 'company' ||
                                      data13 === 'email' ||
                                      data13 === 'emailOrPhoneNumber' ||
                                      data13 === 'title' ||
                                      data13 === 'none'
                                    )
                                  ) {
                                    validate14.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/autoFillType',
                                        schemaPath:
                                          '#/definitions/AutoFillType/enum',
                                        keyword: 'enum',
                                        params: {
                                          allowedValues: schema17.enum,
                                        },
                                        message:
                                          'must be equal to one of the allowed values',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs25 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.linkId !== undefined) {
                                    const _errs28 = errors;
                                    if (typeof data.linkId !== 'string') {
                                      validate14.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/linkId',
                                          schemaPath:
                                            '#/properties/linkId/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid0 = _errs28 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.isDisabled !== undefined) {
                                      const _errs30 = errors;
                                      if (
                                        typeof data.isDisabled !== 'boolean'
                                      ) {
                                        validate14.errors = [
                                          {
                                            instancePath:
                                              instancePath + '/isDisabled',
                                            schemaPath:
                                              '#/properties/isDisabled/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid0 = _errs30 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.fontSize !== undefined) {
                                        let data16 = data.fontSize;
                                        const _errs32 = errors;
                                        const _errs33 = errors;
                                        if (errors === _errs33) {
                                          if (
                                            typeof data16 == 'number' &&
                                            isFinite(data16)
                                          ) {
                                            if (data16 > 48 || isNaN(data16)) {
                                              validate14.errors = [
                                                {
                                                  instancePath:
                                                    instancePath + '/fontSize',
                                                  schemaPath:
                                                    '#/definitions/FontSize/maximum',
                                                  keyword: 'maximum',
                                                  params: {
                                                    comparison: '<=',
                                                    limit: 48,
                                                  },
                                                  message: 'must be <= 48',
                                                },
                                              ];
                                              return false;
                                            } else {
                                              if (data16 < 7 || isNaN(data16)) {
                                                validate14.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/fontSize',
                                                    schemaPath:
                                                      '#/definitions/FontSize/minimum',
                                                    keyword: 'minimum',
                                                    params: {
                                                      comparison: '>=',
                                                      limit: 7,
                                                    },
                                                    message: 'must be >= 7',
                                                  },
                                                ];
                                                return false;
                                              }
                                            }
                                          } else {
                                            validate14.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/fontSize',
                                                schemaPath:
                                                  '#/definitions/FontSize/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number',
                                              },
                                            ];
                                            return false;
                                          }
                                        }
                                        var valid0 = _errs32 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (
                                          data.originalFontSize !== undefined
                                        ) {
                                          let data17 = data.originalFontSize;
                                          const _errs35 = errors;
                                          const _errs36 = errors;
                                          if (errors === _errs36) {
                                            if (
                                              typeof data17 == 'number' &&
                                              isFinite(data17)
                                            ) {
                                              if (
                                                data17 > 48 ||
                                                isNaN(data17)
                                              ) {
                                                validate14.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/originalFontSize',
                                                    schemaPath:
                                                      '#/definitions/FontSize/maximum',
                                                    keyword: 'maximum',
                                                    params: {
                                                      comparison: '<=',
                                                      limit: 48,
                                                    },
                                                    message: 'must be <= 48',
                                                  },
                                                ];
                                                return false;
                                              } else {
                                                if (
                                                  data17 < 7 ||
                                                  isNaN(data17)
                                                ) {
                                                  validate14.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/originalFontSize',
                                                      schemaPath:
                                                        '#/definitions/FontSize/minimum',
                                                      keyword: 'minimum',
                                                      params: {
                                                        comparison: '>=',
                                                        limit: 7,
                                                      },
                                                      message: 'must be >= 7',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                              }
                                            } else {
                                              validate14.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/originalFontSize',
                                                  schemaPath:
                                                    '#/definitions/FontSize/type',
                                                  keyword: 'type',
                                                  params: { type: 'number' },
                                                  message: 'must be number',
                                                },
                                              ];
                                              return false;
                                            }
                                          }
                                          var valid0 = _errs35 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                        if (valid0) {
                                          if (data.fontFamily !== undefined) {
                                            let data18 = data.fontFamily;
                                            const _errs38 = errors;
                                            if (typeof data18 !== 'string') {
                                              validate14.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/fontFamily',
                                                  schemaPath:
                                                    '#/definitions/FontFamily/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                },
                                              ];
                                              return false;
                                            }
                                            if (
                                              !(
                                                data18 === 'helvetica' ||
                                                data18 === 'arial' ||
                                                data18 === 'calibri' ||
                                                data18 === 'cambria' ||
                                                data18 === 'courier' ||
                                                data18 === 'georgia' ||
                                                data18 === 'times' ||
                                                data18 === 'trebuchet' ||
                                                data18 === 'verdana' ||
                                                data18 === 'notoSerif' ||
                                                data18 === 'notoSans' ||
                                                data18 === 'roboto' ||
                                                data18 === 'robotoMono'
                                              )
                                            ) {
                                              validate14.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/fontFamily',
                                                  schemaPath:
                                                    '#/definitions/FontFamily/enum',
                                                  keyword: 'enum',
                                                  params: {
                                                    allowedValues:
                                                      schema20.enum,
                                                  },
                                                  message:
                                                    'must be equal to one of the allowed values',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid0 = _errs38 === errors;
                                          } else {
                                            var valid0 = true;
                                          }
                                          if (valid0) {
                                            if (data.value !== undefined) {
                                              const _errs41 = errors;
                                              if (
                                                typeof data.value !== 'string'
                                              ) {
                                                validate14.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath + '/value',
                                                    schemaPath:
                                                      '#/properties/value/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid0 = _errs41 === errors;
                                            } else {
                                              var valid0 = true;
                                            }
                                            if (valid0) {
                                              if (
                                                data.placeholder !== undefined
                                              ) {
                                                const _errs43 = errors;
                                                if (
                                                  typeof data.placeholder !==
                                                  'string'
                                                ) {
                                                  validate14.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/placeholder',
                                                      schemaPath:
                                                        '#/properties/placeholder/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'string',
                                                      },
                                                      message: 'must be string',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid0 = _errs43 === errors;
                                              } else {
                                                var valid0 = true;
                                              }
                                              if (valid0) {
                                                if (data.masked !== undefined) {
                                                  const _errs45 = errors;
                                                  if (
                                                    typeof data.masked !==
                                                    'boolean'
                                                  ) {
                                                    validate14.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath +
                                                          '/masked',
                                                        schemaPath:
                                                          '#/properties/masked/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'boolean',
                                                        },
                                                        message:
                                                          'must be boolean',
                                                      },
                                                    ];
                                                    return false;
                                                  }
                                                  var valid0 =
                                                    _errs45 === errors;
                                                } else {
                                                  var valid0 = true;
                                                }
                                                if (valid0) {
                                                  if (
                                                    data.isEditableMergeField !==
                                                    undefined
                                                  ) {
                                                    const _errs47 = errors;
                                                    if (
                                                      typeof data.isEditableMergeField !==
                                                      'boolean'
                                                    ) {
                                                      validate14.errors = [
                                                        {
                                                          instancePath:
                                                            instancePath +
                                                            '/isEditableMergeField',
                                                          schemaPath:
                                                            '#/properties/isEditableMergeField/type',
                                                          keyword: 'type',
                                                          params: {
                                                            type: 'boolean',
                                                          },
                                                          message:
                                                            'must be boolean',
                                                        },
                                                      ];
                                                      return false;
                                                    }
                                                    var valid0 =
                                                      _errs47 === errors;
                                                  } else {
                                                    var valid0 = true;
                                                  }
                                                  if (valid0) {
                                                    if (
                                                      data.lines !== undefined
                                                    ) {
                                                      const _errs49 = errors;
                                                      if (
                                                        typeof data.lines !==
                                                        'string'
                                                      ) {
                                                        validate14.errors = [
                                                          {
                                                            instancePath:
                                                              instancePath +
                                                              '/lines',
                                                            schemaPath:
                                                              '#/properties/lines/type',
                                                            keyword: 'type',
                                                            params: {
                                                              type: 'string',
                                                            },
                                                            message:
                                                              'must be string',
                                                          },
                                                        ];
                                                        return false;
                                                      }
                                                      var valid0 =
                                                        _errs49 === errors;
                                                    } else {
                                                      var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                      if (
                                                        data.numLines !==
                                                        undefined
                                                      ) {
                                                        let data24 =
                                                          data.numLines;
                                                        const _errs51 = errors;
                                                        if (
                                                          !(
                                                            typeof data24 ==
                                                              'number' &&
                                                            isFinite(data24)
                                                          )
                                                        ) {
                                                          validate14.errors = [
                                                            {
                                                              instancePath:
                                                                instancePath +
                                                                '/numLines',
                                                              schemaPath:
                                                                '#/properties/numLines/type',
                                                              keyword: 'type',
                                                              params: {
                                                                type: 'number',
                                                              },
                                                              message:
                                                                'must be number',
                                                            },
                                                          ];
                                                          return false;
                                                        }
                                                        var valid0 =
                                                          _errs51 === errors;
                                                      } else {
                                                        var valid0 = true;
                                                      }
                                                      if (valid0) {
                                                        if (
                                                          data.numCharsPerLine !==
                                                          undefined
                                                        ) {
                                                          let data25 =
                                                            data.numCharsPerLine;
                                                          const _errs53 =
                                                            errors;
                                                          if (
                                                            !(
                                                              typeof data25 ==
                                                                'number' &&
                                                              isFinite(data25)
                                                            )
                                                          ) {
                                                            validate14.errors =
                                                              [
                                                                {
                                                                  instancePath:
                                                                    instancePath +
                                                                    '/numCharsPerLine',
                                                                  schemaPath:
                                                                    '#/properties/numCharsPerLine/type',
                                                                  keyword:
                                                                    'type',
                                                                  params: {
                                                                    type: 'number',
                                                                  },
                                                                  message:
                                                                    'must be number',
                                                                },
                                                              ];
                                                            return false;
                                                          }
                                                          var valid0 =
                                                            _errs53 === errors;
                                                        } else {
                                                          var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                          if (
                                                            data.lineHeight !==
                                                            undefined
                                                          ) {
                                                            let data26 =
                                                              data.lineHeight;
                                                            const _errs55 =
                                                              errors;
                                                            if (
                                                              !(
                                                                typeof data26 ==
                                                                  'number' &&
                                                                isFinite(data26)
                                                              )
                                                            ) {
                                                              validate14.errors =
                                                                [
                                                                  {
                                                                    instancePath:
                                                                      instancePath +
                                                                      '/lineHeight',
                                                                    schemaPath:
                                                                      '#/properties/lineHeight/type',
                                                                    keyword:
                                                                      'type',
                                                                    params: {
                                                                      type: 'number',
                                                                    },
                                                                    message:
                                                                      'must be number',
                                                                  },
                                                                ];
                                                              return false;
                                                            }
                                                            var valid0 =
                                                              _errs55 ===
                                                              errors;
                                                          } else {
                                                            var valid0 = true;
                                                          }
                                                          if (valid0) {
                                                            if (
                                                              data.integrationMetadata !==
                                                              undefined
                                                            ) {
                                                              let data27 =
                                                                data.integrationMetadata;
                                                              const _errs57 =
                                                                errors;
                                                              const _errs58 =
                                                                errors;
                                                              if (
                                                                errors ===
                                                                _errs58
                                                              ) {
                                                                if (
                                                                  data27 &&
                                                                  typeof data27 ==
                                                                    'object' &&
                                                                  !Array.isArray(
                                                                    data27,
                                                                  )
                                                                ) {
                                                                  if (
                                                                    data27.externalName !==
                                                                    undefined
                                                                  ) {
                                                                    const _errs60 =
                                                                      errors;
                                                                    if (
                                                                      typeof data27.externalName !==
                                                                      'string'
                                                                    ) {
                                                                      validate14.errors =
                                                                        [
                                                                          {
                                                                            instancePath:
                                                                              instancePath +
                                                                              '/integrationMetadata/externalName',
                                                                            schemaPath:
                                                                              '#/definitions/FieldIntegrationMetadata/properties/externalName/type',
                                                                            keyword:
                                                                              'type',
                                                                            params:
                                                                              {
                                                                                type: 'string',
                                                                              },
                                                                            message:
                                                                              'must be string',
                                                                          },
                                                                        ];
                                                                      return false;
                                                                    }
                                                                    var valid6 =
                                                                      _errs60 ===
                                                                      errors;
                                                                  } else {
                                                                    var valid6 = true;
                                                                  }
                                                                  if (valid6) {
                                                                    if (
                                                                      data27.externalType !==
                                                                      undefined
                                                                    ) {
                                                                      const _errs62 =
                                                                        errors;
                                                                      if (
                                                                        typeof data27.externalType !==
                                                                        'string'
                                                                      ) {
                                                                        validate14.errors =
                                                                          [
                                                                            {
                                                                              instancePath:
                                                                                instancePath +
                                                                                '/integrationMetadata/externalType',
                                                                              schemaPath:
                                                                                '#/definitions/FieldIntegrationMetadata/properties/externalType/type',
                                                                              keyword:
                                                                                'type',
                                                                              params:
                                                                                {
                                                                                  type: 'string',
                                                                                },
                                                                              message:
                                                                                'must be string',
                                                                            },
                                                                          ];
                                                                        return false;
                                                                      }
                                                                      var valid6 =
                                                                        _errs62 ===
                                                                        errors;
                                                                    } else {
                                                                      var valid6 = true;
                                                                    }
                                                                    if (
                                                                      valid6
                                                                    ) {
                                                                      if (
                                                                        data27.isTopField !==
                                                                        undefined
                                                                      ) {
                                                                        const _errs64 =
                                                                          errors;
                                                                        if (
                                                                          typeof data27.isTopField !==
                                                                          'boolean'
                                                                        ) {
                                                                          validate14.errors =
                                                                            [
                                                                              {
                                                                                instancePath:
                                                                                  instancePath +
                                                                                  '/integrationMetadata/isTopField',
                                                                                schemaPath:
                                                                                  '#/definitions/FieldIntegrationMetadata/properties/isTopField/type',
                                                                                keyword:
                                                                                  'type',
                                                                                params:
                                                                                  {
                                                                                    type: 'boolean',
                                                                                  },
                                                                                message:
                                                                                  'must be boolean',
                                                                              },
                                                                            ];
                                                                          return false;
                                                                        }
                                                                        var valid6 =
                                                                          _errs64 ===
                                                                          errors;
                                                                      } else {
                                                                        var valid6 = true;
                                                                      }
                                                                    }
                                                                  }
                                                                } else {
                                                                  validate14.errors =
                                                                    [
                                                                      {
                                                                        instancePath:
                                                                          instancePath +
                                                                          '/integrationMetadata',
                                                                        schemaPath:
                                                                          '#/definitions/FieldIntegrationMetadata/type',
                                                                        keyword:
                                                                          'type',
                                                                        params:
                                                                          {
                                                                            type: 'object',
                                                                          },
                                                                        message:
                                                                          'must be object',
                                                                      },
                                                                    ];
                                                                  return false;
                                                                }
                                                              }
                                                              var valid0 =
                                                                _errs57 ===
                                                                errors;
                                                            } else {
                                                              var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                              if (
                                                                data.validationType !==
                                                                undefined
                                                              ) {
                                                                let data31 =
                                                                  data.validationType;
                                                                const _errs66 =
                                                                  errors;
                                                                if (
                                                                  typeof data31 !==
                                                                  'string'
                                                                ) {
                                                                  validate14.errors =
                                                                    [
                                                                      {
                                                                        instancePath:
                                                                          instancePath +
                                                                          '/validationType',
                                                                        schemaPath:
                                                                          '#/definitions/ValidationType/type',
                                                                        keyword:
                                                                          'type',
                                                                        params:
                                                                          {
                                                                            type: 'string',
                                                                          },
                                                                        message:
                                                                          'must be string',
                                                                      },
                                                                    ];
                                                                  return false;
                                                                }
                                                                if (
                                                                  !(
                                                                    data31 ===
                                                                      'numbers_only' ||
                                                                    data31 ===
                                                                      'letters_only' ||
                                                                    data31 ===
                                                                      'phone_number' ||
                                                                    data31 ===
                                                                      'bank_routing_number' ||
                                                                    data31 ===
                                                                      'bank_account_number' ||
                                                                    data31 ===
                                                                      'email_address' ||
                                                                    data31 ===
                                                                      'zip_code' ||
                                                                    data31 ===
                                                                      'social_security_number' ||
                                                                    data31 ===
                                                                      'employer_identification_number' ||
                                                                    data31 ===
                                                                      'custom_regex'
                                                                  )
                                                                ) {
                                                                  validate14.errors =
                                                                    [
                                                                      {
                                                                        instancePath:
                                                                          instancePath +
                                                                          '/validationType',
                                                                        schemaPath:
                                                                          '#/definitions/ValidationType/enum',
                                                                        keyword:
                                                                          'enum',
                                                                        params:
                                                                          {
                                                                            allowedValues:
                                                                              schema22.enum,
                                                                          },
                                                                        message:
                                                                          'must be equal to one of the allowed values',
                                                                      },
                                                                    ];
                                                                  return false;
                                                                }
                                                                var valid0 =
                                                                  _errs66 ===
                                                                  errors;
                                                              } else {
                                                                var valid0 = true;
                                                              }
                                                              if (valid0) {
                                                                if (
                                                                  data.validationCustomRegex !==
                                                                  undefined
                                                                ) {
                                                                  const _errs69 =
                                                                    errors;
                                                                  if (
                                                                    typeof data.validationCustomRegex !==
                                                                    'string'
                                                                  ) {
                                                                    validate14.errors =
                                                                      [
                                                                        {
                                                                          instancePath:
                                                                            instancePath +
                                                                            '/validationCustomRegex',
                                                                          schemaPath:
                                                                            '#/properties/validationCustomRegex/type',
                                                                          keyword:
                                                                            'type',
                                                                          params:
                                                                            {
                                                                              type: 'string',
                                                                            },
                                                                          message:
                                                                            'must be string',
                                                                        },
                                                                      ];
                                                                    return false;
                                                                  }
                                                                  var valid0 =
                                                                    _errs69 ===
                                                                    errors;
                                                                } else {
                                                                  var valid0 = true;
                                                                }
                                                                if (valid0) {
                                                                  if (
                                                                    data.validationCustomRegexFormatLabel !==
                                                                    undefined
                                                                  ) {
                                                                    const _errs71 =
                                                                      errors;
                                                                    if (
                                                                      typeof data.validationCustomRegexFormatLabel !==
                                                                      'string'
                                                                    ) {
                                                                      validate14.errors =
                                                                        [
                                                                          {
                                                                            instancePath:
                                                                              instancePath +
                                                                              '/validationCustomRegexFormatLabel',
                                                                            schemaPath:
                                                                              '#/properties/validationCustomRegexFormatLabel/type',
                                                                            keyword:
                                                                              'type',
                                                                            params:
                                                                              {
                                                                                type: 'string',
                                                                              },
                                                                            message:
                                                                              'must be string',
                                                                          },
                                                                        ];
                                                                      return false;
                                                                    }
                                                                    var valid0 =
                                                                      _errs71 ===
                                                                      errors;
                                                                  } else {
                                                                    var valid0 = true;
                                                                  }
                                                                  if (valid0) {
                                                                    if (
                                                                      data.formLabel !==
                                                                      undefined
                                                                    ) {
                                                                      const _errs73 =
                                                                        errors;
                                                                      if (
                                                                        typeof data.formLabel !==
                                                                        'string'
                                                                      ) {
                                                                        validate14.errors =
                                                                          [
                                                                            {
                                                                              instancePath:
                                                                                instancePath +
                                                                                '/formLabel',
                                                                              schemaPath:
                                                                                '#/properties/formLabel/type',
                                                                              keyword:
                                                                                'type',
                                                                              params:
                                                                                {
                                                                                  type: 'string',
                                                                                },
                                                                              message:
                                                                                'must be string',
                                                                            },
                                                                          ];
                                                                        return false;
                                                                      }
                                                                      var valid0 =
                                                                        _errs73 ===
                                                                        errors;
                                                                    } else {
                                                                      var valid0 = true;
                                                                    }
                                                                    if (
                                                                      valid0
                                                                    ) {
                                                                      if (
                                                                        data.linkIdViaApi !==
                                                                        undefined
                                                                      ) {
                                                                        const _errs75 =
                                                                          errors;
                                                                        if (
                                                                          typeof data.linkIdViaApi !==
                                                                          'boolean'
                                                                        ) {
                                                                          validate14.errors =
                                                                            [
                                                                              {
                                                                                instancePath:
                                                                                  instancePath +
                                                                                  '/linkIdViaApi',
                                                                                schemaPath:
                                                                                  '#/properties/linkIdViaApi/type',
                                                                                keyword:
                                                                                  'type',
                                                                                params:
                                                                                  {
                                                                                    type: 'boolean',
                                                                                  },
                                                                                message:
                                                                                  'must be boolean',
                                                                              },
                                                                            ];
                                                                          return false;
                                                                        }
                                                                        var valid0 =
                                                                          _errs75 ===
                                                                          errors;
                                                                      } else {
                                                                        var valid0 = true;
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  validate14.errors = vErrors;
  return errors === 0;
}
const schema23 = {
  title: 'SignatureField',
  properties: {
    type: { const: 'signature', default: 'signature' },
    pageIndex: { type: 'number' },
    id: { type: 'string' },
    apiId: { type: 'string' },
    documentId: { type: 'string' },
    x: { type: 'number' },
    y: { type: 'number' },
    width: { type: 'number' },
    height: { type: 'number' },
    signer: { type: 'string' },
    required: { type: 'boolean' },
    readOnly: { type: 'boolean' },
    name: { type: 'string' },
    linkId: { type: 'string' },
    isDisabled: { type: 'boolean' },
    signature: { $ref: '#/definitions/Signature' },
    color: { $ref: '#/definitions/Color' },
    formLabel: { type: 'string' },
  },
  required: [
    'pageIndex',
    'signer',
    'documentId',
    'id',
    'name',
    'required',
    'readOnly',
    'x',
    'y',
    'width',
    'height',
    'type',
  ],
};
const schema27 = {
  type: 'string',
  title: 'Color',
  enum: ['black', 'blue', 'red'],
};
const schema24 = {
  type: 'object',
  title: 'Signature',
  additionalProperties: false,
  properties: {
    type: { $ref: '#/definitions/SignatureType' },
    createType: { $ref: '#/definitions/SignatureCreateType' },
    createdAt: { type: 'string', format: 'date-time' },
    lastUsedAt: { type: 'string', format: 'date-time' },
    guid: { type: 'string' },
    width: { type: 'number' },
    height: { type: 'number' },
  },
  required: ['guid', 'type'],
};
const schema25 = { type: 'string', title: 'SignatureType', enum: ['S', 'I'] };
const schema26 = {
  type: 'string',
  title: 'SignatureCreateType',
  enum: ['A', 'C', 'U', 'T', 'E', 'X'],
};
const formats0 = require('ajv-formats/dist/formats').fullFormats['date-time'];
function validate17(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.guid === undefined && (missing0 = 'guid')) ||
        (data.type === undefined && (missing0 = 'type'))
      ) {
        validate17.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (
            !(
              key0 === 'type' ||
              key0 === 'createType' ||
              key0 === 'createdAt' ||
              key0 === 'lastUsedAt' ||
              key0 === 'guid' ||
              key0 === 'width' ||
              key0 === 'height'
            )
          ) {
            validate17.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.type !== undefined) {
            let data0 = data.type;
            const _errs2 = errors;
            if (typeof data0 !== 'string') {
              validate17.errors = [
                {
                  instancePath: instancePath + '/type',
                  schemaPath: '#/definitions/SignatureType/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            if (!(data0 === 'S' || data0 === 'I')) {
              validate17.errors = [
                {
                  instancePath: instancePath + '/type',
                  schemaPath: '#/definitions/SignatureType/enum',
                  keyword: 'enum',
                  params: { allowedValues: schema25.enum },
                  message: 'must be equal to one of the allowed values',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.createType !== undefined) {
              let data1 = data.createType;
              const _errs5 = errors;
              if (typeof data1 !== 'string') {
                validate17.errors = [
                  {
                    instancePath: instancePath + '/createType',
                    schemaPath: '#/definitions/SignatureCreateType/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              if (
                !(
                  data1 === 'A' ||
                  data1 === 'C' ||
                  data1 === 'U' ||
                  data1 === 'T' ||
                  data1 === 'E' ||
                  data1 === 'X'
                )
              ) {
                validate17.errors = [
                  {
                    instancePath: instancePath + '/createType',
                    schemaPath: '#/definitions/SignatureCreateType/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema26.enum },
                    message: 'must be equal to one of the allowed values',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.createdAt !== undefined) {
                let data2 = data.createdAt;
                const _errs8 = errors;
                if (errors === _errs8) {
                  if (errors === _errs8) {
                    if (typeof data2 === 'string') {
                      if (!formats0.validate(data2)) {
                        validate17.errors = [
                          {
                            instancePath: instancePath + '/createdAt',
                            schemaPath: '#/properties/createdAt/format',
                            keyword: 'format',
                            params: { format: 'date-time' },
                            message: 'must match format "' + 'date-time' + '"',
                          },
                        ];
                        return false;
                      }
                    } else {
                      validate17.errors = [
                        {
                          instancePath: instancePath + '/createdAt',
                          schemaPath: '#/properties/createdAt/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                  }
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.lastUsedAt !== undefined) {
                  let data3 = data.lastUsedAt;
                  const _errs10 = errors;
                  if (errors === _errs10) {
                    if (errors === _errs10) {
                      if (typeof data3 === 'string') {
                        if (!formats0.validate(data3)) {
                          validate17.errors = [
                            {
                              instancePath: instancePath + '/lastUsedAt',
                              schemaPath: '#/properties/lastUsedAt/format',
                              keyword: 'format',
                              params: { format: 'date-time' },
                              message:
                                'must match format "' + 'date-time' + '"',
                            },
                          ];
                          return false;
                        }
                      } else {
                        validate17.errors = [
                          {
                            instancePath: instancePath + '/lastUsedAt',
                            schemaPath: '#/properties/lastUsedAt/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                    }
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.guid !== undefined) {
                    const _errs12 = errors;
                    if (typeof data.guid !== 'string') {
                      validate17.errors = [
                        {
                          instancePath: instancePath + '/guid',
                          schemaPath: '#/properties/guid/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.width !== undefined) {
                      let data5 = data.width;
                      const _errs14 = errors;
                      if (!(typeof data5 == 'number' && isFinite(data5))) {
                        validate17.errors = [
                          {
                            instancePath: instancePath + '/width',
                            schemaPath: '#/properties/width/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs14 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.height !== undefined) {
                        let data6 = data.height;
                        const _errs16 = errors;
                        if (!(typeof data6 == 'number' && isFinite(data6))) {
                          validate17.errors = [
                            {
                              instancePath: instancePath + '/height',
                              schemaPath: '#/properties/height/type',
                              keyword: 'type',
                              params: { type: 'number' },
                              message: 'must be number',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs16 === errors;
                      } else {
                        var valid0 = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate17.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate17.errors = vErrors;
  return errors === 0;
}
function validate16(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    let missing0;
    if (
      (data.pageIndex === undefined && (missing0 = 'pageIndex')) ||
      (data.signer === undefined && (missing0 = 'signer')) ||
      (data.documentId === undefined && (missing0 = 'documentId')) ||
      (data.id === undefined && (missing0 = 'id')) ||
      (data.name === undefined && (missing0 = 'name')) ||
      (data.required === undefined && (missing0 = 'required')) ||
      (data.readOnly === undefined && (missing0 = 'readOnly')) ||
      (data.x === undefined && (missing0 = 'x')) ||
      (data.y === undefined && (missing0 = 'y')) ||
      (data.width === undefined && (missing0 = 'width')) ||
      (data.height === undefined && (missing0 = 'height')) ||
      (data.type === undefined && (missing0 = 'type'))
    ) {
      validate16.errors = [
        {
          instancePath,
          schemaPath: '#/required',
          keyword: 'required',
          params: { missingProperty: missing0 },
          message: "must have required property '" + missing0 + "'",
        },
      ];
      return false;
    } else {
      if (data.type !== undefined) {
        const _errs0 = errors;
        if (!func0(data.type, 'signature')) {
          validate16.errors = [
            {
              instancePath: instancePath + '/type',
              schemaPath: '#/properties/type/const',
              keyword: 'const',
              params: { allowedValue: 'signature' },
              message: 'must be equal to constant',
            },
          ];
          return false;
        }
        var valid0 = _errs0 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.pageIndex !== undefined) {
          let data1 = data.pageIndex;
          const _errs1 = errors;
          if (!(typeof data1 == 'number' && isFinite(data1))) {
            validate16.errors = [
              {
                instancePath: instancePath + '/pageIndex',
                schemaPath: '#/properties/pageIndex/type',
                keyword: 'type',
                params: { type: 'number' },
                message: 'must be number',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.id !== undefined) {
            const _errs3 = errors;
            if (typeof data.id !== 'string') {
              validate16.errors = [
                {
                  instancePath: instancePath + '/id',
                  schemaPath: '#/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.apiId !== undefined) {
              const _errs5 = errors;
              if (typeof data.apiId !== 'string') {
                validate16.errors = [
                  {
                    instancePath: instancePath + '/apiId',
                    schemaPath: '#/properties/apiId/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.documentId !== undefined) {
                const _errs7 = errors;
                if (typeof data.documentId !== 'string') {
                  validate16.errors = [
                    {
                      instancePath: instancePath + '/documentId',
                      schemaPath: '#/properties/documentId/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.x !== undefined) {
                  let data5 = data.x;
                  const _errs9 = errors;
                  if (!(typeof data5 == 'number' && isFinite(data5))) {
                    validate16.errors = [
                      {
                        instancePath: instancePath + '/x',
                        schemaPath: '#/properties/x/type',
                        keyword: 'type',
                        params: { type: 'number' },
                        message: 'must be number',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.y !== undefined) {
                    let data6 = data.y;
                    const _errs11 = errors;
                    if (!(typeof data6 == 'number' && isFinite(data6))) {
                      validate16.errors = [
                        {
                          instancePath: instancePath + '/y',
                          schemaPath: '#/properties/y/type',
                          keyword: 'type',
                          params: { type: 'number' },
                          message: 'must be number',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.width !== undefined) {
                      let data7 = data.width;
                      const _errs13 = errors;
                      if (!(typeof data7 == 'number' && isFinite(data7))) {
                        validate16.errors = [
                          {
                            instancePath: instancePath + '/width',
                            schemaPath: '#/properties/width/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.height !== undefined) {
                        let data8 = data.height;
                        const _errs15 = errors;
                        if (!(typeof data8 == 'number' && isFinite(data8))) {
                          validate16.errors = [
                            {
                              instancePath: instancePath + '/height',
                              schemaPath: '#/properties/height/type',
                              keyword: 'type',
                              params: { type: 'number' },
                              message: 'must be number',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.signer !== undefined) {
                          const _errs17 = errors;
                          if (typeof data.signer !== 'string') {
                            validate16.errors = [
                              {
                                instancePath: instancePath + '/signer',
                                schemaPath: '#/properties/signer/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs17 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.required !== undefined) {
                            const _errs19 = errors;
                            if (typeof data.required !== 'boolean') {
                              validate16.errors = [
                                {
                                  instancePath: instancePath + '/required',
                                  schemaPath: '#/properties/required/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs19 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.readOnly !== undefined) {
                              const _errs21 = errors;
                              if (typeof data.readOnly !== 'boolean') {
                                validate16.errors = [
                                  {
                                    instancePath: instancePath + '/readOnly',
                                    schemaPath: '#/properties/readOnly/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs21 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.name !== undefined) {
                                const _errs23 = errors;
                                if (typeof data.name !== 'string') {
                                  validate16.errors = [
                                    {
                                      instancePath: instancePath + '/name',
                                      schemaPath: '#/properties/name/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs23 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.linkId !== undefined) {
                                  const _errs25 = errors;
                                  if (typeof data.linkId !== 'string') {
                                    validate16.errors = [
                                      {
                                        instancePath: instancePath + '/linkId',
                                        schemaPath: '#/properties/linkId/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs25 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.isDisabled !== undefined) {
                                    const _errs27 = errors;
                                    if (typeof data.isDisabled !== 'boolean') {
                                      validate16.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/isDisabled',
                                          schemaPath:
                                            '#/properties/isDisabled/type',
                                          keyword: 'type',
                                          params: { type: 'boolean' },
                                          message: 'must be boolean',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid0 = _errs27 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.signature !== undefined) {
                                      const _errs29 = errors;
                                      if (
                                        !validate17(data.signature, {
                                          instancePath:
                                            instancePath + '/signature',
                                          parentData: data,
                                          parentDataProperty: 'signature',
                                          rootData,
                                        })
                                      ) {
                                        vErrors =
                                          vErrors === null
                                            ? validate17.errors
                                            : vErrors.concat(validate17.errors);
                                        errors = vErrors.length;
                                      }
                                      var valid0 = _errs29 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.color !== undefined) {
                                        let data16 = data.color;
                                        const _errs30 = errors;
                                        if (typeof data16 !== 'string') {
                                          validate16.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/color',
                                              schemaPath:
                                                '#/definitions/Color/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                        if (
                                          !(
                                            data16 === 'black' ||
                                            data16 === 'blue' ||
                                            data16 === 'red'
                                          )
                                        ) {
                                          validate16.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/color',
                                              schemaPath:
                                                '#/definitions/Color/enum',
                                              keyword: 'enum',
                                              params: {
                                                allowedValues: schema27.enum,
                                              },
                                              message:
                                                'must be equal to one of the allowed values',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid0 = _errs30 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (data.formLabel !== undefined) {
                                          const _errs33 = errors;
                                          if (
                                            typeof data.formLabel !== 'string'
                                          ) {
                                            validate16.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/formLabel',
                                                schemaPath:
                                                  '#/properties/formLabel/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid0 = _errs33 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  validate16.errors = vErrors;
  return errors === 0;
}
const schema28 = {
  title: 'InitialsField',
  properties: {
    type: { const: 'initials', default: 'initials' },
    pageIndex: { type: 'number' },
    id: { type: 'string' },
    apiId: { type: 'string' },
    documentId: { type: 'string' },
    x: { type: 'number' },
    y: { type: 'number' },
    width: { type: 'number' },
    height: { type: 'number' },
    signer: { type: 'string' },
    required: { type: 'boolean' },
    readOnly: { type: 'boolean' },
    name: { type: 'string' },
    linkId: { type: 'string' },
    isDisabled: { type: 'boolean' },
    signature: { $ref: '#/definitions/Signature' },
    color: { $ref: '#/definitions/Color' },
    formLabel: { type: 'string' },
  },
  required: [
    'pageIndex',
    'signer',
    'documentId',
    'id',
    'name',
    'required',
    'readOnly',
    'x',
    'y',
    'width',
    'height',
    'type',
  ],
};
function validate20(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    let missing0;
    if (
      (data.pageIndex === undefined && (missing0 = 'pageIndex')) ||
      (data.signer === undefined && (missing0 = 'signer')) ||
      (data.documentId === undefined && (missing0 = 'documentId')) ||
      (data.id === undefined && (missing0 = 'id')) ||
      (data.name === undefined && (missing0 = 'name')) ||
      (data.required === undefined && (missing0 = 'required')) ||
      (data.readOnly === undefined && (missing0 = 'readOnly')) ||
      (data.x === undefined && (missing0 = 'x')) ||
      (data.y === undefined && (missing0 = 'y')) ||
      (data.width === undefined && (missing0 = 'width')) ||
      (data.height === undefined && (missing0 = 'height')) ||
      (data.type === undefined && (missing0 = 'type'))
    ) {
      validate20.errors = [
        {
          instancePath,
          schemaPath: '#/required',
          keyword: 'required',
          params: { missingProperty: missing0 },
          message: "must have required property '" + missing0 + "'",
        },
      ];
      return false;
    } else {
      if (data.type !== undefined) {
        const _errs0 = errors;
        if (!func0(data.type, 'initials')) {
          validate20.errors = [
            {
              instancePath: instancePath + '/type',
              schemaPath: '#/properties/type/const',
              keyword: 'const',
              params: { allowedValue: 'initials' },
              message: 'must be equal to constant',
            },
          ];
          return false;
        }
        var valid0 = _errs0 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.pageIndex !== undefined) {
          let data1 = data.pageIndex;
          const _errs1 = errors;
          if (!(typeof data1 == 'number' && isFinite(data1))) {
            validate20.errors = [
              {
                instancePath: instancePath + '/pageIndex',
                schemaPath: '#/properties/pageIndex/type',
                keyword: 'type',
                params: { type: 'number' },
                message: 'must be number',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.id !== undefined) {
            const _errs3 = errors;
            if (typeof data.id !== 'string') {
              validate20.errors = [
                {
                  instancePath: instancePath + '/id',
                  schemaPath: '#/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.apiId !== undefined) {
              const _errs5 = errors;
              if (typeof data.apiId !== 'string') {
                validate20.errors = [
                  {
                    instancePath: instancePath + '/apiId',
                    schemaPath: '#/properties/apiId/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.documentId !== undefined) {
                const _errs7 = errors;
                if (typeof data.documentId !== 'string') {
                  validate20.errors = [
                    {
                      instancePath: instancePath + '/documentId',
                      schemaPath: '#/properties/documentId/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.x !== undefined) {
                  let data5 = data.x;
                  const _errs9 = errors;
                  if (!(typeof data5 == 'number' && isFinite(data5))) {
                    validate20.errors = [
                      {
                        instancePath: instancePath + '/x',
                        schemaPath: '#/properties/x/type',
                        keyword: 'type',
                        params: { type: 'number' },
                        message: 'must be number',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.y !== undefined) {
                    let data6 = data.y;
                    const _errs11 = errors;
                    if (!(typeof data6 == 'number' && isFinite(data6))) {
                      validate20.errors = [
                        {
                          instancePath: instancePath + '/y',
                          schemaPath: '#/properties/y/type',
                          keyword: 'type',
                          params: { type: 'number' },
                          message: 'must be number',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.width !== undefined) {
                      let data7 = data.width;
                      const _errs13 = errors;
                      if (!(typeof data7 == 'number' && isFinite(data7))) {
                        validate20.errors = [
                          {
                            instancePath: instancePath + '/width',
                            schemaPath: '#/properties/width/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.height !== undefined) {
                        let data8 = data.height;
                        const _errs15 = errors;
                        if (!(typeof data8 == 'number' && isFinite(data8))) {
                          validate20.errors = [
                            {
                              instancePath: instancePath + '/height',
                              schemaPath: '#/properties/height/type',
                              keyword: 'type',
                              params: { type: 'number' },
                              message: 'must be number',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.signer !== undefined) {
                          const _errs17 = errors;
                          if (typeof data.signer !== 'string') {
                            validate20.errors = [
                              {
                                instancePath: instancePath + '/signer',
                                schemaPath: '#/properties/signer/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs17 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.required !== undefined) {
                            const _errs19 = errors;
                            if (typeof data.required !== 'boolean') {
                              validate20.errors = [
                                {
                                  instancePath: instancePath + '/required',
                                  schemaPath: '#/properties/required/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs19 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.readOnly !== undefined) {
                              const _errs21 = errors;
                              if (typeof data.readOnly !== 'boolean') {
                                validate20.errors = [
                                  {
                                    instancePath: instancePath + '/readOnly',
                                    schemaPath: '#/properties/readOnly/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs21 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.name !== undefined) {
                                const _errs23 = errors;
                                if (typeof data.name !== 'string') {
                                  validate20.errors = [
                                    {
                                      instancePath: instancePath + '/name',
                                      schemaPath: '#/properties/name/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs23 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.linkId !== undefined) {
                                  const _errs25 = errors;
                                  if (typeof data.linkId !== 'string') {
                                    validate20.errors = [
                                      {
                                        instancePath: instancePath + '/linkId',
                                        schemaPath: '#/properties/linkId/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs25 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.isDisabled !== undefined) {
                                    const _errs27 = errors;
                                    if (typeof data.isDisabled !== 'boolean') {
                                      validate20.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/isDisabled',
                                          schemaPath:
                                            '#/properties/isDisabled/type',
                                          keyword: 'type',
                                          params: { type: 'boolean' },
                                          message: 'must be boolean',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid0 = _errs27 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.signature !== undefined) {
                                      const _errs29 = errors;
                                      if (
                                        !validate17(data.signature, {
                                          instancePath:
                                            instancePath + '/signature',
                                          parentData: data,
                                          parentDataProperty: 'signature',
                                          rootData,
                                        })
                                      ) {
                                        vErrors =
                                          vErrors === null
                                            ? validate17.errors
                                            : vErrors.concat(validate17.errors);
                                        errors = vErrors.length;
                                      }
                                      var valid0 = _errs29 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.color !== undefined) {
                                        let data16 = data.color;
                                        const _errs30 = errors;
                                        if (typeof data16 !== 'string') {
                                          validate20.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/color',
                                              schemaPath:
                                                '#/definitions/Color/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                        if (
                                          !(
                                            data16 === 'black' ||
                                            data16 === 'blue' ||
                                            data16 === 'red'
                                          )
                                        ) {
                                          validate20.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/color',
                                              schemaPath:
                                                '#/definitions/Color/enum',
                                              keyword: 'enum',
                                              params: {
                                                allowedValues: schema27.enum,
                                              },
                                              message:
                                                'must be equal to one of the allowed values',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid0 = _errs30 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (data.formLabel !== undefined) {
                                          const _errs33 = errors;
                                          if (
                                            typeof data.formLabel !== 'string'
                                          ) {
                                            validate20.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/formLabel',
                                                schemaPath:
                                                  '#/properties/formLabel/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid0 = _errs33 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  validate20.errors = vErrors;
  return errors === 0;
}
const schema30 = {
  title: 'DateField',
  properties: {
    pageIndex: { type: 'number' },
    id: { type: 'string' },
    apiId: { type: 'string' },
    documentId: { type: 'string' },
    x: { type: 'number' },
    y: { type: 'number' },
    width: { type: 'number' },
    height: { type: 'number' },
    signer: { type: 'string' },
    required: { type: 'boolean' },
    readOnly: { type: 'boolean' },
    name: { type: 'string' },
    linkId: { type: 'string' },
    isDisabled: { type: 'boolean' },
    fontSize: { $ref: '#/definitions/FontSize' },
    originalFontSize: { $ref: '#/definitions/FontSize' },
    fontFamily: { $ref: '#/definitions/FontFamily' },
    lineHeight: { type: 'number' },
    value: { type: ['string', 'null'] },
    placeholder: { type: 'string' },
    type: { const: 'date', default: 'date' },
    dateFormat: { $ref: '#/definitions/JSDateFormat' },
    formLabel: { type: 'string' },
  },
  required: [
    'pageIndex',
    'signer',
    'documentId',
    'value',
    'fontSize',
    'fontFamily',
    'type',
    'id',
    'name',
    'required',
    'readOnly',
    'x',
    'y',
    'width',
    'height',
  ],
};
function validate23(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    let missing0;
    if (
      (data.pageIndex === undefined && (missing0 = 'pageIndex')) ||
      (data.signer === undefined && (missing0 = 'signer')) ||
      (data.documentId === undefined && (missing0 = 'documentId')) ||
      (data.value === undefined && (missing0 = 'value')) ||
      (data.fontSize === undefined && (missing0 = 'fontSize')) ||
      (data.fontFamily === undefined && (missing0 = 'fontFamily')) ||
      (data.type === undefined && (missing0 = 'type')) ||
      (data.id === undefined && (missing0 = 'id')) ||
      (data.name === undefined && (missing0 = 'name')) ||
      (data.required === undefined && (missing0 = 'required')) ||
      (data.readOnly === undefined && (missing0 = 'readOnly')) ||
      (data.x === undefined && (missing0 = 'x')) ||
      (data.y === undefined && (missing0 = 'y')) ||
      (data.width === undefined && (missing0 = 'width')) ||
      (data.height === undefined && (missing0 = 'height'))
    ) {
      validate23.errors = [
        {
          instancePath,
          schemaPath: '#/required',
          keyword: 'required',
          params: { missingProperty: missing0 },
          message: "must have required property '" + missing0 + "'",
        },
      ];
      return false;
    } else {
      if (data.pageIndex !== undefined) {
        let data0 = data.pageIndex;
        const _errs0 = errors;
        if (!(typeof data0 == 'number' && isFinite(data0))) {
          validate23.errors = [
            {
              instancePath: instancePath + '/pageIndex',
              schemaPath: '#/properties/pageIndex/type',
              keyword: 'type',
              params: { type: 'number' },
              message: 'must be number',
            },
          ];
          return false;
        }
        var valid0 = _errs0 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.id !== undefined) {
          const _errs2 = errors;
          if (typeof data.id !== 'string') {
            validate23.errors = [
              {
                instancePath: instancePath + '/id',
                schemaPath: '#/properties/id/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid0 = _errs2 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.apiId !== undefined) {
            const _errs4 = errors;
            if (typeof data.apiId !== 'string') {
              validate23.errors = [
                {
                  instancePath: instancePath + '/apiId',
                  schemaPath: '#/properties/apiId/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs4 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.documentId !== undefined) {
              const _errs6 = errors;
              if (typeof data.documentId !== 'string') {
                validate23.errors = [
                  {
                    instancePath: instancePath + '/documentId',
                    schemaPath: '#/properties/documentId/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.x !== undefined) {
                let data4 = data.x;
                const _errs8 = errors;
                if (!(typeof data4 == 'number' && isFinite(data4))) {
                  validate23.errors = [
                    {
                      instancePath: instancePath + '/x',
                      schemaPath: '#/properties/x/type',
                      keyword: 'type',
                      params: { type: 'number' },
                      message: 'must be number',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.y !== undefined) {
                  let data5 = data.y;
                  const _errs10 = errors;
                  if (!(typeof data5 == 'number' && isFinite(data5))) {
                    validate23.errors = [
                      {
                        instancePath: instancePath + '/y',
                        schemaPath: '#/properties/y/type',
                        keyword: 'type',
                        params: { type: 'number' },
                        message: 'must be number',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.width !== undefined) {
                    let data6 = data.width;
                    const _errs12 = errors;
                    if (!(typeof data6 == 'number' && isFinite(data6))) {
                      validate23.errors = [
                        {
                          instancePath: instancePath + '/width',
                          schemaPath: '#/properties/width/type',
                          keyword: 'type',
                          params: { type: 'number' },
                          message: 'must be number',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.height !== undefined) {
                      let data7 = data.height;
                      const _errs14 = errors;
                      if (!(typeof data7 == 'number' && isFinite(data7))) {
                        validate23.errors = [
                          {
                            instancePath: instancePath + '/height',
                            schemaPath: '#/properties/height/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs14 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.signer !== undefined) {
                        const _errs16 = errors;
                        if (typeof data.signer !== 'string') {
                          validate23.errors = [
                            {
                              instancePath: instancePath + '/signer',
                              schemaPath: '#/properties/signer/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs16 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.required !== undefined) {
                          const _errs18 = errors;
                          if (typeof data.required !== 'boolean') {
                            validate23.errors = [
                              {
                                instancePath: instancePath + '/required',
                                schemaPath: '#/properties/required/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs18 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.readOnly !== undefined) {
                            const _errs20 = errors;
                            if (typeof data.readOnly !== 'boolean') {
                              validate23.errors = [
                                {
                                  instancePath: instancePath + '/readOnly',
                                  schemaPath: '#/properties/readOnly/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs20 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.name !== undefined) {
                              const _errs22 = errors;
                              if (typeof data.name !== 'string') {
                                validate23.errors = [
                                  {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs22 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.linkId !== undefined) {
                                const _errs24 = errors;
                                if (typeof data.linkId !== 'string') {
                                  validate23.errors = [
                                    {
                                      instancePath: instancePath + '/linkId',
                                      schemaPath: '#/properties/linkId/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs24 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.isDisabled !== undefined) {
                                  const _errs26 = errors;
                                  if (typeof data.isDisabled !== 'boolean') {
                                    validate23.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/isDisabled',
                                        schemaPath:
                                          '#/properties/isDisabled/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs26 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.fontSize !== undefined) {
                                    let data14 = data.fontSize;
                                    const _errs28 = errors;
                                    const _errs29 = errors;
                                    if (errors === _errs29) {
                                      if (
                                        typeof data14 == 'number' &&
                                        isFinite(data14)
                                      ) {
                                        if (data14 > 48 || isNaN(data14)) {
                                          validate23.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/fontSize',
                                              schemaPath:
                                                '#/definitions/FontSize/maximum',
                                              keyword: 'maximum',
                                              params: {
                                                comparison: '<=',
                                                limit: 48,
                                              },
                                              message: 'must be <= 48',
                                            },
                                          ];
                                          return false;
                                        } else {
                                          if (data14 < 7 || isNaN(data14)) {
                                            validate23.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/fontSize',
                                                schemaPath:
                                                  '#/definitions/FontSize/minimum',
                                                keyword: 'minimum',
                                                params: {
                                                  comparison: '>=',
                                                  limit: 7,
                                                },
                                                message: 'must be >= 7',
                                              },
                                            ];
                                            return false;
                                          }
                                        }
                                      } else {
                                        validate23.errors = [
                                          {
                                            instancePath:
                                              instancePath + '/fontSize',
                                            schemaPath:
                                              '#/definitions/FontSize/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number',
                                          },
                                        ];
                                        return false;
                                      }
                                    }
                                    var valid0 = _errs28 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.originalFontSize !== undefined) {
                                      let data15 = data.originalFontSize;
                                      const _errs31 = errors;
                                      const _errs32 = errors;
                                      if (errors === _errs32) {
                                        if (
                                          typeof data15 == 'number' &&
                                          isFinite(data15)
                                        ) {
                                          if (data15 > 48 || isNaN(data15)) {
                                            validate23.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/originalFontSize',
                                                schemaPath:
                                                  '#/definitions/FontSize/maximum',
                                                keyword: 'maximum',
                                                params: {
                                                  comparison: '<=',
                                                  limit: 48,
                                                },
                                                message: 'must be <= 48',
                                              },
                                            ];
                                            return false;
                                          } else {
                                            if (data15 < 7 || isNaN(data15)) {
                                              validate23.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/originalFontSize',
                                                  schemaPath:
                                                    '#/definitions/FontSize/minimum',
                                                  keyword: 'minimum',
                                                  params: {
                                                    comparison: '>=',
                                                    limit: 7,
                                                  },
                                                  message: 'must be >= 7',
                                                },
                                              ];
                                              return false;
                                            }
                                          }
                                        } else {
                                          validate23.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/originalFontSize',
                                              schemaPath:
                                                '#/definitions/FontSize/type',
                                              keyword: 'type',
                                              params: { type: 'number' },
                                              message: 'must be number',
                                            },
                                          ];
                                          return false;
                                        }
                                      }
                                      var valid0 = _errs31 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.fontFamily !== undefined) {
                                        let data16 = data.fontFamily;
                                        const _errs34 = errors;
                                        if (typeof data16 !== 'string') {
                                          validate23.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/fontFamily',
                                              schemaPath:
                                                '#/definitions/FontFamily/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                        if (
                                          !(
                                            data16 === 'helvetica' ||
                                            data16 === 'arial' ||
                                            data16 === 'calibri' ||
                                            data16 === 'cambria' ||
                                            data16 === 'courier' ||
                                            data16 === 'georgia' ||
                                            data16 === 'times' ||
                                            data16 === 'trebuchet' ||
                                            data16 === 'verdana' ||
                                            data16 === 'notoSerif' ||
                                            data16 === 'notoSans' ||
                                            data16 === 'roboto' ||
                                            data16 === 'robotoMono'
                                          )
                                        ) {
                                          validate23.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/fontFamily',
                                              schemaPath:
                                                '#/definitions/FontFamily/enum',
                                              keyword: 'enum',
                                              params: {
                                                allowedValues: schema20.enum,
                                              },
                                              message:
                                                'must be equal to one of the allowed values',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid0 = _errs34 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (data.lineHeight !== undefined) {
                                          let data17 = data.lineHeight;
                                          const _errs37 = errors;
                                          if (
                                            !(
                                              typeof data17 == 'number' &&
                                              isFinite(data17)
                                            )
                                          ) {
                                            validate23.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/lineHeight',
                                                schemaPath:
                                                  '#/properties/lineHeight/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid0 = _errs37 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                        if (valid0) {
                                          if (data.value !== undefined) {
                                            let data18 = data.value;
                                            const _errs39 = errors;
                                            if (
                                              typeof data18 !== 'string' &&
                                              data18 !== null
                                            ) {
                                              validate23.errors = [
                                                {
                                                  instancePath:
                                                    instancePath + '/value',
                                                  schemaPath:
                                                    '#/properties/value/type',
                                                  keyword: 'type',
                                                  params: {
                                                    type: schema30.properties
                                                      .value.type,
                                                  },
                                                  message:
                                                    'must be string,null',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid0 = _errs39 === errors;
                                          } else {
                                            var valid0 = true;
                                          }
                                          if (valid0) {
                                            if (
                                              data.placeholder !== undefined
                                            ) {
                                              const _errs41 = errors;
                                              if (
                                                typeof data.placeholder !==
                                                'string'
                                              ) {
                                                validate23.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/placeholder',
                                                    schemaPath:
                                                      '#/properties/placeholder/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid0 = _errs41 === errors;
                                            } else {
                                              var valid0 = true;
                                            }
                                            if (valid0) {
                                              if (data.type !== undefined) {
                                                const _errs43 = errors;
                                                if (!func0(data.type, 'date')) {
                                                  validate23.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath + '/type',
                                                      schemaPath:
                                                        '#/properties/type/const',
                                                      keyword: 'const',
                                                      params: {
                                                        allowedValue: 'date',
                                                      },
                                                      message:
                                                        'must be equal to constant',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid0 = _errs43 === errors;
                                              } else {
                                                var valid0 = true;
                                              }
                                              if (valid0) {
                                                if (
                                                  data.dateFormat !== undefined
                                                ) {
                                                  let data21 = data.dateFormat;
                                                  const _errs44 = errors;
                                                  if (
                                                    typeof data21 !== 'string'
                                                  ) {
                                                    validate23.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath +
                                                          '/dateFormat',
                                                        schemaPath:
                                                          '#/definitions/JSDateFormat/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'string',
                                                        },
                                                        message:
                                                          'must be string',
                                                      },
                                                    ];
                                                    return false;
                                                  }
                                                  if (
                                                    !(
                                                      data21 === 'default' ||
                                                      data21 ===
                                                        'MM / DD / YYYY' ||
                                                      data21 ===
                                                        'MM - DD - YYYY' ||
                                                      data21 ===
                                                        'DD / MM / YYYY' ||
                                                      data21 ===
                                                        'DD - MM - YYYY' ||
                                                      data21 ===
                                                        'YYYY / MM / DD' ||
                                                      data21 ===
                                                        'YYYY - MM - DD'
                                                    )
                                                  ) {
                                                    validate23.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath +
                                                          '/dateFormat',
                                                        schemaPath:
                                                          '#/definitions/JSDateFormat/enum',
                                                        keyword: 'enum',
                                                        params: {
                                                          allowedValues:
                                                            schema34.enum,
                                                        },
                                                        message:
                                                          'must be equal to one of the allowed values',
                                                      },
                                                    ];
                                                    return false;
                                                  }
                                                  var valid0 =
                                                    _errs44 === errors;
                                                } else {
                                                  var valid0 = true;
                                                }
                                                if (valid0) {
                                                  if (
                                                    data.formLabel !== undefined
                                                  ) {
                                                    const _errs47 = errors;
                                                    if (
                                                      typeof data.formLabel !==
                                                      'string'
                                                    ) {
                                                      validate23.errors = [
                                                        {
                                                          instancePath:
                                                            instancePath +
                                                            '/formLabel',
                                                          schemaPath:
                                                            '#/properties/formLabel/type',
                                                          keyword: 'type',
                                                          params: {
                                                            type: 'string',
                                                          },
                                                          message:
                                                            'must be string',
                                                        },
                                                      ];
                                                      return false;
                                                    }
                                                    var valid0 =
                                                      _errs47 === errors;
                                                  } else {
                                                    var valid0 = true;
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  validate23.errors = vErrors;
  return errors === 0;
}
const schema35 = {
  title: 'CheckboxField',
  properties: {
    pageIndex: { type: 'number' },
    id: { type: 'string' },
    apiId: { type: 'string' },
    documentId: { type: 'string' },
    x: { type: 'number' },
    y: { type: 'number' },
    width: { type: 'number' },
    height: { type: 'number' },
    signer: { type: 'string' },
    required: { type: 'boolean' },
    readOnly: { type: 'boolean' },
    name: { type: 'string' },
    isDisabled: { type: 'boolean' },
    type: { const: 'checkbox', default: 'checkbox' },
    checked: { type: 'boolean' },
    requirement: { type: 'string' },
    groupLabel: { type: 'string' },
    groupFormLabel: { type: 'string' },
    group: { type: 'string' },
    integrationMetadata: { $ref: '#/definitions/FieldIntegrationMetadata' },
    formLabel: { type: 'string' },
  },
  required: [
    'pageIndex',
    'signer',
    'documentId',
    'id',
    'name',
    'required',
    'readOnly',
    'x',
    'y',
    'width',
    'height',
    'type',
  ],
};
function validate25(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    let missing0;
    if (
      (data.pageIndex === undefined && (missing0 = 'pageIndex')) ||
      (data.signer === undefined && (missing0 = 'signer')) ||
      (data.documentId === undefined && (missing0 = 'documentId')) ||
      (data.id === undefined && (missing0 = 'id')) ||
      (data.name === undefined && (missing0 = 'name')) ||
      (data.required === undefined && (missing0 = 'required')) ||
      (data.readOnly === undefined && (missing0 = 'readOnly')) ||
      (data.x === undefined && (missing0 = 'x')) ||
      (data.y === undefined && (missing0 = 'y')) ||
      (data.width === undefined && (missing0 = 'width')) ||
      (data.height === undefined && (missing0 = 'height')) ||
      (data.type === undefined && (missing0 = 'type'))
    ) {
      validate25.errors = [
        {
          instancePath,
          schemaPath: '#/required',
          keyword: 'required',
          params: { missingProperty: missing0 },
          message: "must have required property '" + missing0 + "'",
        },
      ];
      return false;
    } else {
      if (data.pageIndex !== undefined) {
        let data0 = data.pageIndex;
        const _errs0 = errors;
        if (!(typeof data0 == 'number' && isFinite(data0))) {
          validate25.errors = [
            {
              instancePath: instancePath + '/pageIndex',
              schemaPath: '#/properties/pageIndex/type',
              keyword: 'type',
              params: { type: 'number' },
              message: 'must be number',
            },
          ];
          return false;
        }
        var valid0 = _errs0 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.id !== undefined) {
          const _errs2 = errors;
          if (typeof data.id !== 'string') {
            validate25.errors = [
              {
                instancePath: instancePath + '/id',
                schemaPath: '#/properties/id/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid0 = _errs2 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.apiId !== undefined) {
            const _errs4 = errors;
            if (typeof data.apiId !== 'string') {
              validate25.errors = [
                {
                  instancePath: instancePath + '/apiId',
                  schemaPath: '#/properties/apiId/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs4 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.documentId !== undefined) {
              const _errs6 = errors;
              if (typeof data.documentId !== 'string') {
                validate25.errors = [
                  {
                    instancePath: instancePath + '/documentId',
                    schemaPath: '#/properties/documentId/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.x !== undefined) {
                let data4 = data.x;
                const _errs8 = errors;
                if (!(typeof data4 == 'number' && isFinite(data4))) {
                  validate25.errors = [
                    {
                      instancePath: instancePath + '/x',
                      schemaPath: '#/properties/x/type',
                      keyword: 'type',
                      params: { type: 'number' },
                      message: 'must be number',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.y !== undefined) {
                  let data5 = data.y;
                  const _errs10 = errors;
                  if (!(typeof data5 == 'number' && isFinite(data5))) {
                    validate25.errors = [
                      {
                        instancePath: instancePath + '/y',
                        schemaPath: '#/properties/y/type',
                        keyword: 'type',
                        params: { type: 'number' },
                        message: 'must be number',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.width !== undefined) {
                    let data6 = data.width;
                    const _errs12 = errors;
                    if (!(typeof data6 == 'number' && isFinite(data6))) {
                      validate25.errors = [
                        {
                          instancePath: instancePath + '/width',
                          schemaPath: '#/properties/width/type',
                          keyword: 'type',
                          params: { type: 'number' },
                          message: 'must be number',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.height !== undefined) {
                      let data7 = data.height;
                      const _errs14 = errors;
                      if (!(typeof data7 == 'number' && isFinite(data7))) {
                        validate25.errors = [
                          {
                            instancePath: instancePath + '/height',
                            schemaPath: '#/properties/height/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs14 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.signer !== undefined) {
                        const _errs16 = errors;
                        if (typeof data.signer !== 'string') {
                          validate25.errors = [
                            {
                              instancePath: instancePath + '/signer',
                              schemaPath: '#/properties/signer/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs16 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.required !== undefined) {
                          const _errs18 = errors;
                          if (typeof data.required !== 'boolean') {
                            validate25.errors = [
                              {
                                instancePath: instancePath + '/required',
                                schemaPath: '#/properties/required/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs18 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.readOnly !== undefined) {
                            const _errs20 = errors;
                            if (typeof data.readOnly !== 'boolean') {
                              validate25.errors = [
                                {
                                  instancePath: instancePath + '/readOnly',
                                  schemaPath: '#/properties/readOnly/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs20 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.name !== undefined) {
                              const _errs22 = errors;
                              if (typeof data.name !== 'string') {
                                validate25.errors = [
                                  {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs22 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.isDisabled !== undefined) {
                                const _errs24 = errors;
                                if (typeof data.isDisabled !== 'boolean') {
                                  validate25.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/isDisabled',
                                      schemaPath:
                                        '#/properties/isDisabled/type',
                                      keyword: 'type',
                                      params: { type: 'boolean' },
                                      message: 'must be boolean',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs24 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.type !== undefined) {
                                  const _errs26 = errors;
                                  if (!func0(data.type, 'checkbox')) {
                                    validate25.errors = [
                                      {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/const',
                                        keyword: 'const',
                                        params: { allowedValue: 'checkbox' },
                                        message: 'must be equal to constant',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs26 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.checked !== undefined) {
                                    const _errs27 = errors;
                                    if (typeof data.checked !== 'boolean') {
                                      validate25.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/checked',
                                          schemaPath:
                                            '#/properties/checked/type',
                                          keyword: 'type',
                                          params: { type: 'boolean' },
                                          message: 'must be boolean',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid0 = _errs27 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.requirement !== undefined) {
                                      const _errs29 = errors;
                                      if (
                                        typeof data.requirement !== 'string'
                                      ) {
                                        validate25.errors = [
                                          {
                                            instancePath:
                                              instancePath + '/requirement',
                                            schemaPath:
                                              '#/properties/requirement/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid0 = _errs29 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.groupLabel !== undefined) {
                                        const _errs31 = errors;
                                        if (
                                          typeof data.groupLabel !== 'string'
                                        ) {
                                          validate25.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/groupLabel',
                                              schemaPath:
                                                '#/properties/groupLabel/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid0 = _errs31 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (data.groupFormLabel !== undefined) {
                                          const _errs33 = errors;
                                          if (
                                            typeof data.groupFormLabel !==
                                            'string'
                                          ) {
                                            validate25.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/groupFormLabel',
                                                schemaPath:
                                                  '#/properties/groupFormLabel/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid0 = _errs33 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                        if (valid0) {
                                          if (data.group !== undefined) {
                                            const _errs35 = errors;
                                            if (
                                              typeof data.group !== 'string'
                                            ) {
                                              validate25.errors = [
                                                {
                                                  instancePath:
                                                    instancePath + '/group',
                                                  schemaPath:
                                                    '#/properties/group/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid0 = _errs35 === errors;
                                          } else {
                                            var valid0 = true;
                                          }
                                          if (valid0) {
                                            if (
                                              data.integrationMetadata !==
                                              undefined
                                            ) {
                                              let data19 =
                                                data.integrationMetadata;
                                              const _errs37 = errors;
                                              const _errs38 = errors;
                                              if (errors === _errs38) {
                                                if (
                                                  data19 &&
                                                  typeof data19 == 'object' &&
                                                  !Array.isArray(data19)
                                                ) {
                                                  if (
                                                    data19.externalName !==
                                                    undefined
                                                  ) {
                                                    const _errs40 = errors;
                                                    if (
                                                      typeof data19.externalName !==
                                                      'string'
                                                    ) {
                                                      validate25.errors = [
                                                        {
                                                          instancePath:
                                                            instancePath +
                                                            '/integrationMetadata/externalName',
                                                          schemaPath:
                                                            '#/definitions/FieldIntegrationMetadata/properties/externalName/type',
                                                          keyword: 'type',
                                                          params: {
                                                            type: 'string',
                                                          },
                                                          message:
                                                            'must be string',
                                                        },
                                                      ];
                                                      return false;
                                                    }
                                                    var valid2 =
                                                      _errs40 === errors;
                                                  } else {
                                                    var valid2 = true;
                                                  }
                                                  if (valid2) {
                                                    if (
                                                      data19.externalType !==
                                                      undefined
                                                    ) {
                                                      const _errs42 = errors;
                                                      if (
                                                        typeof data19.externalType !==
                                                        'string'
                                                      ) {
                                                        validate25.errors = [
                                                          {
                                                            instancePath:
                                                              instancePath +
                                                              '/integrationMetadata/externalType',
                                                            schemaPath:
                                                              '#/definitions/FieldIntegrationMetadata/properties/externalType/type',
                                                            keyword: 'type',
                                                            params: {
                                                              type: 'string',
                                                            },
                                                            message:
                                                              'must be string',
                                                          },
                                                        ];
                                                        return false;
                                                      }
                                                      var valid2 =
                                                        _errs42 === errors;
                                                    } else {
                                                      var valid2 = true;
                                                    }
                                                    if (valid2) {
                                                      if (
                                                        data19.isTopField !==
                                                        undefined
                                                      ) {
                                                        const _errs44 = errors;
                                                        if (
                                                          typeof data19.isTopField !==
                                                          'boolean'
                                                        ) {
                                                          validate25.errors = [
                                                            {
                                                              instancePath:
                                                                instancePath +
                                                                '/integrationMetadata/isTopField',
                                                              schemaPath:
                                                                '#/definitions/FieldIntegrationMetadata/properties/isTopField/type',
                                                              keyword: 'type',
                                                              params: {
                                                                type: 'boolean',
                                                              },
                                                              message:
                                                                'must be boolean',
                                                            },
                                                          ];
                                                          return false;
                                                        }
                                                        var valid2 =
                                                          _errs44 === errors;
                                                      } else {
                                                        var valid2 = true;
                                                      }
                                                    }
                                                  }
                                                } else {
                                                  validate25.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/integrationMetadata',
                                                      schemaPath:
                                                        '#/definitions/FieldIntegrationMetadata/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'object',
                                                      },
                                                      message: 'must be object',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                              }
                                              var valid0 = _errs37 === errors;
                                            } else {
                                              var valid0 = true;
                                            }
                                            if (valid0) {
                                              if (
                                                data.formLabel !== undefined
                                              ) {
                                                const _errs46 = errors;
                                                if (
                                                  typeof data.formLabel !==
                                                  'string'
                                                ) {
                                                  validate25.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/formLabel',
                                                      schemaPath:
                                                        '#/properties/formLabel/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'string',
                                                      },
                                                      message: 'must be string',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid0 = _errs46 === errors;
                                              } else {
                                                var valid0 = true;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  validate25.errors = vErrors;
  return errors === 0;
}
const schema38 = {
  title: 'DropdownField',
  properties: {
    pageIndex: { type: 'number' },
    id: { type: 'string' },
    apiId: { type: 'string' },
    documentId: { type: 'string' },
    x: { type: 'number' },
    y: { type: 'number' },
    width: { type: 'number' },
    height: { type: 'number' },
    signer: { type: 'string' },
    required: { type: 'boolean' },
    readOnly: { type: 'boolean' },
    name: { type: 'string' },
    isDisabled: { type: 'boolean' },
    type: { const: 'dropdown', default: 'dropdown' },
    value: { type: ['string', 'null'] },
    options: { type: 'array', items: { type: 'string' } },
    fontSize: { $ref: '#/definitions/FontSize' },
    fontFamily: { $ref: '#/definitions/FontFamily' },
    lineHeight: { type: 'number' },
    formLabel: { type: 'string' },
  },
  required: [
    'pageIndex',
    'signer',
    'documentId',
    'fontSize',
    'fontFamily',
    'type',
    'id',
    'name',
    'required',
    'readOnly',
    'x',
    'y',
    'width',
    'height',
    'options',
  ],
};
function validate27(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    let missing0;
    if (
      (data.pageIndex === undefined && (missing0 = 'pageIndex')) ||
      (data.signer === undefined && (missing0 = 'signer')) ||
      (data.documentId === undefined && (missing0 = 'documentId')) ||
      (data.fontSize === undefined && (missing0 = 'fontSize')) ||
      (data.fontFamily === undefined && (missing0 = 'fontFamily')) ||
      (data.type === undefined && (missing0 = 'type')) ||
      (data.id === undefined && (missing0 = 'id')) ||
      (data.name === undefined && (missing0 = 'name')) ||
      (data.required === undefined && (missing0 = 'required')) ||
      (data.readOnly === undefined && (missing0 = 'readOnly')) ||
      (data.x === undefined && (missing0 = 'x')) ||
      (data.y === undefined && (missing0 = 'y')) ||
      (data.width === undefined && (missing0 = 'width')) ||
      (data.height === undefined && (missing0 = 'height')) ||
      (data.options === undefined && (missing0 = 'options'))
    ) {
      validate27.errors = [
        {
          instancePath,
          schemaPath: '#/required',
          keyword: 'required',
          params: { missingProperty: missing0 },
          message: "must have required property '" + missing0 + "'",
        },
      ];
      return false;
    } else {
      if (data.pageIndex !== undefined) {
        let data0 = data.pageIndex;
        const _errs0 = errors;
        if (!(typeof data0 == 'number' && isFinite(data0))) {
          validate27.errors = [
            {
              instancePath: instancePath + '/pageIndex',
              schemaPath: '#/properties/pageIndex/type',
              keyword: 'type',
              params: { type: 'number' },
              message: 'must be number',
            },
          ];
          return false;
        }
        var valid0 = _errs0 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.id !== undefined) {
          const _errs2 = errors;
          if (typeof data.id !== 'string') {
            validate27.errors = [
              {
                instancePath: instancePath + '/id',
                schemaPath: '#/properties/id/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid0 = _errs2 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.apiId !== undefined) {
            const _errs4 = errors;
            if (typeof data.apiId !== 'string') {
              validate27.errors = [
                {
                  instancePath: instancePath + '/apiId',
                  schemaPath: '#/properties/apiId/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs4 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.documentId !== undefined) {
              const _errs6 = errors;
              if (typeof data.documentId !== 'string') {
                validate27.errors = [
                  {
                    instancePath: instancePath + '/documentId',
                    schemaPath: '#/properties/documentId/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.x !== undefined) {
                let data4 = data.x;
                const _errs8 = errors;
                if (!(typeof data4 == 'number' && isFinite(data4))) {
                  validate27.errors = [
                    {
                      instancePath: instancePath + '/x',
                      schemaPath: '#/properties/x/type',
                      keyword: 'type',
                      params: { type: 'number' },
                      message: 'must be number',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.y !== undefined) {
                  let data5 = data.y;
                  const _errs10 = errors;
                  if (!(typeof data5 == 'number' && isFinite(data5))) {
                    validate27.errors = [
                      {
                        instancePath: instancePath + '/y',
                        schemaPath: '#/properties/y/type',
                        keyword: 'type',
                        params: { type: 'number' },
                        message: 'must be number',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.width !== undefined) {
                    let data6 = data.width;
                    const _errs12 = errors;
                    if (!(typeof data6 == 'number' && isFinite(data6))) {
                      validate27.errors = [
                        {
                          instancePath: instancePath + '/width',
                          schemaPath: '#/properties/width/type',
                          keyword: 'type',
                          params: { type: 'number' },
                          message: 'must be number',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.height !== undefined) {
                      let data7 = data.height;
                      const _errs14 = errors;
                      if (!(typeof data7 == 'number' && isFinite(data7))) {
                        validate27.errors = [
                          {
                            instancePath: instancePath + '/height',
                            schemaPath: '#/properties/height/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs14 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.signer !== undefined) {
                        const _errs16 = errors;
                        if (typeof data.signer !== 'string') {
                          validate27.errors = [
                            {
                              instancePath: instancePath + '/signer',
                              schemaPath: '#/properties/signer/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs16 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.required !== undefined) {
                          const _errs18 = errors;
                          if (typeof data.required !== 'boolean') {
                            validate27.errors = [
                              {
                                instancePath: instancePath + '/required',
                                schemaPath: '#/properties/required/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs18 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.readOnly !== undefined) {
                            const _errs20 = errors;
                            if (typeof data.readOnly !== 'boolean') {
                              validate27.errors = [
                                {
                                  instancePath: instancePath + '/readOnly',
                                  schemaPath: '#/properties/readOnly/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs20 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.name !== undefined) {
                              const _errs22 = errors;
                              if (typeof data.name !== 'string') {
                                validate27.errors = [
                                  {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs22 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.isDisabled !== undefined) {
                                const _errs24 = errors;
                                if (typeof data.isDisabled !== 'boolean') {
                                  validate27.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/isDisabled',
                                      schemaPath:
                                        '#/properties/isDisabled/type',
                                      keyword: 'type',
                                      params: { type: 'boolean' },
                                      message: 'must be boolean',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs24 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.type !== undefined) {
                                  const _errs26 = errors;
                                  if (!func0(data.type, 'dropdown')) {
                                    validate27.errors = [
                                      {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/const',
                                        keyword: 'const',
                                        params: { allowedValue: 'dropdown' },
                                        message: 'must be equal to constant',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs26 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.value !== undefined) {
                                    let data14 = data.value;
                                    const _errs27 = errors;
                                    if (
                                      typeof data14 !== 'string' &&
                                      data14 !== null
                                    ) {
                                      validate27.errors = [
                                        {
                                          instancePath: instancePath + '/value',
                                          schemaPath: '#/properties/value/type',
                                          keyword: 'type',
                                          params: {
                                            type: schema38.properties.value
                                              .type,
                                          },
                                          message: 'must be string,null',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid0 = _errs27 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.options !== undefined) {
                                      let data15 = data.options;
                                      const _errs29 = errors;
                                      if (errors === _errs29) {
                                        if (Array.isArray(data15)) {
                                          var valid1 = true;
                                          const len0 = data15.length;
                                          for (let i0 = 0; i0 < len0; i0++) {
                                            const _errs31 = errors;
                                            if (
                                              typeof data15[i0] !== 'string'
                                            ) {
                                              validate27.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/options/' +
                                                    i0,
                                                  schemaPath:
                                                    '#/properties/options/items/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid1 = _errs31 === errors;
                                            if (!valid1) {
                                              break;
                                            }
                                          }
                                        } else {
                                          validate27.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/options',
                                              schemaPath:
                                                '#/properties/options/type',
                                              keyword: 'type',
                                              params: { type: 'array' },
                                              message: 'must be array',
                                            },
                                          ];
                                          return false;
                                        }
                                      }
                                      var valid0 = _errs29 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.fontSize !== undefined) {
                                        let data17 = data.fontSize;
                                        const _errs33 = errors;
                                        const _errs34 = errors;
                                        if (errors === _errs34) {
                                          if (
                                            typeof data17 == 'number' &&
                                            isFinite(data17)
                                          ) {
                                            if (data17 > 48 || isNaN(data17)) {
                                              validate27.errors = [
                                                {
                                                  instancePath:
                                                    instancePath + '/fontSize',
                                                  schemaPath:
                                                    '#/definitions/FontSize/maximum',
                                                  keyword: 'maximum',
                                                  params: {
                                                    comparison: '<=',
                                                    limit: 48,
                                                  },
                                                  message: 'must be <= 48',
                                                },
                                              ];
                                              return false;
                                            } else {
                                              if (data17 < 7 || isNaN(data17)) {
                                                validate27.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/fontSize',
                                                    schemaPath:
                                                      '#/definitions/FontSize/minimum',
                                                    keyword: 'minimum',
                                                    params: {
                                                      comparison: '>=',
                                                      limit: 7,
                                                    },
                                                    message: 'must be >= 7',
                                                  },
                                                ];
                                                return false;
                                              }
                                            }
                                          } else {
                                            validate27.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/fontSize',
                                                schemaPath:
                                                  '#/definitions/FontSize/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number',
                                              },
                                            ];
                                            return false;
                                          }
                                        }
                                        var valid0 = _errs33 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (data.fontFamily !== undefined) {
                                          let data18 = data.fontFamily;
                                          const _errs36 = errors;
                                          if (typeof data18 !== 'string') {
                                            validate27.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/fontFamily',
                                                schemaPath:
                                                  '#/definitions/FontFamily/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          if (
                                            !(
                                              data18 === 'helvetica' ||
                                              data18 === 'arial' ||
                                              data18 === 'calibri' ||
                                              data18 === 'cambria' ||
                                              data18 === 'courier' ||
                                              data18 === 'georgia' ||
                                              data18 === 'times' ||
                                              data18 === 'trebuchet' ||
                                              data18 === 'verdana' ||
                                              data18 === 'notoSerif' ||
                                              data18 === 'notoSans' ||
                                              data18 === 'roboto' ||
                                              data18 === 'robotoMono'
                                            )
                                          ) {
                                            validate27.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/fontFamily',
                                                schemaPath:
                                                  '#/definitions/FontFamily/enum',
                                                keyword: 'enum',
                                                params: {
                                                  allowedValues: schema20.enum,
                                                },
                                                message:
                                                  'must be equal to one of the allowed values',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid0 = _errs36 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                        if (valid0) {
                                          if (data.lineHeight !== undefined) {
                                            let data19 = data.lineHeight;
                                            const _errs39 = errors;
                                            if (
                                              !(
                                                typeof data19 == 'number' &&
                                                isFinite(data19)
                                              )
                                            ) {
                                              validate27.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/lineHeight',
                                                  schemaPath:
                                                    '#/properties/lineHeight/type',
                                                  keyword: 'type',
                                                  params: { type: 'number' },
                                                  message: 'must be number',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid0 = _errs39 === errors;
                                          } else {
                                            var valid0 = true;
                                          }
                                          if (valid0) {
                                            if (data.formLabel !== undefined) {
                                              const _errs41 = errors;
                                              if (
                                                typeof data.formLabel !==
                                                'string'
                                              ) {
                                                validate27.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/formLabel',
                                                    schemaPath:
                                                      '#/properties/formLabel/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid0 = _errs41 === errors;
                                            } else {
                                              var valid0 = true;
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  validate27.errors = vErrors;
  return errors === 0;
}
const schema41 = {
  title: 'HyperlinkField',
  properties: {
    type: { const: 'hyperlink', default: 'hyperlink' },
    pageIndex: { type: 'number' },
    id: { type: 'string' },
    apiId: { type: 'string' },
    documentId: { type: 'string' },
    x: { type: 'number' },
    y: { type: 'number' },
    width: { type: 'number' },
    height: { type: 'number' },
    signer: { type: 'string' },
    required: { type: 'boolean' },
    readOnly: { type: 'boolean' },
    name: { type: 'string' },
    linkId: { type: 'string' },
    isDisabled: { type: 'boolean' },
    lineHeight: { type: 'number' },
    fontFamily: { $ref: '#/definitions/FontFamily' },
    fontSize: { $ref: '#/definitions/FontSize' },
    value: { type: ['string', 'null'] },
    url: { type: 'string' },
    formLabel: { type: 'string' },
  },
  required: [
    'pageIndex',
    'signer',
    'documentId',
    'fontSize',
    'fontFamily',
    'value',
    'url',
    'type',
    'id',
    'name',
    'required',
    'readOnly',
    'x',
    'y',
    'width',
    'height',
  ],
};
function validate29(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (data && typeof data == 'object' && !Array.isArray(data)) {
    let missing0;
    if (
      (data.pageIndex === undefined && (missing0 = 'pageIndex')) ||
      (data.signer === undefined && (missing0 = 'signer')) ||
      (data.documentId === undefined && (missing0 = 'documentId')) ||
      (data.fontSize === undefined && (missing0 = 'fontSize')) ||
      (data.fontFamily === undefined && (missing0 = 'fontFamily')) ||
      (data.value === undefined && (missing0 = 'value')) ||
      (data.url === undefined && (missing0 = 'url')) ||
      (data.type === undefined && (missing0 = 'type')) ||
      (data.id === undefined && (missing0 = 'id')) ||
      (data.name === undefined && (missing0 = 'name')) ||
      (data.required === undefined && (missing0 = 'required')) ||
      (data.readOnly === undefined && (missing0 = 'readOnly')) ||
      (data.x === undefined && (missing0 = 'x')) ||
      (data.y === undefined && (missing0 = 'y')) ||
      (data.width === undefined && (missing0 = 'width')) ||
      (data.height === undefined && (missing0 = 'height'))
    ) {
      validate29.errors = [
        {
          instancePath,
          schemaPath: '#/required',
          keyword: 'required',
          params: { missingProperty: missing0 },
          message: "must have required property '" + missing0 + "'",
        },
      ];
      return false;
    } else {
      if (data.type !== undefined) {
        const _errs0 = errors;
        if (!func0(data.type, 'hyperlink')) {
          validate29.errors = [
            {
              instancePath: instancePath + '/type',
              schemaPath: '#/properties/type/const',
              keyword: 'const',
              params: { allowedValue: 'hyperlink' },
              message: 'must be equal to constant',
            },
          ];
          return false;
        }
        var valid0 = _errs0 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.pageIndex !== undefined) {
          let data1 = data.pageIndex;
          const _errs1 = errors;
          if (!(typeof data1 == 'number' && isFinite(data1))) {
            validate29.errors = [
              {
                instancePath: instancePath + '/pageIndex',
                schemaPath: '#/properties/pageIndex/type',
                keyword: 'type',
                params: { type: 'number' },
                message: 'must be number',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.id !== undefined) {
            const _errs3 = errors;
            if (typeof data.id !== 'string') {
              validate29.errors = [
                {
                  instancePath: instancePath + '/id',
                  schemaPath: '#/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.apiId !== undefined) {
              const _errs5 = errors;
              if (typeof data.apiId !== 'string') {
                validate29.errors = [
                  {
                    instancePath: instancePath + '/apiId',
                    schemaPath: '#/properties/apiId/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.documentId !== undefined) {
                const _errs7 = errors;
                if (typeof data.documentId !== 'string') {
                  validate29.errors = [
                    {
                      instancePath: instancePath + '/documentId',
                      schemaPath: '#/properties/documentId/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.x !== undefined) {
                  let data5 = data.x;
                  const _errs9 = errors;
                  if (!(typeof data5 == 'number' && isFinite(data5))) {
                    validate29.errors = [
                      {
                        instancePath: instancePath + '/x',
                        schemaPath: '#/properties/x/type',
                        keyword: 'type',
                        params: { type: 'number' },
                        message: 'must be number',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.y !== undefined) {
                    let data6 = data.y;
                    const _errs11 = errors;
                    if (!(typeof data6 == 'number' && isFinite(data6))) {
                      validate29.errors = [
                        {
                          instancePath: instancePath + '/y',
                          schemaPath: '#/properties/y/type',
                          keyword: 'type',
                          params: { type: 'number' },
                          message: 'must be number',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.width !== undefined) {
                      let data7 = data.width;
                      const _errs13 = errors;
                      if (!(typeof data7 == 'number' && isFinite(data7))) {
                        validate29.errors = [
                          {
                            instancePath: instancePath + '/width',
                            schemaPath: '#/properties/width/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.height !== undefined) {
                        let data8 = data.height;
                        const _errs15 = errors;
                        if (!(typeof data8 == 'number' && isFinite(data8))) {
                          validate29.errors = [
                            {
                              instancePath: instancePath + '/height',
                              schemaPath: '#/properties/height/type',
                              keyword: 'type',
                              params: { type: 'number' },
                              message: 'must be number',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.signer !== undefined) {
                          const _errs17 = errors;
                          if (typeof data.signer !== 'string') {
                            validate29.errors = [
                              {
                                instancePath: instancePath + '/signer',
                                schemaPath: '#/properties/signer/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs17 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.required !== undefined) {
                            const _errs19 = errors;
                            if (typeof data.required !== 'boolean') {
                              validate29.errors = [
                                {
                                  instancePath: instancePath + '/required',
                                  schemaPath: '#/properties/required/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs19 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.readOnly !== undefined) {
                              const _errs21 = errors;
                              if (typeof data.readOnly !== 'boolean') {
                                validate29.errors = [
                                  {
                                    instancePath: instancePath + '/readOnly',
                                    schemaPath: '#/properties/readOnly/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs21 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.name !== undefined) {
                                const _errs23 = errors;
                                if (typeof data.name !== 'string') {
                                  validate29.errors = [
                                    {
                                      instancePath: instancePath + '/name',
                                      schemaPath: '#/properties/name/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs23 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.linkId !== undefined) {
                                  const _errs25 = errors;
                                  if (typeof data.linkId !== 'string') {
                                    validate29.errors = [
                                      {
                                        instancePath: instancePath + '/linkId',
                                        schemaPath: '#/properties/linkId/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs25 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.isDisabled !== undefined) {
                                    const _errs27 = errors;
                                    if (typeof data.isDisabled !== 'boolean') {
                                      validate29.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/isDisabled',
                                          schemaPath:
                                            '#/properties/isDisabled/type',
                                          keyword: 'type',
                                          params: { type: 'boolean' },
                                          message: 'must be boolean',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid0 = _errs27 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.lineHeight !== undefined) {
                                      let data15 = data.lineHeight;
                                      const _errs29 = errors;
                                      if (
                                        !(
                                          typeof data15 == 'number' &&
                                          isFinite(data15)
                                        )
                                      ) {
                                        validate29.errors = [
                                          {
                                            instancePath:
                                              instancePath + '/lineHeight',
                                            schemaPath:
                                              '#/properties/lineHeight/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid0 = _errs29 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.fontFamily !== undefined) {
                                        let data16 = data.fontFamily;
                                        const _errs31 = errors;
                                        if (typeof data16 !== 'string') {
                                          validate29.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/fontFamily',
                                              schemaPath:
                                                '#/definitions/FontFamily/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                        if (
                                          !(
                                            data16 === 'helvetica' ||
                                            data16 === 'arial' ||
                                            data16 === 'calibri' ||
                                            data16 === 'cambria' ||
                                            data16 === 'courier' ||
                                            data16 === 'georgia' ||
                                            data16 === 'times' ||
                                            data16 === 'trebuchet' ||
                                            data16 === 'verdana' ||
                                            data16 === 'notoSerif' ||
                                            data16 === 'notoSans' ||
                                            data16 === 'roboto' ||
                                            data16 === 'robotoMono'
                                          )
                                        ) {
                                          validate29.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/fontFamily',
                                              schemaPath:
                                                '#/definitions/FontFamily/enum',
                                              keyword: 'enum',
                                              params: {
                                                allowedValues: schema20.enum,
                                              },
                                              message:
                                                'must be equal to one of the allowed values',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid0 = _errs31 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (data.fontSize !== undefined) {
                                          let data17 = data.fontSize;
                                          const _errs34 = errors;
                                          const _errs35 = errors;
                                          if (errors === _errs35) {
                                            if (
                                              typeof data17 == 'number' &&
                                              isFinite(data17)
                                            ) {
                                              if (
                                                data17 > 48 ||
                                                isNaN(data17)
                                              ) {
                                                validate29.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/fontSize',
                                                    schemaPath:
                                                      '#/definitions/FontSize/maximum',
                                                    keyword: 'maximum',
                                                    params: {
                                                      comparison: '<=',
                                                      limit: 48,
                                                    },
                                                    message: 'must be <= 48',
                                                  },
                                                ];
                                                return false;
                                              } else {
                                                if (
                                                  data17 < 7 ||
                                                  isNaN(data17)
                                                ) {
                                                  validate29.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/fontSize',
                                                      schemaPath:
                                                        '#/definitions/FontSize/minimum',
                                                      keyword: 'minimum',
                                                      params: {
                                                        comparison: '>=',
                                                        limit: 7,
                                                      },
                                                      message: 'must be >= 7',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                              }
                                            } else {
                                              validate29.errors = [
                                                {
                                                  instancePath:
                                                    instancePath + '/fontSize',
                                                  schemaPath:
                                                    '#/definitions/FontSize/type',
                                                  keyword: 'type',
                                                  params: { type: 'number' },
                                                  message: 'must be number',
                                                },
                                              ];
                                              return false;
                                            }
                                          }
                                          var valid0 = _errs34 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                        if (valid0) {
                                          if (data.value !== undefined) {
                                            let data18 = data.value;
                                            const _errs37 = errors;
                                            if (
                                              typeof data18 !== 'string' &&
                                              data18 !== null
                                            ) {
                                              validate29.errors = [
                                                {
                                                  instancePath:
                                                    instancePath + '/value',
                                                  schemaPath:
                                                    '#/properties/value/type',
                                                  keyword: 'type',
                                                  params: {
                                                    type: schema41.properties
                                                      .value.type,
                                                  },
                                                  message:
                                                    'must be string,null',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid0 = _errs37 === errors;
                                          } else {
                                            var valid0 = true;
                                          }
                                          if (valid0) {
                                            if (data.url !== undefined) {
                                              const _errs39 = errors;
                                              if (
                                                typeof data.url !== 'string'
                                              ) {
                                                validate29.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath + '/url',
                                                    schemaPath:
                                                      '#/properties/url/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid0 = _errs39 === errors;
                                            } else {
                                              var valid0 = true;
                                            }
                                            if (valid0) {
                                              if (
                                                data.formLabel !== undefined
                                              ) {
                                                const _errs41 = errors;
                                                if (
                                                  typeof data.formLabel !==
                                                  'string'
                                                ) {
                                                  validate29.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/formLabel',
                                                      schemaPath:
                                                        '#/properties/formLabel/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'string',
                                                      },
                                                      message: 'must be string',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid0 = _errs41 === errors;
                                              } else {
                                                var valid0 = true;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  validate29.errors = vErrors;
  return errors === 0;
}
function validate13(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="Field.json" */ let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == 'object' && !Array.isArray(data))) {
    validate13.errors = [
      {
        instancePath,
        schemaPath: '#/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      },
    ];
    return false;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (
    !validate14(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
    })
  ) {
    vErrors =
      vErrors === null ? validate14.errors : vErrors.concat(validate14.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs3 = errors;
  if (
    !validate16(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
    })
  ) {
    vErrors =
      vErrors === null ? validate16.errors : vErrors.concat(validate16.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs3 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs4 = errors;
    if (
      !validate20(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
      })
    ) {
      vErrors =
        vErrors === null
          ? validate20.errors
          : vErrors.concat(validate20.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs4 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
      const _errs5 = errors;
      if (
        !validate23(data, {
          instancePath,
          parentData,
          parentDataProperty,
          rootData,
        })
      ) {
        vErrors =
          vErrors === null
            ? validate23.errors
            : vErrors.concat(validate23.errors);
        errors = vErrors.length;
      }
      var _valid0 = _errs5 === errors;
      if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [passing0, 3];
      } else {
        if (_valid0) {
          valid0 = true;
          passing0 = 3;
        }
        const _errs6 = errors;
        if (
          !validate25(data, {
            instancePath,
            parentData,
            parentDataProperty,
            rootData,
          })
        ) {
          vErrors =
            vErrors === null
              ? validate25.errors
              : vErrors.concat(validate25.errors);
          errors = vErrors.length;
        }
        var _valid0 = _errs6 === errors;
        if (_valid0 && valid0) {
          valid0 = false;
          passing0 = [passing0, 4];
        } else {
          if (_valid0) {
            valid0 = true;
            passing0 = 4;
          }
          const _errs7 = errors;
          if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (
              (data.checked === undefined && (missing0 = 'checked')) ||
              (data.requirement === undefined && (missing0 = 'requirement')) ||
              (data.group === undefined && (missing0 = 'group')) ||
              (data.pageIndex === undefined && (missing0 = 'pageIndex')) ||
              (data.signer === undefined && (missing0 = 'signer')) ||
              (data.documentId === undefined && (missing0 = 'documentId')) ||
              (data.id === undefined && (missing0 = 'id')) ||
              (data.name === undefined && (missing0 = 'name')) ||
              (data.required === undefined && (missing0 = 'required')) ||
              (data.readOnly === undefined && (missing0 = 'readOnly')) ||
              (data.x === undefined && (missing0 = 'x')) ||
              (data.y === undefined && (missing0 = 'y')) ||
              (data.width === undefined && (missing0 = 'width')) ||
              (data.height === undefined && (missing0 = 'height')) ||
              (data.type === undefined && (missing0 = 'type'))
            ) {
              const err0 = {
                instancePath,
                schemaPath: '#/definitions/RadioField/required',
                keyword: 'required',
                params: { missingProperty: missing0 },
                message: "must have required property '" + missing0 + "'",
              };
              if (vErrors === null) {
                vErrors = [err0];
              } else {
                vErrors.push(err0);
              }
              errors++;
            } else {
              if (data.pageIndex !== undefined) {
                let data0 = data.pageIndex;
                const _errs9 = errors;
                if (!(typeof data0 == 'number' && isFinite(data0))) {
                  const err1 = {
                    instancePath: instancePath + '/pageIndex',
                    schemaPath:
                      '#/definitions/RadioField/properties/pageIndex/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                  };
                  if (vErrors === null) {
                    vErrors = [err1];
                  } else {
                    vErrors.push(err1);
                  }
                  errors++;
                }
                var valid2 = _errs9 === errors;
              } else {
                var valid2 = true;
              }
              if (valid2) {
                if (data.id !== undefined) {
                  const _errs11 = errors;
                  if (typeof data.id !== 'string') {
                    const err2 = {
                      instancePath: instancePath + '/id',
                      schemaPath: '#/definitions/RadioField/properties/id/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    };
                    if (vErrors === null) {
                      vErrors = [err2];
                    } else {
                      vErrors.push(err2);
                    }
                    errors++;
                  }
                  var valid2 = _errs11 === errors;
                } else {
                  var valid2 = true;
                }
                if (valid2) {
                  if (data.apiId !== undefined) {
                    const _errs13 = errors;
                    if (typeof data.apiId !== 'string') {
                      const err3 = {
                        instancePath: instancePath + '/apiId',
                        schemaPath:
                          '#/definitions/RadioField/properties/apiId/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      };
                      if (vErrors === null) {
                        vErrors = [err3];
                      } else {
                        vErrors.push(err3);
                      }
                      errors++;
                    }
                    var valid2 = _errs13 === errors;
                  } else {
                    var valid2 = true;
                  }
                  if (valid2) {
                    if (data.documentId !== undefined) {
                      const _errs15 = errors;
                      if (typeof data.documentId !== 'string') {
                        const err4 = {
                          instancePath: instancePath + '/documentId',
                          schemaPath:
                            '#/definitions/RadioField/properties/documentId/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        };
                        if (vErrors === null) {
                          vErrors = [err4];
                        } else {
                          vErrors.push(err4);
                        }
                        errors++;
                      }
                      var valid2 = _errs15 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data.x !== undefined) {
                        let data4 = data.x;
                        const _errs17 = errors;
                        if (!(typeof data4 == 'number' && isFinite(data4))) {
                          const err5 = {
                            instancePath: instancePath + '/x',
                            schemaPath:
                              '#/definitions/RadioField/properties/x/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          };
                          if (vErrors === null) {
                            vErrors = [err5];
                          } else {
                            vErrors.push(err5);
                          }
                          errors++;
                        }
                        var valid2 = _errs17 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data.y !== undefined) {
                          let data5 = data.y;
                          const _errs19 = errors;
                          if (!(typeof data5 == 'number' && isFinite(data5))) {
                            const err6 = {
                              instancePath: instancePath + '/y',
                              schemaPath:
                                '#/definitions/RadioField/properties/y/type',
                              keyword: 'type',
                              params: { type: 'number' },
                              message: 'must be number',
                            };
                            if (vErrors === null) {
                              vErrors = [err6];
                            } else {
                              vErrors.push(err6);
                            }
                            errors++;
                          }
                          var valid2 = _errs19 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data.width !== undefined) {
                            let data6 = data.width;
                            const _errs21 = errors;
                            if (
                              !(typeof data6 == 'number' && isFinite(data6))
                            ) {
                              const err7 = {
                                instancePath: instancePath + '/width',
                                schemaPath:
                                  '#/definitions/RadioField/properties/width/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number',
                              };
                              if (vErrors === null) {
                                vErrors = [err7];
                              } else {
                                vErrors.push(err7);
                              }
                              errors++;
                            }
                            var valid2 = _errs21 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data.height !== undefined) {
                              let data7 = data.height;
                              const _errs23 = errors;
                              if (
                                !(typeof data7 == 'number' && isFinite(data7))
                              ) {
                                const err8 = {
                                  instancePath: instancePath + '/height',
                                  schemaPath:
                                    '#/definitions/RadioField/properties/height/type',
                                  keyword: 'type',
                                  params: { type: 'number' },
                                  message: 'must be number',
                                };
                                if (vErrors === null) {
                                  vErrors = [err8];
                                } else {
                                  vErrors.push(err8);
                                }
                                errors++;
                              }
                              var valid2 = _errs23 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data.signer !== undefined) {
                                const _errs25 = errors;
                                if (typeof data.signer !== 'string') {
                                  const err9 = {
                                    instancePath: instancePath + '/signer',
                                    schemaPath:
                                      '#/definitions/RadioField/properties/signer/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err9];
                                  } else {
                                    vErrors.push(err9);
                                  }
                                  errors++;
                                }
                                var valid2 = _errs25 === errors;
                              } else {
                                var valid2 = true;
                              }
                              if (valid2) {
                                if (data.required !== undefined) {
                                  const _errs27 = errors;
                                  if (typeof data.required !== 'boolean') {
                                    const err10 = {
                                      instancePath: instancePath + '/required',
                                      schemaPath:
                                        '#/definitions/RadioField/properties/required/type',
                                      keyword: 'type',
                                      params: { type: 'boolean' },
                                      message: 'must be boolean',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err10];
                                    } else {
                                      vErrors.push(err10);
                                    }
                                    errors++;
                                  }
                                  var valid2 = _errs27 === errors;
                                } else {
                                  var valid2 = true;
                                }
                                if (valid2) {
                                  if (data.readOnly !== undefined) {
                                    const _errs29 = errors;
                                    if (typeof data.readOnly !== 'boolean') {
                                      const err11 = {
                                        instancePath:
                                          instancePath + '/readOnly',
                                        schemaPath:
                                          '#/definitions/RadioField/properties/readOnly/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean',
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err11];
                                      } else {
                                        vErrors.push(err11);
                                      }
                                      errors++;
                                    }
                                    var valid2 = _errs29 === errors;
                                  } else {
                                    var valid2 = true;
                                  }
                                  if (valid2) {
                                    if (data.name !== undefined) {
                                      const _errs31 = errors;
                                      if (typeof data.name !== 'string') {
                                        const err12 = {
                                          instancePath: instancePath + '/name',
                                          schemaPath:
                                            '#/definitions/RadioField/properties/name/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err12];
                                        } else {
                                          vErrors.push(err12);
                                        }
                                        errors++;
                                      }
                                      var valid2 = _errs31 === errors;
                                    } else {
                                      var valid2 = true;
                                    }
                                    if (valid2) {
                                      if (data.linkId !== undefined) {
                                        const _errs33 = errors;
                                        if (typeof data.linkId !== 'string') {
                                          const err13 = {
                                            instancePath:
                                              instancePath + '/linkId',
                                            schemaPath:
                                              '#/definitions/RadioField/properties/linkId/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err13];
                                          } else {
                                            vErrors.push(err13);
                                          }
                                          errors++;
                                        }
                                        var valid2 = _errs33 === errors;
                                      } else {
                                        var valid2 = true;
                                      }
                                      if (valid2) {
                                        if (data.isDisabled !== undefined) {
                                          const _errs35 = errors;
                                          if (
                                            typeof data.isDisabled !== 'boolean'
                                          ) {
                                            const err14 = {
                                              instancePath:
                                                instancePath + '/isDisabled',
                                              schemaPath:
                                                '#/definitions/RadioField/properties/isDisabled/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err14];
                                            } else {
                                              vErrors.push(err14);
                                            }
                                            errors++;
                                          }
                                          var valid2 = _errs35 === errors;
                                        } else {
                                          var valid2 = true;
                                        }
                                        if (valid2) {
                                          if (data.type !== undefined) {
                                            const _errs37 = errors;
                                            if (
                                              !func0(data.type, 'radiobutton')
                                            ) {
                                              const err15 = {
                                                instancePath:
                                                  instancePath + '/type',
                                                schemaPath:
                                                  '#/definitions/RadioField/properties/type/const',
                                                keyword: 'const',
                                                params: {
                                                  allowedValue: 'radiobutton',
                                                },
                                                message:
                                                  'must be equal to constant',
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err15];
                                              } else {
                                                vErrors.push(err15);
                                              }
                                              errors++;
                                            }
                                            var valid2 = _errs37 === errors;
                                          } else {
                                            var valid2 = true;
                                          }
                                          if (valid2) {
                                            if (data.checked !== undefined) {
                                              const _errs38 = errors;
                                              if (
                                                typeof data.checked !==
                                                'boolean'
                                              ) {
                                                const err16 = {
                                                  instancePath:
                                                    instancePath + '/checked',
                                                  schemaPath:
                                                    '#/definitions/RadioField/properties/checked/type',
                                                  keyword: 'type',
                                                  params: { type: 'boolean' },
                                                  message: 'must be boolean',
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err16];
                                                } else {
                                                  vErrors.push(err16);
                                                }
                                                errors++;
                                              }
                                              var valid2 = _errs38 === errors;
                                            } else {
                                              var valid2 = true;
                                            }
                                            if (valid2) {
                                              if (
                                                data.requirement !== undefined
                                              ) {
                                                const _errs40 = errors;
                                                if (
                                                  typeof data.requirement !==
                                                  'string'
                                                ) {
                                                  const err17 = {
                                                    instancePath:
                                                      instancePath +
                                                      '/requirement',
                                                    schemaPath:
                                                      '#/definitions/RadioField/properties/requirement/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err17];
                                                  } else {
                                                    vErrors.push(err17);
                                                  }
                                                  errors++;
                                                }
                                                var valid2 = _errs40 === errors;
                                              } else {
                                                var valid2 = true;
                                              }
                                              if (valid2) {
                                                if (
                                                  data.groupLabel !== undefined
                                                ) {
                                                  const _errs42 = errors;
                                                  if (
                                                    typeof data.groupLabel !==
                                                    'string'
                                                  ) {
                                                    const err18 = {
                                                      instancePath:
                                                        instancePath +
                                                        '/groupLabel',
                                                      schemaPath:
                                                        '#/definitions/RadioField/properties/groupLabel/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'string',
                                                      },
                                                      message: 'must be string',
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err18];
                                                    } else {
                                                      vErrors.push(err18);
                                                    }
                                                    errors++;
                                                  }
                                                  var valid2 =
                                                    _errs42 === errors;
                                                } else {
                                                  var valid2 = true;
                                                }
                                                if (valid2) {
                                                  if (
                                                    data.groupFormLabel !==
                                                    undefined
                                                  ) {
                                                    const _errs44 = errors;
                                                    if (
                                                      typeof data.groupFormLabel !==
                                                      'string'
                                                    ) {
                                                      const err19 = {
                                                        instancePath:
                                                          instancePath +
                                                          '/groupFormLabel',
                                                        schemaPath:
                                                          '#/definitions/RadioField/properties/groupFormLabel/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'string',
                                                        },
                                                        message:
                                                          'must be string',
                                                      };
                                                      if (vErrors === null) {
                                                        vErrors = [err19];
                                                      } else {
                                                        vErrors.push(err19);
                                                      }
                                                      errors++;
                                                    }
                                                    var valid2 =
                                                      _errs44 === errors;
                                                  } else {
                                                    var valid2 = true;
                                                  }
                                                  if (valid2) {
                                                    if (
                                                      data.group !== undefined
                                                    ) {
                                                      const _errs46 = errors;
                                                      if (
                                                        typeof data.group !==
                                                        'string'
                                                      ) {
                                                        const err20 = {
                                                          instancePath:
                                                            instancePath +
                                                            '/group',
                                                          schemaPath:
                                                            '#/definitions/RadioField/properties/group/type',
                                                          keyword: 'type',
                                                          params: {
                                                            type: 'string',
                                                          },
                                                          message:
                                                            'must be string',
                                                        };
                                                        if (vErrors === null) {
                                                          vErrors = [err20];
                                                        } else {
                                                          vErrors.push(err20);
                                                        }
                                                        errors++;
                                                      }
                                                      var valid2 =
                                                        _errs46 === errors;
                                                    } else {
                                                      var valid2 = true;
                                                    }
                                                    if (valid2) {
                                                      if (
                                                        data.formLabel !==
                                                        undefined
                                                      ) {
                                                        const _errs48 = errors;
                                                        if (
                                                          typeof data.formLabel !==
                                                          'string'
                                                        ) {
                                                          const err21 = {
                                                            instancePath:
                                                              instancePath +
                                                              '/formLabel',
                                                            schemaPath:
                                                              '#/definitions/RadioField/properties/formLabel/type',
                                                            keyword: 'type',
                                                            params: {
                                                              type: 'string',
                                                            },
                                                            message:
                                                              'must be string',
                                                          };
                                                          if (
                                                            vErrors === null
                                                          ) {
                                                            vErrors = [err21];
                                                          } else {
                                                            vErrors.push(err21);
                                                          }
                                                          errors++;
                                                        }
                                                        var valid2 =
                                                          _errs48 === errors;
                                                      } else {
                                                        var valid2 = true;
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          var _valid0 = _errs7 === errors;
          if (_valid0 && valid0) {
            valid0 = false;
            passing0 = [passing0, 5];
          } else {
            if (_valid0) {
              valid0 = true;
              passing0 = 5;
            }
            const _errs50 = errors;
            if (
              !validate27(data, {
                instancePath,
                parentData,
                parentDataProperty,
                rootData,
              })
            ) {
              vErrors =
                vErrors === null
                  ? validate27.errors
                  : vErrors.concat(validate27.errors);
              errors = vErrors.length;
            }
            var _valid0 = _errs50 === errors;
            if (_valid0 && valid0) {
              valid0 = false;
              passing0 = [passing0, 6];
            } else {
              if (_valid0) {
                valid0 = true;
                passing0 = 6;
              }
              const _errs51 = errors;
              if (
                !validate29(data, {
                  instancePath,
                  parentData,
                  parentDataProperty,
                  rootData,
                })
              ) {
                vErrors =
                  vErrors === null
                    ? validate29.errors
                    : vErrors.concat(validate29.errors);
                errors = vErrors.length;
              }
              var _valid0 = _errs51 === errors;
              if (_valid0 && valid0) {
                valid0 = false;
                passing0 = [passing0, 7];
              } else {
                if (_valid0) {
                  valid0 = true;
                  passing0 = 7;
                }
              }
            }
          }
        }
      }
    }
  }
  if (!valid0) {
    const err22 = {
      instancePath,
      schemaPath: '#/oneOf',
      keyword: 'oneOf',
      params: { passingSchemas: passing0 },
      message: 'must match exactly one schema in oneOf',
    };
    if (vErrors === null) {
      vErrors = [err22];
    } else {
      vErrors.push(err22);
    }
    errors++;
    validate13.errors = vErrors;
    return false;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate13.errors = vErrors;
  return errors === 0;
}
function validate49(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="File.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.name === undefined && (missing0 = 'name')) ||
        (data.type === undefined && (missing0 = 'type')) ||
        (data.guid === undefined && (missing0 = 'guid')) ||
        (data.fields === undefined && (missing0 = 'fields')) ||
        (data.pwRequired === undefined && (missing0 = 'pwRequired')) ||
        (data.rootSnapshotGuid === undefined && (missing0 = 'rootSnapshotGuid'))
      ) {
        validate49.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func4.call(schema65.properties, key0)) {
            validate49.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.status !== undefined) {
            let data0 = data.status;
            const _errs2 = errors;
            if (typeof data0 !== 'string') {
              validate49.errors = [
                {
                  instancePath: instancePath + '/status',
                  schemaPath: '#/definitions/FileStatus/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            if (
              !(
                data0 === 'converting' ||
                data0 === 'ok' ||
                data0 === 'file downloaded' ||
                data0 === 'downloading' ||
                data0 === 'download queued' ||
                data0 === 'deleted' ||
                data0 === 'error' ||
                data0 === '404 Error' ||
                data0 === 'password required' ||
                data0 === 'too many pages' ||
                data0 === 'file too large' ||
                data0 === 'retrieve error' ||
                data0 === 'bad request' ||
                data0 === 'bad auth'
              )
            ) {
              validate49.errors = [
                {
                  instancePath: instancePath + '/status',
                  schemaPath: '#/definitions/FileStatus/enum',
                  keyword: 'enum',
                  params: { allowedValues: schema66.enum },
                  message: 'must be equal to one of the allowed values',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.name !== undefined) {
              const _errs5 = errors;
              if (typeof data.name !== 'string') {
                validate49.errors = [
                  {
                    instancePath: instancePath + '/name',
                    schemaPath: '#/properties/name/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.type !== undefined) {
                let data2 = data.type;
                const _errs7 = errors;
                if (typeof data2 !== 'string') {
                  validate49.errors = [
                    {
                      instancePath: instancePath + '/type',
                      schemaPath: '#/definitions/FileType/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                if (
                  !(
                    data2 === 'Upload' ||
                    data2 === 'Template' ||
                    data2 === 'External'
                  )
                ) {
                  validate49.errors = [
                    {
                      instancePath: instancePath + '/type',
                      schemaPath: '#/definitions/FileType/enum',
                      keyword: 'enum',
                      params: { allowedValues: schema67.enum },
                      message: 'must be equal to one of the allowed values',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.guid !== undefined) {
                  const _errs10 = errors;
                  if (typeof data.guid !== 'string') {
                    validate49.errors = [
                      {
                        instancePath: instancePath + '/guid',
                        schemaPath: '#/properties/guid/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.documentGuid !== undefined) {
                    const _errs12 = errors;
                    if (typeof data.documentGuid !== 'string') {
                      validate49.errors = [
                        {
                          instancePath: instancePath + '/documentGuid',
                          schemaPath: '#/properties/documentGuid/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.draftSnapshotGuid !== undefined) {
                      const _errs14 = errors;
                      if (typeof data.draftSnapshotGuid !== 'string') {
                        validate49.errors = [
                          {
                            instancePath: instancePath + '/draftSnapshotGuid',
                            schemaPath: '#/properties/draftSnapshotGuid/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs14 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.tsmGroupGuid !== undefined) {
                        const _errs16 = errors;
                        if (typeof data.tsmGroupGuid !== 'string') {
                          validate49.errors = [
                            {
                              instancePath: instancePath + '/tsmGroupGuid',
                              schemaPath: '#/properties/tsmGroupGuid/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs16 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.templateGuid !== undefined) {
                          const _errs18 = errors;
                          if (typeof data.templateGuid !== 'string') {
                            validate49.errors = [
                              {
                                instancePath: instancePath + '/templateGuid',
                                schemaPath: '#/properties/templateGuid/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs18 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.rootSnapshotGuid !== undefined) {
                            const _errs20 = errors;
                            if (typeof data.rootSnapshotGuid !== 'string') {
                              validate49.errors = [
                                {
                                  instancePath:
                                    instancePath + '/rootSnapshotGuid',
                                  schemaPath:
                                    '#/properties/rootSnapshotGuid/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs20 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.order !== undefined) {
                              let data9 = data.order;
                              const _errs22 = errors;
                              if (
                                !(typeof data9 == 'number' && isFinite(data9))
                              ) {
                                validate49.errors = [
                                  {
                                    instancePath: instancePath + '/order',
                                    schemaPath: '#/properties/order/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs22 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.fields !== undefined) {
                                let data10 = data.fields;
                                const _errs24 = errors;
                                if (errors === _errs24) {
                                  if (Array.isArray(data10)) {
                                    var valid3 = true;
                                    const len0 = data10.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                      const _errs26 = errors;
                                      if (
                                        !validate13(data10[i0], {
                                          instancePath:
                                            instancePath + '/fields/' + i0,
                                          parentData: data10,
                                          parentDataProperty: i0,
                                          rootData,
                                        })
                                      ) {
                                        vErrors =
                                          vErrors === null
                                            ? validate13.errors
                                            : vErrors.concat(validate13.errors);
                                        errors = vErrors.length;
                                      }
                                      var valid3 = _errs26 === errors;
                                      if (!valid3) {
                                        break;
                                      }
                                    }
                                  } else {
                                    validate49.errors = [
                                      {
                                        instancePath: instancePath + '/fields',
                                        schemaPath: '#/properties/fields/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array',
                                      },
                                    ];
                                    return false;
                                  }
                                }
                                var valid0 = _errs24 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.pwRequired !== undefined) {
                                  const _errs27 = errors;
                                  if (typeof data.pwRequired !== 'boolean') {
                                    validate49.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/pwRequired',
                                        schemaPath:
                                          '#/properties/pwRequired/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs27 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.pageCount !== undefined) {
                                    let data13 = data.pageCount;
                                    const _errs29 = errors;
                                    if (
                                      !(
                                        typeof data13 == 'number' &&
                                        isFinite(data13)
                                      )
                                    ) {
                                      validate49.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/pageCount',
                                          schemaPath:
                                            '#/properties/pageCount/type',
                                          keyword: 'type',
                                          params: { type: 'number' },
                                          message: 'must be number',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid0 = _errs29 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (
                                      data.externalFileCacheKey !== undefined
                                    ) {
                                      const _errs31 = errors;
                                      if (
                                        typeof data.externalFileCacheKey !==
                                        'string'
                                      ) {
                                        validate49.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/externalFileCacheKey',
                                            schemaPath:
                                              '#/properties/externalFileCacheKey/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid0 = _errs31 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (
                                        data.externalServiceReference !==
                                        undefined
                                      ) {
                                        const _errs33 = errors;
                                        if (
                                          typeof data.externalServiceReference !==
                                          'string'
                                        ) {
                                          validate49.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/externalServiceReference',
                                              schemaPath:
                                                '#/properties/externalServiceReference/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid0 = _errs33 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (
                                          data.externalServiceType !== undefined
                                        ) {
                                          const _errs35 = errors;
                                          if (
                                            typeof data.externalServiceType !==
                                            'string'
                                          ) {
                                            validate49.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/externalServiceType',
                                                schemaPath:
                                                  '#/properties/externalServiceType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid0 = _errs35 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate49.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate49.errors = vErrors;
  return errors === 0;
}
const schema68 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'EditorData.json',
  title: 'EditorData',
  type: 'object',
  additionalProperties: false,
  properties: {
    pages: { type: 'array', items: { $ref: 'Page.json' } },
    fields: { type: 'array', items: { $ref: 'Field.json' } },
    mergeFields: {
      type: 'array',
      items: {
        oneOf: [
          { $ref: 'Field.json#/definitions/MergeField' },
          { $ref: 'Field.json' },
        ],
      },
    },
    pdfFields: { type: 'array', items: { $ref: 'Field.json' } },
    editorFeatures: { type: 'array', items: { type: 'string' } },
    rules: { type: 'array', items: { $ref: 'Rule.json' } },
    transform: {
      type: 'object',
      title: 'Transform',
      additionalProperties: false,
      properties: { rotate: { type: 'integer' } },
      required: ['rotate'],
    },
    documents: { type: 'array', items: { $ref: '#/definitions/Document' } },
    signers: { type: 'array', items: { $ref: 'Recipient.json' } },
    signerOptions: { $ref: '#/definitions/SignerOptions' },
    editorOptions: { $ref: '#/definitions/EditorOptions' },
    ccs: { type: 'array', items: { $ref: '#/definitions/CCs' } },
  },
  required: [
    'pages',
    'fields',
    'mergeFields',
    'pdfFields',
    'editorOptions',
    'rules',
    'signers',
    'documents',
    'signerOptions',
  ],
  definitions: {
    CCs: {
      oneOf: [
        { $ref: 'Recipient.json#/definitions/CCRole' },
        { $ref: 'Recipient.json#/definitions/CCEmail' },
      ],
    },
    EditorOptions: {
      type: 'object',
      title: 'EditorOptions',
      properties: {
        allowEditSigners: { type: 'boolean' },
        allowEditDocuments: { type: 'boolean' },
        canUseCustomRegexDataValidation: { type: 'boolean' },
        canUseDataValidation: { type: 'boolean' },
      },
      required: [
        'allowEditSigners',
        'allowEditDocuments',
        'canUseCustomRegexDataValidation',
        'canUseDataValidation',
      ],
    },
    FieldOptions: {
      type: 'object',
      title: 'FieldOptions',
      properties: {
        dateFormat: { $ref: 'Field.json#/definitions/JSDateFormat' },
      },
    },
    SignatureTypes: {
      type: 'string',
      title: 'SignatureTypes',
      enum: ['draw', 'type', 'upload', 'phone'],
    },
    SignatureType: {
      type: 'object',
      title: 'SignatureType',
      properties: {
        default: { $ref: '#/definitions/SignatureTypes' },
        allowed: {
          type: 'array',
          items: { $ref: '#/definitions/SignatureTypes' },
        },
      },
    },
    SignerOptions: {
      type: 'object',
      title: 'SignerOptions',
      properties: {
        fieldOptions: { $ref: '#/definitions/FieldOptions' },
        signatureType: { $ref: '#/definitions/SignatureType' },
      },
    },
    Document: {
      type: 'object',
      title: 'Document',
      description:
        'Holds information about documents uploaded as part of the request. This is separate from files uploaded on the Prep and Send documents page because the ability to upload documents is available in the Editor as well.',
      additionalProperties: false,
      properties: {
        id: { type: 'string' },
        name: { type: 'string' },
        editable: { type: 'boolean' },
        snapshotGuid: { type: 'string' },
      },
      required: ['id', 'name', 'editable', 'snapshotGuid'],
    },
  },
};
const schema69 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'Page.json',
  title: 'Page',
  type: 'object',
  additionalProperties: false,
  properties: {
    src: { type: 'string' },
    width: { type: 'number' },
    height: { type: 'number' },
    documentId: { type: 'string' },
    orientation: { type: 'integer' },
    snapshotGuid: { type: 'string' },
    cdnSrc: { type: ['string', 'null'] },
  },
  required: ['src', 'width', 'height', 'orientation'],
};
const schema85 = {
  type: 'object',
  title: 'Document',
  description:
    'Holds information about documents uploaded as part of the request. This is separate from files uploaded on the Prep and Send documents page because the ability to upload documents is available in the Editor as well.',
  additionalProperties: false,
  properties: {
    id: { type: 'string' },
    name: { type: 'string' },
    editable: { type: 'boolean' },
    snapshotGuid: { type: 'string' },
  },
  required: ['id', 'name', 'editable', 'snapshotGuid'],
};
const schema99 = {
  type: 'object',
  title: 'EditorOptions',
  properties: {
    allowEditSigners: { type: 'boolean' },
    allowEditDocuments: { type: 'boolean' },
    canUseCustomRegexDataValidation: { type: 'boolean' },
    canUseDataValidation: { type: 'boolean' },
  },
  required: [
    'allowEditSigners',
    'allowEditDocuments',
    'canUseCustomRegexDataValidation',
    'canUseDataValidation',
  ],
};
const schema70 = {
  type: 'object',
  title: 'MergeField',
  additionalProperties: false,
  properties: {
    name: { type: 'string' },
    type: { type: 'string', enum: ['text', 'checkbox'] },
    integrationMetadata: { $ref: '#/definitions/FieldIntegrationMetadata' },
  },
};
function validate54(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      const _errs1 = errors;
      for (const key0 in data) {
        if (
          !(
            key0 === 'name' ||
            key0 === 'type' ||
            key0 === 'integrationMetadata'
          )
        ) {
          validate54.errors = [
            {
              instancePath,
              schemaPath: '#/additionalProperties',
              keyword: 'additionalProperties',
              params: { additionalProperty: key0 },
              message: 'must NOT have additional properties',
            },
          ];
          return false;
          break;
        }
      }
      if (_errs1 === errors) {
        if (data.name !== undefined) {
          const _errs2 = errors;
          if (typeof data.name !== 'string') {
            validate54.errors = [
              {
                instancePath: instancePath + '/name',
                schemaPath: '#/properties/name/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid0 = _errs2 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.type !== undefined) {
            let data1 = data.type;
            const _errs4 = errors;
            if (typeof data1 !== 'string') {
              validate54.errors = [
                {
                  instancePath: instancePath + '/type',
                  schemaPath: '#/properties/type/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            if (!(data1 === 'text' || data1 === 'checkbox')) {
              validate54.errors = [
                {
                  instancePath: instancePath + '/type',
                  schemaPath: '#/properties/type/enum',
                  keyword: 'enum',
                  params: { allowedValues: schema70.properties.type.enum },
                  message: 'must be equal to one of the allowed values',
                },
              ];
              return false;
            }
            var valid0 = _errs4 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.integrationMetadata !== undefined) {
              let data2 = data.integrationMetadata;
              const _errs6 = errors;
              const _errs7 = errors;
              if (errors === _errs7) {
                if (
                  data2 &&
                  typeof data2 == 'object' &&
                  !Array.isArray(data2)
                ) {
                  if (data2.externalName !== undefined) {
                    const _errs9 = errors;
                    if (typeof data2.externalName !== 'string') {
                      validate54.errors = [
                        {
                          instancePath:
                            instancePath + '/integrationMetadata/externalName',
                          schemaPath:
                            '#/definitions/FieldIntegrationMetadata/properties/externalName/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid2 = _errs9 === errors;
                  } else {
                    var valid2 = true;
                  }
                  if (valid2) {
                    if (data2.externalType !== undefined) {
                      const _errs11 = errors;
                      if (typeof data2.externalType !== 'string') {
                        validate54.errors = [
                          {
                            instancePath:
                              instancePath +
                              '/integrationMetadata/externalType',
                            schemaPath:
                              '#/definitions/FieldIntegrationMetadata/properties/externalType/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs11 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data2.isTopField !== undefined) {
                        const _errs13 = errors;
                        if (typeof data2.isTopField !== 'boolean') {
                          validate54.errors = [
                            {
                              instancePath:
                                instancePath +
                                '/integrationMetadata/isTopField',
                              schemaPath:
                                '#/definitions/FieldIntegrationMetadata/properties/isTopField/type',
                              keyword: 'type',
                              params: { type: 'boolean' },
                              message: 'must be boolean',
                            },
                          ];
                          return false;
                        }
                        var valid2 = _errs13 === errors;
                      } else {
                        var valid2 = true;
                      }
                    }
                  }
                } else {
                  validate54.errors = [
                    {
                      instancePath: instancePath + '/integrationMetadata',
                      schemaPath: '#/definitions/FieldIntegrationMetadata/type',
                      keyword: 'type',
                      params: { type: 'object' },
                      message: 'must be object',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate54.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate54.errors = vErrors;
  return errors === 0;
}
const schema72 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'Rule.json',
  title: 'Rule',
  type: 'object',
  additionalProperties: false,
  properties: {
    id: { type: 'string' },
    triggerOperator: { $ref: '#/definitions/TriggerOperator' },
    triggers: {
      type: 'array',
      items: {
        oneOf: [
          { $ref: '#/definitions/StringArrayTrigger' },
          { $ref: '#/definitions/StringTrigger' },
          { $ref: '#/definitions/NonNumericTrigger' },
          { $ref: '#/definitions/NumericTrigger' },
        ],
      },
    },
    actions: { type: 'array', items: { $ref: '#/definitions/Action' } },
  },
  required: ['id', 'triggerOperator', 'triggers', 'actions'],
  definitions: {
    StringArrayOperator: {
      type: 'string',
      title: 'StringArrayOperator',
      enum: ['any', 'none'],
      tsEnumNames: ['Any', 'None'],
    },
    StringOperator: {
      type: 'string',
      title: 'StringOperator',
      enum: ['has', 'hasNot', 'match'],
      tsEnumNames: ['Has', 'HasNot', 'Match'],
    },
    NonNumericOperator: {
      type: 'string',
      title: 'NonNumericOperator',
      enum: ['is', 'not'],
      tsEnumNames: ['Is', 'Not'],
    },
    NumericOperator: {
      type: 'string',
      title: 'NumericOperator',
      enum: ['gt', 'lt'],
      tsEnumNames: ['Lt', 'Gt'],
    },
    TriggerOperator: {
      type: 'string',
      title: 'TriggerOperator',
      enum: ['AND', 'OR'],
      tsEnumNames: ['AND', 'OR'],
    },
    ActionType: {
      type: 'string',
      title: 'ActionType',
      enum: ['change-field-visibility', 'change-group-visibility'],
      tsEnumNames: ['ChangeFieldVisibility', 'ChangeGroupVisibility'],
    },
    StringArrayTrigger: {
      type: 'object',
      title: 'StringArrayTrigger',
      additionalProperties: false,
      properties: {
        id: { type: 'string' },
        operator: { $ref: '#/definitions/StringArrayOperator' },
        value: { type: 'array', items: { type: 'string' } },
      },
      required: ['id', 'operator', 'value'],
    },
    StringTrigger: {
      type: 'object',
      title: 'StringTrigger',
      additionalProperties: false,
      properties: {
        id: { type: 'string' },
        operator: { $ref: '#/definitions/StringOperator' },
        value: { type: ['string'] },
      },
      required: ['id', 'operator', 'value'],
    },
    NonNumericTrigger: {
      type: 'object',
      title: 'NonNumericTrigger',
      additionalProperties: false,
      properties: {
        id: { type: 'string' },
        operator: { $ref: '#/definitions/NonNumericOperator' },
        value: { type: ['string', 'boolean'] },
      },
      required: ['id', 'operator', 'value'],
    },
    NumericTrigger: {
      type: 'object',
      title: 'NumericTrigger',
      additionalProperties: false,
      properties: {
        id: { type: 'string' },
        operator: { $ref: '#/definitions/NumericOperator' },
        value: { type: 'number' },
      },
      required: ['id', 'operator', 'value'],
    },
    Action: {
      type: 'object',
      title: 'Action',
      oneOf: [
        { $ref: '#/definitions/FieldVisibilityAction' },
        { $ref: '#/definitions/GroupVisibilityAction' },
      ],
    },
    FieldVisibilityAction: {
      type: 'object',
      title: 'FieldVisibilityAction',
      additionalProperties: false,
      properties: {
        type: {
          const: 'change-field-visibility',
          default: 'change-field-visibility',
        },
        fieldId: { type: 'string' },
        hidden: { type: 'boolean' },
      },
      required: ['type', 'fieldId', 'hidden'],
    },
    GroupVisibilityAction: {
      type: 'object',
      title: 'GroupVisibilityAction',
      additionalProperties: false,
      properties: {
        type: {
          const: 'change-group-visibility',
          default: 'change-group-visibility',
        },
        groupId: { type: 'string' },
        hidden: { type: 'boolean' },
      },
      required: ['type', 'groupId', 'hidden'],
    },
  },
};
const schema73 = {
  type: 'string',
  title: 'TriggerOperator',
  enum: ['AND', 'OR'],
  tsEnumNames: ['AND', 'OR'],
};
const schema74 = {
  type: 'object',
  title: 'StringArrayTrigger',
  additionalProperties: false,
  properties: {
    id: { type: 'string' },
    operator: { $ref: '#/definitions/StringArrayOperator' },
    value: { type: 'array', items: { type: 'string' } },
  },
  required: ['id', 'operator', 'value'],
};
const schema75 = {
  type: 'string',
  title: 'StringArrayOperator',
  enum: ['any', 'none'],
  tsEnumNames: ['Any', 'None'],
};
function validate59(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.id === undefined && (missing0 = 'id')) ||
        (data.operator === undefined && (missing0 = 'operator')) ||
        (data.value === undefined && (missing0 = 'value'))
      ) {
        validate59.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'id' || key0 === 'operator' || key0 === 'value')) {
            validate59.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.id !== undefined) {
            const _errs2 = errors;
            if (typeof data.id !== 'string') {
              validate59.errors = [
                {
                  instancePath: instancePath + '/id',
                  schemaPath: '#/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.operator !== undefined) {
              let data1 = data.operator;
              const _errs4 = errors;
              if (typeof data1 !== 'string') {
                validate59.errors = [
                  {
                    instancePath: instancePath + '/operator',
                    schemaPath: '#/definitions/StringArrayOperator/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              if (!(data1 === 'any' || data1 === 'none')) {
                validate59.errors = [
                  {
                    instancePath: instancePath + '/operator',
                    schemaPath: '#/definitions/StringArrayOperator/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema75.enum },
                    message: 'must be equal to one of the allowed values',
                  },
                ];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.value !== undefined) {
                let data2 = data.value;
                const _errs7 = errors;
                if (errors === _errs7) {
                  if (Array.isArray(data2)) {
                    var valid2 = true;
                    const len0 = data2.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      const _errs9 = errors;
                      if (typeof data2[i0] !== 'string') {
                        validate59.errors = [
                          {
                            instancePath: instancePath + '/value/' + i0,
                            schemaPath: '#/properties/value/items/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs9 === errors;
                      if (!valid2) {
                        break;
                      }
                    }
                  } else {
                    validate59.errors = [
                      {
                        instancePath: instancePath + '/value',
                        schemaPath: '#/properties/value/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate59.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate59.errors = vErrors;
  return errors === 0;
}
const schema76 = {
  type: 'object',
  title: 'StringTrigger',
  additionalProperties: false,
  properties: {
    id: { type: 'string' },
    operator: { $ref: '#/definitions/StringOperator' },
    value: { type: ['string'] },
  },
  required: ['id', 'operator', 'value'],
};
const schema77 = {
  type: 'string',
  title: 'StringOperator',
  enum: ['has', 'hasNot', 'match'],
  tsEnumNames: ['Has', 'HasNot', 'Match'],
};
function validate61(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.id === undefined && (missing0 = 'id')) ||
        (data.operator === undefined && (missing0 = 'operator')) ||
        (data.value === undefined && (missing0 = 'value'))
      ) {
        validate61.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'id' || key0 === 'operator' || key0 === 'value')) {
            validate61.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.id !== undefined) {
            const _errs2 = errors;
            if (typeof data.id !== 'string') {
              validate61.errors = [
                {
                  instancePath: instancePath + '/id',
                  schemaPath: '#/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.operator !== undefined) {
              let data1 = data.operator;
              const _errs4 = errors;
              if (typeof data1 !== 'string') {
                validate61.errors = [
                  {
                    instancePath: instancePath + '/operator',
                    schemaPath: '#/definitions/StringOperator/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              if (
                !(data1 === 'has' || data1 === 'hasNot' || data1 === 'match')
              ) {
                validate61.errors = [
                  {
                    instancePath: instancePath + '/operator',
                    schemaPath: '#/definitions/StringOperator/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema77.enum },
                    message: 'must be equal to one of the allowed values',
                  },
                ];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.value !== undefined) {
                const _errs7 = errors;
                if (typeof data.value !== 'string') {
                  validate61.errors = [
                    {
                      instancePath: instancePath + '/value',
                      schemaPath: '#/properties/value/type',
                      keyword: 'type',
                      params: { type: schema76.properties.value.type },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate61.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate61.errors = vErrors;
  return errors === 0;
}
const schema78 = {
  type: 'object',
  title: 'NonNumericTrigger',
  additionalProperties: false,
  properties: {
    id: { type: 'string' },
    operator: { $ref: '#/definitions/NonNumericOperator' },
    value: { type: ['string', 'boolean'] },
  },
  required: ['id', 'operator', 'value'],
};
const schema79 = {
  type: 'string',
  title: 'NonNumericOperator',
  enum: ['is', 'not'],
  tsEnumNames: ['Is', 'Not'],
};
function validate63(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.id === undefined && (missing0 = 'id')) ||
        (data.operator === undefined && (missing0 = 'operator')) ||
        (data.value === undefined && (missing0 = 'value'))
      ) {
        validate63.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'id' || key0 === 'operator' || key0 === 'value')) {
            validate63.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.id !== undefined) {
            const _errs2 = errors;
            if (typeof data.id !== 'string') {
              validate63.errors = [
                {
                  instancePath: instancePath + '/id',
                  schemaPath: '#/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.operator !== undefined) {
              let data1 = data.operator;
              const _errs4 = errors;
              if (typeof data1 !== 'string') {
                validate63.errors = [
                  {
                    instancePath: instancePath + '/operator',
                    schemaPath: '#/definitions/NonNumericOperator/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              if (!(data1 === 'is' || data1 === 'not')) {
                validate63.errors = [
                  {
                    instancePath: instancePath + '/operator',
                    schemaPath: '#/definitions/NonNumericOperator/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema79.enum },
                    message: 'must be equal to one of the allowed values',
                  },
                ];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.value !== undefined) {
                let data2 = data.value;
                const _errs7 = errors;
                if (typeof data2 !== 'string' && typeof data2 !== 'boolean') {
                  validate63.errors = [
                    {
                      instancePath: instancePath + '/value',
                      schemaPath: '#/properties/value/type',
                      keyword: 'type',
                      params: { type: schema78.properties.value.type },
                      message: 'must be string,boolean',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate63.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate63.errors = vErrors;
  return errors === 0;
}
const schema80 = {
  type: 'object',
  title: 'NumericTrigger',
  additionalProperties: false,
  properties: {
    id: { type: 'string' },
    operator: { $ref: '#/definitions/NumericOperator' },
    value: { type: 'number' },
  },
  required: ['id', 'operator', 'value'],
};
const schema81 = {
  type: 'string',
  title: 'NumericOperator',
  enum: ['gt', 'lt'],
  tsEnumNames: ['Lt', 'Gt'],
};
function validate65(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.id === undefined && (missing0 = 'id')) ||
        (data.operator === undefined && (missing0 = 'operator')) ||
        (data.value === undefined && (missing0 = 'value'))
      ) {
        validate65.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'id' || key0 === 'operator' || key0 === 'value')) {
            validate65.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.id !== undefined) {
            const _errs2 = errors;
            if (typeof data.id !== 'string') {
              validate65.errors = [
                {
                  instancePath: instancePath + '/id',
                  schemaPath: '#/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.operator !== undefined) {
              let data1 = data.operator;
              const _errs4 = errors;
              if (typeof data1 !== 'string') {
                validate65.errors = [
                  {
                    instancePath: instancePath + '/operator',
                    schemaPath: '#/definitions/NumericOperator/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              if (!(data1 === 'gt' || data1 === 'lt')) {
                validate65.errors = [
                  {
                    instancePath: instancePath + '/operator',
                    schemaPath: '#/definitions/NumericOperator/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema81.enum },
                    message: 'must be equal to one of the allowed values',
                  },
                ];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.value !== undefined) {
                let data2 = data.value;
                const _errs7 = errors;
                if (!(typeof data2 == 'number' && isFinite(data2))) {
                  validate65.errors = [
                    {
                      instancePath: instancePath + '/value',
                      schemaPath: '#/properties/value/type',
                      keyword: 'type',
                      params: { type: 'number' },
                      message: 'must be number',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate65.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate65.errors = vErrors;
  return errors === 0;
}
const schema82 = {
  type: 'object',
  title: 'Action',
  oneOf: [
    { $ref: '#/definitions/FieldVisibilityAction' },
    { $ref: '#/definitions/GroupVisibilityAction' },
  ],
};
const schema83 = {
  type: 'object',
  title: 'FieldVisibilityAction',
  additionalProperties: false,
  properties: {
    type: {
      const: 'change-field-visibility',
      default: 'change-field-visibility',
    },
    fieldId: { type: 'string' },
    hidden: { type: 'boolean' },
  },
  required: ['type', 'fieldId', 'hidden'],
};
const schema84 = {
  type: 'object',
  title: 'GroupVisibilityAction',
  additionalProperties: false,
  properties: {
    type: {
      const: 'change-group-visibility',
      default: 'change-group-visibility',
    },
    groupId: { type: 'string' },
    hidden: { type: 'boolean' },
  },
  required: ['type', 'groupId', 'hidden'],
};
function validate67(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == 'object' && !Array.isArray(data))) {
    validate67.errors = [
      {
        instancePath,
        schemaPath: '#/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      },
    ];
    return false;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  const _errs3 = errors;
  if (errors === _errs3) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.type === undefined && (missing0 = 'type')) ||
        (data.fieldId === undefined && (missing0 = 'fieldId')) ||
        (data.hidden === undefined && (missing0 = 'hidden'))
      ) {
        const err0 = {
          instancePath,
          schemaPath: '#/definitions/FieldVisibilityAction/required',
          keyword: 'required',
          params: { missingProperty: missing0 },
          message: "must have required property '" + missing0 + "'",
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        const _errs5 = errors;
        for (const key0 in data) {
          if (!(key0 === 'type' || key0 === 'fieldId' || key0 === 'hidden')) {
            const err1 = {
              instancePath,
              schemaPath:
                '#/definitions/FieldVisibilityAction/additionalProperties',
              keyword: 'additionalProperties',
              params: { additionalProperty: key0 },
              message: 'must NOT have additional properties',
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
            break;
          }
        }
        if (_errs5 === errors) {
          if (data.type !== undefined) {
            const _errs6 = errors;
            if (!func0(data.type, 'change-field-visibility')) {
              const err2 = {
                instancePath: instancePath + '/type',
                schemaPath:
                  '#/definitions/FieldVisibilityAction/properties/type/const',
                keyword: 'const',
                params: { allowedValue: 'change-field-visibility' },
                message: 'must be equal to constant',
              };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            var valid2 = _errs6 === errors;
          } else {
            var valid2 = true;
          }
          if (valid2) {
            if (data.fieldId !== undefined) {
              const _errs7 = errors;
              if (typeof data.fieldId !== 'string') {
                const err3 = {
                  instancePath: instancePath + '/fieldId',
                  schemaPath:
                    '#/definitions/FieldVisibilityAction/properties/fieldId/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
              }
              var valid2 = _errs7 === errors;
            } else {
              var valid2 = true;
            }
            if (valid2) {
              if (data.hidden !== undefined) {
                const _errs9 = errors;
                if (typeof data.hidden !== 'boolean') {
                  const err4 = {
                    instancePath: instancePath + '/hidden',
                    schemaPath:
                      '#/definitions/FieldVisibilityAction/properties/hidden/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  };
                  if (vErrors === null) {
                    vErrors = [err4];
                  } else {
                    vErrors.push(err4);
                  }
                  errors++;
                }
                var valid2 = _errs9 === errors;
              } else {
                var valid2 = true;
              }
            }
          }
        }
      }
    } else {
      const err5 = {
        instancePath,
        schemaPath: '#/definitions/FieldVisibilityAction/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs11 = errors;
  const _errs12 = errors;
  if (errors === _errs12) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing1;
      if (
        (data.type === undefined && (missing1 = 'type')) ||
        (data.groupId === undefined && (missing1 = 'groupId')) ||
        (data.hidden === undefined && (missing1 = 'hidden'))
      ) {
        const err6 = {
          instancePath,
          schemaPath: '#/definitions/GroupVisibilityAction/required',
          keyword: 'required',
          params: { missingProperty: missing1 },
          message: "must have required property '" + missing1 + "'",
        };
        if (vErrors === null) {
          vErrors = [err6];
        } else {
          vErrors.push(err6);
        }
        errors++;
      } else {
        const _errs14 = errors;
        for (const key1 in data) {
          if (!(key1 === 'type' || key1 === 'groupId' || key1 === 'hidden')) {
            const err7 = {
              instancePath,
              schemaPath:
                '#/definitions/GroupVisibilityAction/additionalProperties',
              keyword: 'additionalProperties',
              params: { additionalProperty: key1 },
              message: 'must NOT have additional properties',
            };
            if (vErrors === null) {
              vErrors = [err7];
            } else {
              vErrors.push(err7);
            }
            errors++;
            break;
          }
        }
        if (_errs14 === errors) {
          if (data.type !== undefined) {
            const _errs15 = errors;
            if (!func0(data.type, 'change-group-visibility')) {
              const err8 = {
                instancePath: instancePath + '/type',
                schemaPath:
                  '#/definitions/GroupVisibilityAction/properties/type/const',
                keyword: 'const',
                params: { allowedValue: 'change-group-visibility' },
                message: 'must be equal to constant',
              };
              if (vErrors === null) {
                vErrors = [err8];
              } else {
                vErrors.push(err8);
              }
              errors++;
            }
            var valid4 = _errs15 === errors;
          } else {
            var valid4 = true;
          }
          if (valid4) {
            if (data.groupId !== undefined) {
              const _errs16 = errors;
              if (typeof data.groupId !== 'string') {
                const err9 = {
                  instancePath: instancePath + '/groupId',
                  schemaPath:
                    '#/definitions/GroupVisibilityAction/properties/groupId/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                };
                if (vErrors === null) {
                  vErrors = [err9];
                } else {
                  vErrors.push(err9);
                }
                errors++;
              }
              var valid4 = _errs16 === errors;
            } else {
              var valid4 = true;
            }
            if (valid4) {
              if (data.hidden !== undefined) {
                const _errs18 = errors;
                if (typeof data.hidden !== 'boolean') {
                  const err10 = {
                    instancePath: instancePath + '/hidden',
                    schemaPath:
                      '#/definitions/GroupVisibilityAction/properties/hidden/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  };
                  if (vErrors === null) {
                    vErrors = [err10];
                  } else {
                    vErrors.push(err10);
                  }
                  errors++;
                }
                var valid4 = _errs18 === errors;
              } else {
                var valid4 = true;
              }
            }
          }
        }
      }
    } else {
      const err11 = {
        instancePath,
        schemaPath: '#/definitions/GroupVisibilityAction/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      };
      if (vErrors === null) {
        vErrors = [err11];
      } else {
        vErrors.push(err11);
      }
      errors++;
    }
  }
  var _valid0 = _errs11 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
  }
  if (!valid0) {
    const err12 = {
      instancePath,
      schemaPath: '#/oneOf',
      keyword: 'oneOf',
      params: { passingSchemas: passing0 },
      message: 'must match exactly one schema in oneOf',
    };
    if (vErrors === null) {
      vErrors = [err12];
    } else {
      vErrors.push(err12);
    }
    errors++;
    validate67.errors = vErrors;
    return false;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate67.errors = vErrors;
  return errors === 0;
}
function validate58(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="Rule.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.id === undefined && (missing0 = 'id')) ||
        (data.triggerOperator === undefined &&
          (missing0 = 'triggerOperator')) ||
        (data.triggers === undefined && (missing0 = 'triggers')) ||
        (data.actions === undefined && (missing0 = 'actions'))
      ) {
        validate58.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (
            !(
              key0 === 'id' ||
              key0 === 'triggerOperator' ||
              key0 === 'triggers' ||
              key0 === 'actions'
            )
          ) {
            validate58.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.id !== undefined) {
            const _errs2 = errors;
            if (typeof data.id !== 'string') {
              validate58.errors = [
                {
                  instancePath: instancePath + '/id',
                  schemaPath: '#/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.triggerOperator !== undefined) {
              let data1 = data.triggerOperator;
              const _errs4 = errors;
              if (typeof data1 !== 'string') {
                validate58.errors = [
                  {
                    instancePath: instancePath + '/triggerOperator',
                    schemaPath: '#/definitions/TriggerOperator/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              if (!(data1 === 'AND' || data1 === 'OR')) {
                validate58.errors = [
                  {
                    instancePath: instancePath + '/triggerOperator',
                    schemaPath: '#/definitions/TriggerOperator/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema73.enum },
                    message: 'must be equal to one of the allowed values',
                  },
                ];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.triggers !== undefined) {
                let data2 = data.triggers;
                const _errs7 = errors;
                if (errors === _errs7) {
                  if (Array.isArray(data2)) {
                    var valid2 = true;
                    const len0 = data2.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                      let data3 = data2[i0];
                      const _errs9 = errors;
                      const _errs10 = errors;
                      let valid3 = false;
                      let passing0 = null;
                      const _errs11 = errors;
                      if (
                        !validate59(data3, {
                          instancePath: instancePath + '/triggers/' + i0,
                          parentData: data2,
                          parentDataProperty: i0,
                          rootData,
                        })
                      ) {
                        vErrors =
                          vErrors === null
                            ? validate59.errors
                            : vErrors.concat(validate59.errors);
                        errors = vErrors.length;
                      }
                      var _valid0 = _errs11 === errors;
                      if (_valid0) {
                        valid3 = true;
                        passing0 = 0;
                      }
                      const _errs12 = errors;
                      if (
                        !validate61(data3, {
                          instancePath: instancePath + '/triggers/' + i0,
                          parentData: data2,
                          parentDataProperty: i0,
                          rootData,
                        })
                      ) {
                        vErrors =
                          vErrors === null
                            ? validate61.errors
                            : vErrors.concat(validate61.errors);
                        errors = vErrors.length;
                      }
                      var _valid0 = _errs12 === errors;
                      if (_valid0 && valid3) {
                        valid3 = false;
                        passing0 = [passing0, 1];
                      } else {
                        if (_valid0) {
                          valid3 = true;
                          passing0 = 1;
                        }
                        const _errs13 = errors;
                        if (
                          !validate63(data3, {
                            instancePath: instancePath + '/triggers/' + i0,
                            parentData: data2,
                            parentDataProperty: i0,
                            rootData,
                          })
                        ) {
                          vErrors =
                            vErrors === null
                              ? validate63.errors
                              : vErrors.concat(validate63.errors);
                          errors = vErrors.length;
                        }
                        var _valid0 = _errs13 === errors;
                        if (_valid0 && valid3) {
                          valid3 = false;
                          passing0 = [passing0, 2];
                        } else {
                          if (_valid0) {
                            valid3 = true;
                            passing0 = 2;
                          }
                          const _errs14 = errors;
                          if (
                            !validate65(data3, {
                              instancePath: instancePath + '/triggers/' + i0,
                              parentData: data2,
                              parentDataProperty: i0,
                              rootData,
                            })
                          ) {
                            vErrors =
                              vErrors === null
                                ? validate65.errors
                                : vErrors.concat(validate65.errors);
                            errors = vErrors.length;
                          }
                          var _valid0 = _errs14 === errors;
                          if (_valid0 && valid3) {
                            valid3 = false;
                            passing0 = [passing0, 3];
                          } else {
                            if (_valid0) {
                              valid3 = true;
                              passing0 = 3;
                            }
                          }
                        }
                      }
                      if (!valid3) {
                        const err0 = {
                          instancePath: instancePath + '/triggers/' + i0,
                          schemaPath: '#/properties/triggers/items/oneOf',
                          keyword: 'oneOf',
                          params: { passingSchemas: passing0 },
                          message: 'must match exactly one schema in oneOf',
                        };
                        if (vErrors === null) {
                          vErrors = [err0];
                        } else {
                          vErrors.push(err0);
                        }
                        errors++;
                        validate58.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs10;
                        if (vErrors !== null) {
                          if (_errs10) {
                            vErrors.length = _errs10;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid2 = _errs9 === errors;
                      if (!valid2) {
                        break;
                      }
                    }
                  } else {
                    validate58.errors = [
                      {
                        instancePath: instancePath + '/triggers',
                        schemaPath: '#/properties/triggers/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.actions !== undefined) {
                  let data4 = data.actions;
                  const _errs15 = errors;
                  if (errors === _errs15) {
                    if (Array.isArray(data4)) {
                      var valid4 = true;
                      const len1 = data4.length;
                      for (let i1 = 0; i1 < len1; i1++) {
                        const _errs17 = errors;
                        if (
                          !validate67(data4[i1], {
                            instancePath: instancePath + '/actions/' + i1,
                            parentData: data4,
                            parentDataProperty: i1,
                            rootData,
                          })
                        ) {
                          vErrors =
                            vErrors === null
                              ? validate67.errors
                              : vErrors.concat(validate67.errors);
                          errors = vErrors.length;
                        }
                        var valid4 = _errs17 === errors;
                        if (!valid4) {
                          break;
                        }
                      }
                    } else {
                      validate58.errors = [
                        {
                          instancePath: instancePath + '/actions',
                          schemaPath: '#/properties/actions/type',
                          keyword: 'type',
                          params: { type: 'array' },
                          message: 'must be array',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs15 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate58.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate58.errors = vErrors;
  return errors === 0;
}
const schema86 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'Recipient.json',
  title: 'Recipient',
  type: 'object',
  oneOf: [
    { $ref: '#/definitions/Role' },
    { $ref: '#/definitions/Signer' },
    { $ref: '#/definitions/FaxRecipient' },
  ],
  definitions: {
    DeliveryType: {
      type: 'string',
      title: 'DeliveryType',
      enum: ['EMAIL', 'EMAIL-SMS'],
      tsEnumNames: ['Email', 'EmailAndSMS'],
      'x-enum-names': ['Email', 'EmailAndSMS'],
    },
    Attachment: {
      type: 'object',
      title: 'Attachment',
      additionalProperties: false,
      properties: {
        id: { type: 'string' },
        name: { type: 'string' },
        instructions: { type: 'string' },
        required: { type: 'boolean' },
      },
      required: ['id', 'name', 'instructions', 'required'],
    },
    Role: {
      type: 'object',
      title: 'Role',
      additionalProperties: false,
      properties: {
        type: { const: 'role', default: 'role' },
        id: { type: 'string' },
        name: { type: 'string' },
        attachments: {
          type: 'array',
          items: { $ref: '#/definitions/Attachment' },
        },
        order: { type: 'integer' },
      },
      required: ['type', 'id', 'name', 'attachments'],
    },
    Signer: {
      type: 'object',
      title: 'Signer',
      additionalProperties: false,
      properties: {
        type: { const: 'signer', default: 'signer' },
        id: { type: 'string' },
        email: {
          oneOf: [{ type: 'string', format: 'email' }, { type: 'null' }],
        },
        name: { type: 'string' },
        role: { oneOf: [{ type: 'null' }, { $ref: '#/definitions/Role' }] },
        attachments: {
          type: 'array',
          items: { $ref: '#/definitions/Attachment' },
        },
        accessCode: { type: 'string' },
        smsAuthNumber: { type: 'string' },
        authType: { type: 'string' },
        smsDeliveryNumber: { type: 'string' },
        deliveryType: { $ref: '#/definitions/DeliveryType' },
        order: { type: 'integer' },
      },
      required: ['type', 'id', 'email', 'name', 'role', 'attachments'],
    },
    FaxRecipient: {
      type: 'object',
      title: 'FaxRecipient',
      additionalProperties: false,
      properties: {
        type: { const: 'fax', default: 'fax' },
        id: { type: 'string' },
        fax: { type: 'string' },
      },
      required: ['id', 'type', 'fax'],
    },
    CCRole: {
      type: 'object',
      title: 'CCRole',
      additionalProperties: false,
      properties: {
        type: { const: 'ccRole', default: 'ccRole' },
        id: { type: 'string' },
        name: { type: 'string' },
      },
      required: ['type', 'id', 'name'],
    },
    CCEmail: {
      type: 'object',
      title: 'CCEmail',
      additionalProperties: false,
      properties: {
        type: { const: 'ccEmail', default: 'ccEmail' },
        id: { type: 'string' },
        email: { type: 'string' },
        role: { $ref: '#/definitions/CCRole' },
      },
      required: ['type', 'id', 'email'],
    },
  },
};
const schema92 = {
  type: 'object',
  title: 'FaxRecipient',
  additionalProperties: false,
  properties: {
    type: { const: 'fax', default: 'fax' },
    id: { type: 'string' },
    fax: { type: 'string' },
  },
  required: ['id', 'type', 'fax'],
};
const schema87 = {
  type: 'object',
  title: 'Role',
  additionalProperties: false,
  properties: {
    type: { const: 'role', default: 'role' },
    id: { type: 'string' },
    name: { type: 'string' },
    attachments: { type: 'array', items: { $ref: '#/definitions/Attachment' } },
    order: { type: 'integer' },
  },
  required: ['type', 'id', 'name', 'attachments'],
};
const schema88 = {
  type: 'object',
  title: 'Attachment',
  additionalProperties: false,
  properties: {
    id: { type: 'string' },
    name: { type: 'string' },
    instructions: { type: 'string' },
    required: { type: 'boolean' },
  },
  required: ['id', 'name', 'instructions', 'required'],
};
function validate71(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.type === undefined && (missing0 = 'type')) ||
        (data.id === undefined && (missing0 = 'id')) ||
        (data.name === undefined && (missing0 = 'name')) ||
        (data.attachments === undefined && (missing0 = 'attachments'))
      ) {
        validate71.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (
            !(
              key0 === 'type' ||
              key0 === 'id' ||
              key0 === 'name' ||
              key0 === 'attachments' ||
              key0 === 'order'
            )
          ) {
            validate71.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.type !== undefined) {
            const _errs2 = errors;
            if (!func0(data.type, 'role')) {
              validate71.errors = [
                {
                  instancePath: instancePath + '/type',
                  schemaPath: '#/properties/type/const',
                  keyword: 'const',
                  params: { allowedValue: 'role' },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.id !== undefined) {
              const _errs3 = errors;
              if (typeof data.id !== 'string') {
                validate71.errors = [
                  {
                    instancePath: instancePath + '/id',
                    schemaPath: '#/properties/id/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.name !== undefined) {
                const _errs5 = errors;
                if (typeof data.name !== 'string') {
                  validate71.errors = [
                    {
                      instancePath: instancePath + '/name',
                      schemaPath: '#/properties/name/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.attachments !== undefined) {
                  let data3 = data.attachments;
                  const _errs7 = errors;
                  if (errors === _errs7) {
                    if (Array.isArray(data3)) {
                      var valid1 = true;
                      const len0 = data3.length;
                      for (let i0 = 0; i0 < len0; i0++) {
                        let data4 = data3[i0];
                        const _errs9 = errors;
                        const _errs10 = errors;
                        if (errors === _errs10) {
                          if (
                            data4 &&
                            typeof data4 == 'object' &&
                            !Array.isArray(data4)
                          ) {
                            let missing1;
                            if (
                              (data4.id === undefined && (missing1 = 'id')) ||
                              (data4.name === undefined &&
                                (missing1 = 'name')) ||
                              (data4.instructions === undefined &&
                                (missing1 = 'instructions')) ||
                              (data4.required === undefined &&
                                (missing1 = 'required'))
                            ) {
                              validate71.errors = [
                                {
                                  instancePath:
                                    instancePath + '/attachments/' + i0,
                                  schemaPath:
                                    '#/definitions/Attachment/required',
                                  keyword: 'required',
                                  params: { missingProperty: missing1 },
                                  message:
                                    "must have required property '" +
                                    missing1 +
                                    "'",
                                },
                              ];
                              return false;
                            } else {
                              const _errs12 = errors;
                              for (const key1 in data4) {
                                if (
                                  !(
                                    key1 === 'id' ||
                                    key1 === 'name' ||
                                    key1 === 'instructions' ||
                                    key1 === 'required'
                                  )
                                ) {
                                  validate71.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/attachments/' + i0,
                                      schemaPath:
                                        '#/definitions/Attachment/additionalProperties',
                                      keyword: 'additionalProperties',
                                      params: { additionalProperty: key1 },
                                      message:
                                        'must NOT have additional properties',
                                    },
                                  ];
                                  return false;
                                  break;
                                }
                              }
                              if (_errs12 === errors) {
                                if (data4.id !== undefined) {
                                  const _errs13 = errors;
                                  if (typeof data4.id !== 'string') {
                                    validate71.errors = [
                                      {
                                        instancePath:
                                          instancePath +
                                          '/attachments/' +
                                          i0 +
                                          '/id',
                                        schemaPath:
                                          '#/definitions/Attachment/properties/id/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid3 = _errs13 === errors;
                                } else {
                                  var valid3 = true;
                                }
                                if (valid3) {
                                  if (data4.name !== undefined) {
                                    const _errs15 = errors;
                                    if (typeof data4.name !== 'string') {
                                      validate71.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/attachments/' +
                                            i0 +
                                            '/name',
                                          schemaPath:
                                            '#/definitions/Attachment/properties/name/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid3 = _errs15 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                  if (valid3) {
                                    if (data4.instructions !== undefined) {
                                      const _errs17 = errors;
                                      if (
                                        typeof data4.instructions !== 'string'
                                      ) {
                                        validate71.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/attachments/' +
                                              i0 +
                                              '/instructions',
                                            schemaPath:
                                              '#/definitions/Attachment/properties/instructions/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid3 = _errs17 === errors;
                                    } else {
                                      var valid3 = true;
                                    }
                                    if (valid3) {
                                      if (data4.required !== undefined) {
                                        const _errs19 = errors;
                                        if (
                                          typeof data4.required !== 'boolean'
                                        ) {
                                          validate71.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/attachments/' +
                                                i0 +
                                                '/required',
                                              schemaPath:
                                                '#/definitions/Attachment/properties/required/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid3 = _errs19 === errors;
                                      } else {
                                        var valid3 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          } else {
                            validate71.errors = [
                              {
                                instancePath:
                                  instancePath + '/attachments/' + i0,
                                schemaPath: '#/definitions/Attachment/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object',
                              },
                            ];
                            return false;
                          }
                        }
                        var valid1 = _errs9 === errors;
                        if (!valid1) {
                          break;
                        }
                      }
                    } else {
                      validate71.errors = [
                        {
                          instancePath: instancePath + '/attachments',
                          schemaPath: '#/properties/attachments/type',
                          keyword: 'type',
                          params: { type: 'array' },
                          message: 'must be array',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs7 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.order !== undefined) {
                    let data9 = data.order;
                    const _errs21 = errors;
                    if (
                      !(
                        typeof data9 == 'number' &&
                        !(data9 % 1) &&
                        !isNaN(data9) &&
                        isFinite(data9)
                      )
                    ) {
                      validate71.errors = [
                        {
                          instancePath: instancePath + '/order',
                          schemaPath: '#/properties/order/type',
                          keyword: 'type',
                          params: { type: 'integer' },
                          message: 'must be integer',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs21 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate71.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate71.errors = vErrors;
  return errors === 0;
}
const schema89 = {
  type: 'object',
  title: 'Signer',
  additionalProperties: false,
  properties: {
    type: { const: 'signer', default: 'signer' },
    id: { type: 'string' },
    email: { oneOf: [{ type: 'string', format: 'email' }, { type: 'null' }] },
    name: { type: 'string' },
    role: { oneOf: [{ type: 'null' }, { $ref: '#/definitions/Role' }] },
    attachments: { type: 'array', items: { $ref: '#/definitions/Attachment' } },
    accessCode: { type: 'string' },
    smsAuthNumber: { type: 'string' },
    authType: { type: 'string' },
    smsDeliveryNumber: { type: 'string' },
    deliveryType: { $ref: '#/definitions/DeliveryType' },
    order: { type: 'integer' },
  },
  required: ['type', 'id', 'email', 'name', 'role', 'attachments'],
};
const schema91 = {
  type: 'string',
  title: 'DeliveryType',
  enum: ['EMAIL', 'EMAIL-SMS'],
  tsEnumNames: ['Email', 'EmailAndSMS'],
  'x-enum-names': ['Email', 'EmailAndSMS'],
};
const formats4 =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
function validate73(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.type === undefined && (missing0 = 'type')) ||
        (data.id === undefined && (missing0 = 'id')) ||
        (data.email === undefined && (missing0 = 'email')) ||
        (data.name === undefined && (missing0 = 'name')) ||
        (data.role === undefined && (missing0 = 'role')) ||
        (data.attachments === undefined && (missing0 = 'attachments'))
      ) {
        validate73.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func4.call(schema89.properties, key0)) {
            validate73.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.type !== undefined) {
            const _errs2 = errors;
            if (!func0(data.type, 'signer')) {
              validate73.errors = [
                {
                  instancePath: instancePath + '/type',
                  schemaPath: '#/properties/type/const',
                  keyword: 'const',
                  params: { allowedValue: 'signer' },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.id !== undefined) {
              const _errs3 = errors;
              if (typeof data.id !== 'string') {
                validate73.errors = [
                  {
                    instancePath: instancePath + '/id',
                    schemaPath: '#/properties/id/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.email !== undefined) {
                let data2 = data.email;
                const _errs5 = errors;
                const _errs6 = errors;
                let valid1 = false;
                let passing0 = null;
                const _errs7 = errors;
                if (errors === _errs7) {
                  if (errors === _errs7) {
                    if (typeof data2 === 'string') {
                      if (!formats4.test(data2)) {
                        const err0 = {
                          instancePath: instancePath + '/email',
                          schemaPath: '#/properties/email/oneOf/0/format',
                          keyword: 'format',
                          params: { format: 'email' },
                          message: 'must match format "' + 'email' + '"',
                        };
                        if (vErrors === null) {
                          vErrors = [err0];
                        } else {
                          vErrors.push(err0);
                        }
                        errors++;
                      }
                    } else {
                      const err1 = {
                        instancePath: instancePath + '/email',
                        schemaPath: '#/properties/email/oneOf/0/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      };
                      if (vErrors === null) {
                        vErrors = [err1];
                      } else {
                        vErrors.push(err1);
                      }
                      errors++;
                    }
                  }
                }
                var _valid0 = _errs7 === errors;
                if (_valid0) {
                  valid1 = true;
                  passing0 = 0;
                }
                const _errs9 = errors;
                if (data2 !== null) {
                  const err2 = {
                    instancePath: instancePath + '/email',
                    schemaPath: '#/properties/email/oneOf/1/type',
                    keyword: 'type',
                    params: { type: 'null' },
                    message: 'must be null',
                  };
                  if (vErrors === null) {
                    vErrors = [err2];
                  } else {
                    vErrors.push(err2);
                  }
                  errors++;
                }
                var _valid0 = _errs9 === errors;
                if (_valid0 && valid1) {
                  valid1 = false;
                  passing0 = [passing0, 1];
                } else {
                  if (_valid0) {
                    valid1 = true;
                    passing0 = 1;
                  }
                }
                if (!valid1) {
                  const err3 = {
                    instancePath: instancePath + '/email',
                    schemaPath: '#/properties/email/oneOf',
                    keyword: 'oneOf',
                    params: { passingSchemas: passing0 },
                    message: 'must match exactly one schema in oneOf',
                  };
                  if (vErrors === null) {
                    vErrors = [err3];
                  } else {
                    vErrors.push(err3);
                  }
                  errors++;
                  validate73.errors = vErrors;
                  return false;
                } else {
                  errors = _errs6;
                  if (vErrors !== null) {
                    if (_errs6) {
                      vErrors.length = _errs6;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.name !== undefined) {
                  const _errs11 = errors;
                  if (typeof data.name !== 'string') {
                    validate73.errors = [
                      {
                        instancePath: instancePath + '/name',
                        schemaPath: '#/properties/name/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs11 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.role !== undefined) {
                    let data4 = data.role;
                    const _errs13 = errors;
                    const _errs14 = errors;
                    let valid2 = false;
                    let passing1 = null;
                    const _errs15 = errors;
                    if (data4 !== null) {
                      const err4 = {
                        instancePath: instancePath + '/role',
                        schemaPath: '#/properties/role/oneOf/0/type',
                        keyword: 'type',
                        params: { type: 'null' },
                        message: 'must be null',
                      };
                      if (vErrors === null) {
                        vErrors = [err4];
                      } else {
                        vErrors.push(err4);
                      }
                      errors++;
                    }
                    var _valid1 = _errs15 === errors;
                    if (_valid1) {
                      valid2 = true;
                      passing1 = 0;
                    }
                    const _errs17 = errors;
                    if (
                      !validate71(data4, {
                        instancePath: instancePath + '/role',
                        parentData: data,
                        parentDataProperty: 'role',
                        rootData,
                      })
                    ) {
                      vErrors =
                        vErrors === null
                          ? validate71.errors
                          : vErrors.concat(validate71.errors);
                      errors = vErrors.length;
                    }
                    var _valid1 = _errs17 === errors;
                    if (_valid1 && valid2) {
                      valid2 = false;
                      passing1 = [passing1, 1];
                    } else {
                      if (_valid1) {
                        valid2 = true;
                        passing1 = 1;
                      }
                    }
                    if (!valid2) {
                      const err5 = {
                        instancePath: instancePath + '/role',
                        schemaPath: '#/properties/role/oneOf',
                        keyword: 'oneOf',
                        params: { passingSchemas: passing1 },
                        message: 'must match exactly one schema in oneOf',
                      };
                      if (vErrors === null) {
                        vErrors = [err5];
                      } else {
                        vErrors.push(err5);
                      }
                      errors++;
                      validate73.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs14;
                      if (vErrors !== null) {
                        if (_errs14) {
                          vErrors.length = _errs14;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs13 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.attachments !== undefined) {
                      let data5 = data.attachments;
                      const _errs18 = errors;
                      if (errors === _errs18) {
                        if (Array.isArray(data5)) {
                          var valid3 = true;
                          const len0 = data5.length;
                          for (let i0 = 0; i0 < len0; i0++) {
                            let data6 = data5[i0];
                            const _errs20 = errors;
                            const _errs21 = errors;
                            if (errors === _errs21) {
                              if (
                                data6 &&
                                typeof data6 == 'object' &&
                                !Array.isArray(data6)
                              ) {
                                let missing1;
                                if (
                                  (data6.id === undefined &&
                                    (missing1 = 'id')) ||
                                  (data6.name === undefined &&
                                    (missing1 = 'name')) ||
                                  (data6.instructions === undefined &&
                                    (missing1 = 'instructions')) ||
                                  (data6.required === undefined &&
                                    (missing1 = 'required'))
                                ) {
                                  validate73.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/attachments/' + i0,
                                      schemaPath:
                                        '#/definitions/Attachment/required',
                                      keyword: 'required',
                                      params: { missingProperty: missing1 },
                                      message:
                                        "must have required property '" +
                                        missing1 +
                                        "'",
                                    },
                                  ];
                                  return false;
                                } else {
                                  const _errs23 = errors;
                                  for (const key1 in data6) {
                                    if (
                                      !(
                                        key1 === 'id' ||
                                        key1 === 'name' ||
                                        key1 === 'instructions' ||
                                        key1 === 'required'
                                      )
                                    ) {
                                      validate73.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/attachments/' + i0,
                                          schemaPath:
                                            '#/definitions/Attachment/additionalProperties',
                                          keyword: 'additionalProperties',
                                          params: { additionalProperty: key1 },
                                          message:
                                            'must NOT have additional properties',
                                        },
                                      ];
                                      return false;
                                      break;
                                    }
                                  }
                                  if (_errs23 === errors) {
                                    if (data6.id !== undefined) {
                                      const _errs24 = errors;
                                      if (typeof data6.id !== 'string') {
                                        validate73.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/attachments/' +
                                              i0 +
                                              '/id',
                                            schemaPath:
                                              '#/definitions/Attachment/properties/id/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid5 = _errs24 === errors;
                                    } else {
                                      var valid5 = true;
                                    }
                                    if (valid5) {
                                      if (data6.name !== undefined) {
                                        const _errs26 = errors;
                                        if (typeof data6.name !== 'string') {
                                          validate73.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/attachments/' +
                                                i0 +
                                                '/name',
                                              schemaPath:
                                                '#/definitions/Attachment/properties/name/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid5 = _errs26 === errors;
                                      } else {
                                        var valid5 = true;
                                      }
                                      if (valid5) {
                                        if (data6.instructions !== undefined) {
                                          const _errs28 = errors;
                                          if (
                                            typeof data6.instructions !==
                                            'string'
                                          ) {
                                            validate73.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/attachments/' +
                                                  i0 +
                                                  '/instructions',
                                                schemaPath:
                                                  '#/definitions/Attachment/properties/instructions/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid5 = _errs28 === errors;
                                        } else {
                                          var valid5 = true;
                                        }
                                        if (valid5) {
                                          if (data6.required !== undefined) {
                                            const _errs30 = errors;
                                            if (
                                              typeof data6.required !==
                                              'boolean'
                                            ) {
                                              validate73.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/attachments/' +
                                                    i0 +
                                                    '/required',
                                                  schemaPath:
                                                    '#/definitions/Attachment/properties/required/type',
                                                  keyword: 'type',
                                                  params: { type: 'boolean' },
                                                  message: 'must be boolean',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid5 = _errs30 === errors;
                                          } else {
                                            var valid5 = true;
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              } else {
                                validate73.errors = [
                                  {
                                    instancePath:
                                      instancePath + '/attachments/' + i0,
                                    schemaPath: '#/definitions/Attachment/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object',
                                  },
                                ];
                                return false;
                              }
                            }
                            var valid3 = _errs20 === errors;
                            if (!valid3) {
                              break;
                            }
                          }
                        } else {
                          validate73.errors = [
                            {
                              instancePath: instancePath + '/attachments',
                              schemaPath: '#/properties/attachments/type',
                              keyword: 'type',
                              params: { type: 'array' },
                              message: 'must be array',
                            },
                          ];
                          return false;
                        }
                      }
                      var valid0 = _errs18 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.accessCode !== undefined) {
                        const _errs32 = errors;
                        if (typeof data.accessCode !== 'string') {
                          validate73.errors = [
                            {
                              instancePath: instancePath + '/accessCode',
                              schemaPath: '#/properties/accessCode/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs32 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.smsAuthNumber !== undefined) {
                          const _errs34 = errors;
                          if (typeof data.smsAuthNumber !== 'string') {
                            validate73.errors = [
                              {
                                instancePath: instancePath + '/smsAuthNumber',
                                schemaPath: '#/properties/smsAuthNumber/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs34 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.authType !== undefined) {
                            const _errs36 = errors;
                            if (typeof data.authType !== 'string') {
                              validate73.errors = [
                                {
                                  instancePath: instancePath + '/authType',
                                  schemaPath: '#/properties/authType/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs36 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.smsDeliveryNumber !== undefined) {
                              const _errs38 = errors;
                              if (typeof data.smsDeliveryNumber !== 'string') {
                                validate73.errors = [
                                  {
                                    instancePath:
                                      instancePath + '/smsDeliveryNumber',
                                    schemaPath:
                                      '#/properties/smsDeliveryNumber/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs38 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.deliveryType !== undefined) {
                                let data15 = data.deliveryType;
                                const _errs40 = errors;
                                if (typeof data15 !== 'string') {
                                  validate73.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/deliveryType',
                                      schemaPath:
                                        '#/definitions/DeliveryType/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                if (
                                  !(
                                    data15 === 'EMAIL' || data15 === 'EMAIL-SMS'
                                  )
                                ) {
                                  validate73.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/deliveryType',
                                      schemaPath:
                                        '#/definitions/DeliveryType/enum',
                                      keyword: 'enum',
                                      params: { allowedValues: schema91.enum },
                                      message:
                                        'must be equal to one of the allowed values',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs40 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.order !== undefined) {
                                  let data16 = data.order;
                                  const _errs43 = errors;
                                  if (
                                    !(
                                      typeof data16 == 'number' &&
                                      !(data16 % 1) &&
                                      !isNaN(data16) &&
                                      isFinite(data16)
                                    )
                                  ) {
                                    validate73.errors = [
                                      {
                                        instancePath: instancePath + '/order',
                                        schemaPath: '#/properties/order/type',
                                        keyword: 'type',
                                        params: { type: 'integer' },
                                        message: 'must be integer',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs43 === errors;
                                } else {
                                  var valid0 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate73.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate73.errors = vErrors;
  return errors === 0;
}
function validate70(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="Recipient.json" */ let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == 'object' && !Array.isArray(data))) {
    validate70.errors = [
      {
        instancePath,
        schemaPath: '#/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      },
    ];
    return false;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (
    !validate71(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
    })
  ) {
    vErrors =
      vErrors === null ? validate71.errors : vErrors.concat(validate71.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs3 = errors;
  if (
    !validate73(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
    })
  ) {
    vErrors =
      vErrors === null ? validate73.errors : vErrors.concat(validate73.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs3 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs4 = errors;
    const _errs5 = errors;
    if (errors === _errs5) {
      if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (
          (data.id === undefined && (missing0 = 'id')) ||
          (data.type === undefined && (missing0 = 'type')) ||
          (data.fax === undefined && (missing0 = 'fax'))
        ) {
          const err0 = {
            instancePath,
            schemaPath: '#/definitions/FaxRecipient/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          };
          if (vErrors === null) {
            vErrors = [err0];
          } else {
            vErrors.push(err0);
          }
          errors++;
        } else {
          const _errs7 = errors;
          for (const key0 in data) {
            if (!(key0 === 'type' || key0 === 'id' || key0 === 'fax')) {
              const err1 = {
                instancePath,
                schemaPath: '#/definitions/FaxRecipient/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              };
              if (vErrors === null) {
                vErrors = [err1];
              } else {
                vErrors.push(err1);
              }
              errors++;
              break;
            }
          }
          if (_errs7 === errors) {
            if (data.type !== undefined) {
              const _errs8 = errors;
              if (!func0(data.type, 'fax')) {
                const err2 = {
                  instancePath: instancePath + '/type',
                  schemaPath:
                    '#/definitions/FaxRecipient/properties/type/const',
                  keyword: 'const',
                  params: { allowedValue: 'fax' },
                  message: 'must be equal to constant',
                };
                if (vErrors === null) {
                  vErrors = [err2];
                } else {
                  vErrors.push(err2);
                }
                errors++;
              }
              var valid2 = _errs8 === errors;
            } else {
              var valid2 = true;
            }
            if (valid2) {
              if (data.id !== undefined) {
                const _errs9 = errors;
                if (typeof data.id !== 'string') {
                  const err3 = {
                    instancePath: instancePath + '/id',
                    schemaPath: '#/definitions/FaxRecipient/properties/id/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  };
                  if (vErrors === null) {
                    vErrors = [err3];
                  } else {
                    vErrors.push(err3);
                  }
                  errors++;
                }
                var valid2 = _errs9 === errors;
              } else {
                var valid2 = true;
              }
              if (valid2) {
                if (data.fax !== undefined) {
                  const _errs11 = errors;
                  if (typeof data.fax !== 'string') {
                    const err4 = {
                      instancePath: instancePath + '/fax',
                      schemaPath:
                        '#/definitions/FaxRecipient/properties/fax/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    };
                    if (vErrors === null) {
                      vErrors = [err4];
                    } else {
                      vErrors.push(err4);
                    }
                    errors++;
                  }
                  var valid2 = _errs11 === errors;
                } else {
                  var valid2 = true;
                }
              }
            }
          }
        }
      } else {
        const err5 = {
          instancePath,
          schemaPath: '#/definitions/FaxRecipient/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        };
        if (vErrors === null) {
          vErrors = [err5];
        } else {
          vErrors.push(err5);
        }
        errors++;
      }
    }
    var _valid0 = _errs4 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
    }
  }
  if (!valid0) {
    const err6 = {
      instancePath,
      schemaPath: '#/oneOf',
      keyword: 'oneOf',
      params: { passingSchemas: passing0 },
      message: 'must match exactly one schema in oneOf',
    };
    if (vErrors === null) {
      vErrors = [err6];
    } else {
      vErrors.push(err6);
    }
    errors++;
    validate70.errors = vErrors;
    return false;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate70.errors = vErrors;
  return errors === 0;
}
const schema93 = {
  type: 'object',
  title: 'SignerOptions',
  properties: {
    fieldOptions: { $ref: '#/definitions/FieldOptions' },
    signatureType: { $ref: '#/definitions/SignatureType' },
  },
};
const schema94 = {
  type: 'object',
  title: 'FieldOptions',
  properties: { dateFormat: { $ref: 'Field.json#/definitions/JSDateFormat' } },
};
function validate78(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.dateFormat !== undefined) {
        let data0 = data.dateFormat;
        if (typeof data0 !== 'string') {
          validate78.errors = [
            {
              instancePath: instancePath + '/dateFormat',
              schemaPath: 'Field.json#/definitions/JSDateFormat/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            },
          ];
          return false;
        }
        if (
          !(
            data0 === 'default' ||
            data0 === 'MM / DD / YYYY' ||
            data0 === 'MM - DD - YYYY' ||
            data0 === 'DD / MM / YYYY' ||
            data0 === 'DD - MM - YYYY' ||
            data0 === 'YYYY / MM / DD' ||
            data0 === 'YYYY - MM - DD'
          )
        ) {
          validate78.errors = [
            {
              instancePath: instancePath + '/dateFormat',
              schemaPath: 'Field.json#/definitions/JSDateFormat/enum',
              keyword: 'enum',
              params: { allowedValues: schema34.enum },
              message: 'must be equal to one of the allowed values',
            },
          ];
          return false;
        }
      }
    } else {
      validate78.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate78.errors = vErrors;
  return errors === 0;
}
const schema96 = {
  type: 'object',
  title: 'SignatureType',
  properties: {
    default: { $ref: '#/definitions/SignatureTypes' },
    allowed: { type: 'array', items: { $ref: '#/definitions/SignatureTypes' } },
  },
};
const schema97 = {
  type: 'string',
  title: 'SignatureTypes',
  enum: ['draw', 'type', 'upload', 'phone'],
};
function validate80(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.default !== undefined) {
        let data0 = data.default;
        const _errs1 = errors;
        if (typeof data0 !== 'string') {
          validate80.errors = [
            {
              instancePath: instancePath + '/default',
              schemaPath: '#/definitions/SignatureTypes/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            },
          ];
          return false;
        }
        if (
          !(
            data0 === 'draw' ||
            data0 === 'type' ||
            data0 === 'upload' ||
            data0 === 'phone'
          )
        ) {
          validate80.errors = [
            {
              instancePath: instancePath + '/default',
              schemaPath: '#/definitions/SignatureTypes/enum',
              keyword: 'enum',
              params: { allowedValues: schema97.enum },
              message: 'must be equal to one of the allowed values',
            },
          ];
          return false;
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.allowed !== undefined) {
          let data1 = data.allowed;
          const _errs4 = errors;
          if (errors === _errs4) {
            if (Array.isArray(data1)) {
              var valid2 = true;
              const len0 = data1.length;
              for (let i0 = 0; i0 < len0; i0++) {
                let data2 = data1[i0];
                const _errs6 = errors;
                if (typeof data2 !== 'string') {
                  validate80.errors = [
                    {
                      instancePath: instancePath + '/allowed/' + i0,
                      schemaPath: '#/definitions/SignatureTypes/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                if (
                  !(
                    data2 === 'draw' ||
                    data2 === 'type' ||
                    data2 === 'upload' ||
                    data2 === 'phone'
                  )
                ) {
                  validate80.errors = [
                    {
                      instancePath: instancePath + '/allowed/' + i0,
                      schemaPath: '#/definitions/SignatureTypes/enum',
                      keyword: 'enum',
                      params: { allowedValues: schema97.enum },
                      message: 'must be equal to one of the allowed values',
                    },
                  ];
                  return false;
                }
                var valid2 = _errs6 === errors;
                if (!valid2) {
                  break;
                }
              }
            } else {
              validate80.errors = [
                {
                  instancePath: instancePath + '/allowed',
                  schemaPath: '#/properties/allowed/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs4 === errors;
        } else {
          var valid0 = true;
        }
      }
    } else {
      validate80.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate80.errors = vErrors;
  return errors === 0;
}
function validate77(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.fieldOptions !== undefined) {
        const _errs1 = errors;
        if (
          !validate78(data.fieldOptions, {
            instancePath: instancePath + '/fieldOptions',
            parentData: data,
            parentDataProperty: 'fieldOptions',
            rootData,
          })
        ) {
          vErrors =
            vErrors === null
              ? validate78.errors
              : vErrors.concat(validate78.errors);
          errors = vErrors.length;
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.signatureType !== undefined) {
          const _errs2 = errors;
          if (
            !validate80(data.signatureType, {
              instancePath: instancePath + '/signatureType',
              parentData: data,
              parentDataProperty: 'signatureType',
              rootData,
            })
          ) {
            vErrors =
              vErrors === null
                ? validate80.errors
                : vErrors.concat(validate80.errors);
            errors = vErrors.length;
          }
          var valid0 = _errs2 === errors;
        } else {
          var valid0 = true;
        }
      }
    } else {
      validate77.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate77.errors = vErrors;
  return errors === 0;
}
const schema100 = {
  oneOf: [
    { $ref: 'Recipient.json#/definitions/CCRole' },
    { $ref: 'Recipient.json#/definitions/CCEmail' },
  ],
};
const schema102 = {
  type: 'object',
  title: 'CCEmail',
  additionalProperties: false,
  properties: {
    type: { const: 'ccEmail', default: 'ccEmail' },
    id: { type: 'string' },
    email: { type: 'string' },
    role: { $ref: '#/definitions/CCRole' },
  },
  required: ['type', 'id', 'email'],
};
function validate84(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.type === undefined && (missing0 = 'type')) ||
        (data.id === undefined && (missing0 = 'id')) ||
        (data.email === undefined && (missing0 = 'email'))
      ) {
        validate84.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (
            !(
              key0 === 'type' ||
              key0 === 'id' ||
              key0 === 'email' ||
              key0 === 'role'
            )
          ) {
            validate84.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.type !== undefined) {
            const _errs2 = errors;
            if (!func0(data.type, 'ccEmail')) {
              validate84.errors = [
                {
                  instancePath: instancePath + '/type',
                  schemaPath: '#/properties/type/const',
                  keyword: 'const',
                  params: { allowedValue: 'ccEmail' },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.id !== undefined) {
              const _errs3 = errors;
              if (typeof data.id !== 'string') {
                validate84.errors = [
                  {
                    instancePath: instancePath + '/id',
                    schemaPath: '#/properties/id/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.email !== undefined) {
                const _errs5 = errors;
                if (typeof data.email !== 'string') {
                  validate84.errors = [
                    {
                      instancePath: instancePath + '/email',
                      schemaPath: '#/properties/email/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.role !== undefined) {
                  let data3 = data.role;
                  const _errs7 = errors;
                  const _errs8 = errors;
                  if (errors === _errs8) {
                    if (
                      data3 &&
                      typeof data3 == 'object' &&
                      !Array.isArray(data3)
                    ) {
                      let missing1;
                      if (
                        (data3.type === undefined && (missing1 = 'type')) ||
                        (data3.id === undefined && (missing1 = 'id')) ||
                        (data3.name === undefined && (missing1 = 'name'))
                      ) {
                        validate84.errors = [
                          {
                            instancePath: instancePath + '/role',
                            schemaPath: '#/definitions/CCRole/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message:
                              "must have required property '" + missing1 + "'",
                          },
                        ];
                        return false;
                      } else {
                        const _errs10 = errors;
                        for (const key1 in data3) {
                          if (
                            !(
                              key1 === 'type' ||
                              key1 === 'id' ||
                              key1 === 'name'
                            )
                          ) {
                            validate84.errors = [
                              {
                                instancePath: instancePath + '/role',
                                schemaPath:
                                  '#/definitions/CCRole/additionalProperties',
                                keyword: 'additionalProperties',
                                params: { additionalProperty: key1 },
                                message: 'must NOT have additional properties',
                              },
                            ];
                            return false;
                            break;
                          }
                        }
                        if (_errs10 === errors) {
                          if (data3.type !== undefined) {
                            const _errs11 = errors;
                            if (!func0(data3.type, 'ccRole')) {
                              validate84.errors = [
                                {
                                  instancePath: instancePath + '/role/type',
                                  schemaPath:
                                    '#/definitions/CCRole/properties/type/const',
                                  keyword: 'const',
                                  params: { allowedValue: 'ccRole' },
                                  message: 'must be equal to constant',
                                },
                              ];
                              return false;
                            }
                            var valid2 = _errs11 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data3.id !== undefined) {
                              const _errs12 = errors;
                              if (typeof data3.id !== 'string') {
                                validate84.errors = [
                                  {
                                    instancePath: instancePath + '/role/id',
                                    schemaPath:
                                      '#/definitions/CCRole/properties/id/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid2 = _errs12 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data3.name !== undefined) {
                                const _errs14 = errors;
                                if (typeof data3.name !== 'string') {
                                  validate84.errors = [
                                    {
                                      instancePath: instancePath + '/role/name',
                                      schemaPath:
                                        '#/definitions/CCRole/properties/name/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid2 = _errs14 === errors;
                              } else {
                                var valid2 = true;
                              }
                            }
                          }
                        }
                      }
                    } else {
                      validate84.errors = [
                        {
                          instancePath: instancePath + '/role',
                          schemaPath: '#/definitions/CCRole/type',
                          keyword: 'type',
                          params: { type: 'object' },
                          message: 'must be object',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs7 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate84.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate84.errors = vErrors;
  return errors === 0;
}
function validate83(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  const _errs0 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs1 = errors;
  const _errs2 = errors;
  if (errors === _errs2) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.type === undefined && (missing0 = 'type')) ||
        (data.id === undefined && (missing0 = 'id')) ||
        (data.name === undefined && (missing0 = 'name'))
      ) {
        const err0 = {
          instancePath,
          schemaPath: 'Recipient.json#/definitions/CCRole/required',
          keyword: 'required',
          params: { missingProperty: missing0 },
          message: "must have required property '" + missing0 + "'",
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        const _errs4 = errors;
        for (const key0 in data) {
          if (!(key0 === 'type' || key0 === 'id' || key0 === 'name')) {
            const err1 = {
              instancePath,
              schemaPath:
                'Recipient.json#/definitions/CCRole/additionalProperties',
              keyword: 'additionalProperties',
              params: { additionalProperty: key0 },
              message: 'must NOT have additional properties',
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
            break;
          }
        }
        if (_errs4 === errors) {
          if (data.type !== undefined) {
            const _errs5 = errors;
            if (!func0(data.type, 'ccRole')) {
              const err2 = {
                instancePath: instancePath + '/type',
                schemaPath:
                  'Recipient.json#/definitions/CCRole/properties/type/const',
                keyword: 'const',
                params: { allowedValue: 'ccRole' },
                message: 'must be equal to constant',
              };
              if (vErrors === null) {
                vErrors = [err2];
              } else {
                vErrors.push(err2);
              }
              errors++;
            }
            var valid2 = _errs5 === errors;
          } else {
            var valid2 = true;
          }
          if (valid2) {
            if (data.id !== undefined) {
              const _errs6 = errors;
              if (typeof data.id !== 'string') {
                const err3 = {
                  instancePath: instancePath + '/id',
                  schemaPath:
                    'Recipient.json#/definitions/CCRole/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                };
                if (vErrors === null) {
                  vErrors = [err3];
                } else {
                  vErrors.push(err3);
                }
                errors++;
              }
              var valid2 = _errs6 === errors;
            } else {
              var valid2 = true;
            }
            if (valid2) {
              if (data.name !== undefined) {
                const _errs8 = errors;
                if (typeof data.name !== 'string') {
                  const err4 = {
                    instancePath: instancePath + '/name',
                    schemaPath:
                      'Recipient.json#/definitions/CCRole/properties/name/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  };
                  if (vErrors === null) {
                    vErrors = [err4];
                  } else {
                    vErrors.push(err4);
                  }
                  errors++;
                }
                var valid2 = _errs8 === errors;
              } else {
                var valid2 = true;
              }
            }
          }
        }
      }
    } else {
      const err5 = {
        instancePath,
        schemaPath: 'Recipient.json#/definitions/CCRole/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
  }
  var _valid0 = _errs1 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs10 = errors;
  if (
    !validate84(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
    })
  ) {
    vErrors =
      vErrors === null ? validate84.errors : vErrors.concat(validate84.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs10 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
  }
  if (!valid0) {
    const err6 = {
      instancePath,
      schemaPath: '#/oneOf',
      keyword: 'oneOf',
      params: { passingSchemas: passing0 },
      message: 'must match exactly one schema in oneOf',
    };
    if (vErrors === null) {
      vErrors = [err6];
    } else {
      vErrors.push(err6);
    }
    errors++;
    validate83.errors = vErrors;
    return false;
  } else {
    errors = _errs0;
    if (vErrors !== null) {
      if (_errs0) {
        vErrors.length = _errs0;
      } else {
        vErrors = null;
      }
    }
  }
  validate83.errors = vErrors;
  return errors === 0;
}
function validate52(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="EditorData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.pages === undefined && (missing0 = 'pages')) ||
        (data.fields === undefined && (missing0 = 'fields')) ||
        (data.mergeFields === undefined && (missing0 = 'mergeFields')) ||
        (data.pdfFields === undefined && (missing0 = 'pdfFields')) ||
        (data.editorOptions === undefined && (missing0 = 'editorOptions')) ||
        (data.rules === undefined && (missing0 = 'rules')) ||
        (data.signers === undefined && (missing0 = 'signers')) ||
        (data.documents === undefined && (missing0 = 'documents')) ||
        (data.signerOptions === undefined && (missing0 = 'signerOptions'))
      ) {
        validate52.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func4.call(schema68.properties, key0)) {
            validate52.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.pages !== undefined) {
            let data0 = data.pages;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (Array.isArray(data0)) {
                var valid1 = true;
                const len0 = data0.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  let data1 = data0[i0];
                  const _errs4 = errors;
                  const _errs5 = errors;
                  if (errors === _errs5) {
                    if (
                      data1 &&
                      typeof data1 == 'object' &&
                      !Array.isArray(data1)
                    ) {
                      let missing1;
                      if (
                        (data1.src === undefined && (missing1 = 'src')) ||
                        (data1.width === undefined && (missing1 = 'width')) ||
                        (data1.height === undefined && (missing1 = 'height')) ||
                        (data1.orientation === undefined &&
                          (missing1 = 'orientation'))
                      ) {
                        validate52.errors = [
                          {
                            instancePath: instancePath + '/pages/' + i0,
                            schemaPath: 'Page.json/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message:
                              "must have required property '" + missing1 + "'",
                          },
                        ];
                        return false;
                      } else {
                        const _errs7 = errors;
                        for (const key1 in data1) {
                          if (
                            !(
                              key1 === 'src' ||
                              key1 === 'width' ||
                              key1 === 'height' ||
                              key1 === 'documentId' ||
                              key1 === 'orientation' ||
                              key1 === 'snapshotGuid' ||
                              key1 === 'cdnSrc'
                            )
                          ) {
                            validate52.errors = [
                              {
                                instancePath: instancePath + '/pages/' + i0,
                                schemaPath: 'Page.json/additionalProperties',
                                keyword: 'additionalProperties',
                                params: { additionalProperty: key1 },
                                message: 'must NOT have additional properties',
                              },
                            ];
                            return false;
                            break;
                          }
                        }
                        if (_errs7 === errors) {
                          if (data1.src !== undefined) {
                            const _errs8 = errors;
                            if (typeof data1.src !== 'string') {
                              validate52.errors = [
                                {
                                  instancePath:
                                    instancePath + '/pages/' + i0 + '/src',
                                  schemaPath: 'Page.json/properties/src/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid3 = _errs8 === errors;
                          } else {
                            var valid3 = true;
                          }
                          if (valid3) {
                            if (data1.width !== undefined) {
                              let data3 = data1.width;
                              const _errs10 = errors;
                              if (
                                !(typeof data3 == 'number' && isFinite(data3))
                              ) {
                                validate52.errors = [
                                  {
                                    instancePath:
                                      instancePath + '/pages/' + i0 + '/width',
                                    schemaPath:
                                      'Page.json/properties/width/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number',
                                  },
                                ];
                                return false;
                              }
                              var valid3 = _errs10 === errors;
                            } else {
                              var valid3 = true;
                            }
                            if (valid3) {
                              if (data1.height !== undefined) {
                                let data4 = data1.height;
                                const _errs12 = errors;
                                if (
                                  !(typeof data4 == 'number' && isFinite(data4))
                                ) {
                                  validate52.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/pages/' +
                                        i0 +
                                        '/height',
                                      schemaPath:
                                        'Page.json/properties/height/type',
                                      keyword: 'type',
                                      params: { type: 'number' },
                                      message: 'must be number',
                                    },
                                  ];
                                  return false;
                                }
                                var valid3 = _errs12 === errors;
                              } else {
                                var valid3 = true;
                              }
                              if (valid3) {
                                if (data1.documentId !== undefined) {
                                  const _errs14 = errors;
                                  if (typeof data1.documentId !== 'string') {
                                    validate52.errors = [
                                      {
                                        instancePath:
                                          instancePath +
                                          '/pages/' +
                                          i0 +
                                          '/documentId',
                                        schemaPath:
                                          'Page.json/properties/documentId/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid3 = _errs14 === errors;
                                } else {
                                  var valid3 = true;
                                }
                                if (valid3) {
                                  if (data1.orientation !== undefined) {
                                    let data6 = data1.orientation;
                                    const _errs16 = errors;
                                    if (
                                      !(
                                        typeof data6 == 'number' &&
                                        !(data6 % 1) &&
                                        !isNaN(data6) &&
                                        isFinite(data6)
                                      )
                                    ) {
                                      validate52.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/pages/' +
                                            i0 +
                                            '/orientation',
                                          schemaPath:
                                            'Page.json/properties/orientation/type',
                                          keyword: 'type',
                                          params: { type: 'integer' },
                                          message: 'must be integer',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid3 = _errs16 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                  if (valid3) {
                                    if (data1.snapshotGuid !== undefined) {
                                      const _errs18 = errors;
                                      if (
                                        typeof data1.snapshotGuid !== 'string'
                                      ) {
                                        validate52.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/pages/' +
                                              i0 +
                                              '/snapshotGuid',
                                            schemaPath:
                                              'Page.json/properties/snapshotGuid/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid3 = _errs18 === errors;
                                    } else {
                                      var valid3 = true;
                                    }
                                    if (valid3) {
                                      if (data1.cdnSrc !== undefined) {
                                        let data8 = data1.cdnSrc;
                                        const _errs20 = errors;
                                        if (
                                          typeof data8 !== 'string' &&
                                          data8 !== null
                                        ) {
                                          validate52.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/pages/' +
                                                i0 +
                                                '/cdnSrc',
                                              schemaPath:
                                                'Page.json/properties/cdnSrc/type',
                                              keyword: 'type',
                                              params: {
                                                type: schema69.properties.cdnSrc
                                                  .type,
                                              },
                                              message: 'must be string,null',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid3 = _errs20 === errors;
                                      } else {
                                        var valid3 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    } else {
                      validate52.errors = [
                        {
                          instancePath: instancePath + '/pages/' + i0,
                          schemaPath: 'Page.json/type',
                          keyword: 'type',
                          params: { type: 'object' },
                          message: 'must be object',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid1 = _errs4 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate52.errors = [
                  {
                    instancePath: instancePath + '/pages',
                    schemaPath: '#/properties/pages/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                  },
                ];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.fields !== undefined) {
              let data9 = data.fields;
              const _errs22 = errors;
              if (errors === _errs22) {
                if (Array.isArray(data9)) {
                  var valid4 = true;
                  const len1 = data9.length;
                  for (let i1 = 0; i1 < len1; i1++) {
                    const _errs24 = errors;
                    if (
                      !validate13(data9[i1], {
                        instancePath: instancePath + '/fields/' + i1,
                        parentData: data9,
                        parentDataProperty: i1,
                        rootData,
                      })
                    ) {
                      vErrors =
                        vErrors === null
                          ? validate13.errors
                          : vErrors.concat(validate13.errors);
                      errors = vErrors.length;
                    }
                    var valid4 = _errs24 === errors;
                    if (!valid4) {
                      break;
                    }
                  }
                } else {
                  validate52.errors = [
                    {
                      instancePath: instancePath + '/fields',
                      schemaPath: '#/properties/fields/type',
                      keyword: 'type',
                      params: { type: 'array' },
                      message: 'must be array',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs22 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.mergeFields !== undefined) {
                let data11 = data.mergeFields;
                const _errs25 = errors;
                if (errors === _errs25) {
                  if (Array.isArray(data11)) {
                    var valid5 = true;
                    const len2 = data11.length;
                    for (let i2 = 0; i2 < len2; i2++) {
                      let data12 = data11[i2];
                      const _errs27 = errors;
                      const _errs28 = errors;
                      let valid6 = false;
                      let passing0 = null;
                      const _errs29 = errors;
                      if (
                        !validate54(data12, {
                          instancePath: instancePath + '/mergeFields/' + i2,
                          parentData: data11,
                          parentDataProperty: i2,
                          rootData,
                        })
                      ) {
                        vErrors =
                          vErrors === null
                            ? validate54.errors
                            : vErrors.concat(validate54.errors);
                        errors = vErrors.length;
                      }
                      var _valid0 = _errs29 === errors;
                      if (_valid0) {
                        valid6 = true;
                        passing0 = 0;
                      }
                      const _errs30 = errors;
                      if (
                        !validate13(data12, {
                          instancePath: instancePath + '/mergeFields/' + i2,
                          parentData: data11,
                          parentDataProperty: i2,
                          rootData,
                        })
                      ) {
                        vErrors =
                          vErrors === null
                            ? validate13.errors
                            : vErrors.concat(validate13.errors);
                        errors = vErrors.length;
                      }
                      var _valid0 = _errs30 === errors;
                      if (_valid0 && valid6) {
                        valid6 = false;
                        passing0 = [passing0, 1];
                      } else {
                        if (_valid0) {
                          valid6 = true;
                          passing0 = 1;
                        }
                      }
                      if (!valid6) {
                        const err0 = {
                          instancePath: instancePath + '/mergeFields/' + i2,
                          schemaPath: '#/properties/mergeFields/items/oneOf',
                          keyword: 'oneOf',
                          params: { passingSchemas: passing0 },
                          message: 'must match exactly one schema in oneOf',
                        };
                        if (vErrors === null) {
                          vErrors = [err0];
                        } else {
                          vErrors.push(err0);
                        }
                        errors++;
                        validate52.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs28;
                        if (vErrors !== null) {
                          if (_errs28) {
                            vErrors.length = _errs28;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid5 = _errs27 === errors;
                      if (!valid5) {
                        break;
                      }
                    }
                  } else {
                    validate52.errors = [
                      {
                        instancePath: instancePath + '/mergeFields',
                        schemaPath: '#/properties/mergeFields/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs25 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.pdfFields !== undefined) {
                  let data13 = data.pdfFields;
                  const _errs31 = errors;
                  if (errors === _errs31) {
                    if (Array.isArray(data13)) {
                      var valid7 = true;
                      const len3 = data13.length;
                      for (let i3 = 0; i3 < len3; i3++) {
                        const _errs33 = errors;
                        if (
                          !validate13(data13[i3], {
                            instancePath: instancePath + '/pdfFields/' + i3,
                            parentData: data13,
                            parentDataProperty: i3,
                            rootData,
                          })
                        ) {
                          vErrors =
                            vErrors === null
                              ? validate13.errors
                              : vErrors.concat(validate13.errors);
                          errors = vErrors.length;
                        }
                        var valid7 = _errs33 === errors;
                        if (!valid7) {
                          break;
                        }
                      }
                    } else {
                      validate52.errors = [
                        {
                          instancePath: instancePath + '/pdfFields',
                          schemaPath: '#/properties/pdfFields/type',
                          keyword: 'type',
                          params: { type: 'array' },
                          message: 'must be array',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs31 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.editorFeatures !== undefined) {
                    let data15 = data.editorFeatures;
                    const _errs34 = errors;
                    if (errors === _errs34) {
                      if (Array.isArray(data15)) {
                        var valid8 = true;
                        const len4 = data15.length;
                        for (let i4 = 0; i4 < len4; i4++) {
                          const _errs36 = errors;
                          if (typeof data15[i4] !== 'string') {
                            validate52.errors = [
                              {
                                instancePath:
                                  instancePath + '/editorFeatures/' + i4,
                                schemaPath:
                                  '#/properties/editorFeatures/items/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid8 = _errs36 === errors;
                          if (!valid8) {
                            break;
                          }
                        }
                      } else {
                        validate52.errors = [
                          {
                            instancePath: instancePath + '/editorFeatures',
                            schemaPath: '#/properties/editorFeatures/type',
                            keyword: 'type',
                            params: { type: 'array' },
                            message: 'must be array',
                          },
                        ];
                        return false;
                      }
                    }
                    var valid0 = _errs34 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.rules !== undefined) {
                      let data17 = data.rules;
                      const _errs38 = errors;
                      if (errors === _errs38) {
                        if (Array.isArray(data17)) {
                          var valid9 = true;
                          const len5 = data17.length;
                          for (let i5 = 0; i5 < len5; i5++) {
                            const _errs40 = errors;
                            if (
                              !validate58(data17[i5], {
                                instancePath: instancePath + '/rules/' + i5,
                                parentData: data17,
                                parentDataProperty: i5,
                                rootData,
                              })
                            ) {
                              vErrors =
                                vErrors === null
                                  ? validate58.errors
                                  : vErrors.concat(validate58.errors);
                              errors = vErrors.length;
                            }
                            var valid9 = _errs40 === errors;
                            if (!valid9) {
                              break;
                            }
                          }
                        } else {
                          validate52.errors = [
                            {
                              instancePath: instancePath + '/rules',
                              schemaPath: '#/properties/rules/type',
                              keyword: 'type',
                              params: { type: 'array' },
                              message: 'must be array',
                            },
                          ];
                          return false;
                        }
                      }
                      var valid0 = _errs38 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.transform !== undefined) {
                        let data19 = data.transform;
                        const _errs41 = errors;
                        if (errors === _errs41) {
                          if (
                            data19 &&
                            typeof data19 == 'object' &&
                            !Array.isArray(data19)
                          ) {
                            let missing2;
                            if (
                              data19.rotate === undefined &&
                              (missing2 = 'rotate')
                            ) {
                              validate52.errors = [
                                {
                                  instancePath: instancePath + '/transform',
                                  schemaPath: '#/properties/transform/required',
                                  keyword: 'required',
                                  params: { missingProperty: missing2 },
                                  message:
                                    "must have required property '" +
                                    missing2 +
                                    "'",
                                },
                              ];
                              return false;
                            } else {
                              const _errs43 = errors;
                              for (const key2 in data19) {
                                if (!(key2 === 'rotate')) {
                                  validate52.errors = [
                                    {
                                      instancePath: instancePath + '/transform',
                                      schemaPath:
                                        '#/properties/transform/additionalProperties',
                                      keyword: 'additionalProperties',
                                      params: { additionalProperty: key2 },
                                      message:
                                        'must NOT have additional properties',
                                    },
                                  ];
                                  return false;
                                  break;
                                }
                              }
                              if (_errs43 === errors) {
                                if (data19.rotate !== undefined) {
                                  let data20 = data19.rotate;
                                  if (
                                    !(
                                      typeof data20 == 'number' &&
                                      !(data20 % 1) &&
                                      !isNaN(data20) &&
                                      isFinite(data20)
                                    )
                                  ) {
                                    validate52.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/transform/rotate',
                                        schemaPath:
                                          '#/properties/transform/properties/rotate/type',
                                        keyword: 'type',
                                        params: { type: 'integer' },
                                        message: 'must be integer',
                                      },
                                    ];
                                    return false;
                                  }
                                }
                              }
                            }
                          } else {
                            validate52.errors = [
                              {
                                instancePath: instancePath + '/transform',
                                schemaPath: '#/properties/transform/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object',
                              },
                            ];
                            return false;
                          }
                        }
                        var valid0 = _errs41 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.documents !== undefined) {
                          let data21 = data.documents;
                          const _errs46 = errors;
                          if (errors === _errs46) {
                            if (Array.isArray(data21)) {
                              var valid11 = true;
                              const len6 = data21.length;
                              for (let i6 = 0; i6 < len6; i6++) {
                                let data22 = data21[i6];
                                const _errs48 = errors;
                                const _errs49 = errors;
                                if (errors === _errs49) {
                                  if (
                                    data22 &&
                                    typeof data22 == 'object' &&
                                    !Array.isArray(data22)
                                  ) {
                                    let missing3;
                                    if (
                                      (data22.id === undefined &&
                                        (missing3 = 'id')) ||
                                      (data22.name === undefined &&
                                        (missing3 = 'name')) ||
                                      (data22.editable === undefined &&
                                        (missing3 = 'editable')) ||
                                      (data22.snapshotGuid === undefined &&
                                        (missing3 = 'snapshotGuid'))
                                    ) {
                                      validate52.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/documents/' + i6,
                                          schemaPath:
                                            '#/definitions/Document/required',
                                          keyword: 'required',
                                          params: { missingProperty: missing3 },
                                          message:
                                            "must have required property '" +
                                            missing3 +
                                            "'",
                                        },
                                      ];
                                      return false;
                                    } else {
                                      const _errs51 = errors;
                                      for (const key3 in data22) {
                                        if (
                                          !(
                                            key3 === 'id' ||
                                            key3 === 'name' ||
                                            key3 === 'editable' ||
                                            key3 === 'snapshotGuid'
                                          )
                                        ) {
                                          validate52.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/documents/' +
                                                i6,
                                              schemaPath:
                                                '#/definitions/Document/additionalProperties',
                                              keyword: 'additionalProperties',
                                              params: {
                                                additionalProperty: key3,
                                              },
                                              message:
                                                'must NOT have additional properties',
                                            },
                                          ];
                                          return false;
                                          break;
                                        }
                                      }
                                      if (_errs51 === errors) {
                                        if (data22.id !== undefined) {
                                          const _errs52 = errors;
                                          if (typeof data22.id !== 'string') {
                                            validate52.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/documents/' +
                                                  i6 +
                                                  '/id',
                                                schemaPath:
                                                  '#/definitions/Document/properties/id/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid13 = _errs52 === errors;
                                        } else {
                                          var valid13 = true;
                                        }
                                        if (valid13) {
                                          if (data22.name !== undefined) {
                                            const _errs54 = errors;
                                            if (
                                              typeof data22.name !== 'string'
                                            ) {
                                              validate52.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/documents/' +
                                                    i6 +
                                                    '/name',
                                                  schemaPath:
                                                    '#/definitions/Document/properties/name/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid13 = _errs54 === errors;
                                          } else {
                                            var valid13 = true;
                                          }
                                          if (valid13) {
                                            if (data22.editable !== undefined) {
                                              const _errs56 = errors;
                                              if (
                                                typeof data22.editable !==
                                                'boolean'
                                              ) {
                                                validate52.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/documents/' +
                                                      i6 +
                                                      '/editable',
                                                    schemaPath:
                                                      '#/definitions/Document/properties/editable/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid13 = _errs56 === errors;
                                            } else {
                                              var valid13 = true;
                                            }
                                            if (valid13) {
                                              if (
                                                data22.snapshotGuid !==
                                                undefined
                                              ) {
                                                const _errs58 = errors;
                                                if (
                                                  typeof data22.snapshotGuid !==
                                                  'string'
                                                ) {
                                                  validate52.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/documents/' +
                                                        i6 +
                                                        '/snapshotGuid',
                                                      schemaPath:
                                                        '#/definitions/Document/properties/snapshotGuid/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'string',
                                                      },
                                                      message: 'must be string',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid13 =
                                                  _errs58 === errors;
                                              } else {
                                                var valid13 = true;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  } else {
                                    validate52.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/documents/' + i6,
                                        schemaPath:
                                          '#/definitions/Document/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object',
                                      },
                                    ];
                                    return false;
                                  }
                                }
                                var valid11 = _errs48 === errors;
                                if (!valid11) {
                                  break;
                                }
                              }
                            } else {
                              validate52.errors = [
                                {
                                  instancePath: instancePath + '/documents',
                                  schemaPath: '#/properties/documents/type',
                                  keyword: 'type',
                                  params: { type: 'array' },
                                  message: 'must be array',
                                },
                              ];
                              return false;
                            }
                          }
                          var valid0 = _errs46 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.signers !== undefined) {
                            let data27 = data.signers;
                            const _errs60 = errors;
                            if (errors === _errs60) {
                              if (Array.isArray(data27)) {
                                var valid14 = true;
                                const len7 = data27.length;
                                for (let i7 = 0; i7 < len7; i7++) {
                                  const _errs62 = errors;
                                  if (
                                    !validate70(data27[i7], {
                                      instancePath:
                                        instancePath + '/signers/' + i7,
                                      parentData: data27,
                                      parentDataProperty: i7,
                                      rootData,
                                    })
                                  ) {
                                    vErrors =
                                      vErrors === null
                                        ? validate70.errors
                                        : vErrors.concat(validate70.errors);
                                    errors = vErrors.length;
                                  }
                                  var valid14 = _errs62 === errors;
                                  if (!valid14) {
                                    break;
                                  }
                                }
                              } else {
                                validate52.errors = [
                                  {
                                    instancePath: instancePath + '/signers',
                                    schemaPath: '#/properties/signers/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array',
                                  },
                                ];
                                return false;
                              }
                            }
                            var valid0 = _errs60 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.signerOptions !== undefined) {
                              const _errs63 = errors;
                              if (
                                !validate77(data.signerOptions, {
                                  instancePath: instancePath + '/signerOptions',
                                  parentData: data,
                                  parentDataProperty: 'signerOptions',
                                  rootData,
                                })
                              ) {
                                vErrors =
                                  vErrors === null
                                    ? validate77.errors
                                    : vErrors.concat(validate77.errors);
                                errors = vErrors.length;
                              }
                              var valid0 = _errs63 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.editorOptions !== undefined) {
                                let data30 = data.editorOptions;
                                const _errs64 = errors;
                                const _errs65 = errors;
                                if (errors === _errs65) {
                                  if (
                                    data30 &&
                                    typeof data30 == 'object' &&
                                    !Array.isArray(data30)
                                  ) {
                                    let missing4;
                                    if (
                                      (data30.allowEditSigners === undefined &&
                                        (missing4 = 'allowEditSigners')) ||
                                      (data30.allowEditDocuments ===
                                        undefined &&
                                        (missing4 = 'allowEditDocuments')) ||
                                      (data30.canUseCustomRegexDataValidation ===
                                        undefined &&
                                        (missing4 =
                                          'canUseCustomRegexDataValidation')) ||
                                      (data30.canUseDataValidation ===
                                        undefined &&
                                        (missing4 = 'canUseDataValidation'))
                                    ) {
                                      validate52.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/editorOptions',
                                          schemaPath:
                                            '#/definitions/EditorOptions/required',
                                          keyword: 'required',
                                          params: { missingProperty: missing4 },
                                          message:
                                            "must have required property '" +
                                            missing4 +
                                            "'",
                                        },
                                      ];
                                      return false;
                                    } else {
                                      if (
                                        data30.allowEditSigners !== undefined
                                      ) {
                                        const _errs67 = errors;
                                        if (
                                          typeof data30.allowEditSigners !==
                                          'boolean'
                                        ) {
                                          validate52.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/editorOptions/allowEditSigners',
                                              schemaPath:
                                                '#/definitions/EditorOptions/properties/allowEditSigners/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid16 = _errs67 === errors;
                                      } else {
                                        var valid16 = true;
                                      }
                                      if (valid16) {
                                        if (
                                          data30.allowEditDocuments !==
                                          undefined
                                        ) {
                                          const _errs69 = errors;
                                          if (
                                            typeof data30.allowEditDocuments !==
                                            'boolean'
                                          ) {
                                            validate52.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/editorOptions/allowEditDocuments',
                                                schemaPath:
                                                  '#/definitions/EditorOptions/properties/allowEditDocuments/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid16 = _errs69 === errors;
                                        } else {
                                          var valid16 = true;
                                        }
                                        if (valid16) {
                                          if (
                                            data30.canUseCustomRegexDataValidation !==
                                            undefined
                                          ) {
                                            const _errs71 = errors;
                                            if (
                                              typeof data30.canUseCustomRegexDataValidation !==
                                              'boolean'
                                            ) {
                                              validate52.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/editorOptions/canUseCustomRegexDataValidation',
                                                  schemaPath:
                                                    '#/definitions/EditorOptions/properties/canUseCustomRegexDataValidation/type',
                                                  keyword: 'type',
                                                  params: { type: 'boolean' },
                                                  message: 'must be boolean',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid16 = _errs71 === errors;
                                          } else {
                                            var valid16 = true;
                                          }
                                          if (valid16) {
                                            if (
                                              data30.canUseDataValidation !==
                                              undefined
                                            ) {
                                              const _errs73 = errors;
                                              if (
                                                typeof data30.canUseDataValidation !==
                                                'boolean'
                                              ) {
                                                validate52.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/editorOptions/canUseDataValidation',
                                                    schemaPath:
                                                      '#/definitions/EditorOptions/properties/canUseDataValidation/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid16 = _errs73 === errors;
                                            } else {
                                              var valid16 = true;
                                            }
                                          }
                                        }
                                      }
                                    }
                                  } else {
                                    validate52.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/editorOptions',
                                        schemaPath:
                                          '#/definitions/EditorOptions/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object',
                                      },
                                    ];
                                    return false;
                                  }
                                }
                                var valid0 = _errs64 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.ccs !== undefined) {
                                  let data35 = data.ccs;
                                  const _errs75 = errors;
                                  if (errors === _errs75) {
                                    if (Array.isArray(data35)) {
                                      var valid17 = true;
                                      const len8 = data35.length;
                                      for (let i8 = 0; i8 < len8; i8++) {
                                        const _errs77 = errors;
                                        if (
                                          !validate83(data35[i8], {
                                            instancePath:
                                              instancePath + '/ccs/' + i8,
                                            parentData: data35,
                                            parentDataProperty: i8,
                                            rootData,
                                          })
                                        ) {
                                          vErrors =
                                            vErrors === null
                                              ? validate83.errors
                                              : vErrors.concat(
                                                  validate83.errors,
                                                );
                                          errors = vErrors.length;
                                        }
                                        var valid17 = _errs77 === errors;
                                        if (!valid17) {
                                          break;
                                        }
                                      }
                                    } else {
                                      validate52.errors = [
                                        {
                                          instancePath: instancePath + '/ccs',
                                          schemaPath: '#/properties/ccs/type',
                                          keyword: 'type',
                                          params: { type: 'array' },
                                          message: 'must be array',
                                        },
                                      ];
                                      return false;
                                    }
                                  }
                                  var valid0 = _errs75 === errors;
                                } else {
                                  var valid0 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate52.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate52.errors = vErrors;
  return errors === 0;
}
function validate89(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.type === undefined && (missing0 = 'type')) ||
        (data.id === undefined && (missing0 = 'id')) ||
        (data.email === undefined && (missing0 = 'email'))
      ) {
        validate89.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (
            !(
              key0 === 'type' ||
              key0 === 'id' ||
              key0 === 'email' ||
              key0 === 'role'
            )
          ) {
            validate89.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.type !== undefined) {
            const _errs2 = errors;
            if (!func0(data.type, 'ccEmail')) {
              validate89.errors = [
                {
                  instancePath: instancePath + '/type',
                  schemaPath: '#/properties/type/const',
                  keyword: 'const',
                  params: { allowedValue: 'ccEmail' },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.id !== undefined) {
              const _errs3 = errors;
              if (typeof data.id !== 'string') {
                validate89.errors = [
                  {
                    instancePath: instancePath + '/id',
                    schemaPath: '#/properties/id/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.email !== undefined) {
                const _errs5 = errors;
                if (typeof data.email !== 'string') {
                  validate89.errors = [
                    {
                      instancePath: instancePath + '/email',
                      schemaPath: '#/properties/email/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.role !== undefined) {
                  let data3 = data.role;
                  const _errs7 = errors;
                  const _errs8 = errors;
                  if (errors === _errs8) {
                    if (
                      data3 &&
                      typeof data3 == 'object' &&
                      !Array.isArray(data3)
                    ) {
                      let missing1;
                      if (
                        (data3.type === undefined && (missing1 = 'type')) ||
                        (data3.id === undefined && (missing1 = 'id')) ||
                        (data3.name === undefined && (missing1 = 'name'))
                      ) {
                        validate89.errors = [
                          {
                            instancePath: instancePath + '/role',
                            schemaPath: '#/definitions/CCRole/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message:
                              "must have required property '" + missing1 + "'",
                          },
                        ];
                        return false;
                      } else {
                        const _errs10 = errors;
                        for (const key1 in data3) {
                          if (
                            !(
                              key1 === 'type' ||
                              key1 === 'id' ||
                              key1 === 'name'
                            )
                          ) {
                            validate89.errors = [
                              {
                                instancePath: instancePath + '/role',
                                schemaPath:
                                  '#/definitions/CCRole/additionalProperties',
                                keyword: 'additionalProperties',
                                params: { additionalProperty: key1 },
                                message: 'must NOT have additional properties',
                              },
                            ];
                            return false;
                            break;
                          }
                        }
                        if (_errs10 === errors) {
                          if (data3.type !== undefined) {
                            const _errs11 = errors;
                            if (!func0(data3.type, 'ccRole')) {
                              validate89.errors = [
                                {
                                  instancePath: instancePath + '/role/type',
                                  schemaPath:
                                    '#/definitions/CCRole/properties/type/const',
                                  keyword: 'const',
                                  params: { allowedValue: 'ccRole' },
                                  message: 'must be equal to constant',
                                },
                              ];
                              return false;
                            }
                            var valid2 = _errs11 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data3.id !== undefined) {
                              const _errs12 = errors;
                              if (typeof data3.id !== 'string') {
                                validate89.errors = [
                                  {
                                    instancePath: instancePath + '/role/id',
                                    schemaPath:
                                      '#/definitions/CCRole/properties/id/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid2 = _errs12 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data3.name !== undefined) {
                                const _errs14 = errors;
                                if (typeof data3.name !== 'string') {
                                  validate89.errors = [
                                    {
                                      instancePath: instancePath + '/role/name',
                                      schemaPath:
                                        '#/definitions/CCRole/properties/name/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid2 = _errs14 === errors;
                              } else {
                                var valid2 = true;
                              }
                            }
                          }
                        }
                      }
                    } else {
                      validate89.errors = [
                        {
                          instancePath: instancePath + '/role',
                          schemaPath: '#/definitions/CCRole/type',
                          keyword: 'type',
                          params: { type: 'object' },
                          message: 'must be object',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs7 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate89.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate89.errors = vErrors;
  return errors === 0;
}
const schema107 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'Template.json',
  title: 'Template',
  type: 'object',
  additionalProperties: false,
  properties: {
    guid: {
      type: 'string',
      $comment: 'This is the unique identifier for the template',
    },
    requestType: { type: 'number' },
    recipientReassignment: { type: 'boolean' },
    starred: { type: 'boolean' },
    recipientOrder: { type: 'boolean' },
    updated: { type: 'string' },
    dateFormat: { $ref: 'Field.json#/definitions/PHPDateFormat' },
    jsDateFormat: { $ref: 'Field.json#/definitions/JSDateFormat' },
    files: { type: 'array', items: { $ref: 'File.json' } },
    editorData: { $ref: 'EditorData.json' },
    recipients: {
      type: 'array',
      items: { $ref: 'Recipient.json#/definitions/Role' },
    },
    ccs: {
      type: 'array',
      items: {
        anyOf: [
          { $ref: 'Recipient.json#/definitions/CCRole' },
          { $ref: 'Recipient.json#/definitions/CCEmail' },
        ],
      },
    },
    title: { type: 'string' },
    message: { type: 'string' },
    locked: { type: 'boolean' },
    shortGuid: { type: 'string' },
    isOwner: { type: 'boolean' },
    isEditable: { type: 'boolean' },
    isDeletable: { type: 'boolean' },
    isEmbedded: { type: 'boolean' },
    isSalesforceCreated: { type: 'boolean' },
    isCreatedByIntegration: { type: 'boolean' },
    linkDetails: { $ref: '#/definitions/LinkDetails' },
    createdBy: { $ref: '#/definitions/CreatedBy' },
    whoHasAccess: { $ref: '#/definitions/WhoHasAccess' },
    disabled: { type: 'boolean' },
  },
  required: [
    'requestType',
    'recipientReassignment',
    'recipientOrder',
    'dateFormat',
    'guid',
    'recipients',
    'title',
    'createdBy',
    'isOwner',
    'message',
  ],
  definitions: {
    LinkDetails: {
      type: 'object',
      title: 'LinkDetails',
      additionalProperties: false,
      properties: {
        shareableLink: { type: 'string' },
        inPersonLink: { type: 'string' },
        receiveSignedCopies: { type: 'boolean' },
      },
      required: ['receiveSignedCopies'],
    },
    CreatedBy: {
      type: 'object',
      title: 'CreatedBy',
      additionalProperties: false,
      properties: {
        name: { type: 'string' },
        email: { type: 'string' },
        date: { type: 'string' },
      },
      required: ['name', 'email', 'date'],
    },
    WhoHasAccess: {
      type: 'object',
      title: 'WhoHasAccess',
      additionalProperties: false,
      properties: {
        admin_count: { type: 'number' },
        member_count: { type: 'number' },
        users: { type: 'array', items: { type: 'string' } },
      },
      required: ['admin_count', 'member_count'],
    },
  },
};
const schema108 = {
  type: 'string',
  title: 'PHPDateFormat',
  enum: [
    'Default',
    'm / d / Y',
    'm - d - Y',
    'd / m / Y',
    'd - m - Y',
    'Y / m / d',
    'Y - m - d',
  ],
};
const schema115 = {
  type: 'object',
  title: 'LinkDetails',
  additionalProperties: false,
  properties: {
    shareableLink: { type: 'string' },
    inPersonLink: { type: 'string' },
    receiveSignedCopies: { type: 'boolean' },
  },
  required: ['receiveSignedCopies'],
};
const schema116 = {
  type: 'object',
  title: 'CreatedBy',
  additionalProperties: false,
  properties: {
    name: { type: 'string' },
    email: { type: 'string' },
    date: { type: 'string' },
  },
  required: ['name', 'email', 'date'],
};
const schema117 = {
  type: 'object',
  title: 'WhoHasAccess',
  additionalProperties: false,
  properties: {
    admin_count: { type: 'number' },
    member_count: { type: 'number' },
    users: { type: 'array', items: { type: 'string' } },
  },
  required: ['admin_count', 'member_count'],
};
function validate94(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.type === undefined && (missing0 = 'type')) ||
        (data.id === undefined && (missing0 = 'id')) ||
        (data.name === undefined && (missing0 = 'name')) ||
        (data.attachments === undefined && (missing0 = 'attachments'))
      ) {
        validate94.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (
            !(
              key0 === 'type' ||
              key0 === 'id' ||
              key0 === 'name' ||
              key0 === 'attachments' ||
              key0 === 'order'
            )
          ) {
            validate94.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.type !== undefined) {
            const _errs2 = errors;
            if (!func0(data.type, 'role')) {
              validate94.errors = [
                {
                  instancePath: instancePath + '/type',
                  schemaPath: '#/properties/type/const',
                  keyword: 'const',
                  params: { allowedValue: 'role' },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.id !== undefined) {
              const _errs3 = errors;
              if (typeof data.id !== 'string') {
                validate94.errors = [
                  {
                    instancePath: instancePath + '/id',
                    schemaPath: '#/properties/id/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.name !== undefined) {
                const _errs5 = errors;
                if (typeof data.name !== 'string') {
                  validate94.errors = [
                    {
                      instancePath: instancePath + '/name',
                      schemaPath: '#/properties/name/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.attachments !== undefined) {
                  let data3 = data.attachments;
                  const _errs7 = errors;
                  if (errors === _errs7) {
                    if (Array.isArray(data3)) {
                      var valid1 = true;
                      const len0 = data3.length;
                      for (let i0 = 0; i0 < len0; i0++) {
                        let data4 = data3[i0];
                        const _errs9 = errors;
                        const _errs10 = errors;
                        if (errors === _errs10) {
                          if (
                            data4 &&
                            typeof data4 == 'object' &&
                            !Array.isArray(data4)
                          ) {
                            let missing1;
                            if (
                              (data4.id === undefined && (missing1 = 'id')) ||
                              (data4.name === undefined &&
                                (missing1 = 'name')) ||
                              (data4.instructions === undefined &&
                                (missing1 = 'instructions')) ||
                              (data4.required === undefined &&
                                (missing1 = 'required'))
                            ) {
                              validate94.errors = [
                                {
                                  instancePath:
                                    instancePath + '/attachments/' + i0,
                                  schemaPath:
                                    '#/definitions/Attachment/required',
                                  keyword: 'required',
                                  params: { missingProperty: missing1 },
                                  message:
                                    "must have required property '" +
                                    missing1 +
                                    "'",
                                },
                              ];
                              return false;
                            } else {
                              const _errs12 = errors;
                              for (const key1 in data4) {
                                if (
                                  !(
                                    key1 === 'id' ||
                                    key1 === 'name' ||
                                    key1 === 'instructions' ||
                                    key1 === 'required'
                                  )
                                ) {
                                  validate94.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/attachments/' + i0,
                                      schemaPath:
                                        '#/definitions/Attachment/additionalProperties',
                                      keyword: 'additionalProperties',
                                      params: { additionalProperty: key1 },
                                      message:
                                        'must NOT have additional properties',
                                    },
                                  ];
                                  return false;
                                  break;
                                }
                              }
                              if (_errs12 === errors) {
                                if (data4.id !== undefined) {
                                  const _errs13 = errors;
                                  if (typeof data4.id !== 'string') {
                                    validate94.errors = [
                                      {
                                        instancePath:
                                          instancePath +
                                          '/attachments/' +
                                          i0 +
                                          '/id',
                                        schemaPath:
                                          '#/definitions/Attachment/properties/id/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid3 = _errs13 === errors;
                                } else {
                                  var valid3 = true;
                                }
                                if (valid3) {
                                  if (data4.name !== undefined) {
                                    const _errs15 = errors;
                                    if (typeof data4.name !== 'string') {
                                      validate94.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/attachments/' +
                                            i0 +
                                            '/name',
                                          schemaPath:
                                            '#/definitions/Attachment/properties/name/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid3 = _errs15 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                  if (valid3) {
                                    if (data4.instructions !== undefined) {
                                      const _errs17 = errors;
                                      if (
                                        typeof data4.instructions !== 'string'
                                      ) {
                                        validate94.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/attachments/' +
                                              i0 +
                                              '/instructions',
                                            schemaPath:
                                              '#/definitions/Attachment/properties/instructions/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid3 = _errs17 === errors;
                                    } else {
                                      var valid3 = true;
                                    }
                                    if (valid3) {
                                      if (data4.required !== undefined) {
                                        const _errs19 = errors;
                                        if (
                                          typeof data4.required !== 'boolean'
                                        ) {
                                          validate94.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/attachments/' +
                                                i0 +
                                                '/required',
                                              schemaPath:
                                                '#/definitions/Attachment/properties/required/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid3 = _errs19 === errors;
                                      } else {
                                        var valid3 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          } else {
                            validate94.errors = [
                              {
                                instancePath:
                                  instancePath + '/attachments/' + i0,
                                schemaPath: '#/definitions/Attachment/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object',
                              },
                            ];
                            return false;
                          }
                        }
                        var valid1 = _errs9 === errors;
                        if (!valid1) {
                          break;
                        }
                      }
                    } else {
                      validate94.errors = [
                        {
                          instancePath: instancePath + '/attachments',
                          schemaPath: '#/properties/attachments/type',
                          keyword: 'type',
                          params: { type: 'array' },
                          message: 'must be array',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs7 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.order !== undefined) {
                    let data9 = data.order;
                    const _errs21 = errors;
                    if (
                      !(
                        typeof data9 == 'number' &&
                        !(data9 % 1) &&
                        !isNaN(data9) &&
                        isFinite(data9)
                      )
                    ) {
                      validate94.errors = [
                        {
                          instancePath: instancePath + '/order',
                          schemaPath: '#/properties/order/type',
                          keyword: 'type',
                          params: { type: 'integer' },
                          message: 'must be integer',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs21 === errors;
                  } else {
                    var valid0 = true;
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate94.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate94.errors = vErrors;
  return errors === 0;
}
function validate96(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.type === undefined && (missing0 = 'type')) ||
        (data.id === undefined && (missing0 = 'id')) ||
        (data.email === undefined && (missing0 = 'email'))
      ) {
        validate96.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (
            !(
              key0 === 'type' ||
              key0 === 'id' ||
              key0 === 'email' ||
              key0 === 'role'
            )
          ) {
            validate96.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.type !== undefined) {
            const _errs2 = errors;
            if (!func0(data.type, 'ccEmail')) {
              validate96.errors = [
                {
                  instancePath: instancePath + '/type',
                  schemaPath: '#/properties/type/const',
                  keyword: 'const',
                  params: { allowedValue: 'ccEmail' },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.id !== undefined) {
              const _errs3 = errors;
              if (typeof data.id !== 'string') {
                validate96.errors = [
                  {
                    instancePath: instancePath + '/id',
                    schemaPath: '#/properties/id/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.email !== undefined) {
                const _errs5 = errors;
                if (typeof data.email !== 'string') {
                  validate96.errors = [
                    {
                      instancePath: instancePath + '/email',
                      schemaPath: '#/properties/email/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.role !== undefined) {
                  let data3 = data.role;
                  const _errs7 = errors;
                  const _errs8 = errors;
                  if (errors === _errs8) {
                    if (
                      data3 &&
                      typeof data3 == 'object' &&
                      !Array.isArray(data3)
                    ) {
                      let missing1;
                      if (
                        (data3.type === undefined && (missing1 = 'type')) ||
                        (data3.id === undefined && (missing1 = 'id')) ||
                        (data3.name === undefined && (missing1 = 'name'))
                      ) {
                        validate96.errors = [
                          {
                            instancePath: instancePath + '/role',
                            schemaPath: '#/definitions/CCRole/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message:
                              "must have required property '" + missing1 + "'",
                          },
                        ];
                        return false;
                      } else {
                        const _errs10 = errors;
                        for (const key1 in data3) {
                          if (
                            !(
                              key1 === 'type' ||
                              key1 === 'id' ||
                              key1 === 'name'
                            )
                          ) {
                            validate96.errors = [
                              {
                                instancePath: instancePath + '/role',
                                schemaPath:
                                  '#/definitions/CCRole/additionalProperties',
                                keyword: 'additionalProperties',
                                params: { additionalProperty: key1 },
                                message: 'must NOT have additional properties',
                              },
                            ];
                            return false;
                            break;
                          }
                        }
                        if (_errs10 === errors) {
                          if (data3.type !== undefined) {
                            const _errs11 = errors;
                            if (!func0(data3.type, 'ccRole')) {
                              validate96.errors = [
                                {
                                  instancePath: instancePath + '/role/type',
                                  schemaPath:
                                    '#/definitions/CCRole/properties/type/const',
                                  keyword: 'const',
                                  params: { allowedValue: 'ccRole' },
                                  message: 'must be equal to constant',
                                },
                              ];
                              return false;
                            }
                            var valid2 = _errs11 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data3.id !== undefined) {
                              const _errs12 = errors;
                              if (typeof data3.id !== 'string') {
                                validate96.errors = [
                                  {
                                    instancePath: instancePath + '/role/id',
                                    schemaPath:
                                      '#/definitions/CCRole/properties/id/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid2 = _errs12 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data3.name !== undefined) {
                                const _errs14 = errors;
                                if (typeof data3.name !== 'string') {
                                  validate96.errors = [
                                    {
                                      instancePath: instancePath + '/role/name',
                                      schemaPath:
                                        '#/definitions/CCRole/properties/name/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid2 = _errs14 === errors;
                              } else {
                                var valid2 = true;
                              }
                            }
                          }
                        }
                      }
                    } else {
                      validate96.errors = [
                        {
                          instancePath: instancePath + '/role',
                          schemaPath: '#/definitions/CCRole/type',
                          keyword: 'type',
                          params: { type: 'object' },
                          message: 'must be object',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs7 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate96.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate96.errors = vErrors;
  return errors === 0;
}
function validate91(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="Template.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.requestType === undefined && (missing0 = 'requestType')) ||
        (data.recipientReassignment === undefined &&
          (missing0 = 'recipientReassignment')) ||
        (data.recipientOrder === undefined && (missing0 = 'recipientOrder')) ||
        (data.dateFormat === undefined && (missing0 = 'dateFormat')) ||
        (data.guid === undefined && (missing0 = 'guid')) ||
        (data.recipients === undefined && (missing0 = 'recipients')) ||
        (data.title === undefined && (missing0 = 'title')) ||
        (data.createdBy === undefined && (missing0 = 'createdBy')) ||
        (data.isOwner === undefined && (missing0 = 'isOwner')) ||
        (data.message === undefined && (missing0 = 'message'))
      ) {
        validate91.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func4.call(schema107.properties, key0)) {
            validate91.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.guid !== undefined) {
            const _errs2 = errors;
            if (typeof data.guid !== 'string') {
              validate91.errors = [
                {
                  instancePath: instancePath + '/guid',
                  schemaPath: '#/properties/guid/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.requestType !== undefined) {
              let data1 = data.requestType;
              const _errs5 = errors;
              if (!(typeof data1 == 'number' && isFinite(data1))) {
                validate91.errors = [
                  {
                    instancePath: instancePath + '/requestType',
                    schemaPath: '#/properties/requestType/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.recipientReassignment !== undefined) {
                const _errs7 = errors;
                if (typeof data.recipientReassignment !== 'boolean') {
                  validate91.errors = [
                    {
                      instancePath: instancePath + '/recipientReassignment',
                      schemaPath: '#/properties/recipientReassignment/type',
                      keyword: 'type',
                      params: { type: 'boolean' },
                      message: 'must be boolean',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.starred !== undefined) {
                  const _errs9 = errors;
                  if (typeof data.starred !== 'boolean') {
                    validate91.errors = [
                      {
                        instancePath: instancePath + '/starred',
                        schemaPath: '#/properties/starred/type',
                        keyword: 'type',
                        params: { type: 'boolean' },
                        message: 'must be boolean',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.recipientOrder !== undefined) {
                    const _errs11 = errors;
                    if (typeof data.recipientOrder !== 'boolean') {
                      validate91.errors = [
                        {
                          instancePath: instancePath + '/recipientOrder',
                          schemaPath: '#/properties/recipientOrder/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.updated !== undefined) {
                      const _errs13 = errors;
                      if (typeof data.updated !== 'string') {
                        validate91.errors = [
                          {
                            instancePath: instancePath + '/updated',
                            schemaPath: '#/properties/updated/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.dateFormat !== undefined) {
                        let data6 = data.dateFormat;
                        const _errs15 = errors;
                        if (typeof data6 !== 'string') {
                          validate91.errors = [
                            {
                              instancePath: instancePath + '/dateFormat',
                              schemaPath:
                                'Field.json#/definitions/PHPDateFormat/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        if (
                          !(
                            data6 === 'Default' ||
                            data6 === 'm / d / Y' ||
                            data6 === 'm - d - Y' ||
                            data6 === 'd / m / Y' ||
                            data6 === 'd - m - Y' ||
                            data6 === 'Y / m / d' ||
                            data6 === 'Y - m - d'
                          )
                        ) {
                          validate91.errors = [
                            {
                              instancePath: instancePath + '/dateFormat',
                              schemaPath:
                                'Field.json#/definitions/PHPDateFormat/enum',
                              keyword: 'enum',
                              params: { allowedValues: schema108.enum },
                              message:
                                'must be equal to one of the allowed values',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.jsDateFormat !== undefined) {
                          let data7 = data.jsDateFormat;
                          const _errs18 = errors;
                          if (typeof data7 !== 'string') {
                            validate91.errors = [
                              {
                                instancePath: instancePath + '/jsDateFormat',
                                schemaPath:
                                  'Field.json#/definitions/JSDateFormat/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          if (
                            !(
                              data7 === 'default' ||
                              data7 === 'MM / DD / YYYY' ||
                              data7 === 'MM - DD - YYYY' ||
                              data7 === 'DD / MM / YYYY' ||
                              data7 === 'DD - MM - YYYY' ||
                              data7 === 'YYYY / MM / DD' ||
                              data7 === 'YYYY - MM - DD'
                            )
                          ) {
                            validate91.errors = [
                              {
                                instancePath: instancePath + '/jsDateFormat',
                                schemaPath:
                                  'Field.json#/definitions/JSDateFormat/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema34.enum },
                                message:
                                  'must be equal to one of the allowed values',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs18 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.files !== undefined) {
                            let data8 = data.files;
                            const _errs21 = errors;
                            if (errors === _errs21) {
                              if (Array.isArray(data8)) {
                                var valid3 = true;
                                const len0 = data8.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                  const _errs23 = errors;
                                  if (
                                    !validate49(data8[i0], {
                                      instancePath:
                                        instancePath + '/files/' + i0,
                                      parentData: data8,
                                      parentDataProperty: i0,
                                      rootData,
                                    })
                                  ) {
                                    vErrors =
                                      vErrors === null
                                        ? validate49.errors
                                        : vErrors.concat(validate49.errors);
                                    errors = vErrors.length;
                                  }
                                  var valid3 = _errs23 === errors;
                                  if (!valid3) {
                                    break;
                                  }
                                }
                              } else {
                                validate91.errors = [
                                  {
                                    instancePath: instancePath + '/files',
                                    schemaPath: '#/properties/files/type',
                                    keyword: 'type',
                                    params: { type: 'array' },
                                    message: 'must be array',
                                  },
                                ];
                                return false;
                              }
                            }
                            var valid0 = _errs21 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.editorData !== undefined) {
                              const _errs24 = errors;
                              if (
                                !validate52(data.editorData, {
                                  instancePath: instancePath + '/editorData',
                                  parentData: data,
                                  parentDataProperty: 'editorData',
                                  rootData,
                                })
                              ) {
                                vErrors =
                                  vErrors === null
                                    ? validate52.errors
                                    : vErrors.concat(validate52.errors);
                                errors = vErrors.length;
                              }
                              var valid0 = _errs24 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.recipients !== undefined) {
                                let data11 = data.recipients;
                                const _errs25 = errors;
                                if (errors === _errs25) {
                                  if (Array.isArray(data11)) {
                                    var valid4 = true;
                                    const len1 = data11.length;
                                    for (let i1 = 0; i1 < len1; i1++) {
                                      const _errs27 = errors;
                                      if (
                                        !validate94(data11[i1], {
                                          instancePath:
                                            instancePath + '/recipients/' + i1,
                                          parentData: data11,
                                          parentDataProperty: i1,
                                          rootData,
                                        })
                                      ) {
                                        vErrors =
                                          vErrors === null
                                            ? validate94.errors
                                            : vErrors.concat(validate94.errors);
                                        errors = vErrors.length;
                                      }
                                      var valid4 = _errs27 === errors;
                                      if (!valid4) {
                                        break;
                                      }
                                    }
                                  } else {
                                    validate91.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/recipients',
                                        schemaPath:
                                          '#/properties/recipients/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array',
                                      },
                                    ];
                                    return false;
                                  }
                                }
                                var valid0 = _errs25 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.ccs !== undefined) {
                                  let data13 = data.ccs;
                                  const _errs28 = errors;
                                  if (errors === _errs28) {
                                    if (Array.isArray(data13)) {
                                      var valid5 = true;
                                      const len2 = data13.length;
                                      for (let i2 = 0; i2 < len2; i2++) {
                                        let data14 = data13[i2];
                                        const _errs30 = errors;
                                        const _errs31 = errors;
                                        let valid6 = false;
                                        const _errs32 = errors;
                                        const _errs33 = errors;
                                        if (errors === _errs33) {
                                          if (
                                            data14 &&
                                            typeof data14 == 'object' &&
                                            !Array.isArray(data14)
                                          ) {
                                            let missing1;
                                            if (
                                              (data14.type === undefined &&
                                                (missing1 = 'type')) ||
                                              (data14.id === undefined &&
                                                (missing1 = 'id')) ||
                                              (data14.name === undefined &&
                                                (missing1 = 'name'))
                                            ) {
                                              const err0 = {
                                                instancePath:
                                                  instancePath + '/ccs/' + i2,
                                                schemaPath:
                                                  'Recipient.json#/definitions/CCRole/required',
                                                keyword: 'required',
                                                params: {
                                                  missingProperty: missing1,
                                                },
                                                message:
                                                  "must have required property '" +
                                                  missing1 +
                                                  "'",
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err0];
                                              } else {
                                                vErrors.push(err0);
                                              }
                                              errors++;
                                            } else {
                                              const _errs35 = errors;
                                              for (const key1 in data14) {
                                                if (
                                                  !(
                                                    key1 === 'type' ||
                                                    key1 === 'id' ||
                                                    key1 === 'name'
                                                  )
                                                ) {
                                                  const err1 = {
                                                    instancePath:
                                                      instancePath +
                                                      '/ccs/' +
                                                      i2,
                                                    schemaPath:
                                                      'Recipient.json#/definitions/CCRole/additionalProperties',
                                                    keyword:
                                                      'additionalProperties',
                                                    params: {
                                                      additionalProperty: key1,
                                                    },
                                                    message:
                                                      'must NOT have additional properties',
                                                  };
                                                  if (vErrors === null) {
                                                    vErrors = [err1];
                                                  } else {
                                                    vErrors.push(err1);
                                                  }
                                                  errors++;
                                                  break;
                                                }
                                              }
                                              if (_errs35 === errors) {
                                                if (data14.type !== undefined) {
                                                  const _errs36 = errors;
                                                  if (
                                                    !func0(
                                                      data14.type,
                                                      'ccRole',
                                                    )
                                                  ) {
                                                    const err2 = {
                                                      instancePath:
                                                        instancePath +
                                                        '/ccs/' +
                                                        i2 +
                                                        '/type',
                                                      schemaPath:
                                                        'Recipient.json#/definitions/CCRole/properties/type/const',
                                                      keyword: 'const',
                                                      params: {
                                                        allowedValue: 'ccRole',
                                                      },
                                                      message:
                                                        'must be equal to constant',
                                                    };
                                                    if (vErrors === null) {
                                                      vErrors = [err2];
                                                    } else {
                                                      vErrors.push(err2);
                                                    }
                                                    errors++;
                                                  }
                                                  var valid8 =
                                                    _errs36 === errors;
                                                } else {
                                                  var valid8 = true;
                                                }
                                                if (valid8) {
                                                  if (data14.id !== undefined) {
                                                    const _errs37 = errors;
                                                    if (
                                                      typeof data14.id !==
                                                      'string'
                                                    ) {
                                                      const err3 = {
                                                        instancePath:
                                                          instancePath +
                                                          '/ccs/' +
                                                          i2 +
                                                          '/id',
                                                        schemaPath:
                                                          'Recipient.json#/definitions/CCRole/properties/id/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'string',
                                                        },
                                                        message:
                                                          'must be string',
                                                      };
                                                      if (vErrors === null) {
                                                        vErrors = [err3];
                                                      } else {
                                                        vErrors.push(err3);
                                                      }
                                                      errors++;
                                                    }
                                                    var valid8 =
                                                      _errs37 === errors;
                                                  } else {
                                                    var valid8 = true;
                                                  }
                                                  if (valid8) {
                                                    if (
                                                      data14.name !== undefined
                                                    ) {
                                                      const _errs39 = errors;
                                                      if (
                                                        typeof data14.name !==
                                                        'string'
                                                      ) {
                                                        const err4 = {
                                                          instancePath:
                                                            instancePath +
                                                            '/ccs/' +
                                                            i2 +
                                                            '/name',
                                                          schemaPath:
                                                            'Recipient.json#/definitions/CCRole/properties/name/type',
                                                          keyword: 'type',
                                                          params: {
                                                            type: 'string',
                                                          },
                                                          message:
                                                            'must be string',
                                                        };
                                                        if (vErrors === null) {
                                                          vErrors = [err4];
                                                        } else {
                                                          vErrors.push(err4);
                                                        }
                                                        errors++;
                                                      }
                                                      var valid8 =
                                                        _errs39 === errors;
                                                    } else {
                                                      var valid8 = true;
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          } else {
                                            const err5 = {
                                              instancePath:
                                                instancePath + '/ccs/' + i2,
                                              schemaPath:
                                                'Recipient.json#/definitions/CCRole/type',
                                              keyword: 'type',
                                              params: { type: 'object' },
                                              message: 'must be object',
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err5];
                                            } else {
                                              vErrors.push(err5);
                                            }
                                            errors++;
                                          }
                                        }
                                        var _valid0 = _errs32 === errors;
                                        valid6 = valid6 || _valid0;
                                        if (!valid6) {
                                          const _errs41 = errors;
                                          if (
                                            !validate96(data14, {
                                              instancePath:
                                                instancePath + '/ccs/' + i2,
                                              parentData: data13,
                                              parentDataProperty: i2,
                                              rootData,
                                            })
                                          ) {
                                            vErrors =
                                              vErrors === null
                                                ? validate96.errors
                                                : vErrors.concat(
                                                    validate96.errors,
                                                  );
                                            errors = vErrors.length;
                                          }
                                          var _valid0 = _errs41 === errors;
                                          valid6 = valid6 || _valid0;
                                        }
                                        if (!valid6) {
                                          const err6 = {
                                            instancePath:
                                              instancePath + '/ccs/' + i2,
                                            schemaPath:
                                              '#/properties/ccs/items/anyOf',
                                            keyword: 'anyOf',
                                            params: {},
                                            message:
                                              'must match a schema in anyOf',
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err6];
                                          } else {
                                            vErrors.push(err6);
                                          }
                                          errors++;
                                          validate91.errors = vErrors;
                                          return false;
                                        } else {
                                          errors = _errs31;
                                          if (vErrors !== null) {
                                            if (_errs31) {
                                              vErrors.length = _errs31;
                                            } else {
                                              vErrors = null;
                                            }
                                          }
                                        }
                                        var valid5 = _errs30 === errors;
                                        if (!valid5) {
                                          break;
                                        }
                                      }
                                    } else {
                                      validate91.errors = [
                                        {
                                          instancePath: instancePath + '/ccs',
                                          schemaPath: '#/properties/ccs/type',
                                          keyword: 'type',
                                          params: { type: 'array' },
                                          message: 'must be array',
                                        },
                                      ];
                                      return false;
                                    }
                                  }
                                  var valid0 = _errs28 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.title !== undefined) {
                                    const _errs42 = errors;
                                    if (typeof data.title !== 'string') {
                                      validate91.errors = [
                                        {
                                          instancePath: instancePath + '/title',
                                          schemaPath: '#/properties/title/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid0 = _errs42 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.message !== undefined) {
                                      const _errs44 = errors;
                                      if (typeof data.message !== 'string') {
                                        validate91.errors = [
                                          {
                                            instancePath:
                                              instancePath + '/message',
                                            schemaPath:
                                              '#/properties/message/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid0 = _errs44 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.locked !== undefined) {
                                        const _errs46 = errors;
                                        if (typeof data.locked !== 'boolean') {
                                          validate91.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/locked',
                                              schemaPath:
                                                '#/properties/locked/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid0 = _errs46 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (data.shortGuid !== undefined) {
                                          const _errs48 = errors;
                                          if (
                                            typeof data.shortGuid !== 'string'
                                          ) {
                                            validate91.errors = [
                                              {
                                                instancePath:
                                                  instancePath + '/shortGuid',
                                                schemaPath:
                                                  '#/properties/shortGuid/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid0 = _errs48 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                        if (valid0) {
                                          if (data.isOwner !== undefined) {
                                            const _errs50 = errors;
                                            if (
                                              typeof data.isOwner !== 'boolean'
                                            ) {
                                              validate91.errors = [
                                                {
                                                  instancePath:
                                                    instancePath + '/isOwner',
                                                  schemaPath:
                                                    '#/properties/isOwner/type',
                                                  keyword: 'type',
                                                  params: { type: 'boolean' },
                                                  message: 'must be boolean',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid0 = _errs50 === errors;
                                          } else {
                                            var valid0 = true;
                                          }
                                          if (valid0) {
                                            if (data.isEditable !== undefined) {
                                              const _errs52 = errors;
                                              if (
                                                typeof data.isEditable !==
                                                'boolean'
                                              ) {
                                                validate91.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/isEditable',
                                                    schemaPath:
                                                      '#/properties/isEditable/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid0 = _errs52 === errors;
                                            } else {
                                              var valid0 = true;
                                            }
                                            if (valid0) {
                                              if (
                                                data.isDeletable !== undefined
                                              ) {
                                                const _errs54 = errors;
                                                if (
                                                  typeof data.isDeletable !==
                                                  'boolean'
                                                ) {
                                                  validate91.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/isDeletable',
                                                      schemaPath:
                                                        '#/properties/isDeletable/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'boolean',
                                                      },
                                                      message:
                                                        'must be boolean',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid0 = _errs54 === errors;
                                              } else {
                                                var valid0 = true;
                                              }
                                              if (valid0) {
                                                if (
                                                  data.isEmbedded !== undefined
                                                ) {
                                                  const _errs56 = errors;
                                                  if (
                                                    typeof data.isEmbedded !==
                                                    'boolean'
                                                  ) {
                                                    validate91.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath +
                                                          '/isEmbedded',
                                                        schemaPath:
                                                          '#/properties/isEmbedded/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'boolean',
                                                        },
                                                        message:
                                                          'must be boolean',
                                                      },
                                                    ];
                                                    return false;
                                                  }
                                                  var valid0 =
                                                    _errs56 === errors;
                                                } else {
                                                  var valid0 = true;
                                                }
                                                if (valid0) {
                                                  if (
                                                    data.isSalesforceCreated !==
                                                    undefined
                                                  ) {
                                                    const _errs58 = errors;
                                                    if (
                                                      typeof data.isSalesforceCreated !==
                                                      'boolean'
                                                    ) {
                                                      validate91.errors = [
                                                        {
                                                          instancePath:
                                                            instancePath +
                                                            '/isSalesforceCreated',
                                                          schemaPath:
                                                            '#/properties/isSalesforceCreated/type',
                                                          keyword: 'type',
                                                          params: {
                                                            type: 'boolean',
                                                          },
                                                          message:
                                                            'must be boolean',
                                                        },
                                                      ];
                                                      return false;
                                                    }
                                                    var valid0 =
                                                      _errs58 === errors;
                                                  } else {
                                                    var valid0 = true;
                                                  }
                                                  if (valid0) {
                                                    if (
                                                      data.isCreatedByIntegration !==
                                                      undefined
                                                    ) {
                                                      const _errs60 = errors;
                                                      if (
                                                        typeof data.isCreatedByIntegration !==
                                                        'boolean'
                                                      ) {
                                                        validate91.errors = [
                                                          {
                                                            instancePath:
                                                              instancePath +
                                                              '/isCreatedByIntegration',
                                                            schemaPath:
                                                              '#/properties/isCreatedByIntegration/type',
                                                            keyword: 'type',
                                                            params: {
                                                              type: 'boolean',
                                                            },
                                                            message:
                                                              'must be boolean',
                                                          },
                                                        ];
                                                        return false;
                                                      }
                                                      var valid0 =
                                                        _errs60 === errors;
                                                    } else {
                                                      var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                      if (
                                                        data.linkDetails !==
                                                        undefined
                                                      ) {
                                                        let data28 =
                                                          data.linkDetails;
                                                        const _errs62 = errors;
                                                        const _errs63 = errors;
                                                        if (
                                                          errors === _errs63
                                                        ) {
                                                          if (
                                                            data28 &&
                                                            typeof data28 ==
                                                              'object' &&
                                                            !Array.isArray(
                                                              data28,
                                                            )
                                                          ) {
                                                            let missing2;
                                                            if (
                                                              data28.receiveSignedCopies ===
                                                                undefined &&
                                                              (missing2 =
                                                                'receiveSignedCopies')
                                                            ) {
                                                              validate91.errors =
                                                                [
                                                                  {
                                                                    instancePath:
                                                                      instancePath +
                                                                      '/linkDetails',
                                                                    schemaPath:
                                                                      '#/definitions/LinkDetails/required',
                                                                    keyword:
                                                                      'required',
                                                                    params: {
                                                                      missingProperty:
                                                                        missing2,
                                                                    },
                                                                    message:
                                                                      "must have required property '" +
                                                                      missing2 +
                                                                      "'",
                                                                  },
                                                                ];
                                                              return false;
                                                            } else {
                                                              const _errs65 =
                                                                errors;
                                                              for (const key2 in data28) {
                                                                if (
                                                                  !(
                                                                    key2 ===
                                                                      'shareableLink' ||
                                                                    key2 ===
                                                                      'inPersonLink' ||
                                                                    key2 ===
                                                                      'receiveSignedCopies'
                                                                  )
                                                                ) {
                                                                  validate91.errors =
                                                                    [
                                                                      {
                                                                        instancePath:
                                                                          instancePath +
                                                                          '/linkDetails',
                                                                        schemaPath:
                                                                          '#/definitions/LinkDetails/additionalProperties',
                                                                        keyword:
                                                                          'additionalProperties',
                                                                        params:
                                                                          {
                                                                            additionalProperty:
                                                                              key2,
                                                                          },
                                                                        message:
                                                                          'must NOT have additional properties',
                                                                      },
                                                                    ];
                                                                  return false;
                                                                  break;
                                                                }
                                                              }
                                                              if (
                                                                _errs65 ===
                                                                errors
                                                              ) {
                                                                if (
                                                                  data28.shareableLink !==
                                                                  undefined
                                                                ) {
                                                                  const _errs66 =
                                                                    errors;
                                                                  if (
                                                                    typeof data28.shareableLink !==
                                                                    'string'
                                                                  ) {
                                                                    validate91.errors =
                                                                      [
                                                                        {
                                                                          instancePath:
                                                                            instancePath +
                                                                            '/linkDetails/shareableLink',
                                                                          schemaPath:
                                                                            '#/definitions/LinkDetails/properties/shareableLink/type',
                                                                          keyword:
                                                                            'type',
                                                                          params:
                                                                            {
                                                                              type: 'string',
                                                                            },
                                                                          message:
                                                                            'must be string',
                                                                        },
                                                                      ];
                                                                    return false;
                                                                  }
                                                                  var valid10 =
                                                                    _errs66 ===
                                                                    errors;
                                                                } else {
                                                                  var valid10 = true;
                                                                }
                                                                if (valid10) {
                                                                  if (
                                                                    data28.inPersonLink !==
                                                                    undefined
                                                                  ) {
                                                                    const _errs68 =
                                                                      errors;
                                                                    if (
                                                                      typeof data28.inPersonLink !==
                                                                      'string'
                                                                    ) {
                                                                      validate91.errors =
                                                                        [
                                                                          {
                                                                            instancePath:
                                                                              instancePath +
                                                                              '/linkDetails/inPersonLink',
                                                                            schemaPath:
                                                                              '#/definitions/LinkDetails/properties/inPersonLink/type',
                                                                            keyword:
                                                                              'type',
                                                                            params:
                                                                              {
                                                                                type: 'string',
                                                                              },
                                                                            message:
                                                                              'must be string',
                                                                          },
                                                                        ];
                                                                      return false;
                                                                    }
                                                                    var valid10 =
                                                                      _errs68 ===
                                                                      errors;
                                                                  } else {
                                                                    var valid10 = true;
                                                                  }
                                                                  if (valid10) {
                                                                    if (
                                                                      data28.receiveSignedCopies !==
                                                                      undefined
                                                                    ) {
                                                                      const _errs70 =
                                                                        errors;
                                                                      if (
                                                                        typeof data28.receiveSignedCopies !==
                                                                        'boolean'
                                                                      ) {
                                                                        validate91.errors =
                                                                          [
                                                                            {
                                                                              instancePath:
                                                                                instancePath +
                                                                                '/linkDetails/receiveSignedCopies',
                                                                              schemaPath:
                                                                                '#/definitions/LinkDetails/properties/receiveSignedCopies/type',
                                                                              keyword:
                                                                                'type',
                                                                              params:
                                                                                {
                                                                                  type: 'boolean',
                                                                                },
                                                                              message:
                                                                                'must be boolean',
                                                                            },
                                                                          ];
                                                                        return false;
                                                                      }
                                                                      var valid10 =
                                                                        _errs70 ===
                                                                        errors;
                                                                    } else {
                                                                      var valid10 = true;
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          } else {
                                                            validate91.errors =
                                                              [
                                                                {
                                                                  instancePath:
                                                                    instancePath +
                                                                    '/linkDetails',
                                                                  schemaPath:
                                                                    '#/definitions/LinkDetails/type',
                                                                  keyword:
                                                                    'type',
                                                                  params: {
                                                                    type: 'object',
                                                                  },
                                                                  message:
                                                                    'must be object',
                                                                },
                                                              ];
                                                            return false;
                                                          }
                                                        }
                                                        var valid0 =
                                                          _errs62 === errors;
                                                      } else {
                                                        var valid0 = true;
                                                      }
                                                      if (valid0) {
                                                        if (
                                                          data.createdBy !==
                                                          undefined
                                                        ) {
                                                          let data32 =
                                                            data.createdBy;
                                                          const _errs72 =
                                                            errors;
                                                          const _errs73 =
                                                            errors;
                                                          if (
                                                            errors === _errs73
                                                          ) {
                                                            if (
                                                              data32 &&
                                                              typeof data32 ==
                                                                'object' &&
                                                              !Array.isArray(
                                                                data32,
                                                              )
                                                            ) {
                                                              let missing3;
                                                              if (
                                                                (data32.name ===
                                                                  undefined &&
                                                                  (missing3 =
                                                                    'name')) ||
                                                                (data32.email ===
                                                                  undefined &&
                                                                  (missing3 =
                                                                    'email')) ||
                                                                (data32.date ===
                                                                  undefined &&
                                                                  (missing3 =
                                                                    'date'))
                                                              ) {
                                                                validate91.errors =
                                                                  [
                                                                    {
                                                                      instancePath:
                                                                        instancePath +
                                                                        '/createdBy',
                                                                      schemaPath:
                                                                        '#/definitions/CreatedBy/required',
                                                                      keyword:
                                                                        'required',
                                                                      params: {
                                                                        missingProperty:
                                                                          missing3,
                                                                      },
                                                                      message:
                                                                        "must have required property '" +
                                                                        missing3 +
                                                                        "'",
                                                                    },
                                                                  ];
                                                                return false;
                                                              } else {
                                                                const _errs75 =
                                                                  errors;
                                                                for (const key3 in data32) {
                                                                  if (
                                                                    !(
                                                                      key3 ===
                                                                        'name' ||
                                                                      key3 ===
                                                                        'email' ||
                                                                      key3 ===
                                                                        'date'
                                                                    )
                                                                  ) {
                                                                    validate91.errors =
                                                                      [
                                                                        {
                                                                          instancePath:
                                                                            instancePath +
                                                                            '/createdBy',
                                                                          schemaPath:
                                                                            '#/definitions/CreatedBy/additionalProperties',
                                                                          keyword:
                                                                            'additionalProperties',
                                                                          params:
                                                                            {
                                                                              additionalProperty:
                                                                                key3,
                                                                            },
                                                                          message:
                                                                            'must NOT have additional properties',
                                                                        },
                                                                      ];
                                                                    return false;
                                                                    break;
                                                                  }
                                                                }
                                                                if (
                                                                  _errs75 ===
                                                                  errors
                                                                ) {
                                                                  if (
                                                                    data32.name !==
                                                                    undefined
                                                                  ) {
                                                                    const _errs76 =
                                                                      errors;
                                                                    if (
                                                                      typeof data32.name !==
                                                                      'string'
                                                                    ) {
                                                                      validate91.errors =
                                                                        [
                                                                          {
                                                                            instancePath:
                                                                              instancePath +
                                                                              '/createdBy/name',
                                                                            schemaPath:
                                                                              '#/definitions/CreatedBy/properties/name/type',
                                                                            keyword:
                                                                              'type',
                                                                            params:
                                                                              {
                                                                                type: 'string',
                                                                              },
                                                                            message:
                                                                              'must be string',
                                                                          },
                                                                        ];
                                                                      return false;
                                                                    }
                                                                    var valid12 =
                                                                      _errs76 ===
                                                                      errors;
                                                                  } else {
                                                                    var valid12 = true;
                                                                  }
                                                                  if (valid12) {
                                                                    if (
                                                                      data32.email !==
                                                                      undefined
                                                                    ) {
                                                                      const _errs78 =
                                                                        errors;
                                                                      if (
                                                                        typeof data32.email !==
                                                                        'string'
                                                                      ) {
                                                                        validate91.errors =
                                                                          [
                                                                            {
                                                                              instancePath:
                                                                                instancePath +
                                                                                '/createdBy/email',
                                                                              schemaPath:
                                                                                '#/definitions/CreatedBy/properties/email/type',
                                                                              keyword:
                                                                                'type',
                                                                              params:
                                                                                {
                                                                                  type: 'string',
                                                                                },
                                                                              message:
                                                                                'must be string',
                                                                            },
                                                                          ];
                                                                        return false;
                                                                      }
                                                                      var valid12 =
                                                                        _errs78 ===
                                                                        errors;
                                                                    } else {
                                                                      var valid12 = true;
                                                                    }
                                                                    if (
                                                                      valid12
                                                                    ) {
                                                                      if (
                                                                        data32.date !==
                                                                        undefined
                                                                      ) {
                                                                        const _errs80 =
                                                                          errors;
                                                                        if (
                                                                          typeof data32.date !==
                                                                          'string'
                                                                        ) {
                                                                          validate91.errors =
                                                                            [
                                                                              {
                                                                                instancePath:
                                                                                  instancePath +
                                                                                  '/createdBy/date',
                                                                                schemaPath:
                                                                                  '#/definitions/CreatedBy/properties/date/type',
                                                                                keyword:
                                                                                  'type',
                                                                                params:
                                                                                  {
                                                                                    type: 'string',
                                                                                  },
                                                                                message:
                                                                                  'must be string',
                                                                              },
                                                                            ];
                                                                          return false;
                                                                        }
                                                                        var valid12 =
                                                                          _errs80 ===
                                                                          errors;
                                                                      } else {
                                                                        var valid12 = true;
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            } else {
                                                              validate91.errors =
                                                                [
                                                                  {
                                                                    instancePath:
                                                                      instancePath +
                                                                      '/createdBy',
                                                                    schemaPath:
                                                                      '#/definitions/CreatedBy/type',
                                                                    keyword:
                                                                      'type',
                                                                    params: {
                                                                      type: 'object',
                                                                    },
                                                                    message:
                                                                      'must be object',
                                                                  },
                                                                ];
                                                              return false;
                                                            }
                                                          }
                                                          var valid0 =
                                                            _errs72 === errors;
                                                        } else {
                                                          var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                          if (
                                                            data.whoHasAccess !==
                                                            undefined
                                                          ) {
                                                            let data36 =
                                                              data.whoHasAccess;
                                                            const _errs82 =
                                                              errors;
                                                            const _errs83 =
                                                              errors;
                                                            if (
                                                              errors === _errs83
                                                            ) {
                                                              if (
                                                                data36 &&
                                                                typeof data36 ==
                                                                  'object' &&
                                                                !Array.isArray(
                                                                  data36,
                                                                )
                                                              ) {
                                                                let missing4;
                                                                if (
                                                                  (data36.admin_count ===
                                                                    undefined &&
                                                                    (missing4 =
                                                                      'admin_count')) ||
                                                                  (data36.member_count ===
                                                                    undefined &&
                                                                    (missing4 =
                                                                      'member_count'))
                                                                ) {
                                                                  validate91.errors =
                                                                    [
                                                                      {
                                                                        instancePath:
                                                                          instancePath +
                                                                          '/whoHasAccess',
                                                                        schemaPath:
                                                                          '#/definitions/WhoHasAccess/required',
                                                                        keyword:
                                                                          'required',
                                                                        params:
                                                                          {
                                                                            missingProperty:
                                                                              missing4,
                                                                          },
                                                                        message:
                                                                          "must have required property '" +
                                                                          missing4 +
                                                                          "'",
                                                                      },
                                                                    ];
                                                                  return false;
                                                                } else {
                                                                  const _errs85 =
                                                                    errors;
                                                                  for (const key4 in data36) {
                                                                    if (
                                                                      !(
                                                                        key4 ===
                                                                          'admin_count' ||
                                                                        key4 ===
                                                                          'member_count' ||
                                                                        key4 ===
                                                                          'users'
                                                                      )
                                                                    ) {
                                                                      validate91.errors =
                                                                        [
                                                                          {
                                                                            instancePath:
                                                                              instancePath +
                                                                              '/whoHasAccess',
                                                                            schemaPath:
                                                                              '#/definitions/WhoHasAccess/additionalProperties',
                                                                            keyword:
                                                                              'additionalProperties',
                                                                            params:
                                                                              {
                                                                                additionalProperty:
                                                                                  key4,
                                                                              },
                                                                            message:
                                                                              'must NOT have additional properties',
                                                                          },
                                                                        ];
                                                                      return false;
                                                                      break;
                                                                    }
                                                                  }
                                                                  if (
                                                                    _errs85 ===
                                                                    errors
                                                                  ) {
                                                                    if (
                                                                      data36.admin_count !==
                                                                      undefined
                                                                    ) {
                                                                      let data37 =
                                                                        data36.admin_count;
                                                                      const _errs86 =
                                                                        errors;
                                                                      if (
                                                                        !(
                                                                          typeof data37 ==
                                                                            'number' &&
                                                                          isFinite(
                                                                            data37,
                                                                          )
                                                                        )
                                                                      ) {
                                                                        validate91.errors =
                                                                          [
                                                                            {
                                                                              instancePath:
                                                                                instancePath +
                                                                                '/whoHasAccess/admin_count',
                                                                              schemaPath:
                                                                                '#/definitions/WhoHasAccess/properties/admin_count/type',
                                                                              keyword:
                                                                                'type',
                                                                              params:
                                                                                {
                                                                                  type: 'number',
                                                                                },
                                                                              message:
                                                                                'must be number',
                                                                            },
                                                                          ];
                                                                        return false;
                                                                      }
                                                                      var valid14 =
                                                                        _errs86 ===
                                                                        errors;
                                                                    } else {
                                                                      var valid14 = true;
                                                                    }
                                                                    if (
                                                                      valid14
                                                                    ) {
                                                                      if (
                                                                        data36.member_count !==
                                                                        undefined
                                                                      ) {
                                                                        let data38 =
                                                                          data36.member_count;
                                                                        const _errs88 =
                                                                          errors;
                                                                        if (
                                                                          !(
                                                                            typeof data38 ==
                                                                              'number' &&
                                                                            isFinite(
                                                                              data38,
                                                                            )
                                                                          )
                                                                        ) {
                                                                          validate91.errors =
                                                                            [
                                                                              {
                                                                                instancePath:
                                                                                  instancePath +
                                                                                  '/whoHasAccess/member_count',
                                                                                schemaPath:
                                                                                  '#/definitions/WhoHasAccess/properties/member_count/type',
                                                                                keyword:
                                                                                  'type',
                                                                                params:
                                                                                  {
                                                                                    type: 'number',
                                                                                  },
                                                                                message:
                                                                                  'must be number',
                                                                              },
                                                                            ];
                                                                          return false;
                                                                        }
                                                                        var valid14 =
                                                                          _errs88 ===
                                                                          errors;
                                                                      } else {
                                                                        var valid14 = true;
                                                                      }
                                                                      if (
                                                                        valid14
                                                                      ) {
                                                                        if (
                                                                          data36.users !==
                                                                          undefined
                                                                        ) {
                                                                          let data39 =
                                                                            data36.users;
                                                                          const _errs90 =
                                                                            errors;
                                                                          if (
                                                                            errors ===
                                                                            _errs90
                                                                          ) {
                                                                            if (
                                                                              Array.isArray(
                                                                                data39,
                                                                              )
                                                                            ) {
                                                                              var valid15 = true;
                                                                              const len3 =
                                                                                data39.length;
                                                                              for (
                                                                                let i3 = 0;
                                                                                i3 <
                                                                                len3;
                                                                                i3++
                                                                              ) {
                                                                                const _errs92 =
                                                                                  errors;
                                                                                if (
                                                                                  typeof data39[
                                                                                    i3
                                                                                  ] !==
                                                                                  'string'
                                                                                ) {
                                                                                  validate91.errors =
                                                                                    [
                                                                                      {
                                                                                        instancePath:
                                                                                          instancePath +
                                                                                          '/whoHasAccess/users/' +
                                                                                          i3,
                                                                                        schemaPath:
                                                                                          '#/definitions/WhoHasAccess/properties/users/items/type',
                                                                                        keyword:
                                                                                          'type',
                                                                                        params:
                                                                                          {
                                                                                            type: 'string',
                                                                                          },
                                                                                        message:
                                                                                          'must be string',
                                                                                      },
                                                                                    ];
                                                                                  return false;
                                                                                }
                                                                                var valid15 =
                                                                                  _errs92 ===
                                                                                  errors;
                                                                                if (
                                                                                  !valid15
                                                                                ) {
                                                                                  break;
                                                                                }
                                                                              }
                                                                            } else {
                                                                              validate91.errors =
                                                                                [
                                                                                  {
                                                                                    instancePath:
                                                                                      instancePath +
                                                                                      '/whoHasAccess/users',
                                                                                    schemaPath:
                                                                                      '#/definitions/WhoHasAccess/properties/users/type',
                                                                                    keyword:
                                                                                      'type',
                                                                                    params:
                                                                                      {
                                                                                        type: 'array',
                                                                                      },
                                                                                    message:
                                                                                      'must be array',
                                                                                  },
                                                                                ];
                                                                              return false;
                                                                            }
                                                                          }
                                                                          var valid14 =
                                                                            _errs90 ===
                                                                            errors;
                                                                        } else {
                                                                          var valid14 = true;
                                                                        }
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              } else {
                                                                validate91.errors =
                                                                  [
                                                                    {
                                                                      instancePath:
                                                                        instancePath +
                                                                        '/whoHasAccess',
                                                                      schemaPath:
                                                                        '#/definitions/WhoHasAccess/type',
                                                                      keyword:
                                                                        'type',
                                                                      params: {
                                                                        type: 'object',
                                                                      },
                                                                      message:
                                                                        'must be object',
                                                                    },
                                                                  ];
                                                                return false;
                                                              }
                                                            }
                                                            var valid0 =
                                                              _errs82 ===
                                                              errors;
                                                          } else {
                                                            var valid0 = true;
                                                          }
                                                          if (valid0) {
                                                            if (
                                                              data.disabled !==
                                                              undefined
                                                            ) {
                                                              const _errs94 =
                                                                errors;
                                                              if (
                                                                typeof data.disabled !==
                                                                'boolean'
                                                              ) {
                                                                validate91.errors =
                                                                  [
                                                                    {
                                                                      instancePath:
                                                                        instancePath +
                                                                        '/disabled',
                                                                      schemaPath:
                                                                        '#/properties/disabled/type',
                                                                      keyword:
                                                                        'type',
                                                                      params: {
                                                                        type: 'boolean',
                                                                      },
                                                                      message:
                                                                        'must be boolean',
                                                                    },
                                                                  ];
                                                                return false;
                                                              }
                                                              var valid0 =
                                                                _errs94 ===
                                                                errors;
                                                            } else {
                                                              var valid0 = true;
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate91.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate91.errors = vErrors;
  return errors === 0;
}
const schema119 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'BulkSend.json',
  type: 'object',
  title: 'BulkSend',
  additionalProperties: false,
  properties: {
    exampleFields: { type: 'array', items: { type: 'string' } },
    signerFile: { oneOf: [{ $ref: 'SignerFile.json' }, { type: 'null' }] },
  },
  required: ['exampleFields'],
};
const schema120 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'SignerFile.json',
  title: 'SignerFile',
  type: 'object',
  properties: {
    status: { $ref: 'File.json#/definitions/FileStatus' },
    name: { type: 'string' },
    type: { $ref: '#/definitions/SignerFileType' },
    progress: { type: 'number' },
  },
  required: ['name', 'type', 'status'],
  definitions: {
    SignerFileType: {
      title: 'SignerFileType',
      type: 'string',
      enum: ['signer'],
      default: 'Signer',
    },
  },
};
const schema122 = {
  title: 'SignerFileType',
  type: 'string',
  enum: ['signer'],
  default: 'Signer',
};
function validate100(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="SignerFile.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.name === undefined && (missing0 = 'name')) ||
        (data.type === undefined && (missing0 = 'type')) ||
        (data.status === undefined && (missing0 = 'status'))
      ) {
        validate100.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.status !== undefined) {
          let data0 = data.status;
          const _errs1 = errors;
          if (typeof data0 !== 'string') {
            validate100.errors = [
              {
                instancePath: instancePath + '/status',
                schemaPath: 'File.json#/definitions/FileStatus/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          if (
            !(
              data0 === 'converting' ||
              data0 === 'ok' ||
              data0 === 'file downloaded' ||
              data0 === 'downloading' ||
              data0 === 'download queued' ||
              data0 === 'deleted' ||
              data0 === 'error' ||
              data0 === '404 Error' ||
              data0 === 'password required' ||
              data0 === 'too many pages' ||
              data0 === 'file too large' ||
              data0 === 'retrieve error' ||
              data0 === 'bad request' ||
              data0 === 'bad auth'
            )
          ) {
            validate100.errors = [
              {
                instancePath: instancePath + '/status',
                schemaPath: 'File.json#/definitions/FileStatus/enum',
                keyword: 'enum',
                params: { allowedValues: schema66.enum },
                message: 'must be equal to one of the allowed values',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.name !== undefined) {
            const _errs4 = errors;
            if (typeof data.name !== 'string') {
              validate100.errors = [
                {
                  instancePath: instancePath + '/name',
                  schemaPath: '#/properties/name/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs4 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.type !== undefined) {
              let data2 = data.type;
              const _errs6 = errors;
              if (typeof data2 !== 'string') {
                validate100.errors = [
                  {
                    instancePath: instancePath + '/type',
                    schemaPath: '#/definitions/SignerFileType/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              if (!(data2 === 'signer')) {
                validate100.errors = [
                  {
                    instancePath: instancePath + '/type',
                    schemaPath: '#/definitions/SignerFileType/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema122.enum },
                    message: 'must be equal to one of the allowed values',
                  },
                ];
                return false;
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.progress !== undefined) {
                let data3 = data.progress;
                const _errs9 = errors;
                if (!(typeof data3 == 'number' && isFinite(data3))) {
                  validate100.errors = [
                    {
                      instancePath: instancePath + '/progress',
                      schemaPath: '#/properties/progress/type',
                      keyword: 'type',
                      params: { type: 'number' },
                      message: 'must be number',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs9 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate100.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate100.errors = vErrors;
  return errors === 0;
}
function validate99(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="BulkSend.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (data.exampleFields === undefined && (missing0 = 'exampleFields')) {
        validate99.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'exampleFields' || key0 === 'signerFile')) {
            validate99.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.exampleFields !== undefined) {
            let data0 = data.exampleFields;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (Array.isArray(data0)) {
                var valid1 = true;
                const len0 = data0.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  const _errs4 = errors;
                  if (typeof data0[i0] !== 'string') {
                    validate99.errors = [
                      {
                        instancePath: instancePath + '/exampleFields/' + i0,
                        schemaPath: '#/properties/exampleFields/items/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid1 = _errs4 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate99.errors = [
                  {
                    instancePath: instancePath + '/exampleFields',
                    schemaPath: '#/properties/exampleFields/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                  },
                ];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.signerFile !== undefined) {
              let data2 = data.signerFile;
              const _errs6 = errors;
              const _errs7 = errors;
              let valid2 = false;
              let passing0 = null;
              const _errs8 = errors;
              if (
                !validate100(data2, {
                  instancePath: instancePath + '/signerFile',
                  parentData: data,
                  parentDataProperty: 'signerFile',
                  rootData,
                })
              ) {
                vErrors =
                  vErrors === null
                    ? validate100.errors
                    : vErrors.concat(validate100.errors);
                errors = vErrors.length;
              }
              var _valid0 = _errs8 === errors;
              if (_valid0) {
                valid2 = true;
                passing0 = 0;
              }
              const _errs9 = errors;
              if (data2 !== null) {
                const err0 = {
                  instancePath: instancePath + '/signerFile',
                  schemaPath: '#/properties/signerFile/oneOf/1/type',
                  keyword: 'type',
                  params: { type: 'null' },
                  message: 'must be null',
                };
                if (vErrors === null) {
                  vErrors = [err0];
                } else {
                  vErrors.push(err0);
                }
                errors++;
              }
              var _valid0 = _errs9 === errors;
              if (_valid0 && valid2) {
                valid2 = false;
                passing0 = [passing0, 1];
              } else {
                if (_valid0) {
                  valid2 = true;
                  passing0 = 1;
                }
              }
              if (!valid2) {
                const err1 = {
                  instancePath: instancePath + '/signerFile',
                  schemaPath: '#/properties/signerFile/oneOf',
                  keyword: 'oneOf',
                  params: { passingSchemas: passing0 },
                  message: 'must match exactly one schema in oneOf',
                };
                if (vErrors === null) {
                  vErrors = [err1];
                } else {
                  vErrors.push(err1);
                }
                errors++;
                validate99.errors = vErrors;
                return false;
              } else {
                errors = _errs7;
                if (vErrors !== null) {
                  if (_errs7) {
                    vErrors.length = _errs7;
                  } else {
                    vErrors = null;
                  }
                }
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate99.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate99.errors = vErrors;
  return errors === 0;
}
function validate48(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="RequestData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.files === undefined && (missing0 = 'files')) ||
        (data.editorData === undefined && (missing0 = 'editorData')) ||
        (data.recipients === undefined && (missing0 = 'recipients')) ||
        (data.ccs === undefined && (missing0 = 'ccs')) ||
        (data.templates === undefined && (missing0 = 'templates')) ||
        (data.bulkSend === undefined && (missing0 = 'bulkSend')) ||
        (data.title === undefined && (missing0 = 'title')) ||
        (data.message === undefined && (missing0 = 'message'))
      ) {
        validate48.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.files !== undefined) {
          let data0 = data.files;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                const _errs3 = errors;
                if (
                  !validate49(data0[i0], {
                    instancePath: instancePath + '/files/' + i0,
                    parentData: data0,
                    parentDataProperty: i0,
                    rootData,
                  })
                ) {
                  vErrors =
                    vErrors === null
                      ? validate49.errors
                      : vErrors.concat(validate49.errors);
                  errors = vErrors.length;
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate48.errors = [
                {
                  instancePath: instancePath + '/files',
                  schemaPath: '#/properties/files/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.editorData !== undefined) {
            const _errs4 = errors;
            if (
              !validate52(data.editorData, {
                instancePath: instancePath + '/editorData',
                parentData: data,
                parentDataProperty: 'editorData',
                rootData,
              })
            ) {
              vErrors =
                vErrors === null
                  ? validate52.errors
                  : vErrors.concat(validate52.errors);
              errors = vErrors.length;
            }
            var valid0 = _errs4 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.recipients !== undefined) {
              let data3 = data.recipients;
              const _errs5 = errors;
              if (errors === _errs5) {
                if (Array.isArray(data3)) {
                  var valid2 = true;
                  const len1 = data3.length;
                  for (let i1 = 0; i1 < len1; i1++) {
                    const _errs7 = errors;
                    if (
                      !validate70(data3[i1], {
                        instancePath: instancePath + '/recipients/' + i1,
                        parentData: data3,
                        parentDataProperty: i1,
                        rootData,
                      })
                    ) {
                      vErrors =
                        vErrors === null
                          ? validate70.errors
                          : vErrors.concat(validate70.errors);
                      errors = vErrors.length;
                    }
                    var valid2 = _errs7 === errors;
                    if (!valid2) {
                      break;
                    }
                  }
                } else {
                  validate48.errors = [
                    {
                      instancePath: instancePath + '/recipients',
                      schemaPath: '#/properties/recipients/type',
                      keyword: 'type',
                      params: { type: 'array' },
                      message: 'must be array',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.ccs !== undefined) {
                let data5 = data.ccs;
                const _errs8 = errors;
                if (errors === _errs8) {
                  if (Array.isArray(data5)) {
                    var valid3 = true;
                    const len2 = data5.length;
                    for (let i2 = 0; i2 < len2; i2++) {
                      let data6 = data5[i2];
                      const _errs10 = errors;
                      const _errs11 = errors;
                      let valid4 = false;
                      let passing0 = null;
                      const _errs12 = errors;
                      if (
                        !validate89(data6, {
                          instancePath: instancePath + '/ccs/' + i2,
                          parentData: data5,
                          parentDataProperty: i2,
                          rootData,
                        })
                      ) {
                        vErrors =
                          vErrors === null
                            ? validate89.errors
                            : vErrors.concat(validate89.errors);
                        errors = vErrors.length;
                      }
                      var _valid0 = _errs12 === errors;
                      if (_valid0) {
                        valid4 = true;
                        passing0 = 0;
                      }
                      const _errs13 = errors;
                      const _errs14 = errors;
                      if (errors === _errs14) {
                        if (
                          data6 &&
                          typeof data6 == 'object' &&
                          !Array.isArray(data6)
                        ) {
                          let missing1;
                          if (
                            (data6.type === undefined && (missing1 = 'type')) ||
                            (data6.id === undefined && (missing1 = 'id')) ||
                            (data6.name === undefined && (missing1 = 'name'))
                          ) {
                            const err0 = {
                              instancePath: instancePath + '/ccs/' + i2,
                              schemaPath:
                                'Recipient.json#/definitions/CCRole/required',
                              keyword: 'required',
                              params: { missingProperty: missing1 },
                              message:
                                "must have required property '" +
                                missing1 +
                                "'",
                            };
                            if (vErrors === null) {
                              vErrors = [err0];
                            } else {
                              vErrors.push(err0);
                            }
                            errors++;
                          } else {
                            const _errs16 = errors;
                            for (const key0 in data6) {
                              if (
                                !(
                                  key0 === 'type' ||
                                  key0 === 'id' ||
                                  key0 === 'name'
                                )
                              ) {
                                const err1 = {
                                  instancePath: instancePath + '/ccs/' + i2,
                                  schemaPath:
                                    'Recipient.json#/definitions/CCRole/additionalProperties',
                                  keyword: 'additionalProperties',
                                  params: { additionalProperty: key0 },
                                  message:
                                    'must NOT have additional properties',
                                };
                                if (vErrors === null) {
                                  vErrors = [err1];
                                } else {
                                  vErrors.push(err1);
                                }
                                errors++;
                                break;
                              }
                            }
                            if (_errs16 === errors) {
                              if (data6.type !== undefined) {
                                const _errs17 = errors;
                                if (!func0(data6.type, 'ccRole')) {
                                  const err2 = {
                                    instancePath:
                                      instancePath + '/ccs/' + i2 + '/type',
                                    schemaPath:
                                      'Recipient.json#/definitions/CCRole/properties/type/const',
                                    keyword: 'const',
                                    params: { allowedValue: 'ccRole' },
                                    message: 'must be equal to constant',
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err2];
                                  } else {
                                    vErrors.push(err2);
                                  }
                                  errors++;
                                }
                                var valid6 = _errs17 === errors;
                              } else {
                                var valid6 = true;
                              }
                              if (valid6) {
                                if (data6.id !== undefined) {
                                  const _errs18 = errors;
                                  if (typeof data6.id !== 'string') {
                                    const err3 = {
                                      instancePath:
                                        instancePath + '/ccs/' + i2 + '/id',
                                      schemaPath:
                                        'Recipient.json#/definitions/CCRole/properties/id/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err3];
                                    } else {
                                      vErrors.push(err3);
                                    }
                                    errors++;
                                  }
                                  var valid6 = _errs18 === errors;
                                } else {
                                  var valid6 = true;
                                }
                                if (valid6) {
                                  if (data6.name !== undefined) {
                                    const _errs20 = errors;
                                    if (typeof data6.name !== 'string') {
                                      const err4 = {
                                        instancePath:
                                          instancePath + '/ccs/' + i2 + '/name',
                                        schemaPath:
                                          'Recipient.json#/definitions/CCRole/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err4];
                                      } else {
                                        vErrors.push(err4);
                                      }
                                      errors++;
                                    }
                                    var valid6 = _errs20 === errors;
                                  } else {
                                    var valid6 = true;
                                  }
                                }
                              }
                            }
                          }
                        } else {
                          const err5 = {
                            instancePath: instancePath + '/ccs/' + i2,
                            schemaPath:
                              'Recipient.json#/definitions/CCRole/type',
                            keyword: 'type',
                            params: { type: 'object' },
                            message: 'must be object',
                          };
                          if (vErrors === null) {
                            vErrors = [err5];
                          } else {
                            vErrors.push(err5);
                          }
                          errors++;
                        }
                      }
                      var _valid0 = _errs13 === errors;
                      if (_valid0 && valid4) {
                        valid4 = false;
                        passing0 = [passing0, 1];
                      } else {
                        if (_valid0) {
                          valid4 = true;
                          passing0 = 1;
                        }
                      }
                      if (!valid4) {
                        const err6 = {
                          instancePath: instancePath + '/ccs/' + i2,
                          schemaPath: '#/properties/ccs/items/oneOf',
                          keyword: 'oneOf',
                          params: { passingSchemas: passing0 },
                          message: 'must match exactly one schema in oneOf',
                        };
                        if (vErrors === null) {
                          vErrors = [err6];
                        } else {
                          vErrors.push(err6);
                        }
                        errors++;
                        validate48.errors = vErrors;
                        return false;
                      } else {
                        errors = _errs11;
                        if (vErrors !== null) {
                          if (_errs11) {
                            vErrors.length = _errs11;
                          } else {
                            vErrors = null;
                          }
                        }
                      }
                      var valid3 = _errs10 === errors;
                      if (!valid3) {
                        break;
                      }
                    }
                  } else {
                    validate48.errors = [
                      {
                        instancePath: instancePath + '/ccs',
                        schemaPath: '#/properties/ccs/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.title !== undefined) {
                  const _errs22 = errors;
                  if (typeof data.title !== 'string') {
                    validate48.errors = [
                      {
                        instancePath: instancePath + '/title',
                        schemaPath: '#/properties/title/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs22 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.message !== undefined) {
                    const _errs24 = errors;
                    if (typeof data.message !== 'string') {
                      validate48.errors = [
                        {
                          instancePath: instancePath + '/message',
                          schemaPath: '#/properties/message/type',
                          keyword: 'type',
                          params: { type: 'string' },
                          message: 'must be string',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs24 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.expiresAt !== undefined) {
                      let data12 = data.expiresAt;
                      const _errs26 = errors;
                      if (errors === _errs26) {
                        if (errors === _errs26) {
                          if (typeof data12 === 'string') {
                            if (!formats0.validate(data12)) {
                              validate48.errors = [
                                {
                                  instancePath: instancePath + '/expiresAt',
                                  schemaPath: '#/properties/expiresAt/format',
                                  keyword: 'format',
                                  params: { format: 'date-time' },
                                  message:
                                    'must match format "' + 'date-time' + '"',
                                },
                              ];
                              return false;
                            }
                          } else {
                            validate48.errors = [
                              {
                                instancePath: instancePath + '/expiresAt',
                                schemaPath: '#/properties/expiresAt/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                        }
                      }
                      var valid0 = _errs26 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.templates !== undefined) {
                        let data13 = data.templates;
                        const _errs28 = errors;
                        if (errors === _errs28) {
                          if (Array.isArray(data13)) {
                            var valid7 = true;
                            const len3 = data13.length;
                            for (let i3 = 0; i3 < len3; i3++) {
                              const _errs30 = errors;
                              if (
                                !validate91(data13[i3], {
                                  instancePath:
                                    instancePath + '/templates/' + i3,
                                  parentData: data13,
                                  parentDataProperty: i3,
                                  rootData,
                                })
                              ) {
                                vErrors =
                                  vErrors === null
                                    ? validate91.errors
                                    : vErrors.concat(validate91.errors);
                                errors = vErrors.length;
                              }
                              var valid7 = _errs30 === errors;
                              if (!valid7) {
                                break;
                              }
                            }
                          } else {
                            validate48.errors = [
                              {
                                instancePath: instancePath + '/templates',
                                schemaPath: '#/properties/templates/type',
                                keyword: 'type',
                                params: { type: 'array' },
                                message: 'must be array',
                              },
                            ];
                            return false;
                          }
                        }
                        var valid0 = _errs28 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.coverPage !== undefined) {
                          let data15 = data.coverPage;
                          const _errs31 = errors;
                          const _errs32 = errors;
                          if (errors === _errs32) {
                            if (
                              data15 &&
                              typeof data15 == 'object' &&
                              !Array.isArray(data15)
                            ) {
                              let missing2;
                              if (
                                (data15.to === undefined &&
                                  (missing2 = 'to')) ||
                                (data15.from === undefined &&
                                  (missing2 = 'from')) ||
                                (data15.message === undefined &&
                                  (missing2 = 'message'))
                              ) {
                                validate48.errors = [
                                  {
                                    instancePath: instancePath + '/coverPage',
                                    schemaPath: 'CoverPage.json/required',
                                    keyword: 'required',
                                    params: { missingProperty: missing2 },
                                    message:
                                      "must have required property '" +
                                      missing2 +
                                      "'",
                                  },
                                ];
                                return false;
                              } else {
                                const _errs34 = errors;
                                for (const key1 in data15) {
                                  if (
                                    !(
                                      key1 === 'to' ||
                                      key1 === 'from' ||
                                      key1 === 'message'
                                    )
                                  ) {
                                    validate48.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/coverPage',
                                        schemaPath:
                                          'CoverPage.json/additionalProperties',
                                        keyword: 'additionalProperties',
                                        params: { additionalProperty: key1 },
                                        message:
                                          'must NOT have additional properties',
                                      },
                                    ];
                                    return false;
                                    break;
                                  }
                                }
                                if (_errs34 === errors) {
                                  if (data15.to !== undefined) {
                                    const _errs35 = errors;
                                    if (typeof data15.to !== 'string') {
                                      validate48.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/coverPage/to',
                                          schemaPath:
                                            'CoverPage.json/properties/to/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid9 = _errs35 === errors;
                                  } else {
                                    var valid9 = true;
                                  }
                                  if (valid9) {
                                    if (data15.from !== undefined) {
                                      const _errs37 = errors;
                                      if (typeof data15.from !== 'string') {
                                        validate48.errors = [
                                          {
                                            instancePath:
                                              instancePath + '/coverPage/from',
                                            schemaPath:
                                              'CoverPage.json/properties/from/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid9 = _errs37 === errors;
                                    } else {
                                      var valid9 = true;
                                    }
                                    if (valid9) {
                                      if (data15.message !== undefined) {
                                        const _errs39 = errors;
                                        if (
                                          typeof data15.message !== 'string'
                                        ) {
                                          validate48.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/coverPage/message',
                                              schemaPath:
                                                'CoverPage.json/properties/message/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid9 = _errs39 === errors;
                                      } else {
                                        var valid9 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            } else {
                              validate48.errors = [
                                {
                                  instancePath: instancePath + '/coverPage',
                                  schemaPath: 'CoverPage.json/type',
                                  keyword: 'type',
                                  params: { type: 'object' },
                                  message: 'must be object',
                                },
                              ];
                              return false;
                            }
                          }
                          var valid0 = _errs31 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.bulkSend !== undefined) {
                            const _errs41 = errors;
                            if (
                              !validate99(data.bulkSend, {
                                instancePath: instancePath + '/bulkSend',
                                parentData: data,
                                parentDataProperty: 'bulkSend',
                                rootData,
                              })
                            ) {
                              vErrors =
                                vErrors === null
                                  ? validate99.errors
                                  : vErrors.concat(validate99.errors);
                              errors = vErrors.length;
                            }
                            var valid0 = _errs41 === errors;
                          } else {
                            var valid0 = true;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate48.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate48.errors = vErrors;
  return errors === 0;
}
const schema123 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'EmbeddedData.json',
  type: 'object',
  title: 'EmbeddedData',
  properties: {
    docGuids: { type: 'array', items: { type: 'string' } },
    isEmbeddedRequest: { type: 'boolean' },
    isEmbeddedTemplate: {
      $comment: 'Is this embedded request creating a template?',
      type: 'boolean',
    },
    isGmail: { type: 'boolean' },
    skipMeNow: { type: 'boolean' },
    usingTemplate: {
      $comment: 'Is this embedded signature request using a template?',
      type: 'boolean',
    },
    isCreatedFromTemplate: { type: 'boolean' },
    parentUrl: { type: 'string' },
    redirectUrl: { type: 'string' },
    editedTemplateGuid: { type: ['string', 'null'] },
    isSelfSign: { type: 'boolean' },
    locale: { type: 'string' },
    appName: { type: 'string' },
    apiApp: { $ref: 'ApiApp.json' },
  },
  required: ['docGuids', 'usingTemplate', 'isSelfSign', 'locale', 'apiApp'],
};
const schema124 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'ApiApp.json',
  type: 'object',
  title: 'ApiApp',
  properties: { clientId: { type: 'string' }, parentUrl: { type: 'string' } },
  required: ['clientId'],
};
function validate104(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="EmbeddedData.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.docGuids === undefined && (missing0 = 'docGuids')) ||
        (data.usingTemplate === undefined && (missing0 = 'usingTemplate')) ||
        (data.isSelfSign === undefined && (missing0 = 'isSelfSign')) ||
        (data.locale === undefined && (missing0 = 'locale')) ||
        (data.apiApp === undefined && (missing0 = 'apiApp'))
      ) {
        validate104.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.docGuids !== undefined) {
          let data0 = data.docGuids;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                const _errs3 = errors;
                if (typeof data0[i0] !== 'string') {
                  validate104.errors = [
                    {
                      instancePath: instancePath + '/docGuids/' + i0,
                      schemaPath: '#/properties/docGuids/items/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate104.errors = [
                {
                  instancePath: instancePath + '/docGuids',
                  schemaPath: '#/properties/docGuids/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.isEmbeddedRequest !== undefined) {
            const _errs5 = errors;
            if (typeof data.isEmbeddedRequest !== 'boolean') {
              validate104.errors = [
                {
                  instancePath: instancePath + '/isEmbeddedRequest',
                  schemaPath: '#/properties/isEmbeddedRequest/type',
                  keyword: 'type',
                  params: { type: 'boolean' },
                  message: 'must be boolean',
                },
              ];
              return false;
            }
            var valid0 = _errs5 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.isEmbeddedTemplate !== undefined) {
              const _errs7 = errors;
              if (typeof data.isEmbeddedTemplate !== 'boolean') {
                validate104.errors = [
                  {
                    instancePath: instancePath + '/isEmbeddedTemplate',
                    schemaPath: '#/properties/isEmbeddedTemplate/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  },
                ];
                return false;
              }
              var valid0 = _errs7 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.isGmail !== undefined) {
                const _errs10 = errors;
                if (typeof data.isGmail !== 'boolean') {
                  validate104.errors = [
                    {
                      instancePath: instancePath + '/isGmail',
                      schemaPath: '#/properties/isGmail/type',
                      keyword: 'type',
                      params: { type: 'boolean' },
                      message: 'must be boolean',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs10 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.skipMeNow !== undefined) {
                  const _errs12 = errors;
                  if (typeof data.skipMeNow !== 'boolean') {
                    validate104.errors = [
                      {
                        instancePath: instancePath + '/skipMeNow',
                        schemaPath: '#/properties/skipMeNow/type',
                        keyword: 'type',
                        params: { type: 'boolean' },
                        message: 'must be boolean',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs12 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.usingTemplate !== undefined) {
                    const _errs14 = errors;
                    if (typeof data.usingTemplate !== 'boolean') {
                      validate104.errors = [
                        {
                          instancePath: instancePath + '/usingTemplate',
                          schemaPath: '#/properties/usingTemplate/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs14 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.isCreatedFromTemplate !== undefined) {
                      const _errs17 = errors;
                      if (typeof data.isCreatedFromTemplate !== 'boolean') {
                        validate104.errors = [
                          {
                            instancePath:
                              instancePath + '/isCreatedFromTemplate',
                            schemaPath:
                              '#/properties/isCreatedFromTemplate/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs17 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.parentUrl !== undefined) {
                        const _errs19 = errors;
                        if (typeof data.parentUrl !== 'string') {
                          validate104.errors = [
                            {
                              instancePath: instancePath + '/parentUrl',
                              schemaPath: '#/properties/parentUrl/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs19 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.redirectUrl !== undefined) {
                          const _errs21 = errors;
                          if (typeof data.redirectUrl !== 'string') {
                            validate104.errors = [
                              {
                                instancePath: instancePath + '/redirectUrl',
                                schemaPath: '#/properties/redirectUrl/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs21 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.editedTemplateGuid !== undefined) {
                            let data10 = data.editedTemplateGuid;
                            const _errs23 = errors;
                            if (typeof data10 !== 'string' && data10 !== null) {
                              validate104.errors = [
                                {
                                  instancePath:
                                    instancePath + '/editedTemplateGuid',
                                  schemaPath:
                                    '#/properties/editedTemplateGuid/type',
                                  keyword: 'type',
                                  params: {
                                    type: schema123.properties
                                      .editedTemplateGuid.type,
                                  },
                                  message: 'must be string,null',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs23 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.isSelfSign !== undefined) {
                              const _errs25 = errors;
                              if (typeof data.isSelfSign !== 'boolean') {
                                validate104.errors = [
                                  {
                                    instancePath: instancePath + '/isSelfSign',
                                    schemaPath: '#/properties/isSelfSign/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs25 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.locale !== undefined) {
                                const _errs27 = errors;
                                if (typeof data.locale !== 'string') {
                                  validate104.errors = [
                                    {
                                      instancePath: instancePath + '/locale',
                                      schemaPath: '#/properties/locale/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs27 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.appName !== undefined) {
                                  const _errs29 = errors;
                                  if (typeof data.appName !== 'string') {
                                    validate104.errors = [
                                      {
                                        instancePath: instancePath + '/appName',
                                        schemaPath: '#/properties/appName/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs29 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.apiApp !== undefined) {
                                    let data14 = data.apiApp;
                                    const _errs31 = errors;
                                    const _errs32 = errors;
                                    if (errors === _errs32) {
                                      if (
                                        data14 &&
                                        typeof data14 == 'object' &&
                                        !Array.isArray(data14)
                                      ) {
                                        let missing1;
                                        if (
                                          data14.clientId === undefined &&
                                          (missing1 = 'clientId')
                                        ) {
                                          validate104.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/apiApp',
                                              schemaPath:
                                                'ApiApp.json/required',
                                              keyword: 'required',
                                              params: {
                                                missingProperty: missing1,
                                              },
                                              message:
                                                "must have required property '" +
                                                missing1 +
                                                "'",
                                            },
                                          ];
                                          return false;
                                        } else {
                                          if (data14.clientId !== undefined) {
                                            const _errs34 = errors;
                                            if (
                                              typeof data14.clientId !==
                                              'string'
                                            ) {
                                              validate104.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/apiApp/clientId',
                                                  schemaPath:
                                                    'ApiApp.json/properties/clientId/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid3 = _errs34 === errors;
                                          } else {
                                            var valid3 = true;
                                          }
                                          if (valid3) {
                                            if (
                                              data14.parentUrl !== undefined
                                            ) {
                                              const _errs36 = errors;
                                              if (
                                                typeof data14.parentUrl !==
                                                'string'
                                              ) {
                                                validate104.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/apiApp/parentUrl',
                                                    schemaPath:
                                                      'ApiApp.json/properties/parentUrl/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid3 = _errs36 === errors;
                                            } else {
                                              var valid3 = true;
                                            }
                                          }
                                        }
                                      } else {
                                        validate104.errors = [
                                          {
                                            instancePath:
                                              instancePath + '/apiApp',
                                            schemaPath: 'ApiApp.json/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object',
                                          },
                                        ];
                                        return false;
                                      }
                                    }
                                    var valid0 = _errs31 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate104.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate104.errors = vErrors;
  return errors === 0;
}
const schema125 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'User.json',
  type: 'object',
  title: 'User',
  properties: {
    id: { type: 'number' },
    name: { type: 'string' },
    firstName: { type: 'string' },
    lastName: { type: 'string' },
    email: { type: 'string' },
    isPaidAccount: { type: 'boolean' },
    isConfirmedAccount: { type: 'boolean' },
    title: { type: 'string' },
    company: { type: 'string' },
    apiIdsEnabled: { type: 'boolean' },
    accountDateFormat: { $ref: '#/definitions/AccountDateFormat' },
    dbxUserId: { type: ['string', 'null'] },
  },
  required: [
    'email',
    'isPaidAccount',
    'isConfirmedAccount',
    'apiIdsEnabled',
    'accountDateFormat',
  ],
  definitions: {
    AccountDateFormat: {
      type: 'string',
      title: 'AccountDateFormat',
      description: 'Preferred date format on account settings',
      enum: [
        'MM / DD / YYYY',
        'MM - DD - YYYY',
        'DD / MM / YYYY',
        'DD - MM - YYYY',
        'YYYY / MM / DD',
        'YYYY - MM - DD',
      ],
      tsEnumNames: [
        'MMDDYYYYSeparatedBySlash',
        'MMDDYYYYSeparatedByHyphen',
        'DDMMYYYYSeparatedBySlash',
        'DDMMYYYYSeparatedByHyphen',
        'YYYYMMDDSeparatedBySlash',
        'YYYYMMDDSeparatedByHyphen',
      ],
      'x-enum-names': [
        'MMDDYYYYSeparatedBySlash',
        'MMDDYYYYSeparatedByHyphen',
        'DDMMYYYYSeparatedBySlash',
        'DDMMYYYYSeparatedByHyphen',
        'YYYYMMDDSeparatedBySlash',
        'YYYYMMDDSeparatedByHyphen',
      ],
    },
  },
};
const schema126 = {
  type: 'string',
  title: 'AccountDateFormat',
  description: 'Preferred date format on account settings',
  enum: [
    'MM / DD / YYYY',
    'MM - DD - YYYY',
    'DD / MM / YYYY',
    'DD - MM - YYYY',
    'YYYY / MM / DD',
    'YYYY - MM - DD',
  ],
  tsEnumNames: [
    'MMDDYYYYSeparatedBySlash',
    'MMDDYYYYSeparatedByHyphen',
    'DDMMYYYYSeparatedBySlash',
    'DDMMYYYYSeparatedByHyphen',
    'YYYYMMDDSeparatedBySlash',
    'YYYYMMDDSeparatedByHyphen',
  ],
  'x-enum-names': [
    'MMDDYYYYSeparatedBySlash',
    'MMDDYYYYSeparatedByHyphen',
    'DDMMYYYYSeparatedBySlash',
    'DDMMYYYYSeparatedByHyphen',
    'YYYYMMDDSeparatedBySlash',
    'YYYYMMDDSeparatedByHyphen',
  ],
};
function validate106(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="User.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.email === undefined && (missing0 = 'email')) ||
        (data.isPaidAccount === undefined && (missing0 = 'isPaidAccount')) ||
        (data.isConfirmedAccount === undefined &&
          (missing0 = 'isConfirmedAccount')) ||
        (data.apiIdsEnabled === undefined && (missing0 = 'apiIdsEnabled')) ||
        (data.accountDateFormat === undefined &&
          (missing0 = 'accountDateFormat'))
      ) {
        validate106.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.id !== undefined) {
          let data0 = data.id;
          const _errs1 = errors;
          if (!(typeof data0 == 'number' && isFinite(data0))) {
            validate106.errors = [
              {
                instancePath: instancePath + '/id',
                schemaPath: '#/properties/id/type',
                keyword: 'type',
                params: { type: 'number' },
                message: 'must be number',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.name !== undefined) {
            const _errs3 = errors;
            if (typeof data.name !== 'string') {
              validate106.errors = [
                {
                  instancePath: instancePath + '/name',
                  schemaPath: '#/properties/name/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.firstName !== undefined) {
              const _errs5 = errors;
              if (typeof data.firstName !== 'string') {
                validate106.errors = [
                  {
                    instancePath: instancePath + '/firstName',
                    schemaPath: '#/properties/firstName/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs5 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.lastName !== undefined) {
                const _errs7 = errors;
                if (typeof data.lastName !== 'string') {
                  validate106.errors = [
                    {
                      instancePath: instancePath + '/lastName',
                      schemaPath: '#/properties/lastName/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs7 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.email !== undefined) {
                  const _errs9 = errors;
                  if (typeof data.email !== 'string') {
                    validate106.errors = [
                      {
                        instancePath: instancePath + '/email',
                        schemaPath: '#/properties/email/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs9 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.isPaidAccount !== undefined) {
                    const _errs11 = errors;
                    if (typeof data.isPaidAccount !== 'boolean') {
                      validate106.errors = [
                        {
                          instancePath: instancePath + '/isPaidAccount',
                          schemaPath: '#/properties/isPaidAccount/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs11 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.isConfirmedAccount !== undefined) {
                      const _errs13 = errors;
                      if (typeof data.isConfirmedAccount !== 'boolean') {
                        validate106.errors = [
                          {
                            instancePath: instancePath + '/isConfirmedAccount',
                            schemaPath: '#/properties/isConfirmedAccount/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs13 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.title !== undefined) {
                        const _errs15 = errors;
                        if (typeof data.title !== 'string') {
                          validate106.errors = [
                            {
                              instancePath: instancePath + '/title',
                              schemaPath: '#/properties/title/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs15 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.company !== undefined) {
                          const _errs17 = errors;
                          if (typeof data.company !== 'string') {
                            validate106.errors = [
                              {
                                instancePath: instancePath + '/company',
                                schemaPath: '#/properties/company/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs17 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.apiIdsEnabled !== undefined) {
                            const _errs19 = errors;
                            if (typeof data.apiIdsEnabled !== 'boolean') {
                              validate106.errors = [
                                {
                                  instancePath: instancePath + '/apiIdsEnabled',
                                  schemaPath: '#/properties/apiIdsEnabled/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs19 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.accountDateFormat !== undefined) {
                              let data10 = data.accountDateFormat;
                              const _errs21 = errors;
                              if (typeof data10 !== 'string') {
                                validate106.errors = [
                                  {
                                    instancePath:
                                      instancePath + '/accountDateFormat',
                                    schemaPath:
                                      '#/definitions/AccountDateFormat/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              if (
                                !(
                                  data10 === 'MM / DD / YYYY' ||
                                  data10 === 'MM - DD - YYYY' ||
                                  data10 === 'DD / MM / YYYY' ||
                                  data10 === 'DD - MM - YYYY' ||
                                  data10 === 'YYYY / MM / DD' ||
                                  data10 === 'YYYY - MM - DD'
                                )
                              ) {
                                validate106.errors = [
                                  {
                                    instancePath:
                                      instancePath + '/accountDateFormat',
                                    schemaPath:
                                      '#/definitions/AccountDateFormat/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema126.enum },
                                    message:
                                      'must be equal to one of the allowed values',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs21 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.dbxUserId !== undefined) {
                                let data11 = data.dbxUserId;
                                const _errs24 = errors;
                                if (
                                  typeof data11 !== 'string' &&
                                  data11 !== null
                                ) {
                                  validate106.errors = [
                                    {
                                      instancePath: instancePath + '/dbxUserId',
                                      schemaPath: '#/properties/dbxUserId/type',
                                      keyword: 'type',
                                      params: {
                                        type: schema125.properties.dbxUserId
                                          .type,
                                      },
                                      message: 'must be string,null',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs24 === errors;
                              } else {
                                var valid0 = true;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate106.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate106.errors = vErrors;
  return errors === 0;
}
function validate11(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="PrepAndSendRequest.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.guid === undefined && (missing0 = 'guid')) ||
        (data.settings === undefined && (missing0 = 'settings')) ||
        (data.flags === undefined && (missing0 = 'flags')) ||
        (data.accountSettings === undefined &&
          (missing0 = 'accountSettings')) ||
        (data.user === undefined && (missing0 = 'user')) ||
        (data.options === undefined && (missing0 = 'options')) ||
        (data.requestData === undefined && (missing0 = 'requestData'))
      ) {
        validate11.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (
            !(
              key0 === 'guid' ||
              key0 === 'settings' ||
              key0 === 'options' ||
              key0 === 'flags' ||
              key0 === 'accountSettings' ||
              key0 === 'requestData' ||
              key0 === 'embeddedData' ||
              key0 === 'user'
            )
          ) {
            validate11.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.guid !== undefined) {
            const _errs2 = errors;
            if (typeof data.guid !== 'string') {
              validate11.errors = [
                {
                  instancePath: instancePath + '/guid',
                  schemaPath: '#/properties/guid/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.settings !== undefined) {
              let data1 = data.settings;
              const _errs4 = errors;
              const _errs5 = errors;
              if (errors === _errs5) {
                if (
                  data1 &&
                  typeof data1 == 'object' &&
                  !Array.isArray(data1)
                ) {
                  const _errs7 = errors;
                  for (const key1 in data1) {
                    if (!func4.call(schema13.properties, key1)) {
                      validate11.errors = [
                        {
                          instancePath: instancePath + '/settings',
                          schemaPath: 'Settings.json/additionalProperties',
                          keyword: 'additionalProperties',
                          params: { additionalProperty: key1 },
                          message: 'must NOT have additional properties',
                        },
                      ];
                      return false;
                      break;
                    }
                  }
                  if (_errs7 === errors) {
                    if (data1.addCoverPage !== undefined) {
                      const _errs8 = errors;
                      if (typeof data1.addCoverPage !== 'boolean') {
                        validate11.errors = [
                          {
                            instancePath:
                              instancePath + '/settings/addCoverPage',
                            schemaPath:
                              'Settings.json/properties/addCoverPage/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs8 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data1.recipientOrder !== undefined) {
                        const _errs10 = errors;
                        if (typeof data1.recipientOrder !== 'boolean') {
                          validate11.errors = [
                            {
                              instancePath:
                                instancePath + '/settings/recipientOrder',
                              schemaPath:
                                'Settings.json/properties/recipientOrder/type',
                              keyword: 'type',
                              params: { type: 'boolean' },
                              message: 'must be boolean',
                            },
                          ];
                          return false;
                        }
                        var valid2 = _errs10 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data1.qes !== undefined) {
                          const _errs12 = errors;
                          if (typeof data1.qes !== 'boolean') {
                            validate11.errors = [
                              {
                                instancePath: instancePath + '/settings/qes',
                                schemaPath: 'Settings.json/properties/qes/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid2 = _errs12 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data1.nom151 !== undefined) {
                            const _errs14 = errors;
                            if (typeof data1.nom151 !== 'boolean') {
                              validate11.errors = [
                                {
                                  instancePath:
                                    instancePath + '/settings/nom151',
                                  schemaPath:
                                    'Settings.json/properties/nom151/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid2 = _errs14 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data1.recipientReassignment !== undefined) {
                              const _errs16 = errors;
                              if (
                                typeof data1.recipientReassignment !== 'boolean'
                              ) {
                                validate11.errors = [
                                  {
                                    instancePath:
                                      instancePath +
                                      '/settings/recipientReassignment',
                                    schemaPath:
                                      'Settings.json/properties/recipientReassignment/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean',
                                  },
                                ];
                                return false;
                              }
                              var valid2 = _errs16 === errors;
                            } else {
                              var valid2 = true;
                            }
                            if (valid2) {
                              if (data1.requireSignerInfo !== undefined) {
                                const _errs18 = errors;
                                if (
                                  typeof data1.requireSignerInfo !== 'boolean'
                                ) {
                                  validate11.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/settings/requireSignerInfo',
                                      schemaPath:
                                        'Settings.json/properties/requireSignerInfo/type',
                                      keyword: 'type',
                                      params: { type: 'boolean' },
                                      message: 'must be boolean',
                                    },
                                  ];
                                  return false;
                                }
                                var valid2 = _errs18 === errors;
                              } else {
                                var valid2 = true;
                              }
                              if (valid2) {
                                if (data1.sendHighResFax !== undefined) {
                                  const _errs20 = errors;
                                  if (
                                    typeof data1.sendHighResFax !== 'boolean'
                                  ) {
                                    validate11.errors = [
                                      {
                                        instancePath:
                                          instancePath +
                                          '/settings/sendHighResFax',
                                        schemaPath:
                                          'Settings.json/properties/sendHighResFax/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid2 = _errs20 === errors;
                                } else {
                                  var valid2 = true;
                                }
                                if (valid2) {
                                  if (data1.needsCharge !== undefined) {
                                    const _errs22 = errors;
                                    if (
                                      typeof data1.needsCharge !== 'boolean'
                                    ) {
                                      validate11.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/settings/needsCharge',
                                          schemaPath:
                                            'Settings.json/properties/needsCharge/type',
                                          keyword: 'type',
                                          params: { type: 'boolean' },
                                          message: 'must be boolean',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid2 = _errs22 === errors;
                                  } else {
                                    var valid2 = true;
                                  }
                                  if (valid2) {
                                    if (data1.hasForm !== undefined) {
                                      const _errs24 = errors;
                                      if (typeof data1.hasForm !== 'boolean') {
                                        validate11.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/settings/hasForm',
                                            schemaPath:
                                              'Settings.json/properties/hasForm/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid2 = _errs24 === errors;
                                    } else {
                                      var valid2 = true;
                                    }
                                    if (valid2) {
                                      if (
                                        data1.mobileFriendlySigning !==
                                        undefined
                                      ) {
                                        const _errs26 = errors;
                                        if (
                                          typeof data1.mobileFriendlySigning !==
                                          'boolean'
                                        ) {
                                          validate11.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/settings/mobileFriendlySigning',
                                              schemaPath:
                                                'Settings.json/properties/mobileFriendlySigning/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid2 = _errs26 === errors;
                                      } else {
                                        var valid2 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                } else {
                  validate11.errors = [
                    {
                      instancePath: instancePath + '/settings',
                      schemaPath: 'Settings.json/type',
                      keyword: 'type',
                      params: { type: 'object' },
                      message: 'must be object',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.options !== undefined) {
                const _errs28 = errors;
                if (
                  !validate12(data.options, {
                    instancePath: instancePath + '/options',
                    parentData: data,
                    parentDataProperty: 'options',
                    rootData,
                  })
                ) {
                  vErrors =
                    vErrors === null
                      ? validate12.errors
                      : vErrors.concat(validate12.errors);
                  errors = vErrors.length;
                }
                var valid0 = _errs28 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.flags !== undefined) {
                  const _errs29 = errors;
                  if (
                    !validate32(data.flags, {
                      instancePath: instancePath + '/flags',
                      parentData: data,
                      parentDataProperty: 'flags',
                      rootData,
                    })
                  ) {
                    vErrors =
                      vErrors === null
                        ? validate32.errors
                        : vErrors.concat(validate32.errors);
                    errors = vErrors.length;
                  }
                  var valid0 = _errs29 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.accountSettings !== undefined) {
                    const _errs30 = errors;
                    if (
                      !validate44(data.accountSettings, {
                        instancePath: instancePath + '/accountSettings',
                        parentData: data,
                        parentDataProperty: 'accountSettings',
                        rootData,
                      })
                    ) {
                      vErrors =
                        vErrors === null
                          ? validate44.errors
                          : vErrors.concat(validate44.errors);
                      errors = vErrors.length;
                    }
                    var valid0 = _errs30 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.requestData !== undefined) {
                      const _errs31 = errors;
                      if (
                        !validate48(data.requestData, {
                          instancePath: instancePath + '/requestData',
                          parentData: data,
                          parentDataProperty: 'requestData',
                          rootData,
                        })
                      ) {
                        vErrors =
                          vErrors === null
                            ? validate48.errors
                            : vErrors.concat(validate48.errors);
                        errors = vErrors.length;
                      }
                      var valid0 = _errs31 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.embeddedData !== undefined) {
                        const _errs32 = errors;
                        if (
                          !validate104(data.embeddedData, {
                            instancePath: instancePath + '/embeddedData',
                            parentData: data,
                            parentDataProperty: 'embeddedData',
                            rootData,
                          })
                        ) {
                          vErrors =
                            vErrors === null
                              ? validate104.errors
                              : vErrors.concat(validate104.errors);
                          errors = vErrors.length;
                        }
                        var valid0 = _errs32 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.user !== undefined) {
                          const _errs33 = errors;
                          if (
                            !validate106(data.user, {
                              instancePath: instancePath + '/user',
                              parentData: data,
                              parentDataProperty: 'user',
                              rootData,
                            })
                          ) {
                            vErrors =
                              vErrors === null
                                ? validate106.errors
                                : vErrors.concat(validate106.errors);
                            errors = vErrors.length;
                          }
                          var valid0 = _errs33 === errors;
                        } else {
                          var valid0 = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate11.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate11.errors = vErrors;
  return errors === 0;
}
const schema127 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'SignerAppRequest.json',
  title: 'SignerAppRequest',
  type: 'object',
  additionalProperties: false,
  properties: {
    pages: { type: 'array', items: { $ref: 'Page.json' } },
    fields: {
      type: 'array',
      items: { $ref: 'Field.json#/definitions/SignerField' },
    },
    rules: { type: 'array', items: { $ref: 'Rule.json' } },
    signedData: {
      type: 'object',
      title: 'signedData',
      patternProperties: {
        '.*': {
          oneOf: [
            { $ref: '#/definitions/SignedSignableField' },
            { $ref: '#/definitions/SignedCheckableField' },
            { $ref: '#/definitions/SignedDefaultField' },
          ],
        },
      },
    },
  },
  required: ['pages', 'fields', 'rules'],
  definitions: {
    SignedSignableField: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['inputsignature', 'inputinitials'] },
        data: {
          type: 'object',
          properties: { guid: { type: 'string' } },
          required: ['guid'],
        },
      },
      required: ['type', 'data'],
    },
    SignedCheckableField: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['inputcheckmark', 'inputradiobutton'] },
        data: {
          type: 'object',
          properties: { checked: { type: 'boolean' } },
          required: ['checked'],
        },
      },
      required: ['type', 'data'],
    },
    SignedDefaultField: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['inputtextbox', 'inputdropdown'] },
        data: {
          type: 'object',
          properties: { value: { type: 'string' } },
          required: ['value'],
        },
      },
      required: ['type', 'data'],
    },
  },
};
const schema138 = {
  type: 'object',
  properties: {
    type: { type: 'string', enum: ['inputsignature', 'inputinitials'] },
    data: {
      type: 'object',
      properties: { guid: { type: 'string' } },
      required: ['guid'],
    },
  },
  required: ['type', 'data'],
};
const schema139 = {
  type: 'object',
  properties: {
    type: { type: 'string', enum: ['inputcheckmark', 'inputradiobutton'] },
    data: {
      type: 'object',
      properties: { checked: { type: 'boolean' } },
      required: ['checked'],
    },
  },
  required: ['type', 'data'],
};
const schema140 = {
  type: 'object',
  properties: {
    type: { type: 'string', enum: ['inputtextbox', 'inputdropdown'] },
    data: {
      type: 'object',
      properties: { value: { type: 'string' } },
      required: ['value'],
    },
  },
  required: ['type', 'data'],
};
const schema129 = {
  title: 'SignerField',
  type: 'object',
  properties: {
    type: { $ref: '#/definitions/FieldType' },
    pageIndex: { type: 'number' },
    id: { type: 'string' },
    apiId: { type: 'string' },
    documentId: { type: 'string' },
    x: { type: 'number' },
    y: { type: 'number' },
    width: { type: 'number' },
    height: { type: 'number' },
    required: { type: 'boolean' },
    readOnly: { type: 'boolean' },
    name: { type: 'string' },
    isAutoFill: { type: 'boolean' },
    autoFillValue: { type: 'string' },
    autoFillType: { $ref: '#/definitions/AutoFillType' },
    linkId: { type: 'string' },
    isDisabled: { type: 'boolean' },
    fontSize: { $ref: '#/definitions/FontSize' },
    originalFontSize: { $ref: '#/definitions/FontSize' },
    fontFamily: { $ref: '#/definitions/FontFamily' },
    value: { type: ['string', 'null'] },
    placeholder: { type: 'string' },
    masked: { type: 'boolean' },
    isEditableMergeField: { type: 'boolean' },
    lines: { type: 'string' },
    numLines: { type: 'number' },
    numCharsPerLine: { type: 'number' },
    lineHeight: { type: 'number' },
    validationType: { $ref: '#/definitions/ValidationType' },
    validationCustomRegex: { type: 'string' },
    validationCustomRegexFormatLabel: { type: 'string' },
    signature: { $ref: '#/definitions/Signature' },
    color: { $ref: '#/definitions/Color' },
    dateFormat: { $ref: '#/definitions/JSDateFormat' },
    checked: { type: 'boolean' },
    requirement: { type: 'string' },
    groupLabel: { type: 'string' },
    groupFormLabel: { type: 'string' },
    group: { type: 'string' },
    options: { type: 'array', items: { type: 'string' } },
    url: { type: 'string' },
    formLabel: { type: 'string' },
  },
};
const schema130 = {
  type: 'string',
  title: 'FieldType',
  enum: [
    'checkbox',
    'date',
    'initials',
    'signature',
    'text',
    'dropdown',
    'radiobutton',
    'hyperlink',
  ],
};
function validate110(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      if (data.type !== undefined) {
        let data0 = data.type;
        const _errs1 = errors;
        if (typeof data0 !== 'string') {
          validate110.errors = [
            {
              instancePath: instancePath + '/type',
              schemaPath: '#/definitions/FieldType/type',
              keyword: 'type',
              params: { type: 'string' },
              message: 'must be string',
            },
          ];
          return false;
        }
        if (
          !(
            data0 === 'checkbox' ||
            data0 === 'date' ||
            data0 === 'initials' ||
            data0 === 'signature' ||
            data0 === 'text' ||
            data0 === 'dropdown' ||
            data0 === 'radiobutton' ||
            data0 === 'hyperlink'
          )
        ) {
          validate110.errors = [
            {
              instancePath: instancePath + '/type',
              schemaPath: '#/definitions/FieldType/enum',
              keyword: 'enum',
              params: { allowedValues: schema130.enum },
              message: 'must be equal to one of the allowed values',
            },
          ];
          return false;
        }
        var valid0 = _errs1 === errors;
      } else {
        var valid0 = true;
      }
      if (valid0) {
        if (data.pageIndex !== undefined) {
          let data1 = data.pageIndex;
          const _errs4 = errors;
          if (!(typeof data1 == 'number' && isFinite(data1))) {
            validate110.errors = [
              {
                instancePath: instancePath + '/pageIndex',
                schemaPath: '#/properties/pageIndex/type',
                keyword: 'type',
                params: { type: 'number' },
                message: 'must be number',
              },
            ];
            return false;
          }
          var valid0 = _errs4 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.id !== undefined) {
            const _errs6 = errors;
            if (typeof data.id !== 'string') {
              validate110.errors = [
                {
                  instancePath: instancePath + '/id',
                  schemaPath: '#/properties/id/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs6 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.apiId !== undefined) {
              const _errs8 = errors;
              if (typeof data.apiId !== 'string') {
                validate110.errors = [
                  {
                    instancePath: instancePath + '/apiId',
                    schemaPath: '#/properties/apiId/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs8 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.documentId !== undefined) {
                const _errs10 = errors;
                if (typeof data.documentId !== 'string') {
                  validate110.errors = [
                    {
                      instancePath: instancePath + '/documentId',
                      schemaPath: '#/properties/documentId/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs10 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.x !== undefined) {
                  let data5 = data.x;
                  const _errs12 = errors;
                  if (!(typeof data5 == 'number' && isFinite(data5))) {
                    validate110.errors = [
                      {
                        instancePath: instancePath + '/x',
                        schemaPath: '#/properties/x/type',
                        keyword: 'type',
                        params: { type: 'number' },
                        message: 'must be number',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs12 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.y !== undefined) {
                    let data6 = data.y;
                    const _errs14 = errors;
                    if (!(typeof data6 == 'number' && isFinite(data6))) {
                      validate110.errors = [
                        {
                          instancePath: instancePath + '/y',
                          schemaPath: '#/properties/y/type',
                          keyword: 'type',
                          params: { type: 'number' },
                          message: 'must be number',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs14 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.width !== undefined) {
                      let data7 = data.width;
                      const _errs16 = errors;
                      if (!(typeof data7 == 'number' && isFinite(data7))) {
                        validate110.errors = [
                          {
                            instancePath: instancePath + '/width',
                            schemaPath: '#/properties/width/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs16 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.height !== undefined) {
                        let data8 = data.height;
                        const _errs18 = errors;
                        if (!(typeof data8 == 'number' && isFinite(data8))) {
                          validate110.errors = [
                            {
                              instancePath: instancePath + '/height',
                              schemaPath: '#/properties/height/type',
                              keyword: 'type',
                              params: { type: 'number' },
                              message: 'must be number',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs18 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.required !== undefined) {
                          const _errs20 = errors;
                          if (typeof data.required !== 'boolean') {
                            validate110.errors = [
                              {
                                instancePath: instancePath + '/required',
                                schemaPath: '#/properties/required/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs20 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.readOnly !== undefined) {
                            const _errs22 = errors;
                            if (typeof data.readOnly !== 'boolean') {
                              validate110.errors = [
                                {
                                  instancePath: instancePath + '/readOnly',
                                  schemaPath: '#/properties/readOnly/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs22 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.name !== undefined) {
                              const _errs24 = errors;
                              if (typeof data.name !== 'string') {
                                validate110.errors = [
                                  {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs24 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.isAutoFill !== undefined) {
                                const _errs26 = errors;
                                if (typeof data.isAutoFill !== 'boolean') {
                                  validate110.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/isAutoFill',
                                      schemaPath:
                                        '#/properties/isAutoFill/type',
                                      keyword: 'type',
                                      params: { type: 'boolean' },
                                      message: 'must be boolean',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs26 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.autoFillValue !== undefined) {
                                  const _errs28 = errors;
                                  if (typeof data.autoFillValue !== 'string') {
                                    validate110.errors = [
                                      {
                                        instancePath:
                                          instancePath + '/autoFillValue',
                                        schemaPath:
                                          '#/properties/autoFillValue/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs28 === errors;
                                } else {
                                  var valid0 = true;
                                }
                                if (valid0) {
                                  if (data.autoFillType !== undefined) {
                                    let data14 = data.autoFillType;
                                    const _errs30 = errors;
                                    if (typeof data14 !== 'string') {
                                      validate110.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/autoFillType',
                                          schemaPath:
                                            '#/definitions/AutoFillType/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        },
                                      ];
                                      return false;
                                    }
                                    if (
                                      !(
                                        data14 === 'name' ||
                                        data14 === 'lastName' ||
                                        data14 === 'firstName' ||
                                        data14 === 'company' ||
                                        data14 === 'email' ||
                                        data14 === 'emailOrPhoneNumber' ||
                                        data14 === 'title' ||
                                        data14 === 'none'
                                      )
                                    ) {
                                      validate110.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/autoFillType',
                                          schemaPath:
                                            '#/definitions/AutoFillType/enum',
                                          keyword: 'enum',
                                          params: {
                                            allowedValues: schema17.enum,
                                          },
                                          message:
                                            'must be equal to one of the allowed values',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid0 = _errs30 === errors;
                                  } else {
                                    var valid0 = true;
                                  }
                                  if (valid0) {
                                    if (data.linkId !== undefined) {
                                      const _errs33 = errors;
                                      if (typeof data.linkId !== 'string') {
                                        validate110.errors = [
                                          {
                                            instancePath:
                                              instancePath + '/linkId',
                                            schemaPath:
                                              '#/properties/linkId/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid0 = _errs33 === errors;
                                    } else {
                                      var valid0 = true;
                                    }
                                    if (valid0) {
                                      if (data.isDisabled !== undefined) {
                                        const _errs35 = errors;
                                        if (
                                          typeof data.isDisabled !== 'boolean'
                                        ) {
                                          validate110.errors = [
                                            {
                                              instancePath:
                                                instancePath + '/isDisabled',
                                              schemaPath:
                                                '#/properties/isDisabled/type',
                                              keyword: 'type',
                                              params: { type: 'boolean' },
                                              message: 'must be boolean',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid0 = _errs35 === errors;
                                      } else {
                                        var valid0 = true;
                                      }
                                      if (valid0) {
                                        if (data.fontSize !== undefined) {
                                          let data17 = data.fontSize;
                                          const _errs37 = errors;
                                          const _errs38 = errors;
                                          if (errors === _errs38) {
                                            if (
                                              typeof data17 == 'number' &&
                                              isFinite(data17)
                                            ) {
                                              if (
                                                data17 > 48 ||
                                                isNaN(data17)
                                              ) {
                                                validate110.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/fontSize',
                                                    schemaPath:
                                                      '#/definitions/FontSize/maximum',
                                                    keyword: 'maximum',
                                                    params: {
                                                      comparison: '<=',
                                                      limit: 48,
                                                    },
                                                    message: 'must be <= 48',
                                                  },
                                                ];
                                                return false;
                                              } else {
                                                if (
                                                  data17 < 7 ||
                                                  isNaN(data17)
                                                ) {
                                                  validate110.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/fontSize',
                                                      schemaPath:
                                                        '#/definitions/FontSize/minimum',
                                                      keyword: 'minimum',
                                                      params: {
                                                        comparison: '>=',
                                                        limit: 7,
                                                      },
                                                      message: 'must be >= 7',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                              }
                                            } else {
                                              validate110.errors = [
                                                {
                                                  instancePath:
                                                    instancePath + '/fontSize',
                                                  schemaPath:
                                                    '#/definitions/FontSize/type',
                                                  keyword: 'type',
                                                  params: { type: 'number' },
                                                  message: 'must be number',
                                                },
                                              ];
                                              return false;
                                            }
                                          }
                                          var valid0 = _errs37 === errors;
                                        } else {
                                          var valid0 = true;
                                        }
                                        if (valid0) {
                                          if (
                                            data.originalFontSize !== undefined
                                          ) {
                                            let data18 = data.originalFontSize;
                                            const _errs40 = errors;
                                            const _errs41 = errors;
                                            if (errors === _errs41) {
                                              if (
                                                typeof data18 == 'number' &&
                                                isFinite(data18)
                                              ) {
                                                if (
                                                  data18 > 48 ||
                                                  isNaN(data18)
                                                ) {
                                                  validate110.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/originalFontSize',
                                                      schemaPath:
                                                        '#/definitions/FontSize/maximum',
                                                      keyword: 'maximum',
                                                      params: {
                                                        comparison: '<=',
                                                        limit: 48,
                                                      },
                                                      message: 'must be <= 48',
                                                    },
                                                  ];
                                                  return false;
                                                } else {
                                                  if (
                                                    data18 < 7 ||
                                                    isNaN(data18)
                                                  ) {
                                                    validate110.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath +
                                                          '/originalFontSize',
                                                        schemaPath:
                                                          '#/definitions/FontSize/minimum',
                                                        keyword: 'minimum',
                                                        params: {
                                                          comparison: '>=',
                                                          limit: 7,
                                                        },
                                                        message: 'must be >= 7',
                                                      },
                                                    ];
                                                    return false;
                                                  }
                                                }
                                              } else {
                                                validate110.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/originalFontSize',
                                                    schemaPath:
                                                      '#/definitions/FontSize/type',
                                                    keyword: 'type',
                                                    params: { type: 'number' },
                                                    message: 'must be number',
                                                  },
                                                ];
                                                return false;
                                              }
                                            }
                                            var valid0 = _errs40 === errors;
                                          } else {
                                            var valid0 = true;
                                          }
                                          if (valid0) {
                                            if (data.fontFamily !== undefined) {
                                              let data19 = data.fontFamily;
                                              const _errs43 = errors;
                                              if (typeof data19 !== 'string') {
                                                validate110.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/fontFamily',
                                                    schemaPath:
                                                      '#/definitions/FontFamily/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                  },
                                                ];
                                                return false;
                                              }
                                              if (
                                                !(
                                                  data19 === 'helvetica' ||
                                                  data19 === 'arial' ||
                                                  data19 === 'calibri' ||
                                                  data19 === 'cambria' ||
                                                  data19 === 'courier' ||
                                                  data19 === 'georgia' ||
                                                  data19 === 'times' ||
                                                  data19 === 'trebuchet' ||
                                                  data19 === 'verdana' ||
                                                  data19 === 'notoSerif' ||
                                                  data19 === 'notoSans' ||
                                                  data19 === 'roboto' ||
                                                  data19 === 'robotoMono'
                                                )
                                              ) {
                                                validate110.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/fontFamily',
                                                    schemaPath:
                                                      '#/definitions/FontFamily/enum',
                                                    keyword: 'enum',
                                                    params: {
                                                      allowedValues:
                                                        schema20.enum,
                                                    },
                                                    message:
                                                      'must be equal to one of the allowed values',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid0 = _errs43 === errors;
                                            } else {
                                              var valid0 = true;
                                            }
                                            if (valid0) {
                                              if (data.value !== undefined) {
                                                let data20 = data.value;
                                                const _errs46 = errors;
                                                if (
                                                  typeof data20 !== 'string' &&
                                                  data20 !== null
                                                ) {
                                                  validate110.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath + '/value',
                                                      schemaPath:
                                                        '#/properties/value/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: schema129
                                                          .properties.value
                                                          .type,
                                                      },
                                                      message:
                                                        'must be string,null',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid0 = _errs46 === errors;
                                              } else {
                                                var valid0 = true;
                                              }
                                              if (valid0) {
                                                if (
                                                  data.placeholder !== undefined
                                                ) {
                                                  const _errs48 = errors;
                                                  if (
                                                    typeof data.placeholder !==
                                                    'string'
                                                  ) {
                                                    validate110.errors = [
                                                      {
                                                        instancePath:
                                                          instancePath +
                                                          '/placeholder',
                                                        schemaPath:
                                                          '#/properties/placeholder/type',
                                                        keyword: 'type',
                                                        params: {
                                                          type: 'string',
                                                        },
                                                        message:
                                                          'must be string',
                                                      },
                                                    ];
                                                    return false;
                                                  }
                                                  var valid0 =
                                                    _errs48 === errors;
                                                } else {
                                                  var valid0 = true;
                                                }
                                                if (valid0) {
                                                  if (
                                                    data.masked !== undefined
                                                  ) {
                                                    const _errs50 = errors;
                                                    if (
                                                      typeof data.masked !==
                                                      'boolean'
                                                    ) {
                                                      validate110.errors = [
                                                        {
                                                          instancePath:
                                                            instancePath +
                                                            '/masked',
                                                          schemaPath:
                                                            '#/properties/masked/type',
                                                          keyword: 'type',
                                                          params: {
                                                            type: 'boolean',
                                                          },
                                                          message:
                                                            'must be boolean',
                                                        },
                                                      ];
                                                      return false;
                                                    }
                                                    var valid0 =
                                                      _errs50 === errors;
                                                  } else {
                                                    var valid0 = true;
                                                  }
                                                  if (valid0) {
                                                    if (
                                                      data.isEditableMergeField !==
                                                      undefined
                                                    ) {
                                                      const _errs52 = errors;
                                                      if (
                                                        typeof data.isEditableMergeField !==
                                                        'boolean'
                                                      ) {
                                                        validate110.errors = [
                                                          {
                                                            instancePath:
                                                              instancePath +
                                                              '/isEditableMergeField',
                                                            schemaPath:
                                                              '#/properties/isEditableMergeField/type',
                                                            keyword: 'type',
                                                            params: {
                                                              type: 'boolean',
                                                            },
                                                            message:
                                                              'must be boolean',
                                                          },
                                                        ];
                                                        return false;
                                                      }
                                                      var valid0 =
                                                        _errs52 === errors;
                                                    } else {
                                                      var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                      if (
                                                        data.lines !== undefined
                                                      ) {
                                                        const _errs54 = errors;
                                                        if (
                                                          typeof data.lines !==
                                                          'string'
                                                        ) {
                                                          validate110.errors = [
                                                            {
                                                              instancePath:
                                                                instancePath +
                                                                '/lines',
                                                              schemaPath:
                                                                '#/properties/lines/type',
                                                              keyword: 'type',
                                                              params: {
                                                                type: 'string',
                                                              },
                                                              message:
                                                                'must be string',
                                                            },
                                                          ];
                                                          return false;
                                                        }
                                                        var valid0 =
                                                          _errs54 === errors;
                                                      } else {
                                                        var valid0 = true;
                                                      }
                                                      if (valid0) {
                                                        if (
                                                          data.numLines !==
                                                          undefined
                                                        ) {
                                                          let data25 =
                                                            data.numLines;
                                                          const _errs56 =
                                                            errors;
                                                          if (
                                                            !(
                                                              typeof data25 ==
                                                                'number' &&
                                                              isFinite(data25)
                                                            )
                                                          ) {
                                                            validate110.errors =
                                                              [
                                                                {
                                                                  instancePath:
                                                                    instancePath +
                                                                    '/numLines',
                                                                  schemaPath:
                                                                    '#/properties/numLines/type',
                                                                  keyword:
                                                                    'type',
                                                                  params: {
                                                                    type: 'number',
                                                                  },
                                                                  message:
                                                                    'must be number',
                                                                },
                                                              ];
                                                            return false;
                                                          }
                                                          var valid0 =
                                                            _errs56 === errors;
                                                        } else {
                                                          var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                          if (
                                                            data.numCharsPerLine !==
                                                            undefined
                                                          ) {
                                                            let data26 =
                                                              data.numCharsPerLine;
                                                            const _errs58 =
                                                              errors;
                                                            if (
                                                              !(
                                                                typeof data26 ==
                                                                  'number' &&
                                                                isFinite(data26)
                                                              )
                                                            ) {
                                                              validate110.errors =
                                                                [
                                                                  {
                                                                    instancePath:
                                                                      instancePath +
                                                                      '/numCharsPerLine',
                                                                    schemaPath:
                                                                      '#/properties/numCharsPerLine/type',
                                                                    keyword:
                                                                      'type',
                                                                    params: {
                                                                      type: 'number',
                                                                    },
                                                                    message:
                                                                      'must be number',
                                                                  },
                                                                ];
                                                              return false;
                                                            }
                                                            var valid0 =
                                                              _errs58 ===
                                                              errors;
                                                          } else {
                                                            var valid0 = true;
                                                          }
                                                          if (valid0) {
                                                            if (
                                                              data.lineHeight !==
                                                              undefined
                                                            ) {
                                                              let data27 =
                                                                data.lineHeight;
                                                              const _errs60 =
                                                                errors;
                                                              if (
                                                                !(
                                                                  typeof data27 ==
                                                                    'number' &&
                                                                  isFinite(
                                                                    data27,
                                                                  )
                                                                )
                                                              ) {
                                                                validate110.errors =
                                                                  [
                                                                    {
                                                                      instancePath:
                                                                        instancePath +
                                                                        '/lineHeight',
                                                                      schemaPath:
                                                                        '#/properties/lineHeight/type',
                                                                      keyword:
                                                                        'type',
                                                                      params: {
                                                                        type: 'number',
                                                                      },
                                                                      message:
                                                                        'must be number',
                                                                    },
                                                                  ];
                                                                return false;
                                                              }
                                                              var valid0 =
                                                                _errs60 ===
                                                                errors;
                                                            } else {
                                                              var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                              if (
                                                                data.validationType !==
                                                                undefined
                                                              ) {
                                                                let data28 =
                                                                  data.validationType;
                                                                const _errs62 =
                                                                  errors;
                                                                if (
                                                                  typeof data28 !==
                                                                  'string'
                                                                ) {
                                                                  validate110.errors =
                                                                    [
                                                                      {
                                                                        instancePath:
                                                                          instancePath +
                                                                          '/validationType',
                                                                        schemaPath:
                                                                          '#/definitions/ValidationType/type',
                                                                        keyword:
                                                                          'type',
                                                                        params:
                                                                          {
                                                                            type: 'string',
                                                                          },
                                                                        message:
                                                                          'must be string',
                                                                      },
                                                                    ];
                                                                  return false;
                                                                }
                                                                if (
                                                                  !(
                                                                    data28 ===
                                                                      'numbers_only' ||
                                                                    data28 ===
                                                                      'letters_only' ||
                                                                    data28 ===
                                                                      'phone_number' ||
                                                                    data28 ===
                                                                      'bank_routing_number' ||
                                                                    data28 ===
                                                                      'bank_account_number' ||
                                                                    data28 ===
                                                                      'email_address' ||
                                                                    data28 ===
                                                                      'zip_code' ||
                                                                    data28 ===
                                                                      'social_security_number' ||
                                                                    data28 ===
                                                                      'employer_identification_number' ||
                                                                    data28 ===
                                                                      'custom_regex'
                                                                  )
                                                                ) {
                                                                  validate110.errors =
                                                                    [
                                                                      {
                                                                        instancePath:
                                                                          instancePath +
                                                                          '/validationType',
                                                                        schemaPath:
                                                                          '#/definitions/ValidationType/enum',
                                                                        keyword:
                                                                          'enum',
                                                                        params:
                                                                          {
                                                                            allowedValues:
                                                                              schema22.enum,
                                                                          },
                                                                        message:
                                                                          'must be equal to one of the allowed values',
                                                                      },
                                                                    ];
                                                                  return false;
                                                                }
                                                                var valid0 =
                                                                  _errs62 ===
                                                                  errors;
                                                              } else {
                                                                var valid0 = true;
                                                              }
                                                              if (valid0) {
                                                                if (
                                                                  data.validationCustomRegex !==
                                                                  undefined
                                                                ) {
                                                                  const _errs65 =
                                                                    errors;
                                                                  if (
                                                                    typeof data.validationCustomRegex !==
                                                                    'string'
                                                                  ) {
                                                                    validate110.errors =
                                                                      [
                                                                        {
                                                                          instancePath:
                                                                            instancePath +
                                                                            '/validationCustomRegex',
                                                                          schemaPath:
                                                                            '#/properties/validationCustomRegex/type',
                                                                          keyword:
                                                                            'type',
                                                                          params:
                                                                            {
                                                                              type: 'string',
                                                                            },
                                                                          message:
                                                                            'must be string',
                                                                        },
                                                                      ];
                                                                    return false;
                                                                  }
                                                                  var valid0 =
                                                                    _errs65 ===
                                                                    errors;
                                                                } else {
                                                                  var valid0 = true;
                                                                }
                                                                if (valid0) {
                                                                  if (
                                                                    data.validationCustomRegexFormatLabel !==
                                                                    undefined
                                                                  ) {
                                                                    const _errs67 =
                                                                      errors;
                                                                    if (
                                                                      typeof data.validationCustomRegexFormatLabel !==
                                                                      'string'
                                                                    ) {
                                                                      validate110.errors =
                                                                        [
                                                                          {
                                                                            instancePath:
                                                                              instancePath +
                                                                              '/validationCustomRegexFormatLabel',
                                                                            schemaPath:
                                                                              '#/properties/validationCustomRegexFormatLabel/type',
                                                                            keyword:
                                                                              'type',
                                                                            params:
                                                                              {
                                                                                type: 'string',
                                                                              },
                                                                            message:
                                                                              'must be string',
                                                                          },
                                                                        ];
                                                                      return false;
                                                                    }
                                                                    var valid0 =
                                                                      _errs67 ===
                                                                      errors;
                                                                  } else {
                                                                    var valid0 = true;
                                                                  }
                                                                  if (valid0) {
                                                                    if (
                                                                      data.signature !==
                                                                      undefined
                                                                    ) {
                                                                      const _errs69 =
                                                                        errors;
                                                                      if (
                                                                        !validate17(
                                                                          data.signature,
                                                                          {
                                                                            instancePath:
                                                                              instancePath +
                                                                              '/signature',
                                                                            parentData:
                                                                              data,
                                                                            parentDataProperty:
                                                                              'signature',
                                                                            rootData,
                                                                          },
                                                                        )
                                                                      ) {
                                                                        vErrors =
                                                                          vErrors ===
                                                                          null
                                                                            ? validate17.errors
                                                                            : vErrors.concat(
                                                                                validate17.errors,
                                                                              );
                                                                        errors =
                                                                          vErrors.length;
                                                                      }
                                                                      var valid0 =
                                                                        _errs69 ===
                                                                        errors;
                                                                    } else {
                                                                      var valid0 = true;
                                                                    }
                                                                    if (
                                                                      valid0
                                                                    ) {
                                                                      if (
                                                                        data.color !==
                                                                        undefined
                                                                      ) {
                                                                        let data32 =
                                                                          data.color;
                                                                        const _errs70 =
                                                                          errors;
                                                                        if (
                                                                          typeof data32 !==
                                                                          'string'
                                                                        ) {
                                                                          validate110.errors =
                                                                            [
                                                                              {
                                                                                instancePath:
                                                                                  instancePath +
                                                                                  '/color',
                                                                                schemaPath:
                                                                                  '#/definitions/Color/type',
                                                                                keyword:
                                                                                  'type',
                                                                                params:
                                                                                  {
                                                                                    type: 'string',
                                                                                  },
                                                                                message:
                                                                                  'must be string',
                                                                              },
                                                                            ];
                                                                          return false;
                                                                        }
                                                                        if (
                                                                          !(
                                                                            data32 ===
                                                                              'black' ||
                                                                            data32 ===
                                                                              'blue' ||
                                                                            data32 ===
                                                                              'red'
                                                                          )
                                                                        ) {
                                                                          validate110.errors =
                                                                            [
                                                                              {
                                                                                instancePath:
                                                                                  instancePath +
                                                                                  '/color',
                                                                                schemaPath:
                                                                                  '#/definitions/Color/enum',
                                                                                keyword:
                                                                                  'enum',
                                                                                params:
                                                                                  {
                                                                                    allowedValues:
                                                                                      schema27.enum,
                                                                                  },
                                                                                message:
                                                                                  'must be equal to one of the allowed values',
                                                                              },
                                                                            ];
                                                                          return false;
                                                                        }
                                                                        var valid0 =
                                                                          _errs70 ===
                                                                          errors;
                                                                      } else {
                                                                        var valid0 = true;
                                                                      }
                                                                      if (
                                                                        valid0
                                                                      ) {
                                                                        if (
                                                                          data.dateFormat !==
                                                                          undefined
                                                                        ) {
                                                                          let data33 =
                                                                            data.dateFormat;
                                                                          const _errs73 =
                                                                            errors;
                                                                          if (
                                                                            typeof data33 !==
                                                                            'string'
                                                                          ) {
                                                                            validate110.errors =
                                                                              [
                                                                                {
                                                                                  instancePath:
                                                                                    instancePath +
                                                                                    '/dateFormat',
                                                                                  schemaPath:
                                                                                    '#/definitions/JSDateFormat/type',
                                                                                  keyword:
                                                                                    'type',
                                                                                  params:
                                                                                    {
                                                                                      type: 'string',
                                                                                    },
                                                                                  message:
                                                                                    'must be string',
                                                                                },
                                                                              ];
                                                                            return false;
                                                                          }
                                                                          if (
                                                                            !(
                                                                              data33 ===
                                                                                'default' ||
                                                                              data33 ===
                                                                                'MM / DD / YYYY' ||
                                                                              data33 ===
                                                                                'MM - DD - YYYY' ||
                                                                              data33 ===
                                                                                'DD / MM / YYYY' ||
                                                                              data33 ===
                                                                                'DD - MM - YYYY' ||
                                                                              data33 ===
                                                                                'YYYY / MM / DD' ||
                                                                              data33 ===
                                                                                'YYYY - MM - DD'
                                                                            )
                                                                          ) {
                                                                            validate110.errors =
                                                                              [
                                                                                {
                                                                                  instancePath:
                                                                                    instancePath +
                                                                                    '/dateFormat',
                                                                                  schemaPath:
                                                                                    '#/definitions/JSDateFormat/enum',
                                                                                  keyword:
                                                                                    'enum',
                                                                                  params:
                                                                                    {
                                                                                      allowedValues:
                                                                                        schema34.enum,
                                                                                    },
                                                                                  message:
                                                                                    'must be equal to one of the allowed values',
                                                                                },
                                                                              ];
                                                                            return false;
                                                                          }
                                                                          var valid0 =
                                                                            _errs73 ===
                                                                            errors;
                                                                        } else {
                                                                          var valid0 = true;
                                                                        }
                                                                        if (
                                                                          valid0
                                                                        ) {
                                                                          if (
                                                                            data.checked !==
                                                                            undefined
                                                                          ) {
                                                                            const _errs76 =
                                                                              errors;
                                                                            if (
                                                                              typeof data.checked !==
                                                                              'boolean'
                                                                            ) {
                                                                              validate110.errors =
                                                                                [
                                                                                  {
                                                                                    instancePath:
                                                                                      instancePath +
                                                                                      '/checked',
                                                                                    schemaPath:
                                                                                      '#/properties/checked/type',
                                                                                    keyword:
                                                                                      'type',
                                                                                    params:
                                                                                      {
                                                                                        type: 'boolean',
                                                                                      },
                                                                                    message:
                                                                                      'must be boolean',
                                                                                  },
                                                                                ];
                                                                              return false;
                                                                            }
                                                                            var valid0 =
                                                                              _errs76 ===
                                                                              errors;
                                                                          } else {
                                                                            var valid0 = true;
                                                                          }
                                                                          if (
                                                                            valid0
                                                                          ) {
                                                                            if (
                                                                              data.requirement !==
                                                                              undefined
                                                                            ) {
                                                                              const _errs78 =
                                                                                errors;
                                                                              if (
                                                                                typeof data.requirement !==
                                                                                'string'
                                                                              ) {
                                                                                validate110.errors =
                                                                                  [
                                                                                    {
                                                                                      instancePath:
                                                                                        instancePath +
                                                                                        '/requirement',
                                                                                      schemaPath:
                                                                                        '#/properties/requirement/type',
                                                                                      keyword:
                                                                                        'type',
                                                                                      params:
                                                                                        {
                                                                                          type: 'string',
                                                                                        },
                                                                                      message:
                                                                                        'must be string',
                                                                                    },
                                                                                  ];
                                                                                return false;
                                                                              }
                                                                              var valid0 =
                                                                                _errs78 ===
                                                                                errors;
                                                                            } else {
                                                                              var valid0 = true;
                                                                            }
                                                                            if (
                                                                              valid0
                                                                            ) {
                                                                              if (
                                                                                data.groupLabel !==
                                                                                undefined
                                                                              ) {
                                                                                const _errs80 =
                                                                                  errors;
                                                                                if (
                                                                                  typeof data.groupLabel !==
                                                                                  'string'
                                                                                ) {
                                                                                  validate110.errors =
                                                                                    [
                                                                                      {
                                                                                        instancePath:
                                                                                          instancePath +
                                                                                          '/groupLabel',
                                                                                        schemaPath:
                                                                                          '#/properties/groupLabel/type',
                                                                                        keyword:
                                                                                          'type',
                                                                                        params:
                                                                                          {
                                                                                            type: 'string',
                                                                                          },
                                                                                        message:
                                                                                          'must be string',
                                                                                      },
                                                                                    ];
                                                                                  return false;
                                                                                }
                                                                                var valid0 =
                                                                                  _errs80 ===
                                                                                  errors;
                                                                              } else {
                                                                                var valid0 = true;
                                                                              }
                                                                              if (
                                                                                valid0
                                                                              ) {
                                                                                if (
                                                                                  data.groupFormLabel !==
                                                                                  undefined
                                                                                ) {
                                                                                  const _errs82 =
                                                                                    errors;
                                                                                  if (
                                                                                    typeof data.groupFormLabel !==
                                                                                    'string'
                                                                                  ) {
                                                                                    validate110.errors =
                                                                                      [
                                                                                        {
                                                                                          instancePath:
                                                                                            instancePath +
                                                                                            '/groupFormLabel',
                                                                                          schemaPath:
                                                                                            '#/properties/groupFormLabel/type',
                                                                                          keyword:
                                                                                            'type',
                                                                                          params:
                                                                                            {
                                                                                              type: 'string',
                                                                                            },
                                                                                          message:
                                                                                            'must be string',
                                                                                        },
                                                                                      ];
                                                                                    return false;
                                                                                  }
                                                                                  var valid0 =
                                                                                    _errs82 ===
                                                                                    errors;
                                                                                } else {
                                                                                  var valid0 = true;
                                                                                }
                                                                                if (
                                                                                  valid0
                                                                                ) {
                                                                                  if (
                                                                                    data.group !==
                                                                                    undefined
                                                                                  ) {
                                                                                    const _errs84 =
                                                                                      errors;
                                                                                    if (
                                                                                      typeof data.group !==
                                                                                      'string'
                                                                                    ) {
                                                                                      validate110.errors =
                                                                                        [
                                                                                          {
                                                                                            instancePath:
                                                                                              instancePath +
                                                                                              '/group',
                                                                                            schemaPath:
                                                                                              '#/properties/group/type',
                                                                                            keyword:
                                                                                              'type',
                                                                                            params:
                                                                                              {
                                                                                                type: 'string',
                                                                                              },
                                                                                            message:
                                                                                              'must be string',
                                                                                          },
                                                                                        ];
                                                                                      return false;
                                                                                    }
                                                                                    var valid0 =
                                                                                      _errs84 ===
                                                                                      errors;
                                                                                  } else {
                                                                                    var valid0 = true;
                                                                                  }
                                                                                  if (
                                                                                    valid0
                                                                                  ) {
                                                                                    if (
                                                                                      data.options !==
                                                                                      undefined
                                                                                    ) {
                                                                                      let data39 =
                                                                                        data.options;
                                                                                      const _errs86 =
                                                                                        errors;
                                                                                      if (
                                                                                        errors ===
                                                                                        _errs86
                                                                                      ) {
                                                                                        if (
                                                                                          Array.isArray(
                                                                                            data39,
                                                                                          )
                                                                                        ) {
                                                                                          var valid9 = true;
                                                                                          const len0 =
                                                                                            data39.length;
                                                                                          for (
                                                                                            let i0 = 0;
                                                                                            i0 <
                                                                                            len0;
                                                                                            i0++
                                                                                          ) {
                                                                                            const _errs88 =
                                                                                              errors;
                                                                                            if (
                                                                                              typeof data39[
                                                                                                i0
                                                                                              ] !==
                                                                                              'string'
                                                                                            ) {
                                                                                              validate110.errors =
                                                                                                [
                                                                                                  {
                                                                                                    instancePath:
                                                                                                      instancePath +
                                                                                                      '/options/' +
                                                                                                      i0,
                                                                                                    schemaPath:
                                                                                                      '#/properties/options/items/type',
                                                                                                    keyword:
                                                                                                      'type',
                                                                                                    params:
                                                                                                      {
                                                                                                        type: 'string',
                                                                                                      },
                                                                                                    message:
                                                                                                      'must be string',
                                                                                                  },
                                                                                                ];
                                                                                              return false;
                                                                                            }
                                                                                            var valid9 =
                                                                                              _errs88 ===
                                                                                              errors;
                                                                                            if (
                                                                                              !valid9
                                                                                            ) {
                                                                                              break;
                                                                                            }
                                                                                          }
                                                                                        } else {
                                                                                          validate110.errors =
                                                                                            [
                                                                                              {
                                                                                                instancePath:
                                                                                                  instancePath +
                                                                                                  '/options',
                                                                                                schemaPath:
                                                                                                  '#/properties/options/type',
                                                                                                keyword:
                                                                                                  'type',
                                                                                                params:
                                                                                                  {
                                                                                                    type: 'array',
                                                                                                  },
                                                                                                message:
                                                                                                  'must be array',
                                                                                              },
                                                                                            ];
                                                                                          return false;
                                                                                        }
                                                                                      }
                                                                                      var valid0 =
                                                                                        _errs86 ===
                                                                                        errors;
                                                                                    } else {
                                                                                      var valid0 = true;
                                                                                    }
                                                                                    if (
                                                                                      valid0
                                                                                    ) {
                                                                                      if (
                                                                                        data.url !==
                                                                                        undefined
                                                                                      ) {
                                                                                        const _errs90 =
                                                                                          errors;
                                                                                        if (
                                                                                          typeof data.url !==
                                                                                          'string'
                                                                                        ) {
                                                                                          validate110.errors =
                                                                                            [
                                                                                              {
                                                                                                instancePath:
                                                                                                  instancePath +
                                                                                                  '/url',
                                                                                                schemaPath:
                                                                                                  '#/properties/url/type',
                                                                                                keyword:
                                                                                                  'type',
                                                                                                params:
                                                                                                  {
                                                                                                    type: 'string',
                                                                                                  },
                                                                                                message:
                                                                                                  'must be string',
                                                                                              },
                                                                                            ];
                                                                                          return false;
                                                                                        }
                                                                                        var valid0 =
                                                                                          _errs90 ===
                                                                                          errors;
                                                                                      } else {
                                                                                        var valid0 = true;
                                                                                      }
                                                                                      if (
                                                                                        valid0
                                                                                      ) {
                                                                                        if (
                                                                                          data.formLabel !==
                                                                                          undefined
                                                                                        ) {
                                                                                          const _errs92 =
                                                                                            errors;
                                                                                          if (
                                                                                            typeof data.formLabel !==
                                                                                            'string'
                                                                                          ) {
                                                                                            validate110.errors =
                                                                                              [
                                                                                                {
                                                                                                  instancePath:
                                                                                                    instancePath +
                                                                                                    '/formLabel',
                                                                                                  schemaPath:
                                                                                                    '#/properties/formLabel/type',
                                                                                                  keyword:
                                                                                                    'type',
                                                                                                  params:
                                                                                                    {
                                                                                                      type: 'string',
                                                                                                    },
                                                                                                  message:
                                                                                                    'must be string',
                                                                                                },
                                                                                              ];
                                                                                            return false;
                                                                                          }
                                                                                          var valid0 =
                                                                                            _errs92 ===
                                                                                            errors;
                                                                                        } else {
                                                                                          var valid0 = true;
                                                                                        }
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                }
                                                                              }
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate110.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate110.errors = vErrors;
  return errors === 0;
}
const pattern0 = new RegExp('.*', 'u');
function validate109(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="SignerAppRequest.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.pages === undefined && (missing0 = 'pages')) ||
        (data.fields === undefined && (missing0 = 'fields')) ||
        (data.rules === undefined && (missing0 = 'rules'))
      ) {
        validate109.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (
            !(
              key0 === 'pages' ||
              key0 === 'fields' ||
              key0 === 'rules' ||
              key0 === 'signedData'
            )
          ) {
            validate109.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.pages !== undefined) {
            let data0 = data.pages;
            const _errs2 = errors;
            if (errors === _errs2) {
              if (Array.isArray(data0)) {
                var valid1 = true;
                const len0 = data0.length;
                for (let i0 = 0; i0 < len0; i0++) {
                  let data1 = data0[i0];
                  const _errs4 = errors;
                  const _errs5 = errors;
                  if (errors === _errs5) {
                    if (
                      data1 &&
                      typeof data1 == 'object' &&
                      !Array.isArray(data1)
                    ) {
                      let missing1;
                      if (
                        (data1.src === undefined && (missing1 = 'src')) ||
                        (data1.width === undefined && (missing1 = 'width')) ||
                        (data1.height === undefined && (missing1 = 'height')) ||
                        (data1.orientation === undefined &&
                          (missing1 = 'orientation'))
                      ) {
                        validate109.errors = [
                          {
                            instancePath: instancePath + '/pages/' + i0,
                            schemaPath: 'Page.json/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message:
                              "must have required property '" + missing1 + "'",
                          },
                        ];
                        return false;
                      } else {
                        const _errs7 = errors;
                        for (const key1 in data1) {
                          if (
                            !(
                              key1 === 'src' ||
                              key1 === 'width' ||
                              key1 === 'height' ||
                              key1 === 'documentId' ||
                              key1 === 'orientation' ||
                              key1 === 'snapshotGuid' ||
                              key1 === 'cdnSrc'
                            )
                          ) {
                            validate109.errors = [
                              {
                                instancePath: instancePath + '/pages/' + i0,
                                schemaPath: 'Page.json/additionalProperties',
                                keyword: 'additionalProperties',
                                params: { additionalProperty: key1 },
                                message: 'must NOT have additional properties',
                              },
                            ];
                            return false;
                            break;
                          }
                        }
                        if (_errs7 === errors) {
                          if (data1.src !== undefined) {
                            const _errs8 = errors;
                            if (typeof data1.src !== 'string') {
                              validate109.errors = [
                                {
                                  instancePath:
                                    instancePath + '/pages/' + i0 + '/src',
                                  schemaPath: 'Page.json/properties/src/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid3 = _errs8 === errors;
                          } else {
                            var valid3 = true;
                          }
                          if (valid3) {
                            if (data1.width !== undefined) {
                              let data3 = data1.width;
                              const _errs10 = errors;
                              if (
                                !(typeof data3 == 'number' && isFinite(data3))
                              ) {
                                validate109.errors = [
                                  {
                                    instancePath:
                                      instancePath + '/pages/' + i0 + '/width',
                                    schemaPath:
                                      'Page.json/properties/width/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number',
                                  },
                                ];
                                return false;
                              }
                              var valid3 = _errs10 === errors;
                            } else {
                              var valid3 = true;
                            }
                            if (valid3) {
                              if (data1.height !== undefined) {
                                let data4 = data1.height;
                                const _errs12 = errors;
                                if (
                                  !(typeof data4 == 'number' && isFinite(data4))
                                ) {
                                  validate109.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/pages/' +
                                        i0 +
                                        '/height',
                                      schemaPath:
                                        'Page.json/properties/height/type',
                                      keyword: 'type',
                                      params: { type: 'number' },
                                      message: 'must be number',
                                    },
                                  ];
                                  return false;
                                }
                                var valid3 = _errs12 === errors;
                              } else {
                                var valid3 = true;
                              }
                              if (valid3) {
                                if (data1.documentId !== undefined) {
                                  const _errs14 = errors;
                                  if (typeof data1.documentId !== 'string') {
                                    validate109.errors = [
                                      {
                                        instancePath:
                                          instancePath +
                                          '/pages/' +
                                          i0 +
                                          '/documentId',
                                        schemaPath:
                                          'Page.json/properties/documentId/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid3 = _errs14 === errors;
                                } else {
                                  var valid3 = true;
                                }
                                if (valid3) {
                                  if (data1.orientation !== undefined) {
                                    let data6 = data1.orientation;
                                    const _errs16 = errors;
                                    if (
                                      !(
                                        typeof data6 == 'number' &&
                                        !(data6 % 1) &&
                                        !isNaN(data6) &&
                                        isFinite(data6)
                                      )
                                    ) {
                                      validate109.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/pages/' +
                                            i0 +
                                            '/orientation',
                                          schemaPath:
                                            'Page.json/properties/orientation/type',
                                          keyword: 'type',
                                          params: { type: 'integer' },
                                          message: 'must be integer',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid3 = _errs16 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                  if (valid3) {
                                    if (data1.snapshotGuid !== undefined) {
                                      const _errs18 = errors;
                                      if (
                                        typeof data1.snapshotGuid !== 'string'
                                      ) {
                                        validate109.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/pages/' +
                                              i0 +
                                              '/snapshotGuid',
                                            schemaPath:
                                              'Page.json/properties/snapshotGuid/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid3 = _errs18 === errors;
                                    } else {
                                      var valid3 = true;
                                    }
                                    if (valid3) {
                                      if (data1.cdnSrc !== undefined) {
                                        let data8 = data1.cdnSrc;
                                        const _errs20 = errors;
                                        if (
                                          typeof data8 !== 'string' &&
                                          data8 !== null
                                        ) {
                                          validate109.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/pages/' +
                                                i0 +
                                                '/cdnSrc',
                                              schemaPath:
                                                'Page.json/properties/cdnSrc/type',
                                              keyword: 'type',
                                              params: {
                                                type: schema69.properties.cdnSrc
                                                  .type,
                                              },
                                              message: 'must be string,null',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid3 = _errs20 === errors;
                                      } else {
                                        var valid3 = true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    } else {
                      validate109.errors = [
                        {
                          instancePath: instancePath + '/pages/' + i0,
                          schemaPath: 'Page.json/type',
                          keyword: 'type',
                          params: { type: 'object' },
                          message: 'must be object',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid1 = _errs4 === errors;
                  if (!valid1) {
                    break;
                  }
                }
              } else {
                validate109.errors = [
                  {
                    instancePath: instancePath + '/pages',
                    schemaPath: '#/properties/pages/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                  },
                ];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.fields !== undefined) {
              let data9 = data.fields;
              const _errs22 = errors;
              if (errors === _errs22) {
                if (Array.isArray(data9)) {
                  var valid4 = true;
                  const len1 = data9.length;
                  for (let i1 = 0; i1 < len1; i1++) {
                    const _errs24 = errors;
                    if (
                      !validate110(data9[i1], {
                        instancePath: instancePath + '/fields/' + i1,
                        parentData: data9,
                        parentDataProperty: i1,
                        rootData,
                      })
                    ) {
                      vErrors =
                        vErrors === null
                          ? validate110.errors
                          : vErrors.concat(validate110.errors);
                      errors = vErrors.length;
                    }
                    var valid4 = _errs24 === errors;
                    if (!valid4) {
                      break;
                    }
                  }
                } else {
                  validate109.errors = [
                    {
                      instancePath: instancePath + '/fields',
                      schemaPath: '#/properties/fields/type',
                      keyword: 'type',
                      params: { type: 'array' },
                      message: 'must be array',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs22 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.rules !== undefined) {
                let data11 = data.rules;
                const _errs25 = errors;
                if (errors === _errs25) {
                  if (Array.isArray(data11)) {
                    var valid5 = true;
                    const len2 = data11.length;
                    for (let i2 = 0; i2 < len2; i2++) {
                      const _errs27 = errors;
                      if (
                        !validate58(data11[i2], {
                          instancePath: instancePath + '/rules/' + i2,
                          parentData: data11,
                          parentDataProperty: i2,
                          rootData,
                        })
                      ) {
                        vErrors =
                          vErrors === null
                            ? validate58.errors
                            : vErrors.concat(validate58.errors);
                        errors = vErrors.length;
                      }
                      var valid5 = _errs27 === errors;
                      if (!valid5) {
                        break;
                      }
                    }
                  } else {
                    validate109.errors = [
                      {
                        instancePath: instancePath + '/rules',
                        schemaPath: '#/properties/rules/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array',
                      },
                    ];
                    return false;
                  }
                }
                var valid0 = _errs25 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.signedData !== undefined) {
                  let data13 = data.signedData;
                  const _errs28 = errors;
                  if (errors === _errs28) {
                    if (
                      data13 &&
                      typeof data13 == 'object' &&
                      !Array.isArray(data13)
                    ) {
                      var valid6 = true;
                      for (const key2 in data13) {
                        if (pattern0.test(key2)) {
                          let data14 = data13[key2];
                          const _errs30 = errors;
                          const _errs31 = errors;
                          let valid7 = false;
                          let passing0 = null;
                          const _errs32 = errors;
                          const _errs33 = errors;
                          if (errors === _errs33) {
                            if (
                              data14 &&
                              typeof data14 == 'object' &&
                              !Array.isArray(data14)
                            ) {
                              let missing2;
                              if (
                                (data14.type === undefined &&
                                  (missing2 = 'type')) ||
                                (data14.data === undefined &&
                                  (missing2 = 'data'))
                              ) {
                                const err0 = {
                                  instancePath:
                                    instancePath +
                                    '/signedData/' +
                                    key2
                                      .replace(/~/g, '~0')
                                      .replace(/\//g, '~1'),
                                  schemaPath:
                                    '#/definitions/SignedSignableField/required',
                                  keyword: 'required',
                                  params: { missingProperty: missing2 },
                                  message:
                                    "must have required property '" +
                                    missing2 +
                                    "'",
                                };
                                if (vErrors === null) {
                                  vErrors = [err0];
                                } else {
                                  vErrors.push(err0);
                                }
                                errors++;
                              } else {
                                if (data14.type !== undefined) {
                                  let data15 = data14.type;
                                  const _errs35 = errors;
                                  if (typeof data15 !== 'string') {
                                    const err1 = {
                                      instancePath:
                                        instancePath +
                                        '/signedData/' +
                                        key2
                                          .replace(/~/g, '~0')
                                          .replace(/\//g, '~1') +
                                        '/type',
                                      schemaPath:
                                        '#/definitions/SignedSignableField/properties/type/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err1];
                                    } else {
                                      vErrors.push(err1);
                                    }
                                    errors++;
                                  }
                                  if (
                                    !(
                                      data15 === 'inputsignature' ||
                                      data15 === 'inputinitials'
                                    )
                                  ) {
                                    const err2 = {
                                      instancePath:
                                        instancePath +
                                        '/signedData/' +
                                        key2
                                          .replace(/~/g, '~0')
                                          .replace(/\//g, '~1') +
                                        '/type',
                                      schemaPath:
                                        '#/definitions/SignedSignableField/properties/type/enum',
                                      keyword: 'enum',
                                      params: {
                                        allowedValues:
                                          schema138.properties.type.enum,
                                      },
                                      message:
                                        'must be equal to one of the allowed values',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err2];
                                    } else {
                                      vErrors.push(err2);
                                    }
                                    errors++;
                                  }
                                  var valid9 = _errs35 === errors;
                                } else {
                                  var valid9 = true;
                                }
                                if (valid9) {
                                  if (data14.data !== undefined) {
                                    let data16 = data14.data;
                                    const _errs37 = errors;
                                    if (errors === _errs37) {
                                      if (
                                        data16 &&
                                        typeof data16 == 'object' &&
                                        !Array.isArray(data16)
                                      ) {
                                        let missing3;
                                        if (
                                          data16.guid === undefined &&
                                          (missing3 = 'guid')
                                        ) {
                                          const err3 = {
                                            instancePath:
                                              instancePath +
                                              '/signedData/' +
                                              key2
                                                .replace(/~/g, '~0')
                                                .replace(/\//g, '~1') +
                                              '/data',
                                            schemaPath:
                                              '#/definitions/SignedSignableField/properties/data/required',
                                            keyword: 'required',
                                            params: {
                                              missingProperty: missing3,
                                            },
                                            message:
                                              "must have required property '" +
                                              missing3 +
                                              "'",
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err3];
                                          } else {
                                            vErrors.push(err3);
                                          }
                                          errors++;
                                        } else {
                                          if (data16.guid !== undefined) {
                                            if (
                                              typeof data16.guid !== 'string'
                                            ) {
                                              const err4 = {
                                                instancePath:
                                                  instancePath +
                                                  '/signedData/' +
                                                  key2
                                                    .replace(/~/g, '~0')
                                                    .replace(/\//g, '~1') +
                                                  '/data/guid',
                                                schemaPath:
                                                  '#/definitions/SignedSignableField/properties/data/properties/guid/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err4];
                                              } else {
                                                vErrors.push(err4);
                                              }
                                              errors++;
                                            }
                                          }
                                        }
                                      } else {
                                        const err5 = {
                                          instancePath:
                                            instancePath +
                                            '/signedData/' +
                                            key2
                                              .replace(/~/g, '~0')
                                              .replace(/\//g, '~1') +
                                            '/data',
                                          schemaPath:
                                            '#/definitions/SignedSignableField/properties/data/type',
                                          keyword: 'type',
                                          params: { type: 'object' },
                                          message: 'must be object',
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err5];
                                        } else {
                                          vErrors.push(err5);
                                        }
                                        errors++;
                                      }
                                    }
                                    var valid9 = _errs37 === errors;
                                  } else {
                                    var valid9 = true;
                                  }
                                }
                              }
                            } else {
                              const err6 = {
                                instancePath:
                                  instancePath +
                                  '/signedData/' +
                                  key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                schemaPath:
                                  '#/definitions/SignedSignableField/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object',
                              };
                              if (vErrors === null) {
                                vErrors = [err6];
                              } else {
                                vErrors.push(err6);
                              }
                              errors++;
                            }
                          }
                          var _valid0 = _errs32 === errors;
                          if (_valid0) {
                            valid7 = true;
                            passing0 = 0;
                          }
                          const _errs41 = errors;
                          const _errs42 = errors;
                          if (errors === _errs42) {
                            if (
                              data14 &&
                              typeof data14 == 'object' &&
                              !Array.isArray(data14)
                            ) {
                              let missing4;
                              if (
                                (data14.type === undefined &&
                                  (missing4 = 'type')) ||
                                (data14.data === undefined &&
                                  (missing4 = 'data'))
                              ) {
                                const err7 = {
                                  instancePath:
                                    instancePath +
                                    '/signedData/' +
                                    key2
                                      .replace(/~/g, '~0')
                                      .replace(/\//g, '~1'),
                                  schemaPath:
                                    '#/definitions/SignedCheckableField/required',
                                  keyword: 'required',
                                  params: { missingProperty: missing4 },
                                  message:
                                    "must have required property '" +
                                    missing4 +
                                    "'",
                                };
                                if (vErrors === null) {
                                  vErrors = [err7];
                                } else {
                                  vErrors.push(err7);
                                }
                                errors++;
                              } else {
                                if (data14.type !== undefined) {
                                  let data18 = data14.type;
                                  const _errs44 = errors;
                                  if (typeof data18 !== 'string') {
                                    const err8 = {
                                      instancePath:
                                        instancePath +
                                        '/signedData/' +
                                        key2
                                          .replace(/~/g, '~0')
                                          .replace(/\//g, '~1') +
                                        '/type',
                                      schemaPath:
                                        '#/definitions/SignedCheckableField/properties/type/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err8];
                                    } else {
                                      vErrors.push(err8);
                                    }
                                    errors++;
                                  }
                                  if (
                                    !(
                                      data18 === 'inputcheckmark' ||
                                      data18 === 'inputradiobutton'
                                    )
                                  ) {
                                    const err9 = {
                                      instancePath:
                                        instancePath +
                                        '/signedData/' +
                                        key2
                                          .replace(/~/g, '~0')
                                          .replace(/\//g, '~1') +
                                        '/type',
                                      schemaPath:
                                        '#/definitions/SignedCheckableField/properties/type/enum',
                                      keyword: 'enum',
                                      params: {
                                        allowedValues:
                                          schema139.properties.type.enum,
                                      },
                                      message:
                                        'must be equal to one of the allowed values',
                                    };
                                    if (vErrors === null) {
                                      vErrors = [err9];
                                    } else {
                                      vErrors.push(err9);
                                    }
                                    errors++;
                                  }
                                  var valid12 = _errs44 === errors;
                                } else {
                                  var valid12 = true;
                                }
                                if (valid12) {
                                  if (data14.data !== undefined) {
                                    let data19 = data14.data;
                                    const _errs46 = errors;
                                    if (errors === _errs46) {
                                      if (
                                        data19 &&
                                        typeof data19 == 'object' &&
                                        !Array.isArray(data19)
                                      ) {
                                        let missing5;
                                        if (
                                          data19.checked === undefined &&
                                          (missing5 = 'checked')
                                        ) {
                                          const err10 = {
                                            instancePath:
                                              instancePath +
                                              '/signedData/' +
                                              key2
                                                .replace(/~/g, '~0')
                                                .replace(/\//g, '~1') +
                                              '/data',
                                            schemaPath:
                                              '#/definitions/SignedCheckableField/properties/data/required',
                                            keyword: 'required',
                                            params: {
                                              missingProperty: missing5,
                                            },
                                            message:
                                              "must have required property '" +
                                              missing5 +
                                              "'",
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err10];
                                          } else {
                                            vErrors.push(err10);
                                          }
                                          errors++;
                                        } else {
                                          if (data19.checked !== undefined) {
                                            if (
                                              typeof data19.checked !==
                                              'boolean'
                                            ) {
                                              const err11 = {
                                                instancePath:
                                                  instancePath +
                                                  '/signedData/' +
                                                  key2
                                                    .replace(/~/g, '~0')
                                                    .replace(/\//g, '~1') +
                                                  '/data/checked',
                                                schemaPath:
                                                  '#/definitions/SignedCheckableField/properties/data/properties/checked/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean',
                                              };
                                              if (vErrors === null) {
                                                vErrors = [err11];
                                              } else {
                                                vErrors.push(err11);
                                              }
                                              errors++;
                                            }
                                          }
                                        }
                                      } else {
                                        const err12 = {
                                          instancePath:
                                            instancePath +
                                            '/signedData/' +
                                            key2
                                              .replace(/~/g, '~0')
                                              .replace(/\//g, '~1') +
                                            '/data',
                                          schemaPath:
                                            '#/definitions/SignedCheckableField/properties/data/type',
                                          keyword: 'type',
                                          params: { type: 'object' },
                                          message: 'must be object',
                                        };
                                        if (vErrors === null) {
                                          vErrors = [err12];
                                        } else {
                                          vErrors.push(err12);
                                        }
                                        errors++;
                                      }
                                    }
                                    var valid12 = _errs46 === errors;
                                  } else {
                                    var valid12 = true;
                                  }
                                }
                              }
                            } else {
                              const err13 = {
                                instancePath:
                                  instancePath +
                                  '/signedData/' +
                                  key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                                schemaPath:
                                  '#/definitions/SignedCheckableField/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object',
                              };
                              if (vErrors === null) {
                                vErrors = [err13];
                              } else {
                                vErrors.push(err13);
                              }
                              errors++;
                            }
                          }
                          var _valid0 = _errs41 === errors;
                          if (_valid0 && valid7) {
                            valid7 = false;
                            passing0 = [passing0, 1];
                          } else {
                            if (_valid0) {
                              valid7 = true;
                              passing0 = 1;
                            }
                            const _errs50 = errors;
                            const _errs51 = errors;
                            if (errors === _errs51) {
                              if (
                                data14 &&
                                typeof data14 == 'object' &&
                                !Array.isArray(data14)
                              ) {
                                let missing6;
                                if (
                                  (data14.type === undefined &&
                                    (missing6 = 'type')) ||
                                  (data14.data === undefined &&
                                    (missing6 = 'data'))
                                ) {
                                  const err14 = {
                                    instancePath:
                                      instancePath +
                                      '/signedData/' +
                                      key2
                                        .replace(/~/g, '~0')
                                        .replace(/\//g, '~1'),
                                    schemaPath:
                                      '#/definitions/SignedDefaultField/required',
                                    keyword: 'required',
                                    params: { missingProperty: missing6 },
                                    message:
                                      "must have required property '" +
                                      missing6 +
                                      "'",
                                  };
                                  if (vErrors === null) {
                                    vErrors = [err14];
                                  } else {
                                    vErrors.push(err14);
                                  }
                                  errors++;
                                } else {
                                  if (data14.type !== undefined) {
                                    let data21 = data14.type;
                                    const _errs53 = errors;
                                    if (typeof data21 !== 'string') {
                                      const err15 = {
                                        instancePath:
                                          instancePath +
                                          '/signedData/' +
                                          key2
                                            .replace(/~/g, '~0')
                                            .replace(/\//g, '~1') +
                                          '/type',
                                        schemaPath:
                                          '#/definitions/SignedDefaultField/properties/type/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err15];
                                      } else {
                                        vErrors.push(err15);
                                      }
                                      errors++;
                                    }
                                    if (
                                      !(
                                        data21 === 'inputtextbox' ||
                                        data21 === 'inputdropdown'
                                      )
                                    ) {
                                      const err16 = {
                                        instancePath:
                                          instancePath +
                                          '/signedData/' +
                                          key2
                                            .replace(/~/g, '~0')
                                            .replace(/\//g, '~1') +
                                          '/type',
                                        schemaPath:
                                          '#/definitions/SignedDefaultField/properties/type/enum',
                                        keyword: 'enum',
                                        params: {
                                          allowedValues:
                                            schema140.properties.type.enum,
                                        },
                                        message:
                                          'must be equal to one of the allowed values',
                                      };
                                      if (vErrors === null) {
                                        vErrors = [err16];
                                      } else {
                                        vErrors.push(err16);
                                      }
                                      errors++;
                                    }
                                    var valid15 = _errs53 === errors;
                                  } else {
                                    var valid15 = true;
                                  }
                                  if (valid15) {
                                    if (data14.data !== undefined) {
                                      let data22 = data14.data;
                                      const _errs55 = errors;
                                      if (errors === _errs55) {
                                        if (
                                          data22 &&
                                          typeof data22 == 'object' &&
                                          !Array.isArray(data22)
                                        ) {
                                          let missing7;
                                          if (
                                            data22.value === undefined &&
                                            (missing7 = 'value')
                                          ) {
                                            const err17 = {
                                              instancePath:
                                                instancePath +
                                                '/signedData/' +
                                                key2
                                                  .replace(/~/g, '~0')
                                                  .replace(/\//g, '~1') +
                                                '/data',
                                              schemaPath:
                                                '#/definitions/SignedDefaultField/properties/data/required',
                                              keyword: 'required',
                                              params: {
                                                missingProperty: missing7,
                                              },
                                              message:
                                                "must have required property '" +
                                                missing7 +
                                                "'",
                                            };
                                            if (vErrors === null) {
                                              vErrors = [err17];
                                            } else {
                                              vErrors.push(err17);
                                            }
                                            errors++;
                                          } else {
                                            if (data22.value !== undefined) {
                                              if (
                                                typeof data22.value !== 'string'
                                              ) {
                                                const err18 = {
                                                  instancePath:
                                                    instancePath +
                                                    '/signedData/' +
                                                    key2
                                                      .replace(/~/g, '~0')
                                                      .replace(/\//g, '~1') +
                                                    '/data/value',
                                                  schemaPath:
                                                    '#/definitions/SignedDefaultField/properties/data/properties/value/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                };
                                                if (vErrors === null) {
                                                  vErrors = [err18];
                                                } else {
                                                  vErrors.push(err18);
                                                }
                                                errors++;
                                              }
                                            }
                                          }
                                        } else {
                                          const err19 = {
                                            instancePath:
                                              instancePath +
                                              '/signedData/' +
                                              key2
                                                .replace(/~/g, '~0')
                                                .replace(/\//g, '~1') +
                                              '/data',
                                            schemaPath:
                                              '#/definitions/SignedDefaultField/properties/data/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object',
                                          };
                                          if (vErrors === null) {
                                            vErrors = [err19];
                                          } else {
                                            vErrors.push(err19);
                                          }
                                          errors++;
                                        }
                                      }
                                      var valid15 = _errs55 === errors;
                                    } else {
                                      var valid15 = true;
                                    }
                                  }
                                }
                              } else {
                                const err20 = {
                                  instancePath:
                                    instancePath +
                                    '/signedData/' +
                                    key2
                                      .replace(/~/g, '~0')
                                      .replace(/\//g, '~1'),
                                  schemaPath:
                                    '#/definitions/SignedDefaultField/type',
                                  keyword: 'type',
                                  params: { type: 'object' },
                                  message: 'must be object',
                                };
                                if (vErrors === null) {
                                  vErrors = [err20];
                                } else {
                                  vErrors.push(err20);
                                }
                                errors++;
                              }
                            }
                            var _valid0 = _errs50 === errors;
                            if (_valid0 && valid7) {
                              valid7 = false;
                              passing0 = [passing0, 2];
                            } else {
                              if (_valid0) {
                                valid7 = true;
                                passing0 = 2;
                              }
                            }
                          }
                          if (!valid7) {
                            const err21 = {
                              instancePath:
                                instancePath +
                                '/signedData/' +
                                key2.replace(/~/g, '~0').replace(/\//g, '~1'),
                              schemaPath:
                                '#/properties/signedData/patternProperties/.*/oneOf',
                              keyword: 'oneOf',
                              params: { passingSchemas: passing0 },
                              message: 'must match exactly one schema in oneOf',
                            };
                            if (vErrors === null) {
                              vErrors = [err21];
                            } else {
                              vErrors.push(err21);
                            }
                            errors++;
                            validate109.errors = vErrors;
                            return false;
                          } else {
                            errors = _errs31;
                            if (vErrors !== null) {
                              if (_errs31) {
                                vErrors.length = _errs31;
                              } else {
                                vErrors = null;
                              }
                            }
                          }
                          var valid6 = _errs30 === errors;
                          if (!valid6) {
                            break;
                          }
                        }
                      }
                    } else {
                      validate109.errors = [
                        {
                          instancePath: instancePath + '/signedData',
                          schemaPath: '#/properties/signedData/type',
                          keyword: 'type',
                          params: { type: 'object' },
                          message: 'must be object',
                        },
                      ];
                      return false;
                    }
                  }
                  var valid0 = _errs28 === errors;
                } else {
                  var valid0 = true;
                }
              }
            }
          }
        }
      }
    } else {
      validate109.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate109.errors = vErrors;
  return errors === 0;
}
const schema141 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'ModalResponse.json',
  title: 'ModalResponse',
  type: 'object',
  additionalProperties: false,
  oneOf: [
    { $ref: '#/definitions/NoModal' },
    { $ref: '#/definitions/GoogleDriveModalIntegrationModal' },
    { $ref: '#/definitions/DropboxIntegrationModal' },
    { $ref: '#/definitions/DocToTemplateModal' },
    { $ref: '#/definitions/CreateTemplateModal' },
    { $ref: '#/definitions/FirstSignatureRequestModal' },
  ],
  definitions: {
    NoModal: {
      type: 'object',
      title: 'NoModal',
      properties: { type: { const: 'None', default: 'None' } },
      required: ['type'],
    },
    GoogleDriveModalIntegrationModal: {
      type: 'object',
      title: 'GoogleDriveModalIntegrationModal',
      properties: { type: { const: 'GoogleDrive', default: 'GoogleDrive' } },
      required: ['type'],
    },
    DropboxIntegrationModal: {
      type: 'object',
      title: 'DropboxIntegrationModal',
      properties: {
        type: { const: 'Dropbox', default: 'Dropbox' },
        dropboxIntegration: {
          $ref: 'AccountSettings.json#/definitions/DropboxIntegration',
        },
      },
      required: ['dropboxIntegration', 'type'],
    },
    DocToTemplateModal: {
      type: 'object',
      title: 'DocToTemplateModal',
      properties: {
        type: { const: 'DocToTemplate', default: 'DocToTemplate' },
        templateConversionCandidateId: { type: 'string' },
        simplifyDocToTemplateModal: { type: 'boolean' },
      },
      required: [
        'templateConversionCandidateId',
        'simplifyDocToTemplateModal',
        'type',
      ],
    },
    CreateTemplateModal: {
      type: 'object',
      title: 'CreateTemplateModal',
      properties: {
        type: { const: 'CreateTemplate', default: 'CreateTemplate' },
        isPaid: { type: 'boolean' },
      },
      required: ['isPaid', 'type'],
    },
    FirstSignatureRequestModal: {
      type: 'object',
      title: 'FirstSignatureRequestModal',
      properties: {
        type: {
          const: 'FirstSignatureRequestModal',
          default: 'FirstSignatureRequestModal',
        },
      },
      required: ['type'],
    },
  },
};
const schema142 = {
  type: 'object',
  title: 'NoModal',
  properties: { type: { const: 'None', default: 'None' } },
  required: ['type'],
};
const schema143 = {
  type: 'object',
  title: 'GoogleDriveModalIntegrationModal',
  properties: { type: { const: 'GoogleDrive', default: 'GoogleDrive' } },
  required: ['type'],
};
const schema146 = {
  type: 'object',
  title: 'DocToTemplateModal',
  properties: {
    type: { const: 'DocToTemplate', default: 'DocToTemplate' },
    templateConversionCandidateId: { type: 'string' },
    simplifyDocToTemplateModal: { type: 'boolean' },
  },
  required: [
    'templateConversionCandidateId',
    'simplifyDocToTemplateModal',
    'type',
  ],
};
const schema147 = {
  type: 'object',
  title: 'CreateTemplateModal',
  properties: {
    type: { const: 'CreateTemplate', default: 'CreateTemplate' },
    isPaid: { type: 'boolean' },
  },
  required: ['isPaid', 'type'],
};
const schema148 = {
  type: 'object',
  title: 'FirstSignatureRequestModal',
  properties: {
    type: {
      const: 'FirstSignatureRequestModal',
      default: 'FirstSignatureRequestModal',
    },
  },
  required: ['type'],
};
const schema144 = {
  type: 'object',
  title: 'DropboxIntegrationModal',
  properties: {
    type: { const: 'Dropbox', default: 'Dropbox' },
    dropboxIntegration: {
      $ref: 'AccountSettings.json#/definitions/DropboxIntegration',
    },
  },
  required: ['dropboxIntegration', 'type'],
};
function validate116(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.dropboxIntegration === undefined &&
          (missing0 = 'dropboxIntegration')) ||
        (data.type === undefined && (missing0 = 'type'))
      ) {
        validate116.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.type !== undefined) {
          const _errs1 = errors;
          if (!func0(data.type, 'Dropbox')) {
            validate116.errors = [
              {
                instancePath: instancePath + '/type',
                schemaPath: '#/properties/type/const',
                keyword: 'const',
                params: { allowedValue: 'Dropbox' },
                message: 'must be equal to constant',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.dropboxIntegration !== undefined) {
            let data1 = data.dropboxIntegration;
            const _errs2 = errors;
            const _errs3 = errors;
            if (errors === _errs3) {
              if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                let missing1;
                if (
                  (data1.id === undefined && (missing1 = 'id')) ||
                  (data1.key === undefined && (missing1 = 'key')) ||
                  (data1.nonce === undefined && (missing1 = 'nonce')) ||
                  (data1.enabled === undefined && (missing1 = 'enabled'))
                ) {
                  validate116.errors = [
                    {
                      instancePath: instancePath + '/dropboxIntegration',
                      schemaPath:
                        'AccountSettings.json#/definitions/DropboxIntegration/required',
                      keyword: 'required',
                      params: { missingProperty: missing1 },
                      message: "must have required property '" + missing1 + "'",
                    },
                  ];
                  return false;
                } else {
                  if (data1.id !== undefined) {
                    const _errs5 = errors;
                    if (!func0(data1.id, 'D')) {
                      validate116.errors = [
                        {
                          instancePath: instancePath + '/dropboxIntegration/id',
                          schemaPath:
                            'AccountSettings.json#/definitions/DropboxIntegration/properties/id/const',
                          keyword: 'const',
                          params: { allowedValue: 'D' },
                          message: 'must be equal to constant',
                        },
                      ];
                      return false;
                    }
                    var valid2 = _errs5 === errors;
                  } else {
                    var valid2 = true;
                  }
                  if (valid2) {
                    if (data1.key !== undefined) {
                      const _errs6 = errors;
                      if (typeof data1.key !== 'string') {
                        validate116.errors = [
                          {
                            instancePath:
                              instancePath + '/dropboxIntegration/key',
                            schemaPath:
                              'AccountSettings.json#/definitions/DropboxIntegration/properties/key/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs6 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data1.nonce !== undefined) {
                        const _errs8 = errors;
                        if (typeof data1.nonce !== 'string') {
                          validate116.errors = [
                            {
                              instancePath:
                                instancePath + '/dropboxIntegration/nonce',
                              schemaPath:
                                'AccountSettings.json#/definitions/DropboxIntegration/properties/nonce/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid2 = _errs8 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data1.enabled !== undefined) {
                          const _errs10 = errors;
                          if (typeof data1.enabled !== 'boolean') {
                            validate116.errors = [
                              {
                                instancePath:
                                  instancePath + '/dropboxIntegration/enabled',
                                schemaPath:
                                  'AccountSettings.json#/definitions/DropboxIntegration/properties/enabled/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid2 = _errs10 === errors;
                        } else {
                          var valid2 = true;
                        }
                      }
                    }
                  }
                }
              } else {
                validate116.errors = [
                  {
                    instancePath: instancePath + '/dropboxIntegration',
                    schemaPath:
                      'AccountSettings.json#/definitions/DropboxIntegration/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                  },
                ];
                return false;
              }
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate116.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate116.errors = vErrors;
  return errors === 0;
}
function validate115(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="ModalResponse.json" */ let vErrors = null;
  let errors = 0;
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  const _errs3 = errors;
  if (errors === _errs3) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (data.type === undefined && (missing0 = 'type')) {
        const err0 = {
          instancePath,
          schemaPath: '#/definitions/NoModal/required',
          keyword: 'required',
          params: { missingProperty: missing0 },
          message: "must have required property '" + missing0 + "'",
        };
        if (vErrors === null) {
          vErrors = [err0];
        } else {
          vErrors.push(err0);
        }
        errors++;
      } else {
        if (data.type !== undefined) {
          if (!func0(data.type, 'None')) {
            const err1 = {
              instancePath: instancePath + '/type',
              schemaPath: '#/definitions/NoModal/properties/type/const',
              keyword: 'const',
              params: { allowedValue: 'None' },
              message: 'must be equal to constant',
            };
            if (vErrors === null) {
              vErrors = [err1];
            } else {
              vErrors.push(err1);
            }
            errors++;
          }
        }
      }
    } else {
      const err2 = {
        instancePath,
        schemaPath: '#/definitions/NoModal/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      };
      if (vErrors === null) {
        vErrors = [err2];
      } else {
        vErrors.push(err2);
      }
      errors++;
    }
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs6 = errors;
  const _errs7 = errors;
  if (errors === _errs7) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing1;
      if (data.type === undefined && (missing1 = 'type')) {
        const err3 = {
          instancePath,
          schemaPath: '#/definitions/GoogleDriveModalIntegrationModal/required',
          keyword: 'required',
          params: { missingProperty: missing1 },
          message: "must have required property '" + missing1 + "'",
        };
        if (vErrors === null) {
          vErrors = [err3];
        } else {
          vErrors.push(err3);
        }
        errors++;
      } else {
        if (data.type !== undefined) {
          if (!func0(data.type, 'GoogleDrive')) {
            const err4 = {
              instancePath: instancePath + '/type',
              schemaPath:
                '#/definitions/GoogleDriveModalIntegrationModal/properties/type/const',
              keyword: 'const',
              params: { allowedValue: 'GoogleDrive' },
              message: 'must be equal to constant',
            };
            if (vErrors === null) {
              vErrors = [err4];
            } else {
              vErrors.push(err4);
            }
            errors++;
          }
        }
      }
    } else {
      const err5 = {
        instancePath,
        schemaPath: '#/definitions/GoogleDriveModalIntegrationModal/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      };
      if (vErrors === null) {
        vErrors = [err5];
      } else {
        vErrors.push(err5);
      }
      errors++;
    }
  }
  var _valid0 = _errs6 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs10 = errors;
    if (
      !validate116(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
      })
    ) {
      vErrors =
        vErrors === null
          ? validate116.errors
          : vErrors.concat(validate116.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs10 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
      const _errs11 = errors;
      const _errs12 = errors;
      if (errors === _errs12) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
          let missing2;
          if (
            (data.templateConversionCandidateId === undefined &&
              (missing2 = 'templateConversionCandidateId')) ||
            (data.simplifyDocToTemplateModal === undefined &&
              (missing2 = 'simplifyDocToTemplateModal')) ||
            (data.type === undefined && (missing2 = 'type'))
          ) {
            const err6 = {
              instancePath,
              schemaPath: '#/definitions/DocToTemplateModal/required',
              keyword: 'required',
              params: { missingProperty: missing2 },
              message: "must have required property '" + missing2 + "'",
            };
            if (vErrors === null) {
              vErrors = [err6];
            } else {
              vErrors.push(err6);
            }
            errors++;
          } else {
            if (data.type !== undefined) {
              const _errs14 = errors;
              if (!func0(data.type, 'DocToTemplate')) {
                const err7 = {
                  instancePath: instancePath + '/type',
                  schemaPath:
                    '#/definitions/DocToTemplateModal/properties/type/const',
                  keyword: 'const',
                  params: { allowedValue: 'DocToTemplate' },
                  message: 'must be equal to constant',
                };
                if (vErrors === null) {
                  vErrors = [err7];
                } else {
                  vErrors.push(err7);
                }
                errors++;
              }
              var valid6 = _errs14 === errors;
            } else {
              var valid6 = true;
            }
            if (valid6) {
              if (data.templateConversionCandidateId !== undefined) {
                const _errs15 = errors;
                if (typeof data.templateConversionCandidateId !== 'string') {
                  const err8 = {
                    instancePath:
                      instancePath + '/templateConversionCandidateId',
                    schemaPath:
                      '#/definitions/DocToTemplateModal/properties/templateConversionCandidateId/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  };
                  if (vErrors === null) {
                    vErrors = [err8];
                  } else {
                    vErrors.push(err8);
                  }
                  errors++;
                }
                var valid6 = _errs15 === errors;
              } else {
                var valid6 = true;
              }
              if (valid6) {
                if (data.simplifyDocToTemplateModal !== undefined) {
                  const _errs17 = errors;
                  if (typeof data.simplifyDocToTemplateModal !== 'boolean') {
                    const err9 = {
                      instancePath:
                        instancePath + '/simplifyDocToTemplateModal',
                      schemaPath:
                        '#/definitions/DocToTemplateModal/properties/simplifyDocToTemplateModal/type',
                      keyword: 'type',
                      params: { type: 'boolean' },
                      message: 'must be boolean',
                    };
                    if (vErrors === null) {
                      vErrors = [err9];
                    } else {
                      vErrors.push(err9);
                    }
                    errors++;
                  }
                  var valid6 = _errs17 === errors;
                } else {
                  var valid6 = true;
                }
              }
            }
          }
        } else {
          const err10 = {
            instancePath,
            schemaPath: '#/definitions/DocToTemplateModal/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
          };
          if (vErrors === null) {
            vErrors = [err10];
          } else {
            vErrors.push(err10);
          }
          errors++;
        }
      }
      var _valid0 = _errs11 === errors;
      if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [passing0, 3];
      } else {
        if (_valid0) {
          valid0 = true;
          passing0 = 3;
        }
        const _errs19 = errors;
        const _errs20 = errors;
        if (errors === _errs20) {
          if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing3;
            if (
              (data.isPaid === undefined && (missing3 = 'isPaid')) ||
              (data.type === undefined && (missing3 = 'type'))
            ) {
              const err11 = {
                instancePath,
                schemaPath: '#/definitions/CreateTemplateModal/required',
                keyword: 'required',
                params: { missingProperty: missing3 },
                message: "must have required property '" + missing3 + "'",
              };
              if (vErrors === null) {
                vErrors = [err11];
              } else {
                vErrors.push(err11);
              }
              errors++;
            } else {
              if (data.type !== undefined) {
                const _errs22 = errors;
                if (!func0(data.type, 'CreateTemplate')) {
                  const err12 = {
                    instancePath: instancePath + '/type',
                    schemaPath:
                      '#/definitions/CreateTemplateModal/properties/type/const',
                    keyword: 'const',
                    params: { allowedValue: 'CreateTemplate' },
                    message: 'must be equal to constant',
                  };
                  if (vErrors === null) {
                    vErrors = [err12];
                  } else {
                    vErrors.push(err12);
                  }
                  errors++;
                }
                var valid8 = _errs22 === errors;
              } else {
                var valid8 = true;
              }
              if (valid8) {
                if (data.isPaid !== undefined) {
                  const _errs23 = errors;
                  if (typeof data.isPaid !== 'boolean') {
                    const err13 = {
                      instancePath: instancePath + '/isPaid',
                      schemaPath:
                        '#/definitions/CreateTemplateModal/properties/isPaid/type',
                      keyword: 'type',
                      params: { type: 'boolean' },
                      message: 'must be boolean',
                    };
                    if (vErrors === null) {
                      vErrors = [err13];
                    } else {
                      vErrors.push(err13);
                    }
                    errors++;
                  }
                  var valid8 = _errs23 === errors;
                } else {
                  var valid8 = true;
                }
              }
            }
          } else {
            const err14 = {
              instancePath,
              schemaPath: '#/definitions/CreateTemplateModal/type',
              keyword: 'type',
              params: { type: 'object' },
              message: 'must be object',
            };
            if (vErrors === null) {
              vErrors = [err14];
            } else {
              vErrors.push(err14);
            }
            errors++;
          }
        }
        var _valid0 = _errs19 === errors;
        if (_valid0 && valid0) {
          valid0 = false;
          passing0 = [passing0, 4];
        } else {
          if (_valid0) {
            valid0 = true;
            passing0 = 4;
          }
          const _errs25 = errors;
          const _errs26 = errors;
          if (errors === _errs26) {
            if (data && typeof data == 'object' && !Array.isArray(data)) {
              let missing4;
              if (data.type === undefined && (missing4 = 'type')) {
                const err15 = {
                  instancePath,
                  schemaPath:
                    '#/definitions/FirstSignatureRequestModal/required',
                  keyword: 'required',
                  params: { missingProperty: missing4 },
                  message: "must have required property '" + missing4 + "'",
                };
                if (vErrors === null) {
                  vErrors = [err15];
                } else {
                  vErrors.push(err15);
                }
                errors++;
              } else {
                if (data.type !== undefined) {
                  if (!func0(data.type, 'FirstSignatureRequestModal')) {
                    const err16 = {
                      instancePath: instancePath + '/type',
                      schemaPath:
                        '#/definitions/FirstSignatureRequestModal/properties/type/const',
                      keyword: 'const',
                      params: { allowedValue: 'FirstSignatureRequestModal' },
                      message: 'must be equal to constant',
                    };
                    if (vErrors === null) {
                      vErrors = [err16];
                    } else {
                      vErrors.push(err16);
                    }
                    errors++;
                  }
                }
              }
            } else {
              const err17 = {
                instancePath,
                schemaPath: '#/definitions/FirstSignatureRequestModal/type',
                keyword: 'type',
                params: { type: 'object' },
                message: 'must be object',
              };
              if (vErrors === null) {
                vErrors = [err17];
              } else {
                vErrors.push(err17);
              }
              errors++;
            }
          }
          var _valid0 = _errs25 === errors;
          if (_valid0 && valid0) {
            valid0 = false;
            passing0 = [passing0, 5];
          } else {
            if (_valid0) {
              valid0 = true;
              passing0 = 5;
            }
          }
        }
      }
    }
  }
  if (!valid0) {
    const err18 = {
      instancePath,
      schemaPath: '#/oneOf',
      keyword: 'oneOf',
      params: { passingSchemas: passing0 },
      message: 'must match exactly one schema in oneOf',
    };
    if (vErrors === null) {
      vErrors = [err18];
    } else {
      vErrors.push(err18);
    }
    errors++;
    validate115.errors = vErrors;
    return false;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      for (const key0 in data) {
        validate115.errors = [
          {
            instancePath,
            schemaPath: '#/additionalProperties',
            keyword: 'additionalProperties',
            params: { additionalProperty: key0 },
            message: 'must NOT have additional properties',
          },
        ];
        return false;
        break;
      }
    } else {
      validate115.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate115.errors = vErrors;
  return errors === 0;
}
const schema149 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'EditSignersObject.json',
  title: 'EditSignersObject',
  type: 'object',
  properties: {
    signers: {
      type: 'array',
      items: { $ref: 'Recipient.json#/definitions/Signer' },
    },
    signerSettings: { $ref: '#/definitions/SignerSettings' },
    signerFeatures: { $ref: '#/definitions/SignerFeatures' },
  },
  required: ['signers', 'signerSettings', 'signerFeatures'],
  definitions: {
    SignerSettings: {
      type: 'object',
      title: 'SignerSettings',
      description: 'SignerSettings',
      properties: {
        isSignerReassignment: { type: 'boolean' },
        isSignerOrder: { type: 'boolean' },
        isQualifiedSignature: { type: 'boolean' },
      },
      required: [
        'isSignerReassignment',
        'isSignerOrder',
        'isQualifiedSignature',
      ],
    },
    SignerFeatures: {
      type: 'object',
      title: 'signerFeatures',
      description: 'signerFeatures',
      properties: {
        allowReassignment: { type: 'boolean' },
        allowRecipientOrder: { type: 'boolean' },
        allowQualifiedESignature: { type: 'boolean' },
      },
      required: [
        'allowReassignment',
        'allowRecipientOrder',
        'allowQualifiedESignature',
      ],
    },
  },
};
const schema153 = {
  type: 'object',
  title: 'SignerSettings',
  description: 'SignerSettings',
  properties: {
    isSignerReassignment: { type: 'boolean' },
    isSignerOrder: { type: 'boolean' },
    isQualifiedSignature: { type: 'boolean' },
  },
  required: ['isSignerReassignment', 'isSignerOrder', 'isQualifiedSignature'],
};
const schema154 = {
  type: 'object',
  title: 'signerFeatures',
  description: 'signerFeatures',
  properties: {
    allowReassignment: { type: 'boolean' },
    allowRecipientOrder: { type: 'boolean' },
    allowQualifiedESignature: { type: 'boolean' },
  },
  required: [
    'allowReassignment',
    'allowRecipientOrder',
    'allowQualifiedESignature',
  ],
};
function validate120(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.type === undefined && (missing0 = 'type')) ||
        (data.id === undefined && (missing0 = 'id')) ||
        (data.email === undefined && (missing0 = 'email')) ||
        (data.name === undefined && (missing0 = 'name')) ||
        (data.role === undefined && (missing0 = 'role')) ||
        (data.attachments === undefined && (missing0 = 'attachments'))
      ) {
        validate120.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!func4.call(schema89.properties, key0)) {
            validate120.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.type !== undefined) {
            const _errs2 = errors;
            if (!func0(data.type, 'signer')) {
              validate120.errors = [
                {
                  instancePath: instancePath + '/type',
                  schemaPath: '#/properties/type/const',
                  keyword: 'const',
                  params: { allowedValue: 'signer' },
                  message: 'must be equal to constant',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.id !== undefined) {
              const _errs3 = errors;
              if (typeof data.id !== 'string') {
                validate120.errors = [
                  {
                    instancePath: instancePath + '/id',
                    schemaPath: '#/properties/id/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs3 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.email !== undefined) {
                let data2 = data.email;
                const _errs5 = errors;
                const _errs6 = errors;
                let valid1 = false;
                let passing0 = null;
                const _errs7 = errors;
                if (errors === _errs7) {
                  if (errors === _errs7) {
                    if (typeof data2 === 'string') {
                      if (!formats4.test(data2)) {
                        const err0 = {
                          instancePath: instancePath + '/email',
                          schemaPath: '#/properties/email/oneOf/0/format',
                          keyword: 'format',
                          params: { format: 'email' },
                          message: 'must match format "' + 'email' + '"',
                        };
                        if (vErrors === null) {
                          vErrors = [err0];
                        } else {
                          vErrors.push(err0);
                        }
                        errors++;
                      }
                    } else {
                      const err1 = {
                        instancePath: instancePath + '/email',
                        schemaPath: '#/properties/email/oneOf/0/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      };
                      if (vErrors === null) {
                        vErrors = [err1];
                      } else {
                        vErrors.push(err1);
                      }
                      errors++;
                    }
                  }
                }
                var _valid0 = _errs7 === errors;
                if (_valid0) {
                  valid1 = true;
                  passing0 = 0;
                }
                const _errs9 = errors;
                if (data2 !== null) {
                  const err2 = {
                    instancePath: instancePath + '/email',
                    schemaPath: '#/properties/email/oneOf/1/type',
                    keyword: 'type',
                    params: { type: 'null' },
                    message: 'must be null',
                  };
                  if (vErrors === null) {
                    vErrors = [err2];
                  } else {
                    vErrors.push(err2);
                  }
                  errors++;
                }
                var _valid0 = _errs9 === errors;
                if (_valid0 && valid1) {
                  valid1 = false;
                  passing0 = [passing0, 1];
                } else {
                  if (_valid0) {
                    valid1 = true;
                    passing0 = 1;
                  }
                }
                if (!valid1) {
                  const err3 = {
                    instancePath: instancePath + '/email',
                    schemaPath: '#/properties/email/oneOf',
                    keyword: 'oneOf',
                    params: { passingSchemas: passing0 },
                    message: 'must match exactly one schema in oneOf',
                  };
                  if (vErrors === null) {
                    vErrors = [err3];
                  } else {
                    vErrors.push(err3);
                  }
                  errors++;
                  validate120.errors = vErrors;
                  return false;
                } else {
                  errors = _errs6;
                  if (vErrors !== null) {
                    if (_errs6) {
                      vErrors.length = _errs6;
                    } else {
                      vErrors = null;
                    }
                  }
                }
                var valid0 = _errs5 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.name !== undefined) {
                  const _errs11 = errors;
                  if (typeof data.name !== 'string') {
                    validate120.errors = [
                      {
                        instancePath: instancePath + '/name',
                        schemaPath: '#/properties/name/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs11 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.role !== undefined) {
                    let data4 = data.role;
                    const _errs13 = errors;
                    const _errs14 = errors;
                    let valid2 = false;
                    let passing1 = null;
                    const _errs15 = errors;
                    if (data4 !== null) {
                      const err4 = {
                        instancePath: instancePath + '/role',
                        schemaPath: '#/properties/role/oneOf/0/type',
                        keyword: 'type',
                        params: { type: 'null' },
                        message: 'must be null',
                      };
                      if (vErrors === null) {
                        vErrors = [err4];
                      } else {
                        vErrors.push(err4);
                      }
                      errors++;
                    }
                    var _valid1 = _errs15 === errors;
                    if (_valid1) {
                      valid2 = true;
                      passing1 = 0;
                    }
                    const _errs17 = errors;
                    if (
                      !validate71(data4, {
                        instancePath: instancePath + '/role',
                        parentData: data,
                        parentDataProperty: 'role',
                        rootData,
                      })
                    ) {
                      vErrors =
                        vErrors === null
                          ? validate71.errors
                          : vErrors.concat(validate71.errors);
                      errors = vErrors.length;
                    }
                    var _valid1 = _errs17 === errors;
                    if (_valid1 && valid2) {
                      valid2 = false;
                      passing1 = [passing1, 1];
                    } else {
                      if (_valid1) {
                        valid2 = true;
                        passing1 = 1;
                      }
                    }
                    if (!valid2) {
                      const err5 = {
                        instancePath: instancePath + '/role',
                        schemaPath: '#/properties/role/oneOf',
                        keyword: 'oneOf',
                        params: { passingSchemas: passing1 },
                        message: 'must match exactly one schema in oneOf',
                      };
                      if (vErrors === null) {
                        vErrors = [err5];
                      } else {
                        vErrors.push(err5);
                      }
                      errors++;
                      validate120.errors = vErrors;
                      return false;
                    } else {
                      errors = _errs14;
                      if (vErrors !== null) {
                        if (_errs14) {
                          vErrors.length = _errs14;
                        } else {
                          vErrors = null;
                        }
                      }
                    }
                    var valid0 = _errs13 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.attachments !== undefined) {
                      let data5 = data.attachments;
                      const _errs18 = errors;
                      if (errors === _errs18) {
                        if (Array.isArray(data5)) {
                          var valid3 = true;
                          const len0 = data5.length;
                          for (let i0 = 0; i0 < len0; i0++) {
                            let data6 = data5[i0];
                            const _errs20 = errors;
                            const _errs21 = errors;
                            if (errors === _errs21) {
                              if (
                                data6 &&
                                typeof data6 == 'object' &&
                                !Array.isArray(data6)
                              ) {
                                let missing1;
                                if (
                                  (data6.id === undefined &&
                                    (missing1 = 'id')) ||
                                  (data6.name === undefined &&
                                    (missing1 = 'name')) ||
                                  (data6.instructions === undefined &&
                                    (missing1 = 'instructions')) ||
                                  (data6.required === undefined &&
                                    (missing1 = 'required'))
                                ) {
                                  validate120.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/attachments/' + i0,
                                      schemaPath:
                                        '#/definitions/Attachment/required',
                                      keyword: 'required',
                                      params: { missingProperty: missing1 },
                                      message:
                                        "must have required property '" +
                                        missing1 +
                                        "'",
                                    },
                                  ];
                                  return false;
                                } else {
                                  const _errs23 = errors;
                                  for (const key1 in data6) {
                                    if (
                                      !(
                                        key1 === 'id' ||
                                        key1 === 'name' ||
                                        key1 === 'instructions' ||
                                        key1 === 'required'
                                      )
                                    ) {
                                      validate120.errors = [
                                        {
                                          instancePath:
                                            instancePath + '/attachments/' + i0,
                                          schemaPath:
                                            '#/definitions/Attachment/additionalProperties',
                                          keyword: 'additionalProperties',
                                          params: { additionalProperty: key1 },
                                          message:
                                            'must NOT have additional properties',
                                        },
                                      ];
                                      return false;
                                      break;
                                    }
                                  }
                                  if (_errs23 === errors) {
                                    if (data6.id !== undefined) {
                                      const _errs24 = errors;
                                      if (typeof data6.id !== 'string') {
                                        validate120.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/attachments/' +
                                              i0 +
                                              '/id',
                                            schemaPath:
                                              '#/definitions/Attachment/properties/id/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid5 = _errs24 === errors;
                                    } else {
                                      var valid5 = true;
                                    }
                                    if (valid5) {
                                      if (data6.name !== undefined) {
                                        const _errs26 = errors;
                                        if (typeof data6.name !== 'string') {
                                          validate120.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/attachments/' +
                                                i0 +
                                                '/name',
                                              schemaPath:
                                                '#/definitions/Attachment/properties/name/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid5 = _errs26 === errors;
                                      } else {
                                        var valid5 = true;
                                      }
                                      if (valid5) {
                                        if (data6.instructions !== undefined) {
                                          const _errs28 = errors;
                                          if (
                                            typeof data6.instructions !==
                                            'string'
                                          ) {
                                            validate120.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/attachments/' +
                                                  i0 +
                                                  '/instructions',
                                                schemaPath:
                                                  '#/definitions/Attachment/properties/instructions/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid5 = _errs28 === errors;
                                        } else {
                                          var valid5 = true;
                                        }
                                        if (valid5) {
                                          if (data6.required !== undefined) {
                                            const _errs30 = errors;
                                            if (
                                              typeof data6.required !==
                                              'boolean'
                                            ) {
                                              validate120.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/attachments/' +
                                                    i0 +
                                                    '/required',
                                                  schemaPath:
                                                    '#/definitions/Attachment/properties/required/type',
                                                  keyword: 'type',
                                                  params: { type: 'boolean' },
                                                  message: 'must be boolean',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid5 = _errs30 === errors;
                                          } else {
                                            var valid5 = true;
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              } else {
                                validate120.errors = [
                                  {
                                    instancePath:
                                      instancePath + '/attachments/' + i0,
                                    schemaPath: '#/definitions/Attachment/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object',
                                  },
                                ];
                                return false;
                              }
                            }
                            var valid3 = _errs20 === errors;
                            if (!valid3) {
                              break;
                            }
                          }
                        } else {
                          validate120.errors = [
                            {
                              instancePath: instancePath + '/attachments',
                              schemaPath: '#/properties/attachments/type',
                              keyword: 'type',
                              params: { type: 'array' },
                              message: 'must be array',
                            },
                          ];
                          return false;
                        }
                      }
                      var valid0 = _errs18 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.accessCode !== undefined) {
                        const _errs32 = errors;
                        if (typeof data.accessCode !== 'string') {
                          validate120.errors = [
                            {
                              instancePath: instancePath + '/accessCode',
                              schemaPath: '#/properties/accessCode/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs32 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.smsAuthNumber !== undefined) {
                          const _errs34 = errors;
                          if (typeof data.smsAuthNumber !== 'string') {
                            validate120.errors = [
                              {
                                instancePath: instancePath + '/smsAuthNumber',
                                schemaPath: '#/properties/smsAuthNumber/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs34 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.authType !== undefined) {
                            const _errs36 = errors;
                            if (typeof data.authType !== 'string') {
                              validate120.errors = [
                                {
                                  instancePath: instancePath + '/authType',
                                  schemaPath: '#/properties/authType/type',
                                  keyword: 'type',
                                  params: { type: 'string' },
                                  message: 'must be string',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs36 === errors;
                          } else {
                            var valid0 = true;
                          }
                          if (valid0) {
                            if (data.smsDeliveryNumber !== undefined) {
                              const _errs38 = errors;
                              if (typeof data.smsDeliveryNumber !== 'string') {
                                validate120.errors = [
                                  {
                                    instancePath:
                                      instancePath + '/smsDeliveryNumber',
                                    schemaPath:
                                      '#/properties/smsDeliveryNumber/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                  },
                                ];
                                return false;
                              }
                              var valid0 = _errs38 === errors;
                            } else {
                              var valid0 = true;
                            }
                            if (valid0) {
                              if (data.deliveryType !== undefined) {
                                let data15 = data.deliveryType;
                                const _errs40 = errors;
                                if (typeof data15 !== 'string') {
                                  validate120.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/deliveryType',
                                      schemaPath:
                                        '#/definitions/DeliveryType/type',
                                      keyword: 'type',
                                      params: { type: 'string' },
                                      message: 'must be string',
                                    },
                                  ];
                                  return false;
                                }
                                if (
                                  !(
                                    data15 === 'EMAIL' || data15 === 'EMAIL-SMS'
                                  )
                                ) {
                                  validate120.errors = [
                                    {
                                      instancePath:
                                        instancePath + '/deliveryType',
                                      schemaPath:
                                        '#/definitions/DeliveryType/enum',
                                      keyword: 'enum',
                                      params: { allowedValues: schema91.enum },
                                      message:
                                        'must be equal to one of the allowed values',
                                    },
                                  ];
                                  return false;
                                }
                                var valid0 = _errs40 === errors;
                              } else {
                                var valid0 = true;
                              }
                              if (valid0) {
                                if (data.order !== undefined) {
                                  let data16 = data.order;
                                  const _errs43 = errors;
                                  if (
                                    !(
                                      typeof data16 == 'number' &&
                                      !(data16 % 1) &&
                                      !isNaN(data16) &&
                                      isFinite(data16)
                                    )
                                  ) {
                                    validate120.errors = [
                                      {
                                        instancePath: instancePath + '/order',
                                        schemaPath: '#/properties/order/type',
                                        keyword: 'type',
                                        params: { type: 'integer' },
                                        message: 'must be integer',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid0 = _errs43 === errors;
                                } else {
                                  var valid0 = true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate120.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate120.errors = vErrors;
  return errors === 0;
}
function validate119(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="EditSignersObject.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.signers === undefined && (missing0 = 'signers')) ||
        (data.signerSettings === undefined && (missing0 = 'signerSettings')) ||
        (data.signerFeatures === undefined && (missing0 = 'signerFeatures'))
      ) {
        validate119.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.signers !== undefined) {
          let data0 = data.signers;
          const _errs1 = errors;
          if (errors === _errs1) {
            if (Array.isArray(data0)) {
              var valid1 = true;
              const len0 = data0.length;
              for (let i0 = 0; i0 < len0; i0++) {
                const _errs3 = errors;
                if (
                  !validate120(data0[i0], {
                    instancePath: instancePath + '/signers/' + i0,
                    parentData: data0,
                    parentDataProperty: i0,
                    rootData,
                  })
                ) {
                  vErrors =
                    vErrors === null
                      ? validate120.errors
                      : vErrors.concat(validate120.errors);
                  errors = vErrors.length;
                }
                var valid1 = _errs3 === errors;
                if (!valid1) {
                  break;
                }
              }
            } else {
              validate119.errors = [
                {
                  instancePath: instancePath + '/signers',
                  schemaPath: '#/properties/signers/type',
                  keyword: 'type',
                  params: { type: 'array' },
                  message: 'must be array',
                },
              ];
              return false;
            }
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.signerSettings !== undefined) {
            let data2 = data.signerSettings;
            const _errs4 = errors;
            const _errs5 = errors;
            if (errors === _errs5) {
              if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                let missing1;
                if (
                  (data2.isSignerReassignment === undefined &&
                    (missing1 = 'isSignerReassignment')) ||
                  (data2.isSignerOrder === undefined &&
                    (missing1 = 'isSignerOrder')) ||
                  (data2.isQualifiedSignature === undefined &&
                    (missing1 = 'isQualifiedSignature'))
                ) {
                  validate119.errors = [
                    {
                      instancePath: instancePath + '/signerSettings',
                      schemaPath: '#/definitions/SignerSettings/required',
                      keyword: 'required',
                      params: { missingProperty: missing1 },
                      message: "must have required property '" + missing1 + "'",
                    },
                  ];
                  return false;
                } else {
                  if (data2.isSignerReassignment !== undefined) {
                    const _errs7 = errors;
                    if (typeof data2.isSignerReassignment !== 'boolean') {
                      validate119.errors = [
                        {
                          instancePath:
                            instancePath +
                            '/signerSettings/isSignerReassignment',
                          schemaPath:
                            '#/definitions/SignerSettings/properties/isSignerReassignment/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid3 = _errs7 === errors;
                  } else {
                    var valid3 = true;
                  }
                  if (valid3) {
                    if (data2.isSignerOrder !== undefined) {
                      const _errs9 = errors;
                      if (typeof data2.isSignerOrder !== 'boolean') {
                        validate119.errors = [
                          {
                            instancePath:
                              instancePath + '/signerSettings/isSignerOrder',
                            schemaPath:
                              '#/definitions/SignerSettings/properties/isSignerOrder/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid3 = _errs9 === errors;
                    } else {
                      var valid3 = true;
                    }
                    if (valid3) {
                      if (data2.isQualifiedSignature !== undefined) {
                        const _errs11 = errors;
                        if (typeof data2.isQualifiedSignature !== 'boolean') {
                          validate119.errors = [
                            {
                              instancePath:
                                instancePath +
                                '/signerSettings/isQualifiedSignature',
                              schemaPath:
                                '#/definitions/SignerSettings/properties/isQualifiedSignature/type',
                              keyword: 'type',
                              params: { type: 'boolean' },
                              message: 'must be boolean',
                            },
                          ];
                          return false;
                        }
                        var valid3 = _errs11 === errors;
                      } else {
                        var valid3 = true;
                      }
                    }
                  }
                }
              } else {
                validate119.errors = [
                  {
                    instancePath: instancePath + '/signerSettings',
                    schemaPath: '#/definitions/SignerSettings/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                  },
                ];
                return false;
              }
            }
            var valid0 = _errs4 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.signerFeatures !== undefined) {
              let data6 = data.signerFeatures;
              const _errs13 = errors;
              const _errs14 = errors;
              if (errors === _errs14) {
                if (
                  data6 &&
                  typeof data6 == 'object' &&
                  !Array.isArray(data6)
                ) {
                  let missing2;
                  if (
                    (data6.allowReassignment === undefined &&
                      (missing2 = 'allowReassignment')) ||
                    (data6.allowRecipientOrder === undefined &&
                      (missing2 = 'allowRecipientOrder')) ||
                    (data6.allowQualifiedESignature === undefined &&
                      (missing2 = 'allowQualifiedESignature'))
                  ) {
                    validate119.errors = [
                      {
                        instancePath: instancePath + '/signerFeatures',
                        schemaPath: '#/definitions/SignerFeatures/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message:
                          "must have required property '" + missing2 + "'",
                      },
                    ];
                    return false;
                  } else {
                    if (data6.allowReassignment !== undefined) {
                      const _errs16 = errors;
                      if (typeof data6.allowReassignment !== 'boolean') {
                        validate119.errors = [
                          {
                            instancePath:
                              instancePath +
                              '/signerFeatures/allowReassignment',
                            schemaPath:
                              '#/definitions/SignerFeatures/properties/allowReassignment/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid5 = _errs16 === errors;
                    } else {
                      var valid5 = true;
                    }
                    if (valid5) {
                      if (data6.allowRecipientOrder !== undefined) {
                        const _errs18 = errors;
                        if (typeof data6.allowRecipientOrder !== 'boolean') {
                          validate119.errors = [
                            {
                              instancePath:
                                instancePath +
                                '/signerFeatures/allowRecipientOrder',
                              schemaPath:
                                '#/definitions/SignerFeatures/properties/allowRecipientOrder/type',
                              keyword: 'type',
                              params: { type: 'boolean' },
                              message: 'must be boolean',
                            },
                          ];
                          return false;
                        }
                        var valid5 = _errs18 === errors;
                      } else {
                        var valid5 = true;
                      }
                      if (valid5) {
                        if (data6.allowQualifiedESignature !== undefined) {
                          const _errs20 = errors;
                          if (
                            typeof data6.allowQualifiedESignature !== 'boolean'
                          ) {
                            validate119.errors = [
                              {
                                instancePath:
                                  instancePath +
                                  '/signerFeatures/allowQualifiedESignature',
                                schemaPath:
                                  '#/definitions/SignerFeatures/properties/allowQualifiedESignature/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid5 = _errs20 === errors;
                        } else {
                          var valid5 = true;
                        }
                      }
                    }
                  }
                } else {
                  validate119.errors = [
                    {
                      instancePath: instancePath + '/signerFeatures',
                      schemaPath: '#/definitions/SignerFeatures/type',
                      keyword: 'type',
                      params: { type: 'object' },
                      message: 'must be object',
                    },
                  ];
                  return false;
                }
              }
              var valid0 = _errs13 === errors;
            } else {
              var valid0 = true;
            }
          }
        }
      }
    } else {
      validate119.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate119.errors = vErrors;
  return errors === 0;
}
const schema155 = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'HomePage.json',
  type: 'object',
  title: 'HomePage',
  additionalProperties: false,
  properties: {
    delinquencyReminderModal: {
      $ref: '#/definitions/DelinquencyReminderModal',
    },
  },
  required: ['delinquencyReminderModal'],
  definitions: {
    DelinquencyReminderModal: {
      type: 'object',
      title: 'DelinquencyReminderModal',
      description: 'Modal displayed in Home page',
      properties: {
        isDelinquencyReminderModalEligible: { type: 'boolean' },
        isTeamAdmin: { type: 'boolean' },
        planName: { type: 'string' },
        endDate: { type: ['number', 'null'] },
        requiredV2Props: {
          type: 'object',
          properties: {
            billingPeriod: { type: 'string' },
            countryCode: { type: 'string' },
            daysUntilRenewal: { type: 'number' },
            existingCurrency: { type: 'string' },
            firstName: { type: 'string' },
            funnelStep: { type: 'string', enum: ['trial', 'renewal'] },
            last4: { type: 'string' },
            rateWithCurrency: { type: 'string' },
          },
        },
        modalType: { type: 'number', minimum: 0, maximum: 3 },
      },
      required: [
        'isDelinquencyReminderModalEligible',
        'isTeamAdmin',
        'planName',
        'endDate',
        'requiredV2Props',
        'modalType',
      ],
    },
  },
};
const schema156 = {
  type: 'object',
  title: 'DelinquencyReminderModal',
  description: 'Modal displayed in Home page',
  properties: {
    isDelinquencyReminderModalEligible: { type: 'boolean' },
    isTeamAdmin: { type: 'boolean' },
    planName: { type: 'string' },
    endDate: { type: ['number', 'null'] },
    requiredV2Props: {
      type: 'object',
      properties: {
        billingPeriod: { type: 'string' },
        countryCode: { type: 'string' },
        daysUntilRenewal: { type: 'number' },
        existingCurrency: { type: 'string' },
        firstName: { type: 'string' },
        funnelStep: { type: 'string', enum: ['trial', 'renewal'] },
        last4: { type: 'string' },
        rateWithCurrency: { type: 'string' },
      },
    },
    modalType: { type: 'number', minimum: 0, maximum: 3 },
  },
  required: [
    'isDelinquencyReminderModalEligible',
    'isTeamAdmin',
    'planName',
    'endDate',
    'requiredV2Props',
    'modalType',
  ],
};
function validate124(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="HomePage.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        data.delinquencyReminderModal === undefined &&
        (missing0 = 'delinquencyReminderModal')
      ) {
        validate124.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'delinquencyReminderModal')) {
            validate124.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.delinquencyReminderModal !== undefined) {
            let data0 = data.delinquencyReminderModal;
            const _errs3 = errors;
            if (errors === _errs3) {
              if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                let missing1;
                if (
                  (data0.isDelinquencyReminderModalEligible === undefined &&
                    (missing1 = 'isDelinquencyReminderModalEligible')) ||
                  (data0.isTeamAdmin === undefined &&
                    (missing1 = 'isTeamAdmin')) ||
                  (data0.planName === undefined && (missing1 = 'planName')) ||
                  (data0.endDate === undefined && (missing1 = 'endDate')) ||
                  (data0.requiredV2Props === undefined &&
                    (missing1 = 'requiredV2Props')) ||
                  (data0.modalType === undefined && (missing1 = 'modalType'))
                ) {
                  validate124.errors = [
                    {
                      instancePath: instancePath + '/delinquencyReminderModal',
                      schemaPath:
                        '#/definitions/DelinquencyReminderModal/required',
                      keyword: 'required',
                      params: { missingProperty: missing1 },
                      message: "must have required property '" + missing1 + "'",
                    },
                  ];
                  return false;
                } else {
                  if (data0.isDelinquencyReminderModalEligible !== undefined) {
                    const _errs5 = errors;
                    if (
                      typeof data0.isDelinquencyReminderModalEligible !==
                      'boolean'
                    ) {
                      validate124.errors = [
                        {
                          instancePath:
                            instancePath +
                            '/delinquencyReminderModal/isDelinquencyReminderModalEligible',
                          schemaPath:
                            '#/definitions/DelinquencyReminderModal/properties/isDelinquencyReminderModalEligible/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid2 = _errs5 === errors;
                  } else {
                    var valid2 = true;
                  }
                  if (valid2) {
                    if (data0.isTeamAdmin !== undefined) {
                      const _errs7 = errors;
                      if (typeof data0.isTeamAdmin !== 'boolean') {
                        validate124.errors = [
                          {
                            instancePath:
                              instancePath +
                              '/delinquencyReminderModal/isTeamAdmin',
                            schemaPath:
                              '#/definitions/DelinquencyReminderModal/properties/isTeamAdmin/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid2 = _errs7 === errors;
                    } else {
                      var valid2 = true;
                    }
                    if (valid2) {
                      if (data0.planName !== undefined) {
                        const _errs9 = errors;
                        if (typeof data0.planName !== 'string') {
                          validate124.errors = [
                            {
                              instancePath:
                                instancePath +
                                '/delinquencyReminderModal/planName',
                              schemaPath:
                                '#/definitions/DelinquencyReminderModal/properties/planName/type',
                              keyword: 'type',
                              params: { type: 'string' },
                              message: 'must be string',
                            },
                          ];
                          return false;
                        }
                        var valid2 = _errs9 === errors;
                      } else {
                        var valid2 = true;
                      }
                      if (valid2) {
                        if (data0.endDate !== undefined) {
                          let data4 = data0.endDate;
                          const _errs11 = errors;
                          if (
                            !(typeof data4 == 'number' && isFinite(data4)) &&
                            data4 !== null
                          ) {
                            validate124.errors = [
                              {
                                instancePath:
                                  instancePath +
                                  '/delinquencyReminderModal/endDate',
                                schemaPath:
                                  '#/definitions/DelinquencyReminderModal/properties/endDate/type',
                                keyword: 'type',
                                params: {
                                  type: schema156.properties.endDate.type,
                                },
                                message: 'must be number,null',
                              },
                            ];
                            return false;
                          }
                          var valid2 = _errs11 === errors;
                        } else {
                          var valid2 = true;
                        }
                        if (valid2) {
                          if (data0.requiredV2Props !== undefined) {
                            let data5 = data0.requiredV2Props;
                            const _errs13 = errors;
                            if (errors === _errs13) {
                              if (
                                data5 &&
                                typeof data5 == 'object' &&
                                !Array.isArray(data5)
                              ) {
                                if (data5.billingPeriod !== undefined) {
                                  const _errs15 = errors;
                                  if (typeof data5.billingPeriod !== 'string') {
                                    validate124.errors = [
                                      {
                                        instancePath:
                                          instancePath +
                                          '/delinquencyReminderModal/requiredV2Props/billingPeriod',
                                        schemaPath:
                                          '#/definitions/DelinquencyReminderModal/properties/requiredV2Props/properties/billingPeriod/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string',
                                      },
                                    ];
                                    return false;
                                  }
                                  var valid3 = _errs15 === errors;
                                } else {
                                  var valid3 = true;
                                }
                                if (valid3) {
                                  if (data5.countryCode !== undefined) {
                                    const _errs17 = errors;
                                    if (typeof data5.countryCode !== 'string') {
                                      validate124.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/delinquencyReminderModal/requiredV2Props/countryCode',
                                          schemaPath:
                                            '#/definitions/DelinquencyReminderModal/properties/requiredV2Props/properties/countryCode/type',
                                          keyword: 'type',
                                          params: { type: 'string' },
                                          message: 'must be string',
                                        },
                                      ];
                                      return false;
                                    }
                                    var valid3 = _errs17 === errors;
                                  } else {
                                    var valid3 = true;
                                  }
                                  if (valid3) {
                                    if (data5.daysUntilRenewal !== undefined) {
                                      let data8 = data5.daysUntilRenewal;
                                      const _errs19 = errors;
                                      if (
                                        !(
                                          typeof data8 == 'number' &&
                                          isFinite(data8)
                                        )
                                      ) {
                                        validate124.errors = [
                                          {
                                            instancePath:
                                              instancePath +
                                              '/delinquencyReminderModal/requiredV2Props/daysUntilRenewal',
                                            schemaPath:
                                              '#/definitions/DelinquencyReminderModal/properties/requiredV2Props/properties/daysUntilRenewal/type',
                                            keyword: 'type',
                                            params: { type: 'number' },
                                            message: 'must be number',
                                          },
                                        ];
                                        return false;
                                      }
                                      var valid3 = _errs19 === errors;
                                    } else {
                                      var valid3 = true;
                                    }
                                    if (valid3) {
                                      if (
                                        data5.existingCurrency !== undefined
                                      ) {
                                        const _errs21 = errors;
                                        if (
                                          typeof data5.existingCurrency !==
                                          'string'
                                        ) {
                                          validate124.errors = [
                                            {
                                              instancePath:
                                                instancePath +
                                                '/delinquencyReminderModal/requiredV2Props/existingCurrency',
                                              schemaPath:
                                                '#/definitions/DelinquencyReminderModal/properties/requiredV2Props/properties/existingCurrency/type',
                                              keyword: 'type',
                                              params: { type: 'string' },
                                              message: 'must be string',
                                            },
                                          ];
                                          return false;
                                        }
                                        var valid3 = _errs21 === errors;
                                      } else {
                                        var valid3 = true;
                                      }
                                      if (valid3) {
                                        if (data5.firstName !== undefined) {
                                          const _errs23 = errors;
                                          if (
                                            typeof data5.firstName !== 'string'
                                          ) {
                                            validate124.errors = [
                                              {
                                                instancePath:
                                                  instancePath +
                                                  '/delinquencyReminderModal/requiredV2Props/firstName',
                                                schemaPath:
                                                  '#/definitions/DelinquencyReminderModal/properties/requiredV2Props/properties/firstName/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string',
                                              },
                                            ];
                                            return false;
                                          }
                                          var valid3 = _errs23 === errors;
                                        } else {
                                          var valid3 = true;
                                        }
                                        if (valid3) {
                                          if (data5.funnelStep !== undefined) {
                                            let data11 = data5.funnelStep;
                                            const _errs25 = errors;
                                            if (typeof data11 !== 'string') {
                                              validate124.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/delinquencyReminderModal/requiredV2Props/funnelStep',
                                                  schemaPath:
                                                    '#/definitions/DelinquencyReminderModal/properties/requiredV2Props/properties/funnelStep/type',
                                                  keyword: 'type',
                                                  params: { type: 'string' },
                                                  message: 'must be string',
                                                },
                                              ];
                                              return false;
                                            }
                                            if (
                                              !(
                                                data11 === 'trial' ||
                                                data11 === 'renewal'
                                              )
                                            ) {
                                              validate124.errors = [
                                                {
                                                  instancePath:
                                                    instancePath +
                                                    '/delinquencyReminderModal/requiredV2Props/funnelStep',
                                                  schemaPath:
                                                    '#/definitions/DelinquencyReminderModal/properties/requiredV2Props/properties/funnelStep/enum',
                                                  keyword: 'enum',
                                                  params: {
                                                    allowedValues:
                                                      schema156.properties
                                                        .requiredV2Props
                                                        .properties.funnelStep
                                                        .enum,
                                                  },
                                                  message:
                                                    'must be equal to one of the allowed values',
                                                },
                                              ];
                                              return false;
                                            }
                                            var valid3 = _errs25 === errors;
                                          } else {
                                            var valid3 = true;
                                          }
                                          if (valid3) {
                                            if (data5.last4 !== undefined) {
                                              const _errs27 = errors;
                                              if (
                                                typeof data5.last4 !== 'string'
                                              ) {
                                                validate124.errors = [
                                                  {
                                                    instancePath:
                                                      instancePath +
                                                      '/delinquencyReminderModal/requiredV2Props/last4',
                                                    schemaPath:
                                                      '#/definitions/DelinquencyReminderModal/properties/requiredV2Props/properties/last4/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string',
                                                  },
                                                ];
                                                return false;
                                              }
                                              var valid3 = _errs27 === errors;
                                            } else {
                                              var valid3 = true;
                                            }
                                            if (valid3) {
                                              if (
                                                data5.rateWithCurrency !==
                                                undefined
                                              ) {
                                                const _errs29 = errors;
                                                if (
                                                  typeof data5.rateWithCurrency !==
                                                  'string'
                                                ) {
                                                  validate124.errors = [
                                                    {
                                                      instancePath:
                                                        instancePath +
                                                        '/delinquencyReminderModal/requiredV2Props/rateWithCurrency',
                                                      schemaPath:
                                                        '#/definitions/DelinquencyReminderModal/properties/requiredV2Props/properties/rateWithCurrency/type',
                                                      keyword: 'type',
                                                      params: {
                                                        type: 'string',
                                                      },
                                                      message: 'must be string',
                                                    },
                                                  ];
                                                  return false;
                                                }
                                                var valid3 = _errs29 === errors;
                                              } else {
                                                var valid3 = true;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              } else {
                                validate124.errors = [
                                  {
                                    instancePath:
                                      instancePath +
                                      '/delinquencyReminderModal/requiredV2Props',
                                    schemaPath:
                                      '#/definitions/DelinquencyReminderModal/properties/requiredV2Props/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object',
                                  },
                                ];
                                return false;
                              }
                            }
                            var valid2 = _errs13 === errors;
                          } else {
                            var valid2 = true;
                          }
                          if (valid2) {
                            if (data0.modalType !== undefined) {
                              let data14 = data0.modalType;
                              const _errs31 = errors;
                              if (errors === _errs31) {
                                if (
                                  typeof data14 == 'number' &&
                                  isFinite(data14)
                                ) {
                                  if (data14 > 3 || isNaN(data14)) {
                                    validate124.errors = [
                                      {
                                        instancePath:
                                          instancePath +
                                          '/delinquencyReminderModal/modalType',
                                        schemaPath:
                                          '#/definitions/DelinquencyReminderModal/properties/modalType/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 3 },
                                        message: 'must be <= 3',
                                      },
                                    ];
                                    return false;
                                  } else {
                                    if (data14 < 0 || isNaN(data14)) {
                                      validate124.errors = [
                                        {
                                          instancePath:
                                            instancePath +
                                            '/delinquencyReminderModal/modalType',
                                          schemaPath:
                                            '#/definitions/DelinquencyReminderModal/properties/modalType/minimum',
                                          keyword: 'minimum',
                                          params: {
                                            comparison: '>=',
                                            limit: 0,
                                          },
                                          message: 'must be >= 0',
                                        },
                                      ];
                                      return false;
                                    }
                                  }
                                } else {
                                  validate124.errors = [
                                    {
                                      instancePath:
                                        instancePath +
                                        '/delinquencyReminderModal/modalType',
                                      schemaPath:
                                        '#/definitions/DelinquencyReminderModal/properties/modalType/type',
                                      keyword: 'type',
                                      params: { type: 'number' },
                                      message: 'must be number',
                                    },
                                  ];
                                  return false;
                                }
                              }
                              var valid2 = _errs31 === errors;
                            } else {
                              var valid2 = true;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              } else {
                validate124.errors = [
                  {
                    instancePath: instancePath + '/delinquencyReminderModal',
                    schemaPath: '#/definitions/DelinquencyReminderModal/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                  },
                ];
                return false;
              }
            }
          }
        }
      }
    } else {
      validate124.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate124.errors = vErrors;
  return errors === 0;
}
function validate10(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="HelloRequest.json" */ let vErrors = null;
  let errors = 0;
  if (!(data && typeof data == 'object' && !Array.isArray(data))) {
    validate10.errors = [
      {
        instancePath,
        schemaPath: '#/type',
        keyword: 'type',
        params: { type: 'object' },
        message: 'must be object',
      },
    ];
    return false;
  }
  const _errs1 = errors;
  let valid0 = false;
  let passing0 = null;
  const _errs2 = errors;
  if (
    !validate11(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
    })
  ) {
    vErrors =
      vErrors === null ? validate11.errors : vErrors.concat(validate11.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs2 === errors;
  if (_valid0) {
    valid0 = true;
    passing0 = 0;
  }
  const _errs4 = errors;
  if (
    !validate109(data, {
      instancePath,
      parentData,
      parentDataProperty,
      rootData,
    })
  ) {
    vErrors =
      vErrors === null
        ? validate109.errors
        : vErrors.concat(validate109.errors);
    errors = vErrors.length;
  }
  var _valid0 = _errs4 === errors;
  if (_valid0 && valid0) {
    valid0 = false;
    passing0 = [passing0, 1];
  } else {
    if (_valid0) {
      valid0 = true;
      passing0 = 1;
    }
    const _errs6 = errors;
    if (
      !validate115(data, {
        instancePath,
        parentData,
        parentDataProperty,
        rootData,
      })
    ) {
      vErrors =
        vErrors === null
          ? validate115.errors
          : vErrors.concat(validate115.errors);
      errors = vErrors.length;
    }
    var _valid0 = _errs6 === errors;
    if (_valid0 && valid0) {
      valid0 = false;
      passing0 = [passing0, 2];
    } else {
      if (_valid0) {
        valid0 = true;
        passing0 = 2;
      }
      const _errs7 = errors;
      if (
        !validate119(data, {
          instancePath,
          parentData,
          parentDataProperty,
          rootData,
        })
      ) {
        vErrors =
          vErrors === null
            ? validate119.errors
            : vErrors.concat(validate119.errors);
        errors = vErrors.length;
      }
      var _valid0 = _errs7 === errors;
      if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [passing0, 3];
      } else {
        if (_valid0) {
          valid0 = true;
          passing0 = 3;
        }
        const _errs8 = errors;
        if (
          !validate124(data, {
            instancePath,
            parentData,
            parentDataProperty,
            rootData,
          })
        ) {
          vErrors =
            vErrors === null
              ? validate124.errors
              : vErrors.concat(validate124.errors);
          errors = vErrors.length;
        }
        var _valid0 = _errs8 === errors;
        if (_valid0 && valid0) {
          valid0 = false;
          passing0 = [passing0, 4];
        } else {
          if (_valid0) {
            valid0 = true;
            passing0 = 4;
          }
        }
      }
    }
  }
  if (!valid0) {
    const err0 = {
      instancePath,
      schemaPath: '#/oneOf',
      keyword: 'oneOf',
      params: { passingSchemas: passing0 },
      message: 'must match exactly one schema in oneOf',
    };
    if (vErrors === null) {
      vErrors = [err0];
    } else {
      vErrors.push(err0);
    }
    errors++;
    validate10.errors = vErrors;
    return false;
  } else {
    errors = _errs1;
    if (vErrors !== null) {
      if (_errs1) {
        vErrors.length = _errs1;
      } else {
        vErrors = null;
      }
    }
  }
  validate10.errors = vErrors;
  return errors === 0;
}
exports.validatePrepAndSendRequest = validate11;
exports.validateSettings = validate126;
function validate126(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="Settings.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      const _errs1 = errors;
      for (const key0 in data) {
        if (!func4.call(schema13.properties, key0)) {
          validate126.errors = [
            {
              instancePath,
              schemaPath: '#/additionalProperties',
              keyword: 'additionalProperties',
              params: { additionalProperty: key0 },
              message: 'must NOT have additional properties',
            },
          ];
          return false;
          break;
        }
      }
      if (_errs1 === errors) {
        if (data.addCoverPage !== undefined) {
          const _errs2 = errors;
          if (typeof data.addCoverPage !== 'boolean') {
            validate126.errors = [
              {
                instancePath: instancePath + '/addCoverPage',
                schemaPath: '#/properties/addCoverPage/type',
                keyword: 'type',
                params: { type: 'boolean' },
                message: 'must be boolean',
              },
            ];
            return false;
          }
          var valid0 = _errs2 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.recipientOrder !== undefined) {
            const _errs4 = errors;
            if (typeof data.recipientOrder !== 'boolean') {
              validate126.errors = [
                {
                  instancePath: instancePath + '/recipientOrder',
                  schemaPath: '#/properties/recipientOrder/type',
                  keyword: 'type',
                  params: { type: 'boolean' },
                  message: 'must be boolean',
                },
              ];
              return false;
            }
            var valid0 = _errs4 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.qes !== undefined) {
              const _errs6 = errors;
              if (typeof data.qes !== 'boolean') {
                validate126.errors = [
                  {
                    instancePath: instancePath + '/qes',
                    schemaPath: '#/properties/qes/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                  },
                ];
                return false;
              }
              var valid0 = _errs6 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.nom151 !== undefined) {
                const _errs8 = errors;
                if (typeof data.nom151 !== 'boolean') {
                  validate126.errors = [
                    {
                      instancePath: instancePath + '/nom151',
                      schemaPath: '#/properties/nom151/type',
                      keyword: 'type',
                      params: { type: 'boolean' },
                      message: 'must be boolean',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs8 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.recipientReassignment !== undefined) {
                  const _errs10 = errors;
                  if (typeof data.recipientReassignment !== 'boolean') {
                    validate126.errors = [
                      {
                        instancePath: instancePath + '/recipientReassignment',
                        schemaPath: '#/properties/recipientReassignment/type',
                        keyword: 'type',
                        params: { type: 'boolean' },
                        message: 'must be boolean',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs10 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.requireSignerInfo !== undefined) {
                    const _errs12 = errors;
                    if (typeof data.requireSignerInfo !== 'boolean') {
                      validate126.errors = [
                        {
                          instancePath: instancePath + '/requireSignerInfo',
                          schemaPath: '#/properties/requireSignerInfo/type',
                          keyword: 'type',
                          params: { type: 'boolean' },
                          message: 'must be boolean',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs12 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.sendHighResFax !== undefined) {
                      const _errs14 = errors;
                      if (typeof data.sendHighResFax !== 'boolean') {
                        validate126.errors = [
                          {
                            instancePath: instancePath + '/sendHighResFax',
                            schemaPath: '#/properties/sendHighResFax/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs14 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.needsCharge !== undefined) {
                        const _errs16 = errors;
                        if (typeof data.needsCharge !== 'boolean') {
                          validate126.errors = [
                            {
                              instancePath: instancePath + '/needsCharge',
                              schemaPath: '#/properties/needsCharge/type',
                              keyword: 'type',
                              params: { type: 'boolean' },
                              message: 'must be boolean',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs16 === errors;
                      } else {
                        var valid0 = true;
                      }
                      if (valid0) {
                        if (data.hasForm !== undefined) {
                          const _errs18 = errors;
                          if (typeof data.hasForm !== 'boolean') {
                            validate126.errors = [
                              {
                                instancePath: instancePath + '/hasForm',
                                schemaPath: '#/properties/hasForm/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean',
                              },
                            ];
                            return false;
                          }
                          var valid0 = _errs18 === errors;
                        } else {
                          var valid0 = true;
                        }
                        if (valid0) {
                          if (data.mobileFriendlySigning !== undefined) {
                            const _errs20 = errors;
                            if (
                              typeof data.mobileFriendlySigning !== 'boolean'
                            ) {
                              validate126.errors = [
                                {
                                  instancePath:
                                    instancePath + '/mobileFriendlySigning',
                                  schemaPath:
                                    '#/properties/mobileFriendlySigning/type',
                                  keyword: 'type',
                                  params: { type: 'boolean' },
                                  message: 'must be boolean',
                                },
                              ];
                              return false;
                            }
                            var valid0 = _errs20 === errors;
                          } else {
                            var valid0 = true;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate126.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate126.errors = vErrors;
  return errors === 0;
}
exports.validateOptions = validate12;
exports.validateFlags = validate32;
exports.validateAccountSettings = validate44;
exports.validateRequestData = validate48;
exports.validateFile = validate49;
exports.validateField = validate13;
exports.validateEditorData = validate52;
exports.validatePage = validate127;
function validate127(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="Page.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.src === undefined && (missing0 = 'src')) ||
        (data.width === undefined && (missing0 = 'width')) ||
        (data.height === undefined && (missing0 = 'height')) ||
        (data.orientation === undefined && (missing0 = 'orientation'))
      ) {
        validate127.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (
            !(
              key0 === 'src' ||
              key0 === 'width' ||
              key0 === 'height' ||
              key0 === 'documentId' ||
              key0 === 'orientation' ||
              key0 === 'snapshotGuid' ||
              key0 === 'cdnSrc'
            )
          ) {
            validate127.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.src !== undefined) {
            const _errs2 = errors;
            if (typeof data.src !== 'string') {
              validate127.errors = [
                {
                  instancePath: instancePath + '/src',
                  schemaPath: '#/properties/src/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.width !== undefined) {
              let data1 = data.width;
              const _errs4 = errors;
              if (!(typeof data1 == 'number' && isFinite(data1))) {
                validate127.errors = [
                  {
                    instancePath: instancePath + '/width',
                    schemaPath: '#/properties/width/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                  },
                ];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.height !== undefined) {
                let data2 = data.height;
                const _errs6 = errors;
                if (!(typeof data2 == 'number' && isFinite(data2))) {
                  validate127.errors = [
                    {
                      instancePath: instancePath + '/height',
                      schemaPath: '#/properties/height/type',
                      keyword: 'type',
                      params: { type: 'number' },
                      message: 'must be number',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs6 === errors;
              } else {
                var valid0 = true;
              }
              if (valid0) {
                if (data.documentId !== undefined) {
                  const _errs8 = errors;
                  if (typeof data.documentId !== 'string') {
                    validate127.errors = [
                      {
                        instancePath: instancePath + '/documentId',
                        schemaPath: '#/properties/documentId/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                      },
                    ];
                    return false;
                  }
                  var valid0 = _errs8 === errors;
                } else {
                  var valid0 = true;
                }
                if (valid0) {
                  if (data.orientation !== undefined) {
                    let data4 = data.orientation;
                    const _errs10 = errors;
                    if (
                      !(
                        typeof data4 == 'number' &&
                        !(data4 % 1) &&
                        !isNaN(data4) &&
                        isFinite(data4)
                      )
                    ) {
                      validate127.errors = [
                        {
                          instancePath: instancePath + '/orientation',
                          schemaPath: '#/properties/orientation/type',
                          keyword: 'type',
                          params: { type: 'integer' },
                          message: 'must be integer',
                        },
                      ];
                      return false;
                    }
                    var valid0 = _errs10 === errors;
                  } else {
                    var valid0 = true;
                  }
                  if (valid0) {
                    if (data.snapshotGuid !== undefined) {
                      const _errs12 = errors;
                      if (typeof data.snapshotGuid !== 'string') {
                        validate127.errors = [
                          {
                            instancePath: instancePath + '/snapshotGuid',
                            schemaPath: '#/properties/snapshotGuid/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                          },
                        ];
                        return false;
                      }
                      var valid0 = _errs12 === errors;
                    } else {
                      var valid0 = true;
                    }
                    if (valid0) {
                      if (data.cdnSrc !== undefined) {
                        let data6 = data.cdnSrc;
                        const _errs14 = errors;
                        if (typeof data6 !== 'string' && data6 !== null) {
                          validate127.errors = [
                            {
                              instancePath: instancePath + '/cdnSrc',
                              schemaPath: '#/properties/cdnSrc/type',
                              keyword: 'type',
                              params: { type: schema69.properties.cdnSrc.type },
                              message: 'must be string,null',
                            },
                          ];
                          return false;
                        }
                        var valid0 = _errs14 === errors;
                      } else {
                        var valid0 = true;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      validate127.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate127.errors = vErrors;
  return errors === 0;
}
exports.validateRule = validate58;
exports.validateRecipient = validate70;
exports.validateTemplate = validate91;
exports.validateCoverPage = validate128;
function validate128(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="CoverPage.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (
        (data.to === undefined && (missing0 = 'to')) ||
        (data.from === undefined && (missing0 = 'from')) ||
        (data.message === undefined && (missing0 = 'message'))
      ) {
        validate128.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        const _errs1 = errors;
        for (const key0 in data) {
          if (!(key0 === 'to' || key0 === 'from' || key0 === 'message')) {
            validate128.errors = [
              {
                instancePath,
                schemaPath: '#/additionalProperties',
                keyword: 'additionalProperties',
                params: { additionalProperty: key0 },
                message: 'must NOT have additional properties',
              },
            ];
            return false;
            break;
          }
        }
        if (_errs1 === errors) {
          if (data.to !== undefined) {
            const _errs2 = errors;
            if (typeof data.to !== 'string') {
              validate128.errors = [
                {
                  instancePath: instancePath + '/to',
                  schemaPath: '#/properties/to/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs2 === errors;
          } else {
            var valid0 = true;
          }
          if (valid0) {
            if (data.from !== undefined) {
              const _errs4 = errors;
              if (typeof data.from !== 'string') {
                validate128.errors = [
                  {
                    instancePath: instancePath + '/from',
                    schemaPath: '#/properties/from/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                  },
                ];
                return false;
              }
              var valid0 = _errs4 === errors;
            } else {
              var valid0 = true;
            }
            if (valid0) {
              if (data.message !== undefined) {
                const _errs6 = errors;
                if (typeof data.message !== 'string') {
                  validate128.errors = [
                    {
                      instancePath: instancePath + '/message',
                      schemaPath: '#/properties/message/type',
                      keyword: 'type',
                      params: { type: 'string' },
                      message: 'must be string',
                    },
                  ];
                  return false;
                }
                var valid0 = _errs6 === errors;
              } else {
                var valid0 = true;
              }
            }
          }
        }
      }
    } else {
      validate128.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate128.errors = vErrors;
  return errors === 0;
}
exports.validateBulkSend = validate99;
exports.validateEmbeddedData = validate104;
exports.validateApiApp = validate129;
function validate129(
  data,
  { instancePath = '', parentData, parentDataProperty, rootData = data } = {},
) {
  /*# sourceURL="ApiApp.json" */ let vErrors = null;
  let errors = 0;
  if (errors === 0) {
    if (data && typeof data == 'object' && !Array.isArray(data)) {
      let missing0;
      if (data.clientId === undefined && (missing0 = 'clientId')) {
        validate129.errors = [
          {
            instancePath,
            schemaPath: '#/required',
            keyword: 'required',
            params: { missingProperty: missing0 },
            message: "must have required property '" + missing0 + "'",
          },
        ];
        return false;
      } else {
        if (data.clientId !== undefined) {
          const _errs1 = errors;
          if (typeof data.clientId !== 'string') {
            validate129.errors = [
              {
                instancePath: instancePath + '/clientId',
                schemaPath: '#/properties/clientId/type',
                keyword: 'type',
                params: { type: 'string' },
                message: 'must be string',
              },
            ];
            return false;
          }
          var valid0 = _errs1 === errors;
        } else {
          var valid0 = true;
        }
        if (valid0) {
          if (data.parentUrl !== undefined) {
            const _errs3 = errors;
            if (typeof data.parentUrl !== 'string') {
              validate129.errors = [
                {
                  instancePath: instancePath + '/parentUrl',
                  schemaPath: '#/properties/parentUrl/type',
                  keyword: 'type',
                  params: { type: 'string' },
                  message: 'must be string',
                },
              ];
              return false;
            }
            var valid0 = _errs3 === errors;
          } else {
            var valid0 = true;
          }
        }
      }
    } else {
      validate129.errors = [
        {
          instancePath,
          schemaPath: '#/type',
          keyword: 'type',
          params: { type: 'object' },
          message: 'must be object',
        },
      ];
      return false;
    }
  }
  validate129.errors = vErrors;
  return errors === 0;
}
exports.validateUser = validate106;
exports.validateSignerAppRequest = validate109;
exports.validateModalResponse = validate115;
exports.validateEditSignersObject = validate119;
exports.validateHomePage = validate124;
